(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"seaweed_farm_02_atlas_1", frames: [[997,0,316,1150],[1315,0,312,1151],[667,0,328,1116],[0,0,343,1116],[1629,0,314,1143],[345,0,320,1148]]},
		{name:"seaweed_farm_02_atlas_2", frames: [[638,0,309,1152],[1262,0,305,1152],[0,0,315,1134],[949,0,311,1134],[1569,0,307,1139],[317,0,319,1116]]},
		{name:"seaweed_farm_02_atlas_3", frames: [[0,0,302,1152],[1237,0,298,1152],[1537,0,303,1131],[304,0,312,1115],[618,0,307,1133],[927,0,308,1117]]},
		{name:"seaweed_farm_02_atlas_4", frames: [[0,0,303,1131],[903,0,299,1126],[1204,0,294,1128],[602,0,299,1134],[1500,0,296,1118],[305,0,295,1151]]},
		{name:"seaweed_farm_02_atlas_5", frames: [[888,0,291,1128],[1472,0,283,1146],[595,0,291,1129],[297,0,296,1113],[0,0,295,1120],[1757,0,291,1113],[1181,0,289,1123]]},
		{name:"seaweed_farm_02_atlas_6", frames: [[1145,0,277,1140],[863,0,280,1128],[1424,0,280,1111],[0,0,290,1106],[1706,0,281,1106],[578,0,283,1117],[292,0,284,1119]]},
		{name:"seaweed_farm_02_atlas_7", frames: [[1386,0,269,1103],[564,0,271,1134],[1111,0,273,1103],[1657,0,267,1109],[0,0,279,1111],[837,0,272,1120],[281,0,281,1103]]},
		{name:"seaweed_farm_02_atlas_8", frames: [[0,0,267,1102],[1358,0,259,1102],[269,0,261,1121],[818,0,257,1122],[532,0,284,1027],[1077,0,279,1026],[1619,0,275,1035]]},
		{name:"seaweed_farm_02_atlas_9", frames: [[255,0,257,1104],[514,0,256,1106],[0,0,253,1123],[1322,0,273,1026],[1597,0,270,1027],[1048,0,272,1030],[772,0,274,1032]]},
		{name:"seaweed_farm_02_atlas_10", frames: [[1557,0,245,1104],[0,0,251,1102],[1043,0,247,1102],[523,0,249,1104],[1292,0,263,1032],[253,0,268,1026],[774,0,267,1026]]},
		{name:"seaweed_farm_02_atlas_11", frames: [[507,0,242,1114],[263,0,242,1116],[1494,0,235,1110],[1254,0,238,1105],[751,0,244,1103],[0,0,261,1035],[997,0,255,1035],[1731,0,252,1028]]},
		{name:"seaweed_farm_02_atlas_12", frames: [[506,0,249,1035],[1006,0,243,1034],[1736,0,238,1032],[0,0,251,1032],[253,0,251,1032],[757,0,247,1031],[1251,0,242,1030],[1495,0,239,1029]]},
		{name:"seaweed_farm_02_atlas_13", frames: [[1701,0,208,1042],[805,1038,265,821],[1433,1036,266,817],[0,1037,277,816],[533,1037,270,816],[1164,1036,267,820],[279,1037,252,876],[0,0,237,1035],[478,0,230,1035],[938,0,224,1036],[1384,0,212,1034],[1164,0,218,1031],[710,0,226,1031],[239,0,237,1028]]},
		{name:"seaweed_farm_02_atlas_14", frames: [[212,0,262,822],[476,0,260,824],[1002,0,257,825],[1522,0,255,827],[1779,0,253,829],[696,826,255,818],[738,0,262,816],[953,827,255,816],[1700,831,251,813],[1261,0,259,816],[455,826,239,875],[0,1034,244,876],[1462,829,236,875],[1210,827,250,831],[246,824,207,1032],[0,0,210,1032]]},
		{name:"seaweed_farm_02_atlas_15", frames: [[1386,820,217,864],[496,0,239,827],[1821,865,227,825],[681,829,235,821],[250,0,244,820],[0,0,248,816],[737,0,241,817],[1224,0,239,817],[1465,0,237,818],[1153,819,231,817],[918,819,233,813],[980,0,242,812],[231,822,225,873],[0,818,229,875],[458,829,221,875],[1605,865,214,876],[1704,0,224,863]]},
		{name:"seaweed_farm_02_atlas_16", frames: [[0,0,222,843],[1752,0,205,862],[224,0,226,823],[452,0,227,815],[681,0,227,814],[1123,0,210,864],[420,825,203,864],[1431,879,197,865],[1827,864,194,866],[1030,873,199,867],[1630,871,195,865],[1231,879,198,866],[215,845,203,868],[1543,0,207,869],[910,0,211,871],[1335,0,206,877],[830,873,198,878],[625,817,203,862],[0,845,213,863]]},
		{name:"seaweed_farm_02_atlas_17", frames: [[1129,0,176,895],[1307,0,174,896],[1483,0,172,897],[1657,0,169,898],[194,877,167,898],[531,870,166,899],[0,865,192,866],[699,874,164,904],[865,897,163,908],[1030,897,161,911],[1358,899,160,915],[1847,899,158,918],[363,877,166,900],[1684,900,161,902],[1520,900,162,901],[1193,898,163,899],[1828,0,169,897],[948,0,179,895],[196,0,189,875],[762,0,184,872],[575,0,185,868],[387,0,186,866],[0,0,194,863]]},
		{name:"seaweed_farm_02_atlas_18", frames: [[1118,910,152,924],[1128,0,169,831],[1299,0,163,830],[1440,832,158,830],[1600,831,152,829],[1754,830,147,828],[1903,828,143,827],[1777,0,145,826],[1624,0,151,828],[1464,0,158,829],[1272,833,166,830],[0,0,174,832],[176,0,157,921],[335,906,155,923],[0,834,156,926],[158,923,155,923],[492,908,154,921],[815,0,154,919],[805,921,154,916],[648,909,155,913],[961,921,155,910],[971,0,155,908],[656,0,157,907],[496,0,158,906],[335,0,159,904]]},
		{name:"seaweed_farm_02_atlas_19", frames: [[425,0,135,820],[425,822,131,823],[693,812,124,821],[1070,819,119,817],[1193,0,114,814],[1191,818,119,812],[693,0,127,810],[285,828,138,809],[558,822,133,810],[562,0,129,811],[819,812,125,813],[946,819,122,814],[1072,0,119,816],[946,0,124,817],[143,823,140,819],[143,0,140,821],[0,827,141,823],[0,0,141,825],[285,0,138,826]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_217 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_216 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_215 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_214 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_213 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_212 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_211 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_210 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_209 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_208 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_207 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_206 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_205 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_204 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_203 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_202 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_201 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_200 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_199 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_198 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_197 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_196 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_195 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_194 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_193 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_192 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_191 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_190 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_189 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_188 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_187 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_186 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_185 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_184 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_183 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_182 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_19"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_308 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_180 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_179 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_178 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_177 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_176 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_175 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_174 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_173 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_172 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_171 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_170 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_169 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_168 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_167 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_166 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_165 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_164 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_163 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_162 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_161 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_160 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_159 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_158 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_157 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_156 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_155 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_154 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_153 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_152 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_151 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_150 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_149 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_148 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_147 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_146 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_145 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_144 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_143 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_142 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_141 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_140 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_139 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_138 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_137 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_136 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_135 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_134 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_133 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_132 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_131 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_130 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_129 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_128 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_127 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_126 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_125 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_124 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_123 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_122 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_121 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_120 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_307 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_306 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_305 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_304 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_303 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_114 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_113 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_112 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_111 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_110 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_109 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_108 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_107 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_106 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_105 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_104 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_103 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_102 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_101 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_100 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_99 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_98 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_97 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_96 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_95 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_94 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_93 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_92 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_91 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_90 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_89 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_88 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_87 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_86 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_85 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_84 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_83 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_82 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_18"]);
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_81 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_80 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_79 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_78 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_77 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_302 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_75 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_74 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_73 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_72 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_5"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_71 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_70 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_69 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_68 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_67 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_301 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_300 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_299 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_298 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_297 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_296 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_295 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_294 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_293 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_292 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_291 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_290 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_289 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_288 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_287 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_286 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_285 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_284 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_283 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_282 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_17"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_281 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_280 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_16"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_279 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_15"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_278 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_277 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_276 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_275 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_274 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_273 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_37 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_272 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_35 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_2"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_34 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_3"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_33 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_32 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_6"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_31 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_30 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_29 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_28 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_271 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_270 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_269 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_14"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_268 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_267 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_266 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_265 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_264 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_263 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_262 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_261 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_260 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_12"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_259 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_13"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_258 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_11"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_257 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_256 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_255 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_254 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_253 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_10"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_252 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_251 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_250 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_9"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_249 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_8"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_7"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(ss["seaweed_farm_02_atlas_4"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.WarpedAsset_11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("ADtHCIh6gBQh+gCh/gJIhQgHQhTgHhTgJIimgTIhfgMQgkgEgjgFQhUgMhTgOQh8gVh7gZIg4gLIgJgCIAAAAQjOgsjPgrIgdgGQiqgjiqgoIhZgVQizgpi0ggQhCgMhCgKQiogaiqgOQhTgGhUgFQiVgHiWABQhWABhWACQiPADiPAIQhRAFhSAHQiTANiTASIg7AHQjIAajGAnIhQAQQjCAojDAiIhQANQjDAgjHAEIhOACQi9AAi8gWQg4gHg3gKQiyghijhOIhCghQgrgWgqgYIgCgBIgHgHIgCgCIgCgIIgBgDIAEgLIABgBIAGgGIAEgCIAGgCIAFgBIANAAIAJACIAPAGQClBVC0A0IAoALQBUAWBYAMQB2APB3AEIASABQBvADBvgFQCEgFCDgSQBhgNBhgSQCFgXCEgcIC3glQCFgaCGgUQBSgNBTgKQCFgRCGgLICdgLQBdgGBegEQB7gGB7gDQBpgCBpAAQB7ACB6AHQBpAGBpAMQCVARCTAYQBWAOBVAQQCYAcCYAiIB+AcQCfAkChAhIBzAYQCmAlCmAiQBTARBSAPQCDAXCDASQBgAOBhAMIATACQCMARCNALQB5AJB4AFQDKAJDLgJQBRgDBRgGQCqgLCpgWIAtgFQCRgUCQgaQBPgOBPgRQCPgcCOggQBEgPBEgRIBygcICNgnQDGg3DGg1IBQgWIGdhuIAmgKQDYg5DbgkIA3gJIA9gHIARgCIAagEIAagEIAWgCIAXgDIAWgCIAVgDIABAAQCSgPCTgGQBKgDBMgBQCYgCCZACQBrACBrAEQCIAFCIAIIDrAMQCHAICHABQBvABBvgDQBxgEBygJQB7gKB6gQIAOgCIBJgMIBSgQIBTgRIBXgUIAygNIATgHIATgHIAAAAIASgHIATgIIASgHIAPgGIAIgEIAOgGIABAAIANgFIAHgBIACAAIAEgBIAEAAIAHACIACABIAHAIIABAAIAFANIABAEIgCAJIAAACIgGAKIgBABIgJAHQixBejIAgIgMABQihAZiiASQhPAJhQAFQirAMisgFQhQgChQgEIk9gPIijgJQhqgFhrgCQiJgEiJABQhrABhqACIhOACQimAEikAPIhHAIIgCAAQgjADgjAFQi0AViwApIhcAWQiuAqitAsIiDAiQiWAmiTAqIitAyIgWAGQjfA/jhA1IgTAEQhiAXhiAVIhlAVQizAki0AZIhcANQjIAajKANIgpACQiaAJiZACIgGAAg");
	this.shape.setTransform(0.025,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-674.8,-45,1349.6999999999998,90.1);


(lib.WarpedAsset_10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("ABzGZQh+AAiBgFQh7gEh8gHQiEgIiEgDQh6gEh5gLQh+gMh+gSIg/gJIgDAAQjQghjOgyQjmg3jjhHQjxhLj0hDQj4hFj9gpQjrgkjtgNQjigMjhARQixAOiwAdQjxAnjqBGQjmBDjpA/QjnA/juAYQj3Aaj4gOQjfgNjYg6QgwgNgvgQIgKgGIgEgLIAEgKIAKgFIAKAAQDTAvDTAYQDlAbDngSQD+gTD4g/QDkg7DghHQDbhGDigvQDWgrDagOQCtgLCtADQDlADDkAXQDnAWDgA1QDpA2DlBCIGqB4QDXA9DaAzQD4A6D+AZQDpAXDoAIQETAJESAGQEdAGEdgNQDCgJDCgPQDigRDjgrQDWgpDSg2QCBghB/glQDuhGDxg3QDlg0Dkg6QD1g9D6geQEAgfECgIQDlgHDlAEQD0AFD1ATQD9ATD/AEQDiADDhgSQB7gKB6gRIgJABIBZgQIBTgRIBTgRIBZgUIBbgXQAlgKAkgMIAVgLIANgEIAOABIAMAGIAJAKIAEANIAAAOIgGAMIgKAJQjDBJjNAmQjvAsjzAPQj8APj9gNQjxgMjxgQQj0gQj1ABIkmADQjuAFjsAYQjlAXjgAyQjxA2jwA3QjvA4jqBGQjqBHjuA2QhtAYhsAWQjmAtjqAZQj5Acj7AHQiyAGixABIh8AAg");
	this.shape.setTransform(0.025,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-679.6,-40.9,1359.3000000000002,81.9);


(lib.WarpedAsset_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("AjaHTQilgWikggQhTgQhSgUQjng3jmg+Qjfg8jkgnIlWg7QjignjlgSQjtgTjuAIQjqAHjpAXInKAsQjkAWjlAXQjnAXjmAcQjtAejvATQjvAUjwgSQjlgRjggwQjsgyi/iUQhFg3hDg7IgIgLIgCgNIACgNIAIgLIALgHIANgDIAJABIAPAJQCcCRDBBWQBSAkBWAUQB9AcB/ASQBvAQBwAIQDoAPDmgTQDkgSDjgdQDbgbDbgVIGngrIGwgtQDjgZDlgKQEAgLD/AQQDyAQDwAnIHCBMQDgAnDeA+QDQA6DTAvQBoAXBoAWQCKAcCLASQFAArFEgSQD7gOD4gtQCkgeClgjQDcgxDeguQB8gbB7gfQENhFELhRQDzhLD1hGQDqhCDtgvQA6gMA6gHIARgCIAZgEIAagEIAWgDIAWgEIAWgDIAVgCIACgBQDbgbDegEQEDgFEDAJQD9AID9ANQD2AND1gHQD4gID3ghQC7gaC2gzIASgIIATgKIASgJIASgIIARgJIAYgLIANgGIAOgGIAHgCIACgBIAHgFIAKACIAHAHIABABIAAAAIAIARIgDALIgHAJQioB9jRAaIlQApQj6Agj8gKIncgUQi8gIi8gDQjzgEjyAGQjNAEjLAXIhHAJIgCAAQjXAYjRA3QjbA5jZA+QjWA9jVA/QhgAdhhAaQjpA+jqA6QiTAliUAgQjfAyjiAmQjaAljdATQiZANiaAEIgOAAQjgAAjdgfg");
	this.shape.setTransform(0,0.0265);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.1,-49.7,1344.2,99.5);


(lib.WarpedAsset_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_217();
	this.instance.setTransform(-60.4,-278.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.4,-278.4,121,557);


(lib.WarpedAsset_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_216();
	this.instance.setTransform(-33.75,-204.95,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.7,-204.9,67.5,410);


(lib.WarpedAsset_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_215();
	this.instance.setTransform(-55.45,-210.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-55.4,-210.8,111,421.5);


(lib.WarpedAsset_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_214();
	this.instance.setTransform(-38,-230.95,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-38,-230.9,76,462);


(lib.WarpedAsset_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_213();
	this.instance.setTransform(-51.2,-215.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-51.2,-215.4,102.5,431);


(lib.WarpedAsset_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_212();
	this.instance.setTransform(-72.6,-282,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.6,-282,145.5,564);


(lib.WarpedAsset_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CachedBmp_211();
	this.instance.setTransform(-51.9,-260.55,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-51.9,-260.5,104,521);


(lib.WarpedAsset_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJKA1TIgJgEIgHgGIgFgIIgEgHIgBgFIgBgIIAAgKIgBgXIAAgMIgBgMIAAgMQhHj3AJkBQAJjtAvjpQAwjsA3jrQA2joBOjiQBMjbBCjfQBCjhAvjmQAwjnAAjsQABjugGjvQgGjtAQjtQAPjrAJjqQAIjqAxjmQAzjnBYjcQBXjcB6jLQB8jNAzjrQAZhxAJhzIADgIIAFgHIAHgFIAIgCIAJACIAHAFIAFAIIADAKIgBA0IABgBIAHgDIAIgBIAJABIAHADIAHAFIAFAHIAEAKIACAKIACAKIABAKIABAJIABAJIABAIIACAHIAEAHIAFAIIADAKIADAJIAAAJIgBAJIgCAJIgCALIgDAIIgDAIIgGALQgFALABAOQAAAMgBAMIgEAXIgDAKIgDAJIgEAKIgDAKQAAAygOAwQgKAlgNAlIgcBNQgKAfgQAdQgOAagQAZQgSAdgPAeIgLAcIgDAIIgEAMIgDAKIgFAKIgEAKIgFAKIgFAKQhLDOhhDGQgZA0gOA5Qg0DTgnDVQgaCPgGCRQgEBJAFBIQAPECgEEEQgEEGACEGQABEQgeEPQgYDWhADPQg5C4g9C4QhHDSg2DXQg4DehFDbQhHDjgUDuQgPC4AVC5IALBkQAPCRAlCOQAKAmAEAnIgDAHIgEAGIgGAFIgHACIgHABIgHAAIgGgDIgFgEIgFgGIgGgIQhWjpgEj3QgChcgDhcQgHjmA3jhQAyjKA1jKQA8jlBAjkQA/jhBNjdQBRjmAojwQAOhWAIhWQAVjwgGjyQgFjsABjtQABjqgJjpQgCgigEghQAKi1ANi1QALiOAmiJQAoiPAriOQAriOBIiDQAthRAdhYQAph5BDhtIAFgIIADgGIAEgGIAIgXIAGgRIAIgUIAEgJIAEgIIAFgLIAFgLIALgnIAIgeIAFgUIADgWQACgRAAgRIACgWIADgLIADgHIADgHIADgKIADgKIACgKIABgMIAAgMIABgMIAAgJIAAgBQgaCXg9CRQhXDOhsDFQg5BmgrBtQhVDXgwDiQgvDggIDkQgJD2gPD1QgQDzAJD0QAHDOgDDNQgCDegnDaQgpDkhDDeQhCDdhKDaQhHDSg3DXQg9DqgxDtQgzDwgND0QgNDvA4DoQAPA+ACA/QABAWgDAVIgDAKIgGAIIgIAGIgJAEIgJABIgKgBgEAJOgxhIABgFIAEgJIAGgIIABgEIADgJIABgCIgCgDIgFgJIgCgGIgHA3g");
	this.shape.setTransform(0.0189,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-341.1,135.7,682.3);


(lib.PuppetShape_33 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_7("synched",0);

	this.instance_1 = new lib.CachedBmp_205();
	this.instance_1.setTransform(-24.75,-209.15,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_206();
	this.instance_2.setTransform(-23.95,-209.65,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_207();
	this.instance_3.setTransform(-23.25,-210.15,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_208();
	this.instance_4.setTransform(-22.85,-210.65,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_209();
	this.instance_5.setTransform(-22.45,-211.1,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_210();
	this.instance_6.setTransform(-22.15,-211.55,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.7,-211.5,96.1,416.6);


(lib.PuppetShape_32 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_7("synched",0);

	this.instance_1 = new lib.CachedBmp_198();
	this.instance_1.setTransform(-47.25,-203.9,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_199();
	this.instance_2.setTransform(-41.9,-203.9,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_200();
	this.instance_3.setTransform(-38,-204.35,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_201();
	this.instance_4.setTransform(-35.35,-204.9,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_202();
	this.instance_5.setTransform(-32.7,-205.85,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_203();
	this.instance_6.setTransform(-29.9,-206.9,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_204();
	this.instance_7.setTransform(-27.45,-207.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.2,-207.8,85.30000000000001,412.9);


(lib.PuppetShape_31 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_7("synched",0);

	this.instance_1 = new lib.CachedBmp_191();
	this.instance_1.setTransform(-35.45,-205,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_192();
	this.instance_2.setTransform(-36.7,-204.7,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_193();
	this.instance_3.setTransform(-38.15,-204.45,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_194();
	this.instance_4.setTransform(-39.6,-204.2,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_195();
	this.instance_5.setTransform(-41.05,-204.05,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_196();
	this.instance_6.setTransform(-42.9,-203.85,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_197();
	this.instance_7.setTransform(-45.05,-203.85,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-205,79.6,410.1);


(lib.PuppetShape_30 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_7("synched",0);

	this.instance_1 = new lib.CachedBmp_183();
	this.instance_1.setTransform(-21.75,-212.05,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_184();
	this.instance_2.setTransform(-22.55,-211.35,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_185();
	this.instance_3.setTransform(-23.5,-210.6,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_186();
	this.instance_4.setTransform(-25.15,-209.85,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_187();
	this.instance_5.setTransform(-26.7,-209,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_188();
	this.instance_6.setTransform(-28.55,-208.1,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_189();
	this.instance_7.setTransform(-30.9,-207.1,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_190();
	this.instance_8.setTransform(-33.25,-206.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.7,-212,99,417.1);


(lib.PuppetShape_29copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_7("synched",0);

	this.instance_1 = new lib.CachedBmp_182();
	this.instance_1.setTransform(-25.45,-208.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33.7,-208.7,77.30000000000001,413.79999999999995);


(lib.PuppetShape_28copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_308();
	this.instance_1.setTransform(-81.4,-215.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-81.4,-215.4,132.7,432);


(lib.PuppetShape_27copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_180();
	this.instance_1.setTransform(-88.25,-228.65,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-88.2,-230.9,126.2,462);


(lib.PuppetShape_27 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_8("synched",0);

	this.instance_1 = new lib.CachedBmp_174();
	this.instance_1.setTransform(-97.85,-277.25,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_175();
	this.instance_2.setTransform(-87.6,-276.8,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_176();
	this.instance_3.setTransform(-77.35,-276.5,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_177();
	this.instance_4.setTransform(-68.2,-276.35,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_178();
	this.instance_5.setTransform(-59.45,-277.85,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_179();
	this.instance_6.setTransform(-53.75,-280.45,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-97.8,-280.4,165.1,559);


(lib.PuppetShape_26 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_6("synched",0);

	this.instance_1 = new lib.CachedBmp_168();
	this.instance_1.setTransform(-73,-209.7,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_169();
	this.instance_2.setTransform(-74.5,-209.9,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_170();
	this.instance_3.setTransform(-76.05,-210.1,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_171();
	this.instance_4.setTransform(-77.65,-210.35,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_172();
	this.instance_5.setTransform(-79.25,-210.75,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_173();
	this.instance_6.setTransform(-80.8,-211.15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-80.8,-211.1,136.4,421.79999999999995);


(lib.PuppetShape_25 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_6("synched",0);

	this.instance_1 = new lib.CachedBmp_160();
	this.instance_1.setTransform(-46.05,-221.85,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_161();
	this.instance_2.setTransform(-47.35,-219.95,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_162();
	this.instance_3.setTransform(-48.4,-218.15,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_163();
	this.instance_4.setTransform(-49.75,-216.3,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_164();
	this.instance_5.setTransform(-52.15,-214.55,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_165();
	this.instance_6.setTransform(-54.4,-212.95,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_166();
	this.instance_7.setTransform(-58.9,-211.45,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_167();
	this.instance_8.setTransform(-65.2,-210.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-65.2,-221.8,157.7,432.5);


(lib.PuppetShape_24 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_6("synched",0);

	this.instance_1 = new lib.CachedBmp_153();
	this.instance_1.setTransform(-47.55,-217.75,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_154();
	this.instance_2.setTransform(-47.4,-218.3,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_155();
	this.instance_3.setTransform(-47.2,-218.9,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_156();
	this.instance_4.setTransform(-47,-219.5,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_157();
	this.instance_5.setTransform(-46.8,-220.05,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_158();
	this.instance_6.setTransform(-46.55,-220.65,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_159();
	this.instance_7.setTransform(-46.35,-221.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-55.4,-221.2,144.1,431.9);


(lib.PuppetShape_23 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_6("synched",0);

	this.instance_1 = new lib.CachedBmp_145();
	this.instance_1.setTransform(-82.35,-211.6,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_146();
	this.instance_2.setTransform(-77.15,-210.65,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_147();
	this.instance_3.setTransform(-71.95,-210.1,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_148();
	this.instance_4.setTransform(-66.7,-210.45,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_149();
	this.instance_5.setTransform(-61.5,-211.65,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_150();
	this.instance_6.setTransform(-56.3,-213,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_151();
	this.instance_7.setTransform(-51.25,-214.55,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_152();
	this.instance_8.setTransform(-48.65,-216.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-82.3,-216.1,149.2,426.79999999999995);


(lib.PuppetShape_22 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_3("synched",0);

	this.instance_1 = new lib.CachedBmp_139();
	this.instance_1.setTransform(-62.65,-290.4,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_140();
	this.instance_2.setTransform(-62.3,-290.95,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_141();
	this.instance_3.setTransform(-61.95,-291.55,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_142();
	this.instance_4.setTransform(-61.6,-292.15,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_143();
	this.instance_5.setTransform(-61.25,-292.75,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_144();
	this.instance_6.setTransform(-60.85,-293.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.6,-293.3,169.8,578.9000000000001);


(lib.PuppetShape_21 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_3("synched",0);

	this.instance_1 = new lib.CachedBmp_132();
	this.instance_1.setTransform(-105.3,-289.15,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_133();
	this.instance_2.setTransform(-97.2,-286.85,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_134();
	this.instance_3.setTransform(-89.05,-284.25,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_135();
	this.instance_4.setTransform(-80.95,-282.5,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_136();
	this.instance_5.setTransform(-72.85,-284.55,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_137();
	this.instance_6.setTransform(-68.95,-286.5,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_138();
	this.instance_7.setTransform(-65.2,-288.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105.3,-289.1,181.6,573.9000000000001);


(lib.PuppetShape_20copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_127();
	this.instance_1.setTransform(-65.05,-228,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_128();
	this.instance_2.setTransform(-69.7,-228.15,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_129();
	this.instance_3.setTransform(-74.3,-228.3,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_130();
	this.instance_4.setTransform(-78.95,-228.45,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_131();
	this.instance_5.setTransform(-83.6,-228.55,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-83.6,-230.9,121.6,462);


(lib.PuppetShape_20 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_8("synched",0);

	this.instance_1 = new lib.CachedBmp_120();
	this.instance_1.setTransform(-72.2,-277.7,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_121();
	this.instance_2.setTransform(-76.55,-277.85,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_122();
	this.instance_3.setTransform(-80.9,-277.95,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_123();
	this.instance_4.setTransform(-85.15,-278,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_124();
	this.instance_5.setTransform(-90.9,-278.05,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_125();
	this.instance_6.setTransform(-96.65,-278,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_126();
	this.instance_7.setTransform(-102.3,-277.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102.3,-278.4,162.9,557);


(lib.PuppetShape_19copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_303();
	this.instance_1.setTransform(-67.1,-214.5,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_304();
	this.instance_2.setTransform(-68.55,-214.6,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_305();
	this.instance_3.setTransform(-70.2,-214.8,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_306();
	this.instance_4.setTransform(-73.45,-214.95,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_307();
	this.instance_5.setTransform(-77.4,-215.15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-77.4,-215.4,128.7,433.9);


(lib.PuppetShape_19 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_8("synched",0);

	this.instance_1 = new lib.CachedBmp_108();
	this.instance_1.setTransform(-43.75,-288.8,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_109();
	this.instance_2.setTransform(-47,-287.8,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_110();
	this.instance_3.setTransform(-49.95,-286.65,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_111();
	this.instance_4.setTransform(-52.45,-285.25,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_112();
	this.instance_5.setTransform(-55.6,-283.6,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_113();
	this.instance_6.setTransform(-59.9,-281.7,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_114();
	this.instance_7.setTransform(-65.15,-279.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-65.1,-288.8,192.89999999999998,567.4000000000001);


(lib.PuppetShape_18 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_100();
	this.instance_1.setTransform(-70,-228.25,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_101();
	this.instance_2.setTransform(-67.7,-228.2,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_102();
	this.instance_3.setTransform(-66.65,-228.15,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_103();
	this.instance_4.setTransform(-65.6,-228.1,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_104();
	this.instance_5.setTransform(-64.55,-228.05,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_105();
	this.instance_6.setTransform(-63.55,-228,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_106();
	this.instance_7.setTransform(-62.5,-228,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_107();
	this.instance_8.setTransform(-61.45,-227.95,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-70,-230.9,108,465.70000000000005);


(lib.PuppetShape_17 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_93();
	this.instance_1.setTransform(-100.45,-229.2,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_94();
	this.instance_2.setTransform(-95.9,-229.15,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_95();
	this.instance_3.setTransform(-91.4,-229.1,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_96();
	this.instance_4.setTransform(-86.8,-229,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_97();
	this.instance_5.setTransform(-82.3,-228.85,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_98();
	this.instance_6.setTransform(-77.75,-228.7,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_99();
	this.instance_7.setTransform(-73.8,-228.45,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-100.4,-230.9,138.4,464);


(lib.PuppetShape_16copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_92();
	this.instance_1.setTransform(-60.45,-227.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.4,-230.9,98.4,462);


(lib.PuppetShape_16 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_3("synched",0);

	this.instance_1 = new lib.CachedBmp_85();
	this.instance_1.setTransform(-87.85,-284.3,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_86();
	this.instance_2.setTransform(-90.35,-285.05,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_87();
	this.instance_3.setTransform(-92.9,-285.8,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_88();
	this.instance_4.setTransform(-95.35,-286.5,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_89();
	this.instance_5.setTransform(-97.85,-287.2,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_90();
	this.instance_6.setTransform(-100.35,-287.9,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_91();
	this.instance_7.setTransform(-102.85,-288.55,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102.8,-288.5,175.7,570.5);


(lib.PuppetShape_15 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_5("synched",0);

	this.instance_1 = new lib.CachedBmp_77();
	this.instance_1.setTransform(-92.95,-228.75,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_78();
	this.instance_2.setTransform(-93.9,-228.8,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_79();
	this.instance_3.setTransform(-94.85,-228.85,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_80();
	this.instance_4.setTransform(-95.75,-228.95,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_81();
	this.instance_5.setTransform(-96.7,-228.95,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_82();
	this.instance_6.setTransform(-97.65,-229,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_83();
	this.instance_7.setTransform(-98.6,-229.05,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_84();
	this.instance_8.setTransform(-99.5,-229.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-99.5,-230.9,137.5,462);


(lib.PuppetShape_14copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_302();
	this.instance_1.setTransform(-65.65,-214.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-65.6,-215.4,116.89999999999999,434.6);


(lib.PuppetShape_14 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_3("synched",0);

	this.instance_1 = new lib.CachedBmp_67();
	this.instance_1.setTransform(-60.45,-293.95,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_68();
	this.instance_2.setTransform(-62.35,-292.75,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_69();
	this.instance_3.setTransform(-64.05,-291.5,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_70();
	this.instance_4.setTransform(-65.55,-290.15,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_71();
	this.instance_5.setTransform(-68.05,-288.75,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_72();
	this.instance_6.setTransform(-70.6,-287.25,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_73();
	this.instance_7.setTransform(-73,-285.65,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_74();
	this.instance_8.setTransform(-75.9,-283.95,0.5,0.5);

	this.instance_9 = new lib.CachedBmp_75();
	this.instance_9.setTransform(-81.85,-282.85,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-81.8,-293.9,181.39999999999998,575.9);


(lib.PuppetShape_13 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_294();
	this.instance_1.setTransform(-41.4,-225.2,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_295();
	this.instance_2.setTransform(-43.4,-223.8,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_296();
	this.instance_3.setTransform(-45.1,-222.35,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_297();
	this.instance_4.setTransform(-46.6,-220.7,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_298();
	this.instance_5.setTransform(-49.45,-218.9,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_299();
	this.instance_6.setTransform(-52.45,-217.1,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_300();
	this.instance_7.setTransform(-55.3,-215.6,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_301();
	this.instance_8.setTransform(-58.55,-214.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-58.5,-225.2,143.1,443.29999999999995);


(lib.PuppetShape_12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_287();
	this.instance_1.setTransform(-44.5,-221.7,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_288();
	this.instance_2.setTransform(-44.1,-222.25,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_289();
	this.instance_3.setTransform(-43.7,-222.8,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_290();
	this.instance_4.setTransform(-43.3,-223.25,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_291();
	this.instance_5.setTransform(-42.85,-223.75,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_292();
	this.instance_6.setTransform(-42.4,-224.25,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_293();
	this.instance_7.setTransform(-41.9,-224.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-51.2,-224.7,131.3,442);


(lib.PuppetShape_11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_4("synched",0);

	this.instance_1 = new lib.CachedBmp_279();
	this.instance_1.setTransform(-85.3,-215.65,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_280();
	this.instance_2.setTransform(-78.35,-215.25,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_281();
	this.instance_3.setTransform(-71.75,-214.85,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_282();
	this.instance_4.setTransform(-65.85,-215.15,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_283();
	this.instance_5.setTransform(-59.95,-216.25,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_284();
	this.instance_6.setTransform(-54,-217.55,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_285();
	this.instance_7.setTransform(-48.6,-219,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_286();
	this.instance_8.setTransform(-46.05,-220.45,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-85.3,-220.4,136.6,437.5);


(lib.PuppetShape_10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_2("synched",0);

	this.instance_1 = new lib.CachedBmp_273();
	this.instance_1.setTransform(-67.3,-260.1,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_274();
	this.instance_2.setTransform(-71.05,-260.2,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_275();
	this.instance_3.setTransform(-74.85,-260.3,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_276();
	this.instance_4.setTransform(-78.7,-260.4,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_277();
	this.instance_5.setTransform(-82.45,-260.55,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_278();
	this.instance_6.setTransform(-86.3,-260.65,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.3,-260.6,138.4,521.1);


(lib.PuppetShape_9copy2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_6("synched",0);

	this.instance_1 = new lib.CachedBmp_37();
	this.instance_1.setTransform(-71.45,-209.65,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-71.4,-210.8,127,421.5);


(lib.PuppetShape_9copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_2("synched",0);

	this.instance_1 = new lib.CachedBmp_272();
	this.instance_1.setTransform(-63.5,-260,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-63.5,-260.5,115.6,521);


(lib.PuppetShape_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_8("synched",0);

	this.instance_1 = new lib.CachedBmp_28();
	this.instance_1.setTransform(-50.5,-282.85,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_29();
	this.instance_2.setTransform(-49.8,-283.7,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_30();
	this.instance_3.setTransform(-49.05,-284.5,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_31();
	this.instance_4.setTransform(-48.25,-285.3,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_32();
	this.instance_5.setTransform(-47.45,-286.05,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_33();
	this.instance_6.setTransform(-46.55,-286.8,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_34();
	this.instance_7.setTransform(-45.65,-287.5,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_35();
	this.instance_8.setTransform(-44.7,-288.15,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.4,-288.1,175.2,566.8);


(lib.PuppetShape_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_2("synched",0);

	this.instance_1 = new lib.CachedBmp_264();
	this.instance_1.setTransform(-39.5,-266.4,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_265();
	this.instance_2.setTransform(-41.5,-265.4,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_266();
	this.instance_3.setTransform(-43.25,-264.25,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_267();
	this.instance_4.setTransform(-44.95,-262.9,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_268();
	this.instance_5.setTransform(-46.45,-261.65,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_269();
	this.instance_6.setTransform(-47.8,-260.95,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_270();
	this.instance_7.setTransform(-51.3,-260.35,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_271();
	this.instance_8.setTransform(-55.65,-259.95,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-55.6,-266.4,147.6,526.9);


(lib.PuppetShape_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_2("synched",0);

	this.instance_1 = new lib.CachedBmp_257();
	this.instance_1.setTransform(-68,-265.1,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_258();
	this.instance_2.setTransform(-50.65,-265.3,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_259();
	this.instance_3.setTransform(-41.55,-265.55,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_260();
	this.instance_4.setTransform(-41.15,-265.75,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_261();
	this.instance_5.setTransform(-40.75,-265.9,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_262();
	this.instance_6.setTransform(-40.35,-266.1,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_263();
	this.instance_7.setTransform(-39.95,-266.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-68,-266.2,153.6,526.7);


(lib.PuppetShape_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_2("synched",0);

	this.instance_1 = new lib.CachedBmp_249();
	this.instance_1.setTransform(-94,-260.85,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_250();
	this.instance_2.setTransform(-90.75,-260.6,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_251();
	this.instance_3.setTransform(-87.5,-260.4,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_252();
	this.instance_4.setTransform(-84.25,-260.2,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_253();
	this.instance_5.setTransform(-81,-260.8,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_254();
	this.instance_6.setTransform(-77.75,-261.5,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_255();
	this.instance_7.setTransform(-74.45,-262.5,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_256();
	this.instance_8.setTransform(-71.2,-263.85,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-94,-263.8,162.3,524.3);


(lib.PuppetShape_5copy4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_8("synched",0);

	this.instance_1 = new lib.CachedBmp_4();
	this.instance_1.setTransform(-108.25,-277.75,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-108.2,-278.4,168.8,557);


(lib.PuppetShape_5copy3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_3("synched",0);

	this.instance_1 = new lib.CachedBmp_3();
	this.instance_1.setTransform(-62.95,-289.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.6,-289.8,157.2,575.5);


(lib.PuppetShape_5copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_10("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("ABmGYQh+AAiAgEQhlgDiSgIQiNgIh8gEQh6gDh4gMQiJgNhzgQIhDgKQjOggjPgyQjng4jihHQjthJj4hEQj4hFj+gpQjtgljrgMQjogLjaAQQisANi1AeQjvAnjsBGQj4BIjXA7QjiA+jxAeQkRAhjggaQjQgYjZhkQgzgYgkgVQgGgDgCgEQgEgFABgHQAAgEAGgFQACgCAIgBIAKABQDeBdCzAmQDPAtD4gWQDtgVEIhEQDRg3DzhMQDihIDagtQDPgqDigPQCggLC6ADQDnAEDiAWQDoAXDfA0QDkA1DqBDIGqB4QDeA+DSAxQD8A7D7AYQDsAXDlAIQERAKETAFQEgAGEagMQCkgIDggQQDkgRDhgsQDWgoDSg2QB8ggCEgnQDrhED0g4QDyg3DXg3QDtg8ECgfQD7gfEHgIQD0gHDWAEQDvAFD6ATQEGATD2AEQDiAEDhgTQBngICOgTIgJABQAvgIAqgIID/g2IBbgXQAkgJAlgNQAEgBAHgEIAKgGIANgEQAJgBAFACQAHACAFAEQAGAFADAFQAEAHAAAGQABAIgCAGQAAACgFAKIgKAJQjDBJjNAmQjyAtjwAOQj+AQj7gOQkdgPjFgNQjsgQj9ABIkmADQjlAEj1AZQjmAXjfAyQkdBAjEAtQj5A6jgBDQj8BMjcAxQh1AahkAUQjmAujqAZQkAAbj0AIQi6AGipABg");
	this.shape.setTransform(1.3339,-0.2917);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-679.6,-41.2,1359.3000000000002,82.2);


(lib.PuppetShape_4copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_9("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("AjSHTQidgVitghQhMgPhYgVQjkg2jqg/Qjcg8jngnIlWg7QjngojfgRQjlgTj2AIQjwAHjjAXInLAsQkEAZjFAUQjxAYjcAbQjhAcj7AVQjrAUj0gRQjlgQjfgoQjygsjAiAQhIguhGg2QgEgDgEgHQgDgGgBgHQAAgIACgFQABgFAGgHIAKgHQAFgDAIgBIAJAAIAPAHQCfB/DKBLQBYAhBSAPQB8AYCCARQBuAOByAHQDnAODmgTQDmgTDigcQC3gXD+gZIGogrIGwgtQDpgZDegJQECgMD+ARQDvAPDyAnIHCBMQDhAnDeA+QDRA6DRAvIDRAtQCJAcCLASQFBArFDgSQD9gOD1gtQCcgcCuglQDOguDsgxQB2gZCBghQERhGEHhPQEFhQDjhBQDkhBDzgxQBBgMAzgGICbgXIACAAQDcgbDdgFQD+gFEIAJQDgAIEbAOQDuAMD7gHQD9gHDygiQC9gZC0gzQAHgCAMgHIAkgSIATgJIARgIIAYgLIANgGIAUgJIADgBIAIgEQAFAAAEABIAHAIIABAAIAAAAQAGAMABAFIgCALIgHAKQipB8jQAaIlQAqQj5Afj9gKIncgUQizgIjFgDQjlgDkAAFQjMAEjMAXIhGAJIgDAAQjYAZjQA3Qj1BAi/A3QjYA8jTA/QhWAahrAdQjAA0kTBEQiRAliWAgQjpAzjYAlQjfAmjYASQi3APh8ABIgkAAQjHAAjfgeg");
	this.shape.setTransform(-0.15,-1.7125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.9,-51.4,1345.5,101.19999999999999);


(lib.PuppetShape_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_11("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00000D").s().p("ADpHCIh6gBQh1gCiIgJIhQgHQhtgKg4gGIlNgoQhvgQg4gKQhSgOilggIhAgNIAAgBImdhWIgdgGQiIgcjMgvIhagVQiXgjjQgmIiEgWQixgbiggNQhvgIg5gCQiHgHikABIisACQijAEh7AIQhQAEhTAIQiNALiZATIg6AHQjNAajBAnIhQAQQjZAsisAdIhQAOQjGAgjFADIhOACQi/AAi7gaQgxgHg9gNQiugmijhVIhBgkQgrgYgogZIgBgBIgIgHIgBgCIgCgIIAAgEIADgKIABgBIAHgFIADgCIAGgCIAGgBIAMABIAKACIAPAGQCiBcCwA6IApAMQBWAaBVAMQBtARB/AGIARABQBnAFB4gFQCGgGCAgRQBNgKB1gVQBbgQCugjIC3gmQBygVCZgYQA3gJBugOQCLgRCAgLICdgLIC7gKQDAgHA2gBQCMgDBGABQB2AAB/AIQBqAGBoAMQCLAQCdAZQByATA5ALQC9AkBzAaIB+AcQBRASDwAzIByAYQDSAuB6AZQBQAQBVAQQCSAZB1AQIDAAaIATACQChASB4AJQB/AKByAFQC9AIDXgIQBRgDBSgGQC5gNCagUIAtgGQCAgQCggdICfgfQC6gmBjgWICHggIBygdQA/gPBPgXIOfj6QDig7DRgiIA3gJIA9gHICcgUIACAAQCFgNCfgIICXgEQDLgCBmACQBqACBrAEQByAECfAJIDrANQCdAIBxAAQBoACB2gEQBggDCDgKQBogICNgRIAOgDIBJgMQAsgIAngIICpglQAdgGAVgHIASgHIATgGIABgBIBbgmIACAAIANgFIAHAAIACgBIADgBIAFAAIAHACIACACIAIAHIAEANIABAEIgBAJIgBACIgFAKIgBABIgKAIQizBfjFAeIgMACQiwAaiUAQQhIAJhWAFQikAMizgEIiggHIk9gPIikgJQhpgEhrgDQiSgDiAAAIjVADIhPACQikAEilAQIhHAHIgCAAIhGAIQi+AXimAnIhcAWQivAqisAtIiDAgQixAuh4AjIjDA4QjZA8joA4IgTAEQh+AdhGAPIhkAVQjEAmijAXIhcANQjCAajQAMIgpADQiGAIitADg");
	this.shape.setTransform(0.5,0.7125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).wait(30));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-674.8,-45,1349.8,90.7);


(lib.PuppetShape_3copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJNA1TIgJgEIgIgGIgFgIIgDgHIgCgNIAAgKIAAgXIgBgkQhFj3ARkAQANjVAyj+IBenXQAyjtBIjfQBNjyA4jKQA0i7A5kNQAwjmAFjsQAEjtgDjvQgDjkAVj2QAVkDAKjRQAMjoAyjnQAzjkBXjeQBXjaB2jNQB3jOAqjtQAWhzAEhxIACgIQACgGADgCQADgDAEgCIAIgCIAJACQAFACACACQAEAFABADQADAFAAAFIACA0IABgBIAHgEIAIgBIAIAAIAIAEQAFACACACIAFAHQAEAFABAEIACALIADAJIABAKIABAJIACAJIABAIIADAHIAJAPIAEAJIADAJIAAAJIgDAdIgCAIIgEAJIgFALQgEALABAOQABANgBAMIgEAWIgFAUIgEAKQgDAHAAADQABA0gMAvQgJAmgMAkIgaBOQgKAggOAdIgeA0QgXAngJAUIgKAcIgGAUIgRApIgEAKQhJDQhgDFQgZAzgOA6QgxDIgsDgQgbCOgJCSQgEBDADBOQALEBgIEEQgJEEgDEIQgFEDghEZQgbDYg8DLQhGDpgqCIQhCDQgxDaQg4D4g4DDQhADcgXD2QgSC3APC5IAJBkQAMCPAiCQQALAuABAfQAAADgDAEQgBACgEAEQgBACgFADIgGACIgHABIgHgBIgHgDIgEgEIgFgGIgGgIQhRjqABj3IABi3QgCjfA0jlIBemVQAzjaA8jxQA4jbBLjkQBMjhArj2QANhOAKheQAZjmgBj6QgBjTAGkFQAEj1gFjeQgBghgEgiQATj0AKh1QANiPAmiHQAbhfA4i9QApiMBJiGQAshSAbhXQAoh6BAhtIALgVIAghZIAGgLIAQhFIAFgVIACgWIACg4QAAgDADgHIAJgZIACgKIADgKIAAguQgYCgg3CKQhWDahmC8Qg5BpgpBrQhTDUgyDkQgxDdgMDmQgLDogUECQgTD0AEDyQADDPgEDMQgFDXgpDfQgsDwg9DSQhEDxhADHQhCDUgyDXQgyDYgyEBQg0ENgRDWQgTDuA0DoQAOA7ACBBQAAAagDARIgEAKIgGAIIgIAGIgIADIgKABQgFAAgEgBgEAJKgxkIABgDIAJgRIAEgNIAAgCIgCgDIgHgPg");
	this.shape.setTransform(0.4649,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-341.2,135.7,682.5);


(lib.PuppetShape_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJNA1TIgJgEIgIgGIgFgIIgDgHIgCgNIAAgKIAAgXIgBgkQhFj3ARkAQANjVAyj+QA+k7AhicQAwjrBJjhQBGjaA/jiQA1i9A4kLQAxjnADjrQAEjtgCjvQgCjuAUjsQAVkDAKjRQAMjoAyjnQA1jrBWjWQBXjeB1jKQB3jOAqjtQAWhzAEhxIACgIQACgGADgCQADgDAEgCIAIgCIAJACQAFACACACQAEAFABADQADAFAAAFIACA0IABgBIAHgEIAIgBIAIAAIAIAEQAFACACACIAFAHQAEAFABAEIACALIADAJIABAKIABAJIACAJIABAIIADAHIAJAPIAEAJIADAJIAAAJIgDAdIgCAIIgEAJIgFALQgEALABAOQABANgBAMIgEAWIgFAUIgEAKQgDAHAAADQABA0gMAvQgJAmgMAkIgaBOQgKAggOAdIgeA0QgVAjgKAZIgLAbIgWA9IgFAKQhIDOhhDHQgaA3gNA2QgxDFgsDjQgbCOgJCSQgEBDADBOQALEEgJEBQgIEEgEEIQgDEEgjEYQgZDWg9DNQhGDpgqCIQhCDQgxDaQg0Dsg8DPQhADcgXD2QgSC9APCzIAJBkQAMCPAiCQQALAuABAfQAAADgDAEQgBACgEAEQgBADgFACIgGACIgHABIgHgBIgHgDIgFgEIgEgGIgGgIQhRjqACj3QABhbgBhcQgCjfA0jlIBemVQAzjaA8jxQA4jbBLjkQBMjhArj2QANhOAKheQAZjvgBjxQgBjaAGj+QAEj1gFjeQgBgegDglQAPjVANiUQANiPAmiHIBTkcQAriPBHiDQAshSAbhXQAnh3BBhwIAHgPIAEgGIAghZIAGgLIAQhFIAFgVIACgWIACg4QAAgDADgHIAJgZIACgKIADgKIAAguQgYCfg2CLQhZDghkC2Qg7BugnBmQhUDZgxDfQgxDdgMDmQgLDogUECQgUDxAFD1QAEDPgGDLQgFDbgoDcQgsDwg9DSQhEDxhADHQhADLg0DgQgwDUg0EFQg0ENgRDWQgTDuA0DoQAOA7ACBBQAAAagDARIgEAKIgGAIIgIAGIgIADIgKABQgFAAgEgBgEAJKgxkIABgDIAJgRIAEgNIAAgCIgCgDIgHgPg");
	this.shape.setTransform(0.4649,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-341.2,135.7,682.5);


(lib.PuppetShape_2copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJ1A1YQgEAAgFgCQgFgCgEgDIgHgGIgEgJIgCgJIgBgHIABgGIACgHIAUg1IAEgLQAKh1AkiCQAdhqAziBQA3iLAXhJQAmh3ANhmQANhmgHiFQgEhWgRiYIgajtQgOiGgFhpIgMjqQgHiJgBhjQgBiMAIhkQAKiDAahtQAWhXAoiUQAtinARhCQAZhgAmiKIBAjqQAxi2BgkVQBWj1A2jQQAahgAniDIBDjeQAchcAeh/IA0jfIAzjgQAeh/AchhQAchlAAiAQgBhHgPigQgDglgFhOQgIhDgVgrQgCgDABgGQAAgCACgHQABgEAEgCQAEgFADAAQADgCAFAAQAFAAADACIAJAGQAEAEACAEIATAwIABgBIAFgGQAEgEADAAQAFgDADAAIAIAAQAEAAAEACQADABAEADIAIAIIAMAQIAEAJIAFAIIAEAIIAKAMIAGAEIAIAFIAQANIAFAHIAHAQQAEAHAAAEIACAIIABAXQAAALAHAQQAIASABAIIgBAMIgBALIgCALIgGAVQgFAJABADQALAjADBAQABAqAAAjIgBBTQAAAhgGAgQgDAPgLAsQgKAngEAbIgJBfIgCALQgSDdhEDVQgRA2gKA9QgiDThEDcIhWEfQgUBEgRBMQgyDmheEVQhqE6g7DAQgbBYg5CtQgwCagbBsQgzDLgXDTQgJBUgBBnQAABKAFB1QAIDAAlD1QAVCIAJBcQANB+AABoQAACagFBXQgICGgYBsQgwDPgwCdIgdBhQgsCNgZCQQgIAugLAeQgBACgEADIgHAEQgEACgDAAIgHAAIgHgCIgGgEQgDgCgCgDIgDgGIgEgRQAPjoBfjzQAhhUAVhYQAfiGAPhTQAVh3AFhlQAKiwgcjmIgejqQgUiUgKhWQgQiFgGhkQgHh9AFhuQAOkMA7jiQAThJAdhkQAYhXAwiXQA1imAVhFQAwimBfkkQBTj/AxjIQAHgcAGgmQBFjPAfiOQAXhrAximQAviZAViBQAbiaAoiEQAahUAFhfQAHh9Aeh9IACgKIABgGIABgHIAFheIACgMQAAgNgDgbIgCgfIgDgWIgGgVIgLgfIgEgNIABAqQAGBsgEAuQgTD/g4C4QgnB9gVBlQg9EPg2CxIhEDeQgoCDgZBdQg+DnhYD3QhZD+g5DaIhsGRIg6DWQgkCDgVBSQgaBogMB3QgLBigCCAQgDBkAFCCIALDmQAFBhAMB9IAYDeQARCgAGBUQAKCHgEByQgDB2giCEQgaBpgzCCQgyCCgcBcQglB6gOBqQgIA5gXA/QgGATgMAUQgCAEgFADIgIAGIgKACIgEABIgFgBgEAIzgwZIAFgLIAKgdQACgEgBgCIABgGQABgEgBgCIgEgEQgDgDABgCQABgDgEgIIgEgHQgEAiAAAzgEAIogyUIAKAWIAAgCIAAgKIADgJIAAgEIgBgJIgBgCIgEgCIgLgFQgEgCgBgCQADAKAGAPg");
	this.shape.setTransform(4.7813,-0.425);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("EgJ7A1WQgGgCgCgCIgIgHIgFgIIgCgJIgBgIIABgFIAUg9IADgLQAMjZBlkLQA2iRAWhFQAmh4AOhkQAOhngFiDQgDhagOiVIgWjtQgLiGgDhpIgHjpQgDiIABhkQACiKAJhkQALiDAahsQAShLAqigQAniXAThSQANg0BqmhQAwi+BZkOQBSj3A0jOQAmicBYklQAbhbAgiBIA2jgIA3jeQAgh/AdhgQAehlACh/QABhSgMiVIgIh0QgHhDgVgrQgBgDABgGQAAgDACgFIAFgIIAHgEIAJgCQAEABAEACQAEABAEAEIAGAIIASAxIABgCIAFgFIAHgEQAFgCADgBIAIAAIAIACQADABAEAEIAIAIIAiA2IAGADIAIAGQAFACADAEIAHAHIAFAHIALAbIABAJIABAWQAAAMAGAQQAIASAAAHIAAANIgBALIgCAKIgDALIgDALQgFAIABAEQAMAmABA8QABAmgBAnIgDBTQAAAggHAhQgFAagKAgQgLAqgEAZIgDAdIgJBMQgVDahIDWQgSA2gKA9QglDWhADYQgNAohFD3QgTBAgQBPQgwDuhWEOQhqFNgyCuQgaBZg1CuQgvCbgZBrQgxDMgbDRQgLBTgDBoQgCBJACB1QAEDBAgD0QASCEAIBgQAKB8gBBqQgDCZgGBXQgJCFgYBsQgsDNguCfIgaBiQgoCIgVCVQgIAwgJAcQgBADgEADQgCACgEABQgEACgEAAIgHAAIgHgCIgGgCIgFgGIgDgFIgCgHIgCgKQAIjpBZj0QAehVAUhXQAeiLAOhPQAVh3AHhkQAMiygYjkQgGhCgUioQgRiVgIhVQgNiGgEhjQgEh9AIhuQATj+A7jtIAuitQAWhRAvicQAwidAVhPQAliGBilGQBQkFArjCQAHgcAFgnQBCjNAdiRQAXhzAvidQAviaAXiAQAciZAriEQAbhUAHheQAJh8Afh9IADgJIABgHIABgIIAJhpIgCgoIgCgfIgDgWIgFgUIgKghIgFgOIABArQAEBqgEAxQgZECg6CzQgqCDgWBdQhCEYgyCoQheE4giCGQg4DdhXECQhUD6g2DfIhlGRIg3DXQglCMgRBIQgtC6gLEHQgEBlACCBIAGDlQAECXAcElQAPCiAEBSQAICHgGBwQgFB1giCFQgaBmgxCEQgvCAgaBfQgiB5gLBrQgFA3gVBCQgGATgLAVQgCAEgFADQgEAFgEABQgEACgFABIgKABIgJgDgEAIzgwWIABgDQABgEADgFIALgjIAAgLIgEgFQgDgDABgCQACgEgEgHIgEgHQgEAhAAA1gEAIpgyTIAKAZIgBgEIABgJIACgKIABgEIgBgJIgBgCIgEgCIgLgGIgEgEQACALAGAOg");
	this.shape_1.setTransform(4.5625,-0.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("EgJ4A1WIgJgEIgHgGIgGgIIgCgJIgBgHIAAgGIABgHIAUhCQAFjhBekGQA3iZATg9QAmh5APhkQAPhmgCiDQgChXgMiXQgNidgFhQQgIiEgBhrIgCjoQAAiIADhjQAFiIAKhmQANiBAahtIA6jqQAjiPAVhaQAVheBYl4QAwjLBSkCQBOj3AwjQQApiqBRkYQAZhWAiiGIA4jfIA8jeQAhh8AfhhQAghmAEh+QADhXgKiQIgIhzQgGhEgUgsQgBgCABgGQAAgDACgGQACgDADgEIAIgEQAEgCAEABQAFAAADABIAIAGIAGAJIARAxIABgCIAGgFIAHgEIAIgDIAIABIAIACQAEABACAEQAGAEADADIAYAqIAJANIAFAEIAIAFIAQAOIAEAIIAKAbIABAIIAAAXQAAAMAGAPQAHARABAJIgCAXIgCALIgGAVIgCAGQgCADABACQALAmABA9QAAAmgCAoIgEBSQgBAggHAhQgEATgLAnQgNArgEAXIgOBpQgYDYhMDWQgUA8gJA2QgmDVg/DYQgVBHg6DYQgRBGgPBJQgqDthRERQhgFBgzC8IhLEGQgsCegYBpQgyDagcDCQgNBUgFBnQgFBMAABxQAADBAbD1QAPCFAHBeQAHB9gDBpQgECWgHBZQgLCEgXBsQgwDdgkCPIgZBhQgkCMgRCTQgFAtgIAfQgBADgFADIgGAEIgHACIgHAAIgHgBIgHgDIgEgFIgEgGIgEgRQAAjsBTjyQAehbARhSQAdiQANhJQAVh5AIhjQAPiwgTjmIgXjpQgNiQgHhaQgVkSATjCQAYj5A8jvIAsitQAThKAvijQAsiYAUhUQArilBTkoQBIj8AqjMQAFgWAGgtQA+jQAbiOQAYh2AuibQAuiaAZiAQAdiWAuiGQAchTAJheQAKh8Ajh9IAEgQIABgHIAJhdIABgMIgChHIgCgWIgGgVIgJggIgFgOIABArQACBngGAzQgbD+g/C2QgsCAgXBfQhFEXgxCnQhVEjgmCcQg2DhhRD+QhPD6gzDhIhdGSQgiCQhHEcQgsC5gQEHQgHBkAACBIABDlQABCfAVEcQAMClAEBOQAFCHgHBxQgHBzgiCEQgZBjgxCHQgrB8gZBkQgdB4gIBtQgEA7gTA+QgGAXgJARQgBADgFAFIgIAGIgJAEIgKAAIgJgCgEAIygwVIAJgXQADgGABgFIACgMIABgLIgDgFQgEgDACgCQABgEgEgHIgDgHQgEAhgBA0gEAIpgyRIAJAYIgBgEIABgJIAEgKIgBgMIAAgDIgFgBIgKgGIgEgFQACAKAFAQg");
	this.shape_2.setTransform(4.45,-0.3917);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("EgJ2A1XQgGgCgDgCIgHgGIgFgIIgDgIIgCgIIAAgGIAFgRIAFgWIAJgiQgDjqBZkAQA6isAOgrQAlh6AQhjQAQhlAAiEQAAhZgKiVQgKiXgDhVQgGiEAChrIAEjoQADiHAFhjQAPkdAsi9IA4jpQAgiHAThjIBmnWQAtjQBMj+QBMj+AsjKQApi7BMkIQAXhPAkiNQAoiaAThFIA/jdQAjh6AghjQAihlAIh9QAEhcgJiMIgGhzQgGhDgSgtQgBgCABgGQgBgDADgGQACgEADgCIAIgFIAIgBIAIACQAFADADADQAEAFACAEIARAxIAAgCIAGgFIAHgEIAIgCIAIAAIAIACIAHAFIAIAIIALARIADAJIAFAIIADAIIAJANIAGAFIAJAFIANAOIAFAIIAKAbIABAJIgBAWQgBAOAGAOQAHAUAAAFIgBAYIgEAUIgEALQgEAIABADQAKAoABA7QgBAzgCAbIgGBSQgCAkgHAdQgGAYgLAiQgMAlgFAcIgEAdIgDAgIgJAsQgcDWhODWQgTA3gMA6QgpDYg8DUQgaBbgwDEQgPA8gOBUQgoDzhLELQhZFEgvC7IhGEGQgrCfgWBpQgwDWghDGQgYCNgHDqQgFDDAWDyQAMCGAFBeQAGB8gFBpQgHCXgIBXQgNCEgVBsQgpDJgmCiIgWBiQghCLgLCUQgFAwgHAcQAAADgEADQgCACgFACQgEADgDAAIgHAAIgHgBIgGgDIgGgFIgDgFIgGgRQgGjsBMj0QAdhbAPhSQAeiaALhAQAVh5AKhiQAQisgPjpQgYk4gJicQgPkLAYjIQAdjtA7j4IAritQAPg8AwiyQAniTAVhZQAeiABWlOQBDj9AmjMQAGggAEgkQA6jPAbiQQAVh5AuiYQAvicAah+QAeiTAxiHQAehSAKheQAMh6Alh+IADgJIABgHIACgHIAKhdIACgMIgBhHIgCgVQgBgIgEgOIgJggIgEgPIAAAsQAABlgHA1QghD/hBCzQgpBzgdBrIg6DfQgjCAgbBdQhPEVgmCqQgyDghOEBQhMD8guDfIhXGTQgSBbgeB8IgzDWQgsC7gUEFQgIBkgECAIgEDlQgCCYAPEiQAJCkACBPQAECHgIBwQgJBxgiCFQgYBfgwCLQhYEAgGDGQgCA3gRBDQgGAYgHAQIgHAIQgFAGgDABIgJAEIgJAAgEAIygwUIABgCIAIgUIAGgXIAAgLIgEgFQgCgCABgDQABgDgBgDIgCgFIgEgHQgDAfgBA1gEAIqgyQIAJAaIgBgFIADgTIABgEIgBgJIAAgCIgOgIIgEgEQACAKAFAPg");
	this.shape_3.setTransform(4.3,-0.375);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("EgJyA1XQgGgCgDgCIgIgFIgGgIIgDgJIgBgHIgBgGIABgIIANg3IADgLQgKjuBSj+IBGjZQAlh7AQhhQARhmACiDQABhZgHiVQgOkqAHiwIAJjoQAGiFAHhkQAVkdAsi6IA2jqQAdiCAThnIBdnXQArjaBHj2QBHkCApjGQAojEBIkAIA7jdQAliLAYhTQBQkTA5ilQAkhmAKh8QAHhfgGiJIgGhzQgFhDgRgtQgBgDACgGQgBgDADgFQABgEAEgDIAHgEQACgBAHAAQAGABACABQAGAEACACIAFAJIAQAxIAHgGIAHgEIAIgCIAIABIAIACIAHAFIAHAIIAFAJIAGAIIALAaIAJANIAFAEIAIAGQAGAEACADIAGAHIAEAIIAJAcIAAAJIAAAJIgBANQAAAMAFAPQAGATABAHIgCAXIgCALIgFAUQgEAIABAEQAKAngBA7QgBAtgDAhIgHBSQgDAigIAfQgFAUgNAlQgNAqgFAXIgFAdIgKBBIgDAKQgfDVhRDWQgUA1gMA7QgnDKg9DhQgcBpgrC2QgPBCgMBOQgkD0hEEMQhSE9gtDCQgNA9g0DLQgpCjgVBkQg0D6gfCjQgaCRgMDlQgKDFARDvQAJCIADBcQADB9gHBnQgKCcgIBSQgNCEgVBqIhdHOQgcCKgICVQgDAxgGAcQgBADgEADIgGAEQgCACgFABIgHABIgHgBIgGgDIgGgFIgDgFIgDgGIgDgKQgPjuBHj0QAahbAPhSIAnjbQAVh7AKhgQATitgLjoQgSk4gFicQgHkMAbjGQAijpA8j6IAoisIA7juQAliQAUhcQAah/BRlQQBAkJAgjCQAFgcADgnQA2jOAZiSQAWh8AtiVQAuiZAciBQAfiPAziKQAghTALhdQAQh/Amh3IAEgQIACgHIACgXIACgTIAIgzIACgMIAAhHQAAgHgCgOIgEgWIgIggIgFgRIAAAtQgBBjgIA3QglD7hFC1QgtB4gcBlQhQEogqCUQhKEHgmC4QgvDehKEDQhFD0grDpIhPGTQgbCLhEEjQgrC9gZEDQgKBkgHB/IgKDkQgGClAKEUQAGCsABBHQABCHgKBvQgJBwgiCFQgXBagvCQQhSD4gBDQQAAA1gOBFQgEATgJAWQgCAEgEAEQgDAEgFADIgJAEIgJABIgBAAIgIgBgEAIxgwQIACgFIADgIIAHgWIADgLIAAgMIgDgFQgDgCABgDQABgCgDgJIgDgHQgDAdgCA5gEAIrgyOIAGAXIABgCIABgKIADgJIABgEIgBgJIAAgCIgEgCIgKgHQgDgCgBgCIAHAag");
	this.shape_4.setTransform(4.125,-0.3437);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("EgJwA1XQgFgBgEgCIgIgGIgGgHIgDgJIgCgHIAAgOIAJgrIADgMIACgLQgSjzBMj8QAviRAVhIQAlh9ARhgQAShmADiDQAChWgEiXQgIkhAMi5IAPjnQAJiFAJhkQAZkXAsi+QBDkeAfi1QAaicA6k8QAnjdBCjzQBCkAAnjKQAmjFBFj/IA8jdQAjiEAchaQBQkIBAivQAmhmANh7QAJhigFiGIgDhzQgGhDgPgtIABgJQAAgDACgFQABgEAEgDIAHgEIAJgBIAIADIAIAGIAGAJIAOAxIABgBIAGgFQAFgDACgBIAIgCIAJABQAFABACACIAHAFIAHAIIAPAaIADAJIAIAPIAEAGIAVASIAFAIIAFAIIAHAcIAAASIgCANQAAAKAFARQAFARABAIIgCAXIgCALIgBAKIgEALQgEAHABAEQAKAqgCA5QgCArgEAjIgIBRQgDAhgJAgIgTA5QgNAngGAZIgFAdIgMBAIgDALQghDQhVDYQgXA6gKA2QgqDVg6DVQghCAgjCfQgOBFgKBLQgfD1g/EMQhLE9gqDEQgQBNgsC7QgnCogUBgIhTGcQgdCMgSDqQgPDEALDwQAHCHABBcQAAB9gIBoQgOCjgIBKQgPCEgTBpQgqDXgcCUIgQBiQgYCKgDCWQgBAugGAfQAAADgEADQgBACgFADIgHADIgHABIgHgBIgHgCIgFgFIgEgFIgHgQQgWjxBAjyQAYhWAOhYIAmjbQAWh/AKhcQAWitgGjoIgIjpQgEiNgBheQgBkFAhjMQAjjbA9kGIAnisIA4jtQAgiNAUhgQAbiLBHlGQA4kAAfjLQAEgmACgeQAxjIAaiYQAVh9AsiVQAtiUAeiFQAgiOA3iKQAhhTAMhcQARh6Aph8IAHgWIAFgqIADgVIADgSIACgMIADgMIABgoIAAgfIgBgVIgEgWIgHggIgFgSIgBAuQgCBhgKA4QgqD8hHCzQgtBxgfBrQgeBjhdFYQhHEDglC8QgtDhhFEBQg/DwgoDtIhIGVQgZCNhAEhQgrC6geEGQgLBjgKB/IgPDkQgLCrAEENQADC4gBA6QAACIgLBtQgLBvgiCGQgVBTgvCXQhND2AHDTQABA4gNBDQgDAVgJAUQgBAEgEAEQgEAFgDACQgGAEgDAAQgEACgFAAIgDAAIgHgBgEAIwgwOIACgFIAHgTIADgLQADgJAAgCIAAgMQAAgBgEgEQgBgDAAgCQABgCgDgJIgDgHQgCAbgDA7gEAIrgyNIAHAaIgBgEIAGgTIAAgEIAAgJIAAgCIgFgCIgJgHIgEgFQACAKAEAQg");
	this.shape_5.setTransform(4,-0.3271);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("EgJuA1XIgJgDIgIgFIgGgHIgDgJIgCgIIgBgFIABgIIALhDQgZj3BHj5QAsiSAUhJQAliAARheQAShlAGiDQADhXgBiWQgDkZASjBIAUjlQANiHALhiQAfkcAqi3QBAkUAdi+IBMnYQAijXA+j7QBAkJAijCQAmjRBBj0IA8jeQAjh/AehfQBRj/BGi1QAohnAPh5QAMhmgDiDIgDhzQgEhDgOgtQgBgDACgGQAAgEACgEQADgFADgCIAHgEIAJAAQAGAAACACQAFADACAEIAGAIIANAyIABgBIAGgFIAIgEQAEgBAEAAIAQADIAGAGIAHAIIAFAJIAFAJIALAaIAIANIAFAFIAIAGQAFAEACADIAGAIIADAIIAHAcIAAAJIgCAWQgBAMAFAPIAGAZIgCAYIgCAKIgCAKIgEALQgDAHAAAEQAKAugDA1QgDAsgEAhIgKBSQgEAigJAeQgEAPgQAqQgOAngHAZIgFAdIgNBAIgDAKQglDQhXDWQgWA3gMA6QgrDPg5DaQghCBgfCdQgOBEgIBNQgbD0g5ENQhFFDglC/QgRBWgmCzQgnCtgRBcQgnDFguDXQgfCNgYDnQgUDJAGDrQAGEWgRCxQgSC0gHA4QgPCFgUBoQgmDKgZChIgNBjQgVCNACCTQAAAxgEAcIgFAGQgBADgEACQgEADgDAAIgHABIgHgBIgHgBIgGgFIgEgFIgHgQQgdjwA5jzQAXhfAMhQIAkjbQAWiGALhWQAXitgBjoIgBjpQgBiLAChgQAFkGAljIQAnjVA9kKIAmitIA0juQAdiIAShkQAbicA9k2QA0kGAajGQAEgjACghQAvjTAWiOQAWiFAqiNQAtiVAgiFQAiiOA4iJQAhhRAPhdQASh4Ash8IAEgJIABgHIACgHIAQhcIACgMQACgSAAgXIABgeIAAgWIgEgVQgCgNgFgUIgEgSIgCAvQgEBegLA6QgvD7hKCyQgvBxggBqQgvCbhOEfQhED+giDBQgoDbhCEJQg7DwgkDuQgVCOgrEHQgcCqg5EFQgpC3gjEJQgUCPgbE1QgRC8gBD8QAAC5gCA5QgDCHgMBtQgMBughCGQgTBKgvCgQhHDyAMDYQADA1gKBHQgEAVgGAUIgGAIQgEAGgDABIgJAFIgJACIgDAAIgHgBgEAIvgwKIACgHIAEgIIADgLIADgLIADgLIgBgMIgCgFQgCgCAAgDQABgDgDgIIgCgIQgDAWgDBDgEAIsgyMIAGAZIAAgDIABgJIAEgJIAAgFIAAgJIAAgBQAAgBgBAAQAAgBAAAAQgBAAAAAAQgBgBgBAAIgJgHIgEgFIAGAag");
	this.shape_6.setTransform(3.875,-0.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("EgJqA1XIgKgDIgIgFIgGgHIgGgQIgBgFIABgIIAGgsIACgMIABgLQggj6BBj4IA+jdQAkiCARhcQAThlAHiDQAFhUACiZQADkUAXjFIA2nMQAokpAmipQA8kFAdjNIBDnZQAfjhA4jyQA7kIAgjEQAjjUBAjyIA8jeQAih8AhhiQBNjrBQjHQAqhnASh5QAPhogBh/QgBhjgBgQQgDhDgNgvQAAgDABgGQAAgDADgFIAFgGIAIgEQAEgBAFABQAEAAADACQAGAEACADQAEAEABAFIAHAZIAGAZIABgBIAGgFIAHgEIAIgBIAJABIAHADIAHAFIAHAJIAEAJQAEAFABAEIAKAaIAIANIAFAGIAIAGIAGAIIAGAHIAGARIADAUIAAAJIgDAWQgBANAEANQAFASABAIIgCAXIgCALIgGAUQgDAIAAADQAJAugEA1QgEAygEAcIgLBRQgFAhgKAfQgGAVgPAjQgQAtgGATIgGAdIgBAJIgCAMIgLAqIgDALQgpDPhZDVQgXA1gMA6QgvDbg0DOQggB9gdChQgMBBgIBQQgXD6gzEIQhCFegdCmQgRBigiCnQgnC+gOBLQgjC/gyDeQghCPgdDkQgYDGgBDuQgBEZgVCtIgbDrQgRCIgSBlQgnDRgTCaIgLBiQgQCMAGCVQACAtgEAgQgBADgEADQgBADgEACQgDADgEABIgHABIgHAAIgHgCIgFgFIgFgFIgHgPQgljyAzjyQAUhbAMhVQAKhKAYiRQAYiSAKhKQAZiyAEjjIAEjpQADiJAEhiQAMj/ApjOQAjiuBEkwQARhOAThdIAxjuQAbiGAPhoQAbisA0knQAvkEAWjJQAEghAAgiQAqjKAXiYQAViHAqiMQAvifAfh6QAiiMA7iKQAjhTAQhbQAWh7Ath4IAIgWIARhcIADgMIAEhcIgNhKIgDAvQgGBdgNA8QgyD3hOCzQgwBwgiBqQg4CyhGEHQhAD0giDMQgkDcg+EIQg3DygfDtQgNBrgsErQgaC1g2D7QgoCygoENQgVCPgkE1QgVC7gHD7QgEC8gDA2QgFCHgNBsQgNBsghCHQgOA6gxCyQhBDwARDbQAFA5gJBCQgCAWgHAUIgFAIIgHAIIgJAEIgJACIgCABIgHgBgEAIvgwIIACgHIADgIIAHgWIACgLIAAgMIgDgFQgBgDAAgCQABgDgDgJIgCgHIgGBZgEAIygxzIAAgBIACgKIAEgJIABgNIgBgCIgDgCIgJgIIgEgFIAKAyg");
	this.shape_7.setTransform(3.6972,-0.2917);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("EgJlA1XIgJgDIgIgEQgFgEgCgDIgEgJIgCgHIgBgGIAIhLQglj7A7j4QAIgkAyi6QAjiHARhYQAThmAJiDQAGhUAFiZQAIkJAejOIBBnKQAukyAkieQA5j5AbjZIA6naQAbjgA0j0QA3kHAdjGQAgjVA+jxQBIkYA4ilQBQjtBUjEQBRjAADkGIAAhzQgChCgLgwQgBgDACgGIADgIIAGgGIAHgEQAEgBAFABIAIADIAHAHQAEAEABAFIALAzIABgCIAHgEIAHgEIAIgBQAFAAADACQAGABACABIAGAGIAHAJIAMAbIADAJIADAIIAIAOIAMAMIAMAQIADAIIAFAdIgBAIIgDAWQgCAMAEAPQAEAQABAJIgCAXIgIAfQgDAIAAADQAIAsgFA3QgDAogGAmIgOBRQgGAjgJAcIgWA4QgPAigJAdIgGAdIgPA/IgEALQgtDPhbDSQgVAzgOA8Qg0DtguC8QgfB+gbCgQgMBGgFBKQgTD6gtEJQgzEqgiDbQgQBqgdChIgyEJQglDMgyDRQghCNgjDmQgeDGgHDsQgIEUgYCxIgeDrQgTCNgQBfQgkDLgQCgIgJBjQgMCNAKCUQADArgDAiQAAADgEAEQgBACgFADQgCADgEAAIgHACIgHAAIgHgCIgGgEIgEgFIgEgGIgEgKQgsjxAujyQARhgALhSQALhXAViFIAijbQAbiwAKjlQAPlgAIh0QARj5AujTIBqnbQARhOASheQAeiZAPhVQAXiDAOhrQARh6A0laQAoj6AUjUQACgeABglQAljCAYihQATiHAqiMQAuicAgh9QAkiPA8iGQAkhQAShdQAYh6Awh4IAIgXIAThbIADgMIAGhHIAAgVIgCgWIgFghIgEgVIgEAxQgIBbgOA+Qg4D1hQCyQgzBzghBmQhCDHg9DyQg+DzgfDNQggDUg6ERQgzD2gZDrQgPCIgjEOQgYC8g0D1QghCYgyEmQgYCNgrE2QgcDBgMD0IgMDxQgICHgNBrQgOBqggCJIg7DsQg9DxAYDbQAFA7gHBBQgCAXgGATIgFAJQgFAGgCABIgIAFIgJACIgDAAIgHAAgEAIwgwEIABgBIACgIIADgIIAEgLIACgKIADgLIAAgMIgCgFQgCgEAAgCIgBgLIgDgIIgHBbgEAI2gxtIgBgFIAGgTIABgEIABgJIgBgCIgDgCIgIgIIgEgFIAJA2g");
	this.shape_8.setTransform(3.237,-0.2667);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("EgJfA1WQgFAAgEgCIgJgEIgGgHIgHgQIgBgFIAAgIIAGhEQgrj7A2j5QANg+ApiiQAjiMAPhUQAUhlALiEQAHhRAJicQAPkHAijPIBMnIQA0k5AiiWQA4j2AYjbIAxnaQAXjjAvjyQAxj9AcjRQAejdA7jrQBEkMA+ixQBOjgBdjQQBWjEAIkAQAChXAAgcQgBhCgKgxQgBgCACgGIADgIIAGgGQAEgDAEgBQAEgBAEABQAGABACACIAHAHIAFAJIAKAzIABgBIAHgEIAHgEIAIgBIAIACQAEABAEACIAGAGIAHAJIALAbIADAJIADAJIAHAOIAFAFIAHAHIALAQIADAJIAEAdIgBAIIgEAWQgCAKADAQQAEAOAAAMIgCAXIgCAKIgFAVQgEAHABADQAIAwgHAzQgDAngIAnIgPBQQgHAkgKAbIgXA4QgQAigIAdIgIAcIgQA/IgDAKQgxDOhdDSQgYA4gMA3QgxDfgwDJQgeB8gaCiQgLBLgDBFQgOD1goEPQgpERghD1QgOBsgcCfIgtEKQglDTgyDKQgmCZglDaQgjDJgNDoQgQEWgbCvQgLBGgXCkQgVCXgOBUQgiDMgMCgIgGBjQgJCOAPCTQAEAugCAfQAAACgEAEIgFAGIgHAEIgHABIgHAAIgHgCIgGgDIgEgFIgIgQQgzjwAnjzQAOhVALhdQAKhfAUh+IAjjcQAdi0APjhQAalyAJhhQAZj6AxjQQBBkSArjJQAQhOARhdQA2kqAVizQASipApkrQAjj/AQjRQACgeAAglQAijFAWifQATiHApiMQAriQAkiJQAliNA+iIQAmhQAThcQAZh5Azh4IAJgWIAUhbIAEgMIAEgnIADgfIABgVIgBgWIgFghIgDgWIgFAyQgKBYgQA/Qg+D2hSCwQg1BzgiBlQhEDKg7DuQg7DugeDTQgeDag0ELQgtD0gWDuQgMCJgeEOQgXDIgxDpQgdCHg5E4QgWByg3FPQggC9gTD3IgRDwQgLCJgOBpQgOBogfCKIg4DtQg3DtAcDhQAHA6gFBBQgCAWgGAVQgBAEgDAFIgHAHIgIAFIgKADIgCAAIgHgBgEAIygwAIABgEIADgIIADgHIADgLIADgLIACgLIAAgLIgCgGQgBgDAAgCIgBgMIgCgIIAAgCIgJBggEAI5gxsIAAgFIADgJIAEgJIABgNIAAgCIgDgDIgIgIIgDgFIAAAAIAAAAIAGA2g");
	this.shape_9.setTransform(2.742,-0.2417);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("EgJjA1VIgJgFIgHgGIgEgJIgDgHIgBgGIAEhAIABgLQgxj9Awj4QAOhNAjiVQAjiWAPhLQAThlAOiEQAHhIANilQAVkBApjUIBWnGIArjmQAZiFAWhiQA2juAVjkIAqnaQASjkArjyQAsj/AZjQQAajYA7jxQBAkEBDi6QBNjXBkjXQBcjGAMj9QAEhLAAgoQAAhBgIgyQAAgCABgGIAEgIIAGgGQAGgDACAAQAEgBAEABIAIADQAEADADAEQADAGABAEIAJAzIABgCIAHgEIAHgDIAJgBIAIACIAIADIAFAGIAHAJIAIATIADAJIAFASIAGAOIAFAGIAHAHIAGAIIAFAIIACAJIADAdIgBAIIgCAJIgDANQgDALAEAPQADAPAAALIgCAWIgEAVIgEAKQgDAHABAEQAGAwgHAzQgGAxgHAcIgQBQQgIAjgKAcQgGAPgTAoQgQAjgKAbIgHAdIgRA+IgEALQg1DNheDRQgYA2gMA4Qg7EBgnCmQggCKgUCVQgJBFgDBLQgKD3giENQgmEsgZDcQgNBygYCZIgrELQghDPg1DPQgjCHgvDrQgpDLgTDlQgYEYgeCrQgRBbgUCPIgjDrQgfDFgICnIgEBjQgFCMATCVQAFAtgBAgQgBADgDAEIgFAFIgHAEIgHACIgHAAIgHgBIgGgEIgEgFIgEgGIgFgJQg4jwAgj0QANhfAIhUQAQioAvkSQAeiuAWjnQAhlUAPh+QAej1A2jTQA/j1AvjkQARhSAPhaQAwkTASjKQAUjUAekCQAekAALjPQACgXAAgtQAhjZASiLQASiKApiKQAuieAih8QAliKBBiJQAnhUAUhYQAbh4A2h3IAJgWIAXhbIADgMIAJhGIABgrIgHg3IACgLIADgIIADgHIADgLIACgKIADgLIAAgMIgCgFQgBgEAAgCIgBgMIgCgHIgQCVQgLBXgSBBQhBDuhWC1Qg1BuglBpQhIDOg4DqQg7DzgZDOQgaDSgwEUQgqD3gQDrQgMCegYD6QgUDQgwDjQgfCWg6EpQgeCVg4EqQgoDLgWDnIgXDwQgOCLgOBmQgPBkgeCOIg0DuQgxDuAhDhQAIA6gEBBQgBAYgFATQgCAFgDAEIgGAIIgIAFQgDABgHABIgJABgEAI8gxqIAAgFIAHgSIABgEIABgJIAAgCIgDgDIgHgIQgDgDgBgCIAFA2g");
	this.shape_10.setTransform(2.3124,-0.225);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("EgJfA1UIgIgEIgHgGIgFgJIgEgMIAAgIIABgKQAAgMABgLIABgYIABgLQg2j9Aqj5QAOhXAfiMQAlitALg2QAThkAQiFQAHg8ATixQAbkAAvjTQAwjcAvjpQA8kyAiiaQA1jsASjlQAUkOANjNQAOjmAmjxQApkDAVjNQAYjhA5jpQA8j6BJjEQBQjbBmjRQBijIARj6QAFhLABgoQABhBgGgyQAAgDABgFQABgEADgEQACgDAEgDIAIgDIAJAAQAFABACADQAFADACAEIAEAJIAIA0IABgCIAHgEQAFgCACAAIAJgBIAIACIAHADIAGAHIAGAJIAHATIADAJIAIAZIADAHIAFAGIAGAHIAKARIACAJIACAdIgBAIIgGAVQgDANADAOQADANAAAMIgCAXIgCAKIgDAKIgDAKQgDAHAAAEQAFAxgHAyQgIAxgHAcIgSBQQgHAggMAeIgaA3QgRAjgKAaIgIAdIgFAUIgNAqIgFAKQg3DMhgDQQgYA1gNA5QghCMhAEbQgeCHgTCYQgJBKgBBGQgFD+gdEGQghEvgUDaQgLB3gVCVQgLBUgdC3QgeDQg3DPQgjCCg2DwQgtDOgZDhQgfERgkCxQgUBkgUCFIgiDrQgeDLgDCiIgBBjQgCCOAWCTQAHArgBAiQAAACgDAEIgFAGQgCACgFACIgGACIgIAAIgGgBIgHgEIgEgEIgJgPQg/jxAbjyQAJhSAIhiQAOi8AvkAQAgiyAcjjQAolFAViMQAkjxA6jWQA+jlAxjzQAQhOAPheQApkDAQjaQALikAekzQAYj/AIjRQABgXgBgsQAhj0AOhyQASiKAoiKQAtiZAjiBQAoiPBBiEQAohQAWhbQAfh6A3h0IAJgVIAPg9IADgKIAHgUIAEgLIAKhGIACgWIAAgWIgFg3QAAgFACgGIACgHIADgIIADgKIADgLIACgLIAAgLIgCgLIgBgMIgCgHQgLBjgHAyQgNBUgUBCQhEDqhaC3Qg4BwgkBmQhJDLg4DtQg4DrgYDWQgXDXgqEQQglD4gNDrQgJCwgTDpQgRDRgvDiQhJFqgTBVIhgG/QgrDHgdDpIgdDvQgRCOgPBjQgPBfgdCTIgwDuQgsDsAmDkQAJA4gCBEQgBAYgFATQgBAFgDAEQgDAEgEAEIgIAFIgJADIgJAAIgKgCgEAI/gxpIAAgEIAHgTIABgEIACgIIAAgDIgDgDIgHgIIgDgFIADA2g");
	this.shape_11.setTransform(1.9436,-0.1833);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("EgJaA1UIgJgEIgHgGIgFgIQgCgDgBgFIgBgFIAAgHIAAgKIACg7Qg5j7Ajj8QANheAbiGQAfiYAPhNQAThjATiGIAejtQAij/A0jTQA5jjAxjfQAShPAfiVQAhifAQhIQA0jrAOjmQAOjyALjpQAKjsAhjsQAkkAATjQQAUjiA3jpQA5jyBNjOQBSjaBqjRQBojMAXj0QAPiQgHhWIABgJQABgDADgFQADgDADgBIAIgEIAJABIAHADIAHAJQADAFABAEIAGA0IABgCIAHgEQAFgCACAAIAJAAIAIACIAHADIAGAHIAFAJIAHATIAHAcIAGAOIAEAGIAGAIIAJARIACAJIABAdIgIAdQgEANADANQACAPAAAKIgDAXIgCAKIgJAfQAFAygJAxQgIAsgJAgIgUBQQgIAhgNAdQgJAVgRAhQgUAogIAVIgJAcIgTA+IgFAKQg6DHhhDTQgYAzgOA6QgoCsg3D8QgfCKgPCUQgIBHAABKQgCEEgXEBQgaEtgQDcQgPDRgxFIQggDcg1DEQgkCCg7DvQgzDPgfDeQgnETgnCuQgkCkgpEvQgaDCAACsIACBkQACCQAZCQQAHArAAAiQAAACgDAEQgBADgEADQgCADgEABIgHADIgHAAIgHgBIgGgEIgFgEIgEgGIgFgJQhEjvAUj0QAJhlAEhPQAMjNAvjxQAji2AhjfQArkgAfiwQAqjtA+jXQBBjmAwjzQAPhMAOhfQAlkCALjcQAMjRAUkGQATj5AFjYQAAgegBglIAqlmQAQiMAoiJIBRkaQAniMBEiHQAphSAXhZQAgh4A6h0IAKgVIAfhmIAPhbIAAgVIgCgiIgBgWIACgLIAJgZIACgKIADgLIAAgMIgCgLIgBgMIgBgIIAAgCQgVC5glB1QhMDphaC0Qg1BogpBuQhNDUg1DkQg1DogVDZQgVDbgkEOQghD3gIDsQgIDWgNDDQgODSgtDiQg6EgglCfQhJE3ghCHQgzDRghDdIgiDvQgVCTgPBcQgMBPgfCiQgeCfgNBRQglDvApDjQAKA6gBBCQAAAXgFAUQgBAFgDAEQgDAEgEAEQgEAEgDACIgKACIgJABIgJgCgEAJBgxnIABgFIADgJIAEgJIABgEIACgIIAAgCIgDgEIgGgHIgDgGg");
	this.shape_12.setTransform(1.5842,-0.15);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("EgJWA1UIgJgEIgHgHIgFgIIgDgGIgBgGIgBgIIABhEQg9j8Adj7QAMhmAXiBIAsjlQAThkAWiGIAkjtQAmj3A8jZQA7jYA4joQAXhfAdiFIAxjmQA0jrAKjnQALkBAGjaQAGjuAcjqQAfkHARjLQARjhA1jrQA5j0BPjNQBUjbBujOQBsjNAejyQARiFgEhgIACgIQAAgEAEgFQACgDAEgCIAIgDQAFABAEABQAFABACADQAFAEABAEQADAEABAFIAFAzIABgBIAHgDQAFgCACAAIAJAAIAIADIAHADIAFAGIAGAKIAGATIAGAcIACAHIADAIIAEAGIAGAHIAJASIABASIgBAUIgCAJIgCAIIgEAMQgEANACANQACANgBAMIgIAqIgDALIgDAKQADAzgJAwQgKAwgJAcIgWBPQgJAigNAbIgbA1QgTAkgLAZIgJAcIgQAzIgEAKIgFAKQg+DJhiDQQgZA0gNA6QgqCtg1D6QgdCKgOCVQgGBEABBNQACEBgREDQgUEagMDwQgMDlgsE2QgdDWg4DKQgnCLg+DmQg3DNgmDgQgtEKgsC1QguC9gjEWQgYC+AGCwIAEBjQAFCOAcCTQAJAqAAAjQABACgEAFIgFAFQgBACgFADIgGACIgHAAIgHgBIgHgDIgEgEIgFgGIgFgIQhJjtAOj2QAGhlADhQQAIjWAwjqQAli0AojhQAwkOAnjAQAwjvBAjUQBEjhAvj3QAQhSAMhaQAgj6AIjkQAGjJAQkPQAOj0ABjdQABgcgDgoQASiwAUi3QAPiKAniKIBSkcQAniKBGiHQArhTAYhXQAih4A9hzIAKgWIAdhZIAEgMIAIgnIAGgeIADgVIABgWIgBg4IACgLIADgHIADgHIADgLIACgKIACgLIABgLIgCgLIAAgNIgBgKQgWCygqB6QhPDkhfC4Qg4BrgnBqQhODRg1DnQg1DmgRDcQgTDngeEBQgbDxgFD0QgDDIgLDRQgLDUgsDhQgyEBgwDAQhAD+gzC9Qg3DOgnDgQgcCfg0E9IgrDxQgZCPgNBhQggDuAuDlQAMA9gBBAQAAAYgEATQgBAEgDAFQgDAFgEADQgEAEgDABIgJAEIgKABIgJgCgEAJEgxlIABgFIADgJIAFgJIADgMIAAgDIgDgDIgFgJIgDgFg");
	this.shape_13.setTransform(1.2328,-0.1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("EgJSA1TIgJgDIgHgHIgFgIIgDgHIgCgFIAAhMQhBj4AXkAQAQi5A3kWQAShcAaiPIAqjsQAqjuBDjgQBCjdA6jhQAqiiBAknQAxjmAIjsQAHjqACjxQABjpAZjxQAZj7AOjYQAPjlAzjoQA2jrBTjWQBVjbBzjOQBxjMAkjwQAUiBgBhkIACgJIAFgHIAGgFIAJgDIAIABIAHAEIAGAIQADAGABAEIADA0IABgBIAHgEIAIgCIAIABIAIADIAHAEIAFAGQADAEACAGIAGATIAFAcIAFAPIAEAGIAFAJIAFAJIADAIIABAJIAAAJIgCAUIgCAJIgIAUQgEAKACAPQABAMgBANIgDAXIgMAoQADA0gLAvQgJAogLAjIgYBPQgJAggOAdIgdA0QgVAlgJAXIgKAcIgaBHQhFDRhgDGQgZA1gNA4Qg0DYgqDQQgdCLgLCUQgGBHACBKQAHEBgNEEQgMDkgKEnQgIDwgmEsQgcDUg6DNIhrFxQg9DTgqDYQgyD7gzDCQg3DPgdEDQgUDBAKCvIAGBjQAICPAgCRQAJAsABAhQABADgEAEQgBADgDADIgGAFIgHACIgHABIgHgBIgGgEIgFgEIgFgFIgFgJQhOjsAJj2QADhbABhbQAEjbAxjnQAtjNAojIQA2kGAtjGQA1jnBFjaQBHjhAuj2QAMg/AMhtQAejvADjwQADjIAKkRQAKj6gCjYQAAgbgEgoQARjEARikQANiLAoiKIBSkcQApiMBHiGQAqhQAbhZQAlh6A+hvIAHgPIAEgGIAHgXIAFgSIASgxIAFgLIAVhwIAAg4IADgKIAFgPIAGgUIACgLIAAgLIAAgMIgBgWQgXCogwCDQhTDhhiC3Qg5BrgoBqQhRDSgzDmQgyDigPDgQgPDsgZD+QgYD4ABDtQAADAgIDaQgIDbgrDbQguD1g3DMQhED8g3C+Qg8DMguDfQghClg4E2Qg4EvgUC0QgZDwAxDkQAMA6ABBCQAAAYgDATIgEAKIgGAIIgIAGIgJADIgKABIgJgCgEAJHgxnIAAgCIAJgRIABgEIADgLIgDgDIgFgJIgDgGg");
	this.shape_14.setTransform(0.8591,-0.0312);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-342.1,138.8,683.4000000000001);


(lib.PuppetShape_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJ1A1YQgEAAgFgCQgFgCgEgDIgHgGIgEgJIgCgJIgBgHIABgGIACgHIAUg1IAEgLQAKh1AkiCQAdhqAziBQA3iLAXhJQAmh3ANhmQANhmgHiFQgEhWgRiYIgajtQgOiGgFhpIgMjqQgHiJgBhjQgBiMAIhkQAKiDAahtQAWhXAoiUQAtinARhCQAZhgAmiKIBAjqQAxi2BgkVQBWj1A2jQQAZhgAoiDIBDjeQAchcAeh/IA0jfIA0jgQAeiBAbhfQAchlAAiAQgBhHgPigQgDglgFhOQgIhDgVgrQgCgDABgGQAAgCACgHQABgEAEgCQAEgFADAAQADgCAFAAQAFAAADACIAJAGQAEAEACAEIATAwIABgBIAFgGQAEgEADAAQAFgDADAAIAIAAQAEAAAEACQADABAEADIAIAIIAMAQIAEAJIAFAIIAEAIIAKAMIAGAEIAIAFIAQANIAFAHIAHAQQAEAHAAAEIACAIIABAXQAAALAHAQQAIASABAIIgBAMIgBALIgCALIgGAVQgFAJABADQALAjADBAQABAqAAAjIgBBTQAAAhgGAgQgDAPgLAsQgKAngEAbIgLBqQgSDdhEDVQgSA7gJA4QgiDThEDcIhWEfQgUBEgRBMQgyDmheEVQhqE6g7DAQgbBYg5CtQgwCagbBsQgzDLgXDTQgJBUgBBnQAABIAFB3QAIDBAlD0QAVCIAJBcQANB+AABoQAACagFBXQgICGgYBsQgwDPgwCdIgdBhQgsCNgZCQQgIAugLAeQgBACgEADIgHAEQgEACgDAAIgHAAIgHgCIgGgEQgDgCgCgDIgDgGIgEgRQAPjoBfjzQAhhUAVhYQAfiGAPhTQAVh3AFhlQAKiwgcjmIgejqQgViXgKhTQgPiGgGhjQgHh9AFhuQAOkMA7jiQAThJAdhkQAYhXAwiXQA1imAVhFQAwimBfkkQBTj/AxjIQAHgcAGgnQBFjMAfiQQAXhrAximQAviZAViBQAbicAoiCQAahVAFheQAHh9Aeh9IACgKIABgGIABgHIAFheIACgMQAAgNgDgbIgCgfIgDgWIgGgVIgLgfIgEgNIABAqQAGBsgEAuQgTD/g4C4QgpCHgTBbQg9ESg2CuIhEDeQgoCDgZBdQg+DnhYD3QhbEGg3DSIhsGRIg6DWQgkCDgVBSQgaBogMB3QgLBigCCAQgDBkAFCCIALDmQAFBhAMB9IAYDeQARCgAGBUQAKCHgEByQgDB2giCEQgaBpgzCCQgyCCgcBcQglB6gOBqQgIA5gXA/QgGATgMAUQgCAEgFADIgIAGIgKACIgEABIgFgBgEAIzgwZIAFgLIAKgdQACgEgBgCIABgGQABgEgBgCIgEgEQgDgDABgCQABgDgEgIIgEgHQgEAiAAAzgEAIogyUIAKAWIAAgCIAAgKIADgJIAAgEIgBgJIgBgCIgEgCIgLgFQgEgCgBgCQADAKAGAPg");
	this.shape.setTransform(4.7813,-0.425);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("EgJ7A1WQgGgCgCgCIgIgHIgFgIIgCgJIgBgIIABgFIAUg9IADgLQAMjZBlkLQA2iRAWhFQAmh4AOhkQAOhngFiDQgDhagOiVIgWjtQgLiGgDhpIgHjpQgDiIABhkQACiKAJhkQALiDAahsQAShLAqigQAniXAThSQANg0BqmhQAwi+BZkOQBSj3A0jOQAmicBYklQAbhbAgiBIA2jgIA3jeQAgh/AdhgQAehlACh/QABhSgMiVIgIh0QgHhDgVgrQgBgDABgGQAAgDACgFIAFgIIAHgEIAJgCQAEABAEACQAEABAEAEIAGAIIASAxIABgCIAFgFIAHgEQAFgCADgBIAIAAIAIACQADABAEAEIAIAIIAZApIAJANIAGADIAIAGQAFACADAEIAHAHIAFAHIALAbIABAJIABAWQAAAMAGAQQAIASAAAHIAAANIgBALIgCAKIgDALIgDALQgFAIABAEQAMAmABA8QABAmgBAnIgDBTQAAAggHAhQgFAagKAgQgLAqgEAZIgDAdIgCAgIgHAsQgVDahIDWQgSA2gKA9QglDWhADYQgNAohFD3QgTBAgQBPQgwDuhWEOQhqFNgyCuQgaBZg1CuQgvCbgZBrQgxDMgbDRQgLBTgDBoQgCBJACB1QAEDBAgD0QASCEAIBgQAKB8gBBqQgDCZgGBXQgJCFgYBsQgsDNguCfIgaBiQgoCIgVCVQgIAwgJAcQgBADgEADQgCACgEABQgEACgEAAIgHAAIgHgCIgGgCIgFgGIgDgFIgCgHIgCgKQAIjpBZj0QAehVAUhXQAeiLAOhPQAVh3AHhkQAMiygYjkQgGhCgUioQgRiVgIhVQgNiGgEhjQgEh9AIhuQATj+A7jtIAuitQAWhRAvicQAwidAVhPQAliGBilGQBQkFArjCQAHgcAFgnQBCjNAdiRQAXhzAvidQAviaAXiAQAciZAriEQAbhUAHheQAJh8Afh9IADgJIABgHIABgIIAJhpIgCgoIgCgfIgDgWIgFgUIgKghIgFgOIABArQAEBqgEAxQgZECg6CzQgqCDgWBdQhCEYgyCoQheE4giCGQg4DdhXECQhUD6g2DfIhlGRIg3DXQglCMgRBIQgtC6gLEHQgEBlACCBIAGDlQAECXAcElQAPCiAEBSQAICHgGBwQgFB1giCFQgaBmgxCEQgvCAgaBfQgiB5gLBrQgFA3gVBCQgGATgLAVQgCAEgFADQgEAFgEABQgEACgFABIgKABIgJgDgEAIzgwWIABgDQABgEADgFIALgjIAAgLIgEgFQgDgDABgCQACgEgEgHIgEgHQgEAhAAA1gEAIpgyTIAKAZIgBgEIABgJIACgKIABgEIgBgJIgBgCIgEgCIgLgGIgEgEQACALAGAOg");
	this.shape_1.setTransform(4.5625,-0.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("EgJ4A1WIgJgEIgHgGIgGgIIgCgJIgBgHIAAgGIABgHIAUhCQAFjhBekGQA3iZATg9QAmh5APhkQAPhmgCiDQgChXgMiXQgNidgFhQQgIiEgBhrIgCjoQAAiIADhjQAFiIAKhmQANiBAahtIA6jqQAjiPAVhaQAVheBYl4QAwjLBSkCQBOj3AwjQQApiqBRkYQAZhWAiiGIA4jfIA8jeQAhh8AfhhQAghmAEh+QADhXgKiQIgIhzQgGhEgUgsQgBgCABgGQAAgDACgGQACgDADgEIAIgEQAEgCAEABQAFAAADABIAIAGIAGAJIARAxIABgCIAGgFIAHgEIAIgDIAIABIAIACQAEABACAEQAGAEADADIAYAqIAJANIAFAEIAIAFIAQAOIAEAIIAKAbIABAIIAAAXQAAAMAGAPQAHARABAJIgCAXIgCALIgGAVIgCAGQgCADABACQALAmABA9QAAAmgCAoIgEBSQgBAggHAhQgEATgLAnQgNArgEAXIgOBpQgYDYhMDWQgUA8gJA2QgmDVg/DYQgVBHg6DYQgRBGgPBJQgqDthRERQhgFBgzC8IhLEGQgsCegYBpQgyDagcDCQgNBUgFBnQgFBMAABxQAADBAbD1QAPCFAHBeQAHB9gDBpQgECWgHBZQgLCEgXBsQgwDdgkCPIgZBhQgkCMgRCTQgFAtgIAfQgBADgFADIgGAEIgHACIgHAAIgHgBIgHgDIgEgFIgEgGIgEgRQAAjsBTjyQAehbARhSQAdiQANhJQAVh5AIhjQAPiwgTjmIgXjpQgNiQgHhaQgVkSATjCQAYj5A8jvIAsitQAThKAvijQAsiYAUhUQArilBTkoQBIj8AqjMQAFgWAGgtQA+jQAbiOQAYh2AuibQAuiaAZiAQAdiWAuiGQAchTAJheQAKh8Ajh9IAEgQIABgHIAJhdIABgMIgChHIgCgWIgGgVIgJggIgFgOIABArQACBngGAzQgbD+g/C2QgsCAgXBfQhFEXgxCnQhVEjgmCcQg2DhhRD+QhPD6gzDhIhdGSQgiCQhHEcQgsC5gQEHQgHBkAACBIABDlQABCfAVEcQAMClAEBOQAFCHgHBxQgHBzgiCEQgZBjgxCHQgrB8gZBkQgdB4gIBtQgEA7gTA+QgGAXgJARQgBADgFAFIgIAGIgJAEIgKAAIgJgCgEAIygwVIAJgXQADgGABgFIACgMIABgLIgDgFQgEgDACgCQABgEgEgHIgDgHQgEAhgBA0gEAIpgyRIAJAYIgBgEIABgJIAEgKIgBgMIAAgDIgFgBIgKgGIgEgFQACAKAFAQg");
	this.shape_2.setTransform(4.45,-0.3917);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("EgJ2A1XQgGgCgDgCIgHgGIgFgIIgDgIIgCgIIAAgGIAFgRIAFgWIAJgiQgDjqBZkAQA6isAOgrQAlh6AQhjQAQhlAAiEQAAhZgKiVQgKiXgDhVQgGiEAChrIAEjoQADiHAFhjQAPkdAsi9IA4jpQAgiHAThjIBmnWQAtjQBMj+QBMj+AsjKQApi7BMkIQAXhPAkiNQAoiaAThFIA/jdQAjh6AghjQAihlAIh9QAEhcgJiMIgGhzQgGhDgSgtQgBgCABgGQgBgDADgGQACgEADgCIAIgFIAIgBIAIACQAFADADADQAEAFACAEIARAxIAAgCIAGgFIAHgEIAIgCIAIAAIAIACIAHAFIAIAIIALARIADAJIAFAIIADAIIAJANIAGAFIAJAFIANAOIAFAIIAKAbIABAJIgBAWQgBAOAGAOQAHAUAAAFIgBAYIgEAUIgEALQgEAIABADQAKAoABA7QgBAzgCAbIgGBSQgCAkgHAdQgGAYgLAiQgMAlgFAcIgEAdIgDAgIgJAsQgcDWhODWQgTA3gMA6QgpDYg8DUQgaBbgwDEQgPA8gOBUQgoDzhLELQhZFEgvC7IhGEGQgrCfgWBpQgwDWghDGQgYCNgHDqQgFDDAWDyQAMCGAFBeQAGB8gFBpQgHCXgIBXQgNCEgVBsQgpDJgmCiIgWBiQghCLgLCUQgFAwgHAcQAAADgEADQgCACgFACQgEADgDAAIgHAAIgHgBIgGgDIgGgFIgDgFIgGgRQgGjsBMj0QAdhbAPhSQAeiaALhAQAVh5AKhiQAQisgPjpQgYk4gJicQgPkLAYjIQAdjtA7j4IAritQAPg8AwiyQAniTAVhZQAeiABWlOQBDj9AmjMQAGggAEgkQA6jPAbiQQAVh5AuiYQAvicAah+QAeiTAxiHQAehSAKheQAMh6Alh+IADgJIABgHIACgHIAKhdIACgMIgBhHIgCgVQgBgIgEgOIgJggIgEgPIAAAsQAABlgHA1QghD/hBCzQgpBzgdBrIg6DfQgjCAgbBdQhPEVgmCqQgyDghOEBQhMD8guDfIhXGTQgSBbgeB8IgzDWQgsC7gUEFQgIBkgECAIgEDlQgCCYAPEiQAJCkACBPQAECHgIBwQgJBxgiCFQgYBfgwCLQhYEAgGDGQgCA3gRBDQgGAYgHAQIgHAIQgFAGgDABIgJAEIgJAAgEAIygwUIABgCIAIgUIAGgXIAAgLIgEgFQgCgCABgDQABgDgBgDIgCgFIgEgHQgDAfgBA1gEAIqgyQIAJAaIgBgFIADgTIABgEIgBgJIAAgCIgOgIIgEgEQACAKAFAPg");
	this.shape_3.setTransform(4.3,-0.375);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("EgJyA1XQgGgCgDgCIgIgFIgGgIIgDgJIgBgHIgBgGIABgIIANg3IADgLQgKjuBSj+IBGjZQAlh7AQhhQARhmACiDQABhZgHiVQgOkqAHiwIAJjoQAGiFAHhkQAVkdAsi6IA2jqQAdiCAThnIBdnXQArjaBHj2QBHkCApjGQAojEBIkAIA7jdQAliLAYhTQBQkTA5ilQAkhmAKh8QAHhfgGiJIgGhzQgFhDgRgtQgBgDACgGQgBgDADgFQABgEAEgDIAHgEQACgBAHAAQAGABACABQAGAEACACIAFAJIAQAxIAHgGIAHgEIAIgCIAIABIAIACIAHAFIAHAIIAFAJIAGAIIALAaIAJANIAFAEIAIAGQAGAEACADIAGAHIAEAIIAJAcIAAAJIAAAJIgBANQAAAMAFAPQAGATABAHIgCAXIgCALIgFAUQgEAIABAEQAKAngBA7QgBAtgDAhIgHBSQgDAigIAfQgFAUgNAlQgNAqgFAXIgFAdIgKBBIgDAKQgfDVhRDWQgUA1gMA7QgnDKg9DhQgcBpgrC2QgPBCgMBOQgkD0hEEMQhSE9gtDCQgNA9g0DLQgpCjgVBkQg0D6gfCjQgaCRgMDlQgKDFARDvQAJCIADBcQADB9gHBnQgKCcgIBSQgNCEgVBqIhdHOQgcCKgICVQgDAxgGAcQgBADgEADIgGAEQgCACgFABIgHABIgHgBIgGgDIgGgFIgDgFIgDgGIgDgKQgPjuBHj0QAahbAPhSIAnjbQAVh7AKhgQATitgLjoQgSk4gFicQgHkMAbjGQAijpA8j6IAoisIA7juQAliQAUhcQAah/BRlQQBAkJAgjCQAFgcADgnQA2jOAZiSQAWh8AtiVQAuiZAciBQAfiPAziKQAghTALhdQAQh/Amh3IAEgQIACgHIACgXIACgTIAIgzIACgMIAAhHQAAgHgCgOIgEgWIgIggIgFgRIAAAtQgBBjgIA3QglD7hFC1QgtB4gcBlQhQEogqCUQhKEHgmC4QgvDehKEDQhFD0grDpIhPGTQgbCLhEEjQgrC9gZEDQgKBkgHB/IgKDkQgGClAKEUQAGCsABBHQABCHgKBvQgJBwgiCFQgXBagvCQQhSD4gBDQQAAA1gOBFQgEATgJAWQgCAEgEAEQgDAEgFADIgJAEIgJABIgBAAIgIgBgEAIxgwQIACgFIADgIIAHgWIADgLIAAgMIgDgFQgDgCABgDQABgCgDgJIgDgHQgDAdgCA5gEAIrgyOIAGAXIABgCIABgKIADgJIABgEIgBgJIAAgCIgEgCIgKgHQgDgCgBgCIAHAag");
	this.shape_4.setTransform(4.125,-0.3437);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("EgJwA1XQgFgBgEgCIgIgGIgGgHIgDgJIgCgHIAAgOIAJgrIADgMIACgLQgSjzBMj8QAviRAVhIQAlh9ARhgQAShmADiDQAChWgEiXQgIkhAMi5IAPjnQAJiFAJhkQAZkXAsi+QBDkeAfi1QAaicA6k8QAnjdBCjzQBCkAAnjKQAmjFBFj/IA8jdQAjiEAchaQBQkIBAivQAmhmANh7QAJhigFiGIgDhzQgGhDgPgtIABgJQAAgDACgFQABgEAEgDIAHgEIAJgBIAIADIAIAGIAGAJIAOAxIABgBIAGgFQAFgDACgBIAIgCIAJABQAFABACACIAHAFIAHAIIAPAaIADAJIAIAPIAEAGIAVASIAFAIIAFAIIAHAcIAAASIgCANQAAAKAFARQAFARABAIIgCAXIgCALIgBAKIgEALQgEAHABAEQAKAqgCA5QgCArgEAjIgIBRQgDAhgJAgIgTA5QgNAngGAZIgFAdIgEAgIgIAgIgDALQghDQhVDYQgXA6gKA2QgqDVg6DVQghCAgjCfQgOBFgKBLQgfD1g/EMQhLE9gqDEQgQBNgsC7QgnCogUBgIhTGcQgdCMgSDqQgPDEALDwQAHCHABBcQAAB9gIBoQgOCjgIBKQgPCEgTBpQgqDXgcCUIgQBiQgYCKgDCWQgBAugGAfQAAADgEADQgBACgFADIgHADIgHABIgHgBIgHgCIgFgFIgEgFIgHgQQgWjxBAjyQAYhWAOhYIAmjbQAWh/AKhcQAWitgGjoIgIjpQgEiNgBheQgBkFAhjMQAjjbA9kGIAnisIA4jtQAgiNAUhgQAbiLBHlGQA4kAAfjLQAEgmACgeQAxjIAaiYQAVh9AsiVQAtiUAeiFQAgiOA3iKQAhhTAMhcQARh6Aph8IAHgWIAFgqIADgVIADgSIACgMIADgMIABgoIAAgfIgBgVIgEgWIgHggIgFgSIgBAuQgCBhgKA4QgqD8hHCzQgtBxgfBrQgeBjhdFYQhHEDglC8QgtDhhFEBQg/DwgoDtIhIGVQgZCNhAEhQgrC6geEGQgLBjgKB/IgPDkQgLCrAEENQADC4gBA6QAACIgLBtQgLBvgiCGQgVBTgvCXQhND2AHDTQABA4gNBDQgDAVgJAUQgBAEgEAEQgEAFgDACQgGAEgDAAQgEACgFAAIgDAAIgHgBgEAIwgwOIACgFIAHgTIADgLQADgJAAgCIAAgMQAAgBgEgEQgBgDAAgCQABgCgDgJIgDgHQgCAbgDA7gEAIrgyNIAHAaIgBgEIAGgTIAAgEIAAgJIAAgCIgFgCIgJgHIgEgFQACAKAEAQg");
	this.shape_5.setTransform(4,-0.3271);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("EgJuA1XIgJgDIgIgFIgGgHIgDgJIgCgIIgBgFIABgIIALhDQgZj3BHj5QAsiSAUhJQAliAARheQAShlAGiDQADhXgBiWQgDkZASjBIAUjlQANiHALhiQAfkcAqi3QBAkUAdi+IBMnYQAijXA+j7QBAkJAijCQAmjRBBj0IA8jeQAjh/AehfQBRj/BGi1QAohnAPh5QAMhmgDiDIgDhzQgEhDgOgtQgBgDACgGQAAgEACgEQADgFADgCIAHgEIAJAAQAGAAACACQAFADACAEIAGAIIANAyIABgBIAGgFIAIgEQAEgBAEAAIAQADIAGAGIAHAIIAFAJIAFAJIALAaIAIANIAFAFIAIAGQAFAEACADIAGAIIADAIIAHAcIAAAJIgCAWQgBAMAFAPIAGAZIgCAYIgCAKIgCAKIgEALQgDAHAAAEQAKAugDA1QgDAsgEAhIgKBSQgEAigJAeQgEAPgQAqQgOAngHAZIgFAdIgNBAIgDAKQglDQhXDWQgWA3gMA6QgrDPg5DaQghCBgfCdQgOBEgIBNQgbD0g5ENQhFFDglC/QgRBWgmCzQgnCtgRBcQgnDFguDXQgfCNgYDnQgUDJAGDrQAGEWgRCxQgSC0gHA4QgPCFgUBoQgmDKgZChIgNBjQgVCNACCTQAAAxgEAcIgFAGQgBADgEACQgEADgDAAIgHABIgHgBIgHgBIgGgFIgEgFIgHgQQgdjwA5jzQAXhfAMhQIAkjbQAWiGALhWQAXitgBjoIgBjpQgBiLAChgQAFkGAljIQAnjVA9kKIAmitIA0juQAdiIAShkQAbicA9k2QA0kGAajGQAEgjACghQAvjTAWiOQAWiFAqiNQAtiVAgiFQAiiOA4iJQAhhRAPhdQASh4Ash8IAEgJIABgHIACgHIAQhcIACgMQACgSAAgXIABgeIAAgWIgEgVQgCgNgFgUIgEgSIgCAvQgEBegLA6QgvD7hKCyQgvBxggBqQgvCbhOEfQhED+giDBQgoDbhCEJQg7DwgkDuQgVCOgrEHQgcCqg5EFQgpC3gjEJQgUCPgbE1QgRC8gBD8QAAC5gCA5QgDCHgMBtQgMBughCGQgTBKgvCgQhHDyAMDYQADA1gKBHQgEAVgGAUIgGAIQgEAGgDABIgJAFIgJACIgDAAIgHgBgEAIvgwKIACgHIAEgIIADgLIADgLIADgLIgBgMIgCgFQgCgCAAgDQABgDgDgIIgCgIQgDAWgDBDgEAIsgyMIAGAZIAAgDIABgJIAEgJIAAgFIAAgJIAAgBQAAgBgBAAQAAgBAAAAQgBAAAAAAQgBgBgBAAIgJgHIgEgFIAGAag");
	this.shape_6.setTransform(3.875,-0.3);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("EgJqA1XIgKgDIgIgFIgGgHIgGgQIgBgFIABgIIAGgsIACgMIABgLQggj6BBj4IA+jdQAkiCARhcQAThlAHiDQAFhUACiZQADkUAXjFIA2nMQAokpAmipQA8kFAdjNIBDnZQAfjhA4jyQA7kIAgjEQAjjUBAjyIA8jeQAih8AhhiQBNjrBQjHQAqhnASh5QAPhogBh/QgBhjgBgQQgDhDgNgvQAAgDABgGQAAgDADgFIAFgGIAIgEQAEgBAFABQAEAAADACQAGAEACADQAEAEABAFIAHAZIAGAZIABgBIAGgFIAHgEIAIgBIAJABIAHADIAHAFIAHAJIAEAJQAEAFABAEIAKAaIAIANIAFAGIAIAGIAGAIIAGAHIAGARIADAUIAAAJIgDAWQgBANAEANQAFASABAIIgCAXIgCALIgGAUQgDAIAAADQAJAugEA1QgEAygEAcIgLBRQgFAhgKAfQgGAVgPAjQgQAtgGATIgGAdIgBAJIgCAMIgLAqIgDALQgpDPhZDVQgXA1gMA6QgvDbg0DOQggB9gdChQgMBBgIBQQgXD6gzEIQhCFegdCmQgRBigiCnQgnC+gOBLQgjC/gyDeQghCPgdDkQgYDGgBDuQgBEZgVCtIgbDrQgRCIgSBlQgnDRgTCaIgLBiQgQCMAGCVQACAtgEAgQgBADgEADQgBADgEACQgDADgEABIgHABIgHAAIgHgCIgFgFIgFgFIgHgPQgljyAzjyQAUhbAMhVQAKhKAYiRQAYiSAKhKQAZiyAEjjIAEjpQADiJAEhiQAMj/ApjOQAjiuBEkwQARhOAThdIAxjuQAbiGAPhoQAbisA0knQAvkEAWjJQAEghAAgiQAqjKAXiYQAViHAqiMQAvifAfh6QAiiMA7iKQAjhTAQhbQAWh7Ath4IAIgWIARhcIADgMIAEhcIgNhKIgDAvQgGBdgNA8QgyD3hOCzQgwBwgiBqQg4CyhGEHQhAD0giDMQgkDcg+EIQg3DygfDtQgNBrgsErQgaC1g2D7QgoCygoENQgVCPgkE1QgVC7gHD7QgEC8gDA2QgFCHgNBsQgNBsghCHQgOA6gxCyQhBDwARDbQAFA5gJBCQgCAWgHAUIgFAIIgHAIIgJAEIgJACIgCABIgHgBgEAIvgwIIACgHIADgIIAHgWIACgLIAAgMIgDgFQgBgDAAgCQABgDgDgJIgCgHIgGBZgEAIygxzIAAgBIACgKIAEgJIABgNIgBgCIgDgCIgJgIIgEgFIAKAyg");
	this.shape_7.setTransform(3.6972,-0.2917);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("EgJlA1XIgJgDIgIgEQgFgEgCgDIgEgJIgCgHIgBgGIAIhLQglj7A7j4QAIgkAyi6QAjiHARhYQAThmAJiDQAGhUAFiZQAIkJAejOIBBnKQAukyAkieQA5j5AbjZIA6naQAbjgA0j0QA3kHAdjGQAgjVA+jxQBIkYA4ilQBQjtBUjEQBRjAADkGIAAhzQgChCgLgwQgBgDACgGIADgIIAGgGIAHgEQAEgBAFABIAIADIAHAHQAEAEABAFIALAzIABgCIAHgEIAHgEIAIgBQAFAAADACQAGABACABIAGAGIAHAJIAMAbIADAJIADAIIAIAOIAMAMIAMAQIADAIIAFAdIgBAIIgDAWQgCAMAEAPQAEAQABAJIgCAXIgIAfQgDAIAAADQAIAsgFA3QgDAogGAmIgOBRQgGAjgJAcIgWA4QgPAigJAdIgGAdIgPA/IgEALQgtDPhbDSQgVAzgOA8Qg0DtguC8QgfB+gbCgQgMBGgFBKQgTD6gtEJQgzEqgiDbQgQBqgdChIgyEJQglDMgyDRQghCNgjDmQgeDGgHDsQgIEUgYCxIgeDrQgTCNgQBfQgkDLgQCgIgJBjQgMCNAKCUQADArgDAiQAAADgEAEQgBACgFADQgCADgEAAIgHACIgHAAIgHgCIgGgEIgEgFIgEgGIgEgKQgsjxAujyQARhgALhSQALhXAViFIAijbQAbiwAKjlQAPlgAIh0QARj5AujTIBqnbQARhOASheQAeiZAPhVQAXiDAOhrQARh6A0laQAoj6AUjUQACgeABglQAljCAYihQATiHAqiMQAuicAgh9QAkiPA8iGQAkhQAShdQAYh6Awh4IAIgXIAThbIADgMIAGhHIAAgVIgCgWIgFghIgEgVIgEAxQgIBbgOA+Qg4D1hQCyQgzBzghBmQhCDHg9DyQg+DzgfDNQggDUg6ERQgzD2gZDrQgPCIgjEOQgYC8g0D1QghCYgyEmQgYCNgrE2QgcDBgMD0IgMDxQgICHgNBrQgOBqggCJIg7DsQg9DxAYDbQAFA7gHBBQgCAXgGATIgFAJQgFAGgCABIgIAFIgJACIgDAAIgHAAgEAIwgwEIABgBIACgIIADgIIAEgLIACgKIADgLIAAgMIgCgFQgCgEAAgCIgBgLIgDgIIgHBbgEAI2gxtIgBgFIAGgTIABgEIABgJIgBgCIgDgCIgIgIIgEgFIAJA2g");
	this.shape_8.setTransform(3.237,-0.2667);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("EgJfA1WQgFAAgEgCIgJgEIgGgHIgHgQIgBgFIAAgIIAGhEQgrj7A2j5QANg+ApiiQAjiMAPhUQAUhlALiEQAHhRAJicQAPkHAijPIBMnIQA0k5AiiWQA4j2AYjbIAxnaQAXjjAvjyQAxj9AcjRQAejdA7jrQBEkMA+ixQBOjgBdjQQBWjEAIkAQAChXAAgcQgBhCgKgxQgBgCACgGIADgIIAGgGQAEgDAEgBQAEgBAEABQAGABACACIAHAHIAFAJIAKAzIABgBIAHgEIAHgEIAIgBIAIACQAEABAEACIAGAGIAHAJIALAbIADAJIADAJIAHAOIAFAFIAHAHIALAQIADAJIAEAdIgBAIIgEAWQgCAKADAQQAEAOAAAMIgCAXIgCAKIgFAVQgEAHABADQAIAwgHAzQgDAngIAnIgPBQQgHAkgKAbIgXA4QgQAigIAdIgIAcIgBAJIgPA2IgDAKQgxDOhdDSQgYA4gMA3QgxDfgwDJQgeB8gaCiQgLBLgDBFQgOD1goEPQgpERghD1QgOBsgcCfIgtEKQglDTgyDKQgmCZglDaQgjDJgNDoQgQEWgbCvQgLBGgXCkQgVCXgOBUQgiDMgMCgIgGBjQgJCOAPCTQAEAugCAfQAAACgEAEIgFAGIgHAEIgHABIgHAAIgHgCIgGgDIgEgFIgIgQQgzjwAnjzQAOhVALhdQAKhfAUh+IAjjcQAdi0APjhQAalyAJhhQAZj6AxjQQBBkSArjJQAQhOARhdQA2kqAVizQASipApkrQAjj/AQjRQACgeAAglQAijFAWifQATiHApiMQAriQAkiJQAliNA+iIQAmhQAThcQAZh5Azh4IAJgWIAUhbIAEgMIAEgnIADgfIABgVIgBgWIgFghIgDgWIgFAyQgKBYgQA/Qg+D2hSCwQg1BzgiBlQhEDKg7DuQg7DugeDTQgeDag0ELQgtD0gWDuQgMCJgeEOQgXDIgxDpQgdCHg5E4QgWByg3FPQggC9gTD3IgRDwQgLCJgOBpQgOBogfCKIg4DtQg3DtAcDhQAHA6gFBBQgCAWgGAVQgBAEgDAFIgHAHIgIAFIgKADIgCAAIgHgBgEAIygwAIABgEIADgIIADgHIADgLIADgLIACgLIAAgLIgCgGQgBgDAAgCIgBgMIgCgIIAAgCIgJBggEAI5gxsIAAgFIADgJIAEgJIABgNIAAgCIgDgDIgIgIIgDgFIAAAAIAAAAIAGA2g");
	this.shape_9.setTransform(2.742,-0.2417);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("EgJjA1VIgJgFIgHgGIgEgJIgDgHIgBgGIAEhAIABgLQgxj9Awj4QAOhNAjiVQAjiWAPhLQAThlAOiEQAHhIANilQAVkBApjUIBWnGIArjmQAZiFAWhiQA2juAVjkIAqnaQASjkArjyQAsj/AZjQQAajYA7jxQBAkEBDi6QBNjXBkjXQBcjGAMj9QAEhLAAgoQAAhBgIgyQAAgCABgGIAEgIIAGgGQAGgDACAAQAEgBAEABIAIADQAEADADAEQADAGABAEIAJAzIABgCIAHgEIAHgDIAJgBIAIACIAIADIAFAGIAHAJIAIATIADAJIAFASIAGAOIAFAGIAHAHIAGAIIAFAIIACAJIADAdIgBAIIgCAJIgDANQgDALAEAPQADAPAAALIgCAWIgEAVIgEAKQgDAHABAEQAGAwgHAzQgGAxgHAcIgQBQQgIAjgKAcQgGAPgTAoQgQAjgKAbIgHAdIgFAUIgMAqIgEALQg1DNheDRQgYA2gMA4Qg7EBgnCmQggCKgUCVQgJBFgDBLQgKD3giENQgmEsgZDcQgNBygYCZIgrELQghDPg1DPQgjCHgvDrQgpDLgTDlQgYEYgeCrQgRBbgUCPIgjDrQgfDFgICnIgEBjQgFCMATCVQAFAtgBAgQgBADgDAEIgFAFIgHAEIgHACIgHAAIgHgBIgGgEIgEgFIgEgGIgFgJQg4jwAgj0QANhfAIhUQAQioAvkSQAeiuAWjnQAhlUAPh+QAej1A2jTQA/j1AvjkQARhSAPhaQAwkTASjKQAUjUAekCQAekAALjPQACgXAAgtQAhjZASiLQASiKApiKQAuieAih8QAliKBBiJQAnhUAUhYQAbh4A2h3IAJgWIAXhbIADgMIAJhGIABgrIgHg3IACgLIADgIIADgHIADgLIACgKIADgLIAAgMIgCgFQgBgEAAgCIgBgMIgCgHIgQCVQgLBXgSBBQhBDuhWC1Qg1BuglBpQhIDOg4DqQg7DzgZDOQgaDSgwEUQgqD3gQDrQgMCegYD6QgUDQgwDjQgfCWg6EpQgeCVg4EqQgoDLgWDnIgXDwQgOCLgOBmQgPBkgeCOIg0DuQgxDuAhDhQAIA6gEBBQgBAYgFATQgCAFgDAEIgGAIIgIAFQgDABgHABIgJABgEAI8gxqIAAgFIAHgSIABgEIABgJIAAgCIgDgDIgHgIQgDgDgBgCIAFA2g");
	this.shape_10.setTransform(2.3124,-0.225);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("EgJfA1UIgIgEIgHgGIgFgJIgEgMIAAgIIABgKQAAgMABgLIABgYIABgLQg2j9Aqj5QAOhXAfiMQAlitALg2QAThkAQiFQAHg8ATixQAbkAAvjTQAwjcAvjpQA8kyAiiaQA1jsASjlQAUkOANjNQAOjmAmjxQApkDAVjNQAYjhA5jpQA8j6BJjEQBQjbBmjRQBijIARj6QAFhLABgoQABhBgGgyQAAgDABgFQABgEADgEQACgDAEgDIAIgDIAJAAQAFABACADQAFADACAEIAEAJIAIA0IABgCIAHgEQAFgCACAAIAJgBIAIACIAHADIAGAHIAGAJIAHATIADAJIAIAZIADAHIAFAGIAGAHIAKARIACAJIACAdIgBAIIgGAVQgDANADAOQADANAAAMIgCAXIgCAKIgDAKIgDAKQgDAHAAAEQAFAxgHAyQgIAxgHAcIgSBQQgHAggMAeIgaA3QgRAjgKAaIgIAdIgSA+IgFAKQg3DMhgDQQgYA1gNA5QghCMhAEbQgeCHgTCYQgJBKgBBGQgFD+gdEGQghEvgUDaQgLB3gVCVQgLBUgdC3QgeDQg3DPQgjCCg2DwQgtDOgZDhQgfERgkCxQgUBkgUCFIgiDrQgeDLgDCiIgBBjQgCCOAWCTQAHArgBAiQAAACgDAEIgFAGQgCACgFACIgGACIgIAAIgGgBIgHgEIgEgEIgJgPQg/jxAbjyQAJhSAIhiQAOi8AvkAQAgiyAcjjQAolFAViMQAkjxA6jWQA+jlAxjzQAQhOAPheQApkDAQjaQALikAekzQAYj/AIjRQABgXgBgsQAhj0AOhyQASiKAoiKQAtiZAjiBQAoiPBBiEQAohQAWhbQAfh6A3h0IAJgVIAPg9IADgKIAHgUIAEgLIAKhGIACgWIAAgWIgFg3QAAgFACgGIACgHIADgIIADgKIADgLIACgLIAAgLIgCgLIgBgMIgCgHQgLBjgHAyQgNBUgUBCQhEDqhaC3Qg4BwgkBmQhJDLg4DtQg4DrgYDWQgXDXgqEQQglD4gNDrQgJCwgTDpQgRDRgvDiQhJFqgTBVIhgG/QgrDHgdDpIgdDvQgRCOgPBjQgPBfgdCTIgwDuQgsDsAmDkQAJA4gCBEQgBAYgFATQgBAFgDAEQgDAEgEAEIgIAFIgJADIgJAAIgKgCgEAI/gxpIAAgEIAHgTIABgEIACgIIAAgDIgDgDIgHgIIgDgFIADA2g");
	this.shape_11.setTransform(1.9436,-0.1833);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("EgJaA1UIgJgEIgHgGIgFgIQgCgDgBgFIgBgFIAAgHIAAgKIACg7Qg5j7Ajj8QANheAbiGQAfiYAPhNQAThjATiGIAejtQAij/A0jTQA5jjAxjfQAShPAfiVQAhifAQhIQA0jrAOjmQAOjyALjpQAKjsAhjsQAkkAATjQQAUjiA3jpQA5jyBNjOQBSjaBqjRQBojMAXj0QAPiQgHhWIABgJQABgDADgFQADgDADgBIAIgEIAJABIAHADIAHAJQADAFABAEIAGA0IABgCIAHgEQAFgCACAAIAJAAIAIACIAHADIAGAHIAFAJIAHATIAHAcIAGAOIAEAGIAGAIIAJARIACAJIABAdIgIAdQgEANADANQACAPAAAKIgDAXIgCAKIgJAfQAFAygJAxQgIAsgJAgIgUBQQgIAhgNAdQgJAVgRAhQgUAogIAVIgJAcIgTA+IgFAKQg6DHhhDTQgYAzgOA6QgoCsg3D8QgfCKgPCUQgIBHAABKQgCEEgXEBQgaEtgQDcQgPDRgxFIQggDcg1DEQgkCCg7DvQgzDPgfDeQgnETgnCuQgkCkgpEvQgaDCAACsIACBkQACCQAZCQQAHArAAAiQAAACgDAEQgBADgEADQgCADgEABIgHADIgHAAIgHgBIgGgEIgFgEIgEgGIgFgJQhEjvAUj0QAJhlAEhPQAMjNAvjxQAji2AhjfQArkgAfiwQAqjtA+jXQBBjmAwjzQAPhMAOhfQAlkCALjcQAMjRAUkGQATj5AFjYQAAgegBglIAqlmQAQiMAoiJIBRkaQAniMBEiHQAphSAXhZQAgh4A6h0IAKgVIAfhmIAPhbIAAgVIgCgiIgBgWIACgLIAJgZIACgKIADgLIAAgMIgCgLIgBgMIgBgIIAAgCQgVC5glB1QhMDphaC0Qg1BogpBuQhNDUg1DkQg1DogVDZQgVDbgkEOQghD3gIDsQgIDWgNDDQgODSgtDiQg6EgglCfQhJE3ghCHQgzDRghDdIgiDvQgVCTgPBcQgMBPgfCiQgeCfgNBRQglDvApDjQAKA6gBBCQAAAXgFAUQgBAFgDAEQgDAEgEAEQgEAEgDACIgKACIgJABIgJgCgEAJBgxnIABgFIADgJIAEgJIABgEIACgIIAAgCIgDgEIgGgHIgDgGg");
	this.shape_12.setTransform(1.5842,-0.15);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("EgJWA1UIgJgEIgHgHIgFgIIgDgGIgBgGIgBgIIABhEQg9j8Adj7QAMhmAXiBIAsjlQAThkAWiGIAkjtQAmj3A8jZQA7jYA4joQAXhfAdiFIAxjmQA0jrAKjnQALkBAGjaQAGjuAcjqQAfkHARjLQARjhA1jrQA5j0BPjNQBUjbBujOQBsjNAejyQARiFgEhgIACgIQAAgEAEgFQACgDAEgCIAIgDQAFABAEABQAFABACADQAFAEABAEQADAEABAFIAFAzIABgBIAHgDQAFgCACAAIAJAAIAIADIAHADIAFAGIAGAKIAGATIAGAcIACAHIADAIIAEAGIAGAHIAJASIABASIgBAUIgCAJIgCAIIgEAMQgEANACANQACANgBAMIgIAqIgDALIgDAKQADAzgJAwQgKAwgJAcIgWBPQgJAigNAbIgbA1QgTAkgLAZIgJAcIgQAzIgEAKIgFAKQg+DJhiDQQgZA0gNA6QgqCtg1D6QgdCKgOCVQgGBEABBNQACEBgREDQgUEagMDwQgMDlgsE2QgdDWg4DKQgnCLg+DmQg3DNgmDgQgtEKgsC1QguC9gjEWQgYC+AGCwIAEBjQAFCOAcCTQAJAqAAAjQABACgEAFIgFAFQgBACgFADIgGACIgHAAIgHgBIgHgDIgEgEIgFgGIgFgIQhJjtAOj2QAGhlADhQQAIjWAwjqQAli0AojhQAwkOAnjAQAwjvBAjUQBEjhAvj3QAQhSAMhaQAgj6AIjkQAGjJAQkPQAOj0ABjdQABgcgDgoQASiwAUi3QAPiKAniKIBSkcQAniKBGiHQArhTAYhXQAih4A9hzIAKgWIAdhZIAEgMIAIgnIAGgeIADgVIABgWIgBg4IACgLIADgHIADgHIADgLIACgKIACgLIABgLIgCgLIAAgNIgBgKQgWCygqB6QhPDkhfC4Qg4BrgnBqQhODRg1DnQg1DmgRDcQgTDngeEBQgbDxgFD0QgDDIgLDRQgLDUgsDhQgyEBgwDAQhAD+gzC9Qg3DOgnDgQgcCfg0E9IgrDxQgZCPgNBhQggDuAuDlQAMA9gBBAQAAAYgEATQgBAEgDAFQgDAFgEADQgEAEgDABIgJAEIgKABIgJgCgEAJEgxlIABgFIADgJIAFgJIADgMIAAgDIgDgDIgFgJIgDgFg");
	this.shape_13.setTransform(1.2328,-0.1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("EgJSA1TIgJgDIgHgHIgFgIIgDgHIgCgFIAAhMQhBj4AXkAQAQi5A3kWQAShcAaiPIAqjsQAqjuBDjgQBCjdA6jhQAqiiBAknQAxjmAIjsQAHjqACjxQABjpAZjxQAZj7AOjYQAPjlAzjoQA2jrBTjWQBVjbBzjOQBxjMAkjwQAUiBgBhkIACgJIAFgHIAGgFIAJgDIAIABIAHAEIAGAIQADAGABAEIADA0IABgBIAHgEIAIgCIAIABIAIADIAHAEIAFAGQADAEACAGIAGATIAFAcIAFAPIAEAGIAFAJIAFAJIADAIIABAJIAAAJIgCAUIgCAJIgIAUQgEAKACAPQABAMgBANIgDAXIgMAoQADA0gLAvQgJAogLAjIgYBPQgJAggOAdIgdA0QgVAlgJAXIgKAcIgaBHQhFDRhgDGQgZA1gNA4Qg0DYgqDQQgdCLgLCUQgGBHACBKQAHEBgNEEQgMDkgKEnQgIDwgmEsQgcDUg6DNIhrFxQg9DTgqDYQgyD7gzDCQg3DPgdEDQgUDBAKCvIAGBjQAICPAgCRQAJAsABAhQABADgEAEQgBADgDADIgGAFIgHACIgHABIgHgBIgGgEIgFgEIgFgFIgFgJQhOjsAJj2QADhbABhbQAEjbAxjnQAtjNAojIQA2kGAtjGQA1jnBFjaQBHjhAuj2QAMg/AMhtQAejvADjwQADjIAKkRQAKj6gCjYQAAgbgEgoQARjEARikQANiLAoiKIBSkcQApiMBHiGQAqhQAbhZQAlh6A+hvIAHgPIAEgGIAHgXIAFgSIASgxIAFgLIAVhwIAAg4IADgKIALgjIACgLIAAgLIAAgMIgBgWQgXCogwCDQhTDhhiC3Qg5BrgoBqQhRDSgzDmQgyDigPDgQgPDsgZD+QgYD4ABDtQAADAgIDaQgIDbgrDbQguD1g3DMQhED8g3C+Qg8DMguDfQghClg4E2Qg4EvgUC0QgZDwAxDkQAMA6ABBCQAAAYgDATIgEAKIgGAIIgIAGIgJADIgKABIgJgCgEAJHgxnIAAgCIAJgRIABgEIADgLIgDgDIgFgJIgDgGg");
	this.shape_14.setTransform(0.8591,-0.0312);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("EgJNA1TIgJgEIgIgGIgFgIIgDgHIgCgNIAAgKIAAgXIgBgkQhFj3ARkAQANjVAyj+IBenXQAyjtBIjfQBNjyA4jKQA0i7A5kNQAwjmAFjsQAEj2gDjmQgCjmAUj0QAVkDAKjRQAMjoAyjnQAzjkBXjeQBZjfB0jIQB3jOAqjtQAWhzAEhxIACgIQACgGADgCQADgDAEgCIAIgCIAJACQAFACACACQAEAFABADQADAFAAAFIACA0IABgBIAHgEIAIgBIAIAAIAIAEQAFACACACIAFAHQAEAFABAEIACALIADAJIABAKIABAJIACAJIABAIIADAHIAJAPIAEAJIADAJIAAAJIgDAdIgCAIIgEAJIgFALQgEALABAOQABANgBAMIgEAWIgFAUIgEAKQgDAHAAADQABA0gMAvQgJAmgMAkIgaBOQgKAggOAdIgeA0QgWAlgKAWIgKAcIgXA9IgEAKQhKDThfDCQgZAzgOA6QgxDIgsDgQgbCOgJCSQgEBDADBOQALEBgIEEQgJEEgDEIQgFEDghEZQgbDYg8DLQhGDpgqCIQhCDQgxDaQg4D4g4DDQhADcgXD2QgSC3APC5IAJBkQAMCPAiCQQALAuABAfQAAADgDAEQgBACgEAEQgBACgFADIgGACIgHABIgHgBIgHgDIgEgEIgFgGIgGgIQhRjqABj3IABi3QgCjfA0jlIBemVQAzjaA8jxQA4jbBLjkQBMjhArj2QANhOAKheQAZjmgBj6QgBjTAGkFQAEj1gFjeQgBghgEgiQATj0AKh1QANiPAmiHQAbhfA4i9QApiMBJiGQAshSAbhXQAnh3BBhwIAHgPIAEgGIAghZIAGgLIAQhFIAFgVIACgWIACg4QAAgDADgHIAJgZIACgKIADgKIAAguQgYCgg3CKQhWDahmC8Qg7BugnBmQhTDUgyDkQgxDdgMDmQgLDogUECQgTDxAED1QADDIgEDTQgFDXgpDfQgsDwg9DSQhEDxhADHQhCDUgyDXQgyDYgyEBQg0ENgRDWQgTDuA0DoQAOA7ACBBQAAAagDARIgEAKIgGAIIgIAGIgIADIgKABQgFAAgEgBgEAJKgxkIABgDIAJgRIAEgNIAAgCIgCgDIgHgPg");
	this.shape_15.setTransform(0.4649,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-342.1,138.8,683.4000000000001);


(lib.PuppetShape_1copy2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJIA1SIgJgDIgIgGIgFgIIgDgHIgCgGIgBgHIgChFQhHj0AJkEQAIjpAwjtQAwjpA4juQA0jkBQjmQBPjiA/jYQBBjbAwjsQAwjnAAjsQABjUgHkIQgGjpAQjyQAPj2AIjfQAIjnAxjpQAyjhBajiQBajfB4jHQB7jNAyjsQAXhsAKh3IACgIIAFgIQADgDAEgBQAFgCAEAAIAIACQAFACACACQAEAEABAFIADAJIAAA0IABgBIAHgDIAIgBIAIABIAIADIAHAFIAFAHIAEAKIAEAUIACASIAFAZIADAHIAFAIIAGASIAAAJIgEAdIgDAIQgBAFgDAEIgFALQgFAKABAOQAAAMgBANIgEAXIgKAdQgDAHAAADQAAAygNAwQgLApgMAhIgcBOQgKAegPAeQgLATgUAgQgVAjgMAYIgKAbIgLAeIgSApQhPDWheC+QgZAzgOA6Qg0DOgoDaQgaCRgHCPQgDBGAEBLQAPECgDEDQgEESACD6QABEJgeEWQgYDZhADLQg3C2g+C6QhGDQg3DZQg7DqhCDQQhHDlgTDsQgPC1AUC7IALBkQAQCRAkCPQAMAuACAeQAAADgDAEIgEAGIgGAFIgHADIgHABIgHgBIgGgDIgFgEIgLgOQhWjogEj4IgEi3QgIjoA3jfQAjiPBEkFQBDj9A5jMQA9jaBPjkQBSjqAmjtQAOhPAIhdQAVjngGj6QgFjYABkBQAAj6gJjYQgBgegEgmQALjJAMigQALiPAniJQAfhvA0itQAqiNBKiFQAthRAdhXQAph5BChtIAIgPIAEgGIAjhYIAFgLIAXhZQACgIABgOIADghIABgXQABgFADgFIAIgZIADgKIACgKIACguQgZCYg9CQQhXDShsDCQg5BmgrBtQhWDZgwDgQgvDggIDjQgIDwgPD7QgPDvAID4QAHDIgCDTQgCDcgnDcQgpDkhDDeQhFDmhHDRQhFDJg6DfQg9DsgxDsQgzDwgND0QgMDuA3DpQAPA7ADBBQABAXgDAVIgEAJIgGAJIgHAGIgJADIgKABIgJgBgEAJOgxkIABgCIAEgJIAFgIIAFgMIAAgDIgCgDIgEgJIgCgGg");
	this.shape.setTransform(0.0494,0.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("EgJOA1TIgJgEIgHgGIgFgIIgEgHIgBgFIgBgSIAAgXIgBgkQhDj3ARkAQANjMAzkHIBdnWQAwjqBIjjQBHjgA9jcQA0i/A5kJQAwjpAFjpQAEjYgCkEQgBjxAUjpQAVjsAMjoQALjlAzjpQA0jnBXjbQBWjaB1jOQB2jMAqjvQAVh3AEhtIACgJIAEgHQADgDAEgCIAIgCQAFAAAEABQAFADACACQAFAFABADIADAJIABA0IACgBIAHgDQAEgCAEAAIAIABIAIADIAHAEIAFAHIAFAKIAFATIABAKIAEAaIADAHIAEAHIAFAIIAHASIABAJIgDAdIgLAcQgEALABAOQABAOgBALIgDAXQgBAEgCAGIgHAUQgDAGAAAEQACAygMAwQgKArgLAgIgaBOQgLAjgNAaQgKAUgUAgQgXApgIASIgKAcIgKAeIgEAKIgEALIgKAUQhGDMhiDJQgaA3gNA2QgzDSgqDWQgcCMgJCUQgEBIADBIQAKECgJEEQgIEUgFD3QgEEBgjEcQgaDWg8DNIhwFwQhADRgxDaQg0Dtg7DOQg+DZgYD5QgSC5AOC3IAIBkQALCMAiCTQALAuABAfQABADgEAEQAAACgEAEQgCADgEACIgHACIgHABIgHgBIgGgDIgFgEIgFgGIgFgIQhRjqACj3IABi3QgBjgA0jkIBdmVQA3jwA3jbQA5jlBIjbQBLjhAsj1QAMhMALhgQAZjpAAj3QAAjHAGkSQAFj5gFjZQgBgegDglQAMi0AQi1QANiNAniJIBTkcQAqiNBIiFQArhQAchYQAmh5BBhwIAFgIIACgGIAEgGIAghZIAFgLIAKgnIALgzIACgWIABghIABgXQAAgEADgGIADgIIACgHIAGgUIACgLIABgtQgYChg2CJQhWDdhlC5Qg7BugnBmQhUDZgxDgQgxDfgMDjQgMDegUENQgVDzAEDzQADDHgFDTQgFDZgqDeQgsDug8DTQg+DehFDbQhBDSgxDYQgsDBg3EYQg0EKgSDZQgUDvA0DnQAOA9ABA/QAAAagDARIgDAKIgHAIQgEAFgDABIgJADIgKABQgFAAgEgBgEAJJgxjIABgEIAJgSIAEgMIABgDIgDgDIgHgOg");
	this.shape_1.setTransform(0.529,0.025);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("EgJTA1UIgJgEIgHgGIgFgIIgDgHIgBgGIgBhMQhAj7AZj8QARiwA4kfQAThhAYiJIAojsQApjvBCjgQBEjsA1jSQAniaBCkwQAyjqAIjnQAJkEACjYQADjmAajzQAajyAPjhQARjnAzjmQA3jtBSjUQBXjfBvjKQBwjMAijxQATiCgChjIACgIQABgFADgDQADgEAEgBIAIgDIAIABIAIAEIAGAIIADAKIAEA0IABgBIAHgEIAIgCQADgBAFABIAIADIAHAEIAFAHIAGAJIADAKIAHAmIADAHIACAHIAEAHIAGAHIAIASIABASIgBAUIgCAJIgIAUQgEANACAMQACAMgBANIgDAXIgFAUIgEAKQgDAHAAADQADAxgLAyQgJAsgKAgIgXBOQgLAkgMAZIgcA1QgVAlgKAYIgSA6IgRApQhCDLhhDMQgZAzgOA6QgzDXgrDRQgcCIgNCXQgFBEABBMQAGD/gOEHQgQEdgJDtQgJD1goEnQgdDYg4DJQgkB7hGD2Qg7DRgqDbQgvD6gzDDQg1DLgeEHQgWC/AKCwIAFBkQAICOAeCSQAJArACAiQAAACgDAFIgFAGQgDADgDABIgHACIgHABIgHgBIgGgDIgFgEIgEgGIgGgJQhMjtAKj0IAFi2QAFjaAxjoQAvjdAki4QA1kKAsjDQAxjhBGjgQBHjhAuj2QAPhVAKhXQAejzAEjsQAEi5AMkfQAKjwAAjiQgBgigCgiQANicAVjLQAOiNAniJIBSkbQApiLBHiHQAphOAbhbQAjh3A/hzIAKgVIAHgXIAGgSIAWg8IAThaIABgWQABgRgBgRIAAgWIACgLIAJgYIACgLIADgKIAAgMIgBgLIgBgWQgXCtguB+QhRDhhiC4Qg3BpgqBsQhQDUgzDkQg0DogPDaQgQDkgaEGQgZDwgBD1QgBDAgJDaQgJDbgrDaQgwD8g0DFQg7Dig+DYQg6DKgtDjQgPBLhIGQIgqDxQgWCHgMBqQgbDuAwDmQAMA7ABBBQAAAYgEATQgBAEgDAFIgGAJIgIAFQgDACgGABIgJABIgKgBgEAJGgxkIABgFIAKgVIACgJIAAgDIgCgDIgGgIIgDgGg");
	this.shape_2.setTransform(0.9359,-0.0562);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("EgJXA1UIgJgEIgHgGQgCgCgDgGIgDgHIgBgGIgBgIIABgJIAAgYIABgXIAAgMQg8j7Agj8QAMhiAZiEIAsjlQAUhiAUiHIAijtQAjj2A6jbQA2jQA5jwQAVhcAeiJIAxjmQA0juALjjQANj2AIjmQAHjkAfj0QAhkCASjQQATjhA1jqQA4jtBQjTQBRjYBujSQBqjMAbj0QAQiMgGhZIACgIQAAgDAEgFIAGgGIAIgDIAJABIAHAEIAGAIIAEAJIAFA0IACgBIAGgEIAIgCQAGgBADABIAIACIAHAEQACABADAFIAGAJIAPA3IADAHIAEAGIAGAIIAJARIACAJIAAAdIgCAIIgDAJIgEAMQgDANACANQACASAAAHIgDAXIgFAUIgDAKQgDAHAAADQAEAygKAxQgHAogKAkIgVBQQgIAfgOAeQgIATgTAjQgTAkgJAZIgSA6IgMAfIgEALQg8DIhiDRQgZA1gNA4QgtDBgyDnQgeCKgPCUQgGBGAABLQABEHgUD+QgTDsgSEeQgNDaguE/QgeDXg3DJQgkCCg+DvQg1DNgkDhQgoEDgsC9QgrC0glEfQgZC/AECuIADBkQADCQAcCQQAIAtAAAgQAAADgDAEIgFAGQgDADgDABIgHACIgHABIgHgBIgGgEIgFgEIgEgGIgFgJQhHjvARjzIAKi1QAKjRAvjuQAmjBAkjUQAvkfAiiwQAsjpBBjbQBBjbAxj9QAPhNANheQAjkBAJjeQAIjKASkNQARj/ACjSQABgcgDgoIAolmQAPiJApiMIBRkbQAoiMBEiGQAohOAahcQAih5A7hzIAKgVIALgpIAGgUIALgdIAEgLIAHgnIAJg0IAAgWIgCg4QAAgFADgFIACgIIADgHIAGgVIACgKIAAgMIgCgLIAAgMIgBgHQgLBWgMA+QgQBSgWBDQhODphdC0Qg1BngqBuQhMDMg2DsQg2DqgSDYQgTDaghEOQgeDzgGDyQgECzgODmQgMDWgsDfQg3ETgqCtQhLEwgkCLQg2DQgkDfIgmDtIgmDvIgrDyQgaCUgOBcQgiDtAsDlQALA6gBBCQgBAagDARIgEAJIgHAJIgIAFIgJADIgJABIgJgCgEAJDgxmIABgFIAIgSIABgEIACgIIAAgDIgDgDQgEgEgCgEIgDgFg");
	this.shape_3.setTransform(1.3435,-0.125);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("EgJdA1UIgIgEIgHgGIgFgIIgDgHIgBgGIAAgIIAAgKIACguIABgMQg4j7Anj7QAOhaAdiKQAoi9AHgmQAThlARiFQAJhCATiqQAdj8AyjXQAvjJA1j6IAvjlIAxjnQA1jyAPjfQAUkTAKjIQANjpAkjuQAnkGAUjLQAVjZA5jxQA7j4BLjHQBRjdBnjPQBkjKAVj3QAGhJABgqQAChAgGgzQAAgDABgFQABgEADgEIAGgGIAIgDIAJABQAEABAEACIAGAIIAEAJIAEAaIADAZIABgBIAHgEQAFgCADAAIAIgBIAIACIAIAEIAFAGIAGAJIAKAdIACAJIACAJIAGAOIAFAGIAGAHIAGAJIAEAIIACAJIABAdIgHAdQgDAMADAPQACAOAAALIgCAXIgKAkQgCADABACQAFAygIAxQgJAxgHAbIgTBQQgIAhgMAdQgFAOgVAoQgTAngIAXQgFATgEAJIgSA+IgFAKQg3DHhiDVQgXAzgOA6QguDGgyDiQgfCIgRCWQgIBIgBBJQgEEAgaEEQgeEwgSDZQgKB5gUCUQgNBhgaCqQghDeg0DBQgiB9g5D1QgvDIgdDnQggEDgoC+QgVBkgUCEIgjDsQgcDEgBCpIAABjQAACPAXCSQAHAsAAAgQAAADgDAEIgFAGQgDADgEABIgGACIgIAAIgGgBIgHgDIgEgFIgJgPQhCjvAYj0QAJhaAGhaQAOi+Avj/QAji/AcjWQAqkvAZihQAojyA6jUQA+jfAzj5QAOhGAQhmQAokJANjVQAMi6AYkcQAWj0AHjdQACgcgCgnIAtlmQAQiIApiMQAuifAih7QAoiOBCiFQAphSAWhZQAfh4A4h1IAFgJIAFgNIAahaQAAgEAEgIQACgLAEgcIAFgeIACgWQABgHgBgPIgCghIgCgWQAAgFACgGIACgHIADgIIAGgVIACgKIAAgMIgCgLQABgDgCgJIgBgJIAAgBQgKBfgJA5QgOBTgVBDQhJDthZCyQg2BsgmBqQhLDQg3DoQg3DogWDaQgYDjgmEEQgjDzgLDxQgIC2gSDiQgQDXgtDdQhFFRgZBuIhkG+QgvDLgeDlIgfDuQgTCPgPBhQgOBZgeCZQgiCugLBBQgpDvAnDiQAKA4gCBEQgBAYgEASQgBAFgDAFIgHAIIgIAFQgEACgFABIgJAAIgKgCgEAJAgxoIAAgEIADgKIAFgJIABgEIABgIIAAgDIgDgDIgGgIIgDgFIACA2g");
	this.shape_4.setTransform(1.7952,-0.175);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("EgJiA1VIgJgFIgHgGIgEgJQgCgCgBgFIgBgFIADg1IABgMIABgLQgyj8Atj5QAPhPAiiUQAjiYAOhJQAThlAOiEQAIhHAOimQAWkBArjTQAni/AykHIAsjmQAaiGAVhhQA2jyAUjfQAaknANi0QASjnApjvQAskCAXjNQAZjaA7jwQA+j7BFjDQBPjaBkjTQBejHANj8QAFhRAAgiQAAhBgHgyIABgIQAAgEAEgEQABgDAFgDQADgCAEgBIAJAAQAFABADACIAGAIQADAEACAFIAJAzIABgBIAGgEIAIgDIAIgBIAIACIAIADIAFAGIAHAJIAIATIACAJIADAJIACAJIAHAOIAFAGIAGAHIAGAIIAFAJIACAIIADAdIgBAJIgFAVQgDANADANQADAQAAAKIgCAXIgFAUIgDAKQgDAHAAAEQAHAwgHAzQgFAkgJApIgRBQQgGAfgNAgIgYA3QgTAngHAXIgaBaIgEALQg1DLheDSQgYA3gNA3IhhGoQgeCEgVCaQgJBDgDBOQgID6ghEKQgoFNgUC7QgMBzgYCYIgpELQgjDXg0DHQgjCJgxDpQgpDLgVDlQgaETggCwQgRBdgVCNIgjDrQgfDKgGCiIgDBjQgFCOAUCTQAGArgBAiQAAACgEAEIgFAGQgCACgEACIgHACIgHAAIgHgBIgGgEIgFgFIgJgPQg6jvAfj0QALhdAIhWQAQipAvkSQAgi3AXjeQAhlDATiPQAfjzA3jVQA7jgA0j5QAOhFARhmQAukOARjQQAQi4AgkdQAcj6ALjWQACgegBgmQAfjVATiQQARiIApiLQAuibAih/QAmiMBBiIQAnhRAVhaQAdh5A1h2IAEgJIACgGIADgHIAUhPIADgLIAEgMIAJhGIACgWIgBgWIgDghIgCgWQgBgEACgHIAMgkIACgLIAAgLIgCgGQgBgDAAgCQABgDgCgJIgCgIQgLBzgFAjQgMBWgSBBQhEDvhWCzQg0BtgmBqQhFDGg7DyQg5DrgaDWQgaDcguELQgoD9gPDmQgNC2gVDhQgUDTgvDgIhaG/QgfCVg6EqQgoDKgZDoIgYDvQgOCLgPBmQgPBjgeCPIgyDuQgwDtAiDiQAJA5gEBDQgCAbgEAQQgBADgDAGIgHAIIgIAFIgJACIgKABgEAI9gxpIAAgFIADgJIAEgJIABgEIABgJIAAgDIgDgCIgHgIIgEgGIAFA3g");
	this.shape_5.setTransform(2.2411,-0.2083);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("EgJeA1WQgGAAgEgCIgIgEIgHgHIgEgIIgDgHIAAgGIAAgIIAGhEQgsj8A0j4QAOhAAnigQAjiNAQhUQAThkAMiEQAGhJAKikQAPkHAljPIBNnIIAojnQAYiDAXhkQA4j5AXjZIAwnaQAXjkAujxQAvj2AcjYQAdjcA8jsQBBkEBBi6QBPjgBcjPQBXjBAJkDQADhYgBgbQgBhCgJgxQAAgCABgGIADgIIAGgGQAEgDAEgBQAEgBAFABQAFABACACIAHAHQAEAGABAEIAKAzIABgCIAHgEIAHgDIAIgBIAJABIAHADIAGAGIAHAJIAIASIADAKIADAIIADAJIAHAOIAFAGIAHAHIALAQIACAIIAEAdIgBAJIgBAJIgDAMQgCANADAOQAEAOAAALIgCAXIgCALIgCAKIgDAKQgEAHABAEQAHAsgGA3QgFAqgGAjIgQBRQgHAkgKAbQgJAYgOAfQgTAqgGAVIgHAcIgQA/IgEALQgxDMhdDTQgXA1gNA6QgxDfgwDJQghCHgWCXQgKBFgEBLQgOEAgnEEQgvFGgZDAQgOBugbCdIguEKQgjDPgzDPQgkCQgoDiQgkDIgODqQgREQgcC0QgMBJgWChQgWCZgNBSQgjDPgKCdIgGBjQgICOAPCTQAFAsgDAhQAAACgDAEIgGAGIgGAEIgHABIgHAAIgHgCIgGgDIgEgFIgEgGIgFgJQgzjxAljzQAPhbAJhXQALhhATh8IAkjcQAbipASjsQAXlAAPiTQAZj6AyjQQA6jxAyjqQAQhOARhdQA0kbAVjCQAQiTAqlBQAij5AQjWQACgeAAgmQAjjUAUiQQATiHApiMQAxilAeh0QAliNA+iIQAmhSAThaQAah3Azh5IAEgJIAFgNIAEgXQACgLACgIIAFgUIAFgSIADgMIADgLIAFgoIADgfIABgVQAAgHgCgPIgEghIgDgWIgFAyQgKBYgQBAQg+DxhTC0Qg0BvgkBpQhCDCg9D2Qg8DygcDOQgeDbgzELQguD7gUDnQgSDKgYDNQgVDFgyDtQgUBegZCBIgqDfQgMBDhCF+QgiDIgSDsIgSDwQgLCKgPBnQgOBngfCMQgRBQgmCdQg2DtAdDhQAHA4gFBDQgBAVgGAWQgBADgEAFIgHAIIgIAFIgJADIgCAAIgHgBgEAIzgv/IABgFIACgHIADgIQABgEADgHIACgKIACgLIAAgMIgCgFQgBgDAAgDIgBgLIgCgHIgIBdgEAI6gxsIAAgEIAHgXIABgJIgBgCIgDgDIgHgHIgEgFIAHA1g");
	this.shape_6.setTransform(2.6719,-0.2417);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("EgJlA1XIgJgCIgIgFIgHgHIgEgJIgCgHIgBgGIABgRIADgXIAEgjQgnj6A8j5QAJgnAxi3QAkiHAQhYQAThlAJiDQAGhSAGibQAIkIAdjQQAqkwAYiaQAsksAmikQA5j6AbjYIA6naQAcjjAzjxQA4kNAcjAQAfjQA/j3QBGkPA7itQBOjlBWjMQBRi/ACkHQABhXgBgcQgChCgMgwQAAgDABgGIADgIQACgDAEgDIAIgEQAEgBAEABQAGABACACQAGAFABACIAFAJIAMAyIABgBIAGgFIAHgDIAJgBIAIABQAGABACACIAGAGIAGAIIAKASIANAiQABAEADACIAFAGIAHAGIAMAQIADAJIAFAcIgBAJIgBAJIgCAMQgCAMAEAPQAFAQAAAKIgCAXIgHAfQgEAHABAEQAIAtgFA2QgEArgGAiIgNBRQgGAkgJAcQgJAZgNAfQgRApgHAWIgZBmQgsDNhcDVQgXA2gMA5QguDUg1DUQgfB/gbCfQgMBEgFBNQgSDyguERQg0EzghDSQgQBngeCjIgxEKQgkDHgyDWQgiCLgjDoQgeDHgHDrQgIEZgYCtIgfDrQgSCMgRBgQglDQgPCbIgIBjQgNCOALCSQADArgDAiIgEAGIgFAGQgDACgEABQgDACgEAAIgHAAIgHgCIgGgEIgEgFIgDgGIgFgKQgsjwAtjzQARheALhTQALhXAViFIAjjcQAaisALjpQAOlPAJiEQARj6AujTIBqnbQARhOASheQA8k2AWimQAUibAyk5QAoj7ATjTQADgeABgmQAnjSAViRQAUiGAqiMQAtiYAhiCQAkiLA9iKQAkhSAShbQAWh5Axh5IAIgWIAThbIADgMIADgoIADgfIAAgVIgCgWQgBgOgFgTIgDgUIgEAwQgIBagOA+Qg5D4hPCwQgwBtgkBsQg/C+hAD7Qg+DzggDNQgiDgg4EFQgyDygbDuQgUC2geDhQgXC8g1D1QggCWgzEpQgUB4gvFKQgbDDgMDyIgMDxQgICJgOBqQgNBpggCKIg8DrQg8DsAXDgQAGA2gHBGQgCAXgGATQgBAEgEAFIgHAHIgIAFIgJACIgDAAIgHAAgEAIxgwGIADgHIADgIIADgLIADgLIACgLIAAgLIgCgFQgCgEABgCQAAgDgCgJIgCgIIAAgBIgHBbgEAIxgyIIAFAaIAAgEIACgKIADgJIABgEIABgJIgBgCIgLgKIgEgFIAEAbg");
	this.shape_7.setTransform(3.2188,-0.2667);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("EgJsA1XQgGgBgDgCIgIgFIgGgHIgGgQIAAgGIAAgHIAJhDQgej7BCj3IA+jcQAkiDARhbQAThlAHiEQAEhUABiZQADkTAWjGIAajlQAPiJAMheQAmklAnitQA8kAAdjSIBFnZQAgjgA5jzQA6kAAhjLQAjjSBBj0QBNkmAxiWQBQjyBNjBQAqhnAQh5QAPhogBh/QAAhigCgRQgDhDgNgvQgBgDACgGQAAgCACgGQADgEADgCIAHgEQAFgBAEABQAGAAACACQAFAEACADQAEAEACAFIAMAyIABgBIAHgFIAHgEIAIgBIAJABIAHADIAGAFIAIAIIAJASIADAJIAEAJIAHAPQABAEADADIAGAFIAHAGIAMAQIADAIIAFASQACAGAAAEIAAAJIgBAJIgCANQgBAOAEANQAFASAAAHIgCAYIgBAKIgGAVQgDAHAAAEQAJAtgEA2QgCAngGAmIgLBSQgFAjgJAdQgGATgPAlQgQApgGAXIgFAdIgSBKQgoDOhaDWQgWA4gMA3QgqDHg6DiQggCDgdCbQgNBGgHBLQgXD3g0ELQhGFpgbCbQgQBggjCpQgnC6gOBPQgoDWguDHQggCOgdDlQgZDHACDsQAAEagVCtIgbDrQgQCIgTBlQglDMgVCfIgLBiQgSCMAGCVQACAugFAfQAAADgDADQgCADgEACQgDADgEABIgHABIgHAAIgHgCIgGgFIgDgFIgIgPQgkjxA1jzQAVhiAKhOQAKhHAYiUQAYiPAKhNQAZiwADjlIAEjpQACiJAEhiQALkAApjNQAmi9BAkhIAlirIAxjuQAaiGARhoQAaipA2kqQAuj+AXjPQAEgdACgmQApjHAYibQAViHAqiMQAwiiAeh3QAhiLA7iLQAjhQARheQAUh6Ath5IAGgQIACgHIARhcIADgMIAEhGQABgIgBgOIgJg2IgFgUIgCAwQgHBdgLA8Qg0D4hLCyQgxB0ghBmQg5C0hFEGQhADxgiDPQglDWg+ENQg5D0geDsQgPBqgsErQgZCug4ECQgmCrgpEUQgTCEglFAQgVC+gFD5IgGDxQgGCIgMBsQgNBsghCHQgQA/gvCsQhDDxARDaQAFA1gJBGQgDAYgHASQgBAEgEAFIgHAHIgJAEIgJACIgCABIgIgBgEAIugwJIADgHIADgIIAHgVIACgLIAAgMIgDgFQgBgDAAgCQABgEgDgIIgCgIIgHBZgEAIygxwIAAgEQAAgFACgFIADgJIAAgEIABgJIgBgCIgDgDIgIgHIgFgFIALA1g");
	this.shape_8.setTransform(3.75,-0.2917);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("EgJuA1XQgGgBgDgCQgFgCgDgDIgHgHIgCgJIgDgHIAAgGIAAgIIADgJIAJg6QgXj2BIj5QAtiSAVhJQAlh/AQheQAThmAEiDQAEhWgCiXQgFkYAQjCIAUjmQALiGAKhiQAfkeAqi2QBBkaAdi5QAZibA1k9QAkjcA/j1QA+j7AmjQQAmjQBDj1IA8jdQAiiAAeheQBQj9BFi4QAnhnAOh6QAMhlgEiCIgDhzQgEhDgPguQgBgDACgGQgBgDADgFQABgEAFgDIAHgEQADgBAFABQAFAAADACIAIAGIAGAJIANAyIABgBIAGgFIAIgEQAEgCAEAAIAIACQAFAAADACIAGAFQAEAEADAEIAKASIAFAJIADAIIAHAQIAEAGIAOALQAEAEADAEIAFAHIAHARIAEATIgCAfQAAAKAEARQAGARAAAJIgCAXIgBAKIgGAVQgDAIAAADQAJAsgCA3QgDAygEAcIgJBSQgDAfgJAhQgHAXgNAiQgPAogGAYIgFAdIgNBAIgCAKQglDRhXDWQgUA0gNA8QgvDfg1DKQggB9ghCiQgOBAgIBQQgdD3g6EKQhBEkgsDeQgRBXgoCyQgoCugRBaQgiCtgyDwQgfCLgVDpQgTDBAHDzQADCIAABcQgCB8gJBnQgQCkgIBJQgPCEgUBpQgnDKgaChIgOBiQgWCPABCSQABAsgGAhQgBACgEAEIgFAEQgDADgEABIgHABIgHgBIgHgCIgFgFIgEgFIgDgGIgEgKQgcjwA7jzQAXhaANhVIAljbQAWiEALhXQAWiwgCjlIgDjpQgCiLABhgQAEkHAjjIQAljPA+kRIAmisIA1juQAfiJAShkQAYiGBDlLQAzj6AdjSQAEgiACgiQAvjPAYiSQAWiGAqiMQAuiYAfiBQAhiNA4iKQAihVAOhaQARh5Ash8IADgJIABgHIACgGIANhRIACgMIADgMIACgoIAAgfIAAgVIgEgWIgLgyIgCAuQgEBfgLA6QgsD6hKC0QgvBzggBoQg3C6hFEAQhED8gkDDQgpDghCEDQg+DygkDsIhCGVQgeC0g5D7QgoC1giEKQgTCPgZE3QgQC7ABD8QABCygCBAQgCCIgMBtQgLBugjCGQgTBOgvCdQhJDzALDWQADA4gLBDQgEAXgHASQgBAEgEAFIgHAHIgJAEQgEACgFAAIgDAAIgHgBgEAIwgwMIAJgYIACgLIADgMIAAgLIgDgFQgBgDAAgCQABgDgDgJIgDgIQgCAXgDBBgEAIygxxIAAgFIABgKIAEgJIAAgEIABgJIgBgCIgEgCIgJgHIgEgFIAMA1g");
	this.shape_9.setTransform(3.9,-0.3137);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("EgJxA1XIgJgDIgIgGIgGgHQgBgCgCgHIgCgIIAAgFIABgIIAMg3IACgLQgPjzBPj7QAviRAWhIQAlh9ARhgQARhmADiDQAChWgGiXQgLkhALi5IAMjoQAIiFAIhkQAYkdAri5QBHkuAdilQAcibA8k8QAojVBEj7QBEj9ApjNQAnjJBGj7IA8jcQAjiHAbhYQBRkOA8ipQAlhmALh7QAJhigGiGIgFhzQgFhCgQguQgBgDABgGQAAgDADgFQABgEAEgDIAHgEIAJgBQAFAAADACQAFADADAEIAFAIIAPAyIABgBIAGgGIAHgDQAEgCAEAAIAJABQAEAAADACIAHAFIAHAIIAaAyIAFAGIAFAFIAQANIAGAHIAEAIIAIAcIgBAfQgBAMAFAPQAGASABAIIgCAXIgCAKIgFAVQgEAIABADQAKAsgCA3QgCAzgDAbIgHBSQgEAlgIAbQgFAVgNAlQgOAngFAZIgFAdIgLBAIgDALQghDShTDXQgVA3gLA6QgrDTg5DXQgeBsgoCzQgPBIgKBIQggDuhDESQhWFngjCaQgOBEgwDDQgoClgUBjQhAE6gTBjQgcCOgPDnQgNC9AND4QAICHABBcQACB9gHBoQgMCbgIBSQgOCEgVBqIhHFrIgSBiQgaCNgECTQgBArgHAhQAAADgFADQgBADgEACIgHADIgHABIgHgBIgHgDIgFgEIgEgFIgDgHIgDgKQgUjuBDj0QAYhXAQhXIAmjaQAVh9ALheQAUivgIjmIgKjqQgFiNgCheQgEkJAfjIQAijdA9kEIAoitIA5jtQAiiNAThgQAgieBGkyQA6j7AhjQQAFgiACghQA0jNAZiUQAWh9AsiUQAtiUAeiGQAfiOA2iKQAhhWALhaQAQh5Aoh9IAHgWIAMhdQAAgEADgIIAAhHIgBgVIgEgWQgBgJgHgXIgEgRIgBAtQgCBigJA4QgoD7hGC0QguB5gdBjQgZBYglCGIg8DdQhJEGglC6QgtDghHEBQhED3goDmIhLGUQgZCNhCEiQgsC/gbEAQgLBjgICAQgEA1gJCvQgKCwAHEJQAFCxAABBQgBCIgKBtQgKBwgiCGQgWBWgvCUQhPD3ADDRQABA4gNBCQgEAWgIATIgGAJIgIAHIgIAEIgKABIgJgBgEAIxgwQIABgEIAIgTIADgLIACgLIAAgMIgDgFQgCgCABgDQAAgCgDgJIgCgHQgDAdgCA4gEAIrgyOIAHAYIAAgCIABgKIADgJIABgEIgBgJIAAgCIgEgCIgJgHIgFgFIAHAag");
	this.shape_10.setTransform(4.0625,-0.3333);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("EgJ0A1XIgJgEIgIgFIgFgIIgDgJIgCgHIAAgGIABgIIALgrIADgMIADgLQgHjsBWj/IBIjYQAlh6AQhiQARhmAAiDQAAhZgIiVQgRkpAEiyIAHjoQAEiGAGhjQAIiIAMhlQAQiAAZhsIA3jpQAfiEAUhmIBhnXQArjPBLj/QBKj/ArjJQAni4BMkMQAUhIAniUQAmiSAWhNQBRkfA0iaQAihmAJh8QAGhegIiKIgGhzQgGhDgRgtQgBgCABgGQAAgEACgFQACgEADgCQAEgEAEgBIAIgBQAFAAADACIAIAGIAGAJIAQAxIABgBIAGgFQADgDADgBQAFgCAEAAIAIAAIAIACIAGAFQAFAEADAEIALARIAMAaIAIAMIAOALQAHAFABACIAGAHIAFAIIAJAbIAAAfQgBAMAGAPQAGAUABAGIgCAXIgHAgQgEAHAAAEQALApgBA6QgBAzgCAbIgGBSQgCAhgIAfQgFAXgMAjQgLAhgHAgIgEAeIgIA1IgFAWQgdDVhQDWQgUA2gLA7QgoDTg9DYQgXBUgyDLQgQBEgMBMQgmDzhIEMQhcFagnClQgNA1g3DSQgrCigVBmQgtDNglDPQgZCOgJDpQgIC9AVD4QALCGADBdQAFB9gGBoQgICZgIBVQgMCEgWBrQgzD2gaB1IgVBiQgeCNgKCSQgDAsgIAhQAAACgEAEIgGAEIgIADIgHAAIgHgBIgGgDIgFgEIgEgGIgGgQQgKjuBKjzQAbhaAQhTQAgitAIgtQAVh7AKhgQASiwgOjlIgPjqQgJiQgEhbQgMkLAajHQAejtA8j3IAqitQANg4Awi1QAmiSAUhbQAdiBBTlNQBCkCAkjIQAFgdADgnQA3jIAciXQAXh9AsiUQAvibAah/QAeiPAziLQAfhTAKhdQAOh7Alh8IAGgXIAGg+IACgKIADgVIACgMIAAgoIgBgfQABgHgCgOIgFgWIgIggIgFgRIAAAuQAABkgIA1QgjD+hCC0QgtB8gaBiQhPEogqCUQhNEOgmCxQgyDihMD/QhID3gtDkIgpDLIgqDIQgTBbgcB9IgyDWQgsC9gWEDQgJBigFCBIgHDlQgFCfAOEaQAICoABBLQADCHgJBvQgJBygiCFQgYBdgwCNQhUD6gEDMQgCA3gPBDQgGAYgIARQgCAEgEAEIgIAHQgFADgDAAIgKABIgBAAIgIgBgEAIxgwQIACgFIAEgJIAHgWIABgGQACgDgBgCIAAgMIgDgFQgCgCABgDQAAgCgDgJIgDgHQgDAfgCA4gEAIqgyPIAIAYIAAgDIABgJIADgKIAAgEIAAgJIgBgCIgEgCIgJgGQgEgCgBgDQACALAFAPg");
	this.shape_11.setTransform(4.225,-0.3533);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("EgJ4A1WIgIgDIgIgGIgFgIIgDgJIgBgIIAAgGIACgHIAThBQACjlBdkEQA4ieASg4QAmh5AOhkQAQhmgCiDQgBhZgMiVQgMidgEhQQgIiEABhqIAAjpQAAiIAEhjQAFiIALhlQANiBAahtIA6jpQAiiMAUheIBsnWQAsjDBTkKQBNj4AvjPQAoixBQkRQAZhUAiiIQAqiqAPg1IA8jeQAih7AghiQAfhmAGh+QAEhYgLiPIgGhzQgGhDgTgtQgBgCABgGQgBgDADgGQABgEAEgCQAEgFADAAIAIgBQAFAAADACQAHADABADQAFAGABACIAJAYIAJAZIAAgBIAGgGIAGgEIAJgCIAIAAIAIACQAEACADADIAHAIIAQAZIAEAJIAEAIIAJAMIAGAFIAIAFIAIAHIAGAHIAFAIIAKAbIABAIIAAAXQAAANAGAOQAHATAAAHIgCAXIgBALIgGAVQgEAIABADQAKAmABA9QAAAqgCAkIgEBSQgCAggGAhQgFASgLAoQgNAlgEAcIgGAzIgBALIgIArQgaDahMDUQgSA2gLA8QgnDTg+DZQgXBNg3DSQgQBCgOBOQgrDuhPEQQheFBgyC8IhJEGQgsCegYBpQgvDYgfDFQgOBUgFBmQgEBLgBBzQgDC/AaD2QAPCIAFBcQAIB9gEBoQgFCVgHBaQgMCEgXBsQgrDQgnCbIgYBiQgjCPgPCQQgFAqgJAiQgBACgDADQgDADgEACIgHACIgHAAIgHgBIgGgDIgGgFIgDgGIgCgGIgDgKQgBjtBQjyQAdhXAShWQAeiVAMhEQAVh5AIhjQAQiugSjoIgVjpQgNiSgHhZQgSkTAUjAQAaj1A6jyIAtitQAShIAuilQAriYAUhUQAkiRBYk9QBGj6ApjOQAGghAEgiQA8jLAciUQAXh0AuidQAuiYAaiCQAciTAwiIQAchRAKhgQALh6Ajh+IAEgQIABgHIAJhdIACgMIgChIIgCgVIgFgVIgKggIgEgPIABAsQABBmgGAzQgdD8g/C4QgpB2gbBpQhMEtgrCQQhQETgpCsQgzDfhTEBQhOD7gxDfIhbGTQggCQhHEcQgsC6gSEGQgGBkgBCBQgCA5AACsQAACeAVEcQALChADBTQAFCGgIBxQgHBzgiCEQgZBigxCIQgqB7gYBlQgdB4gHBtQgDA4gSBCQgHAWgIASQgDAEgEAEIgIAGIgJAEIgJAAIgKgCgEAIygwUIAKgXIAGgXIAAgMIgEgEQgDgDABgCQACgDgCgEIgCgFIgEgHQgDAhgBA1gEAIqgyRIAJAZIgBgEIABgKIACgJIABgEIgBgJIgBgCIgNgIQgFgCAAgCQACAKAGAPg");
	this.shape_12.setTransform(4.4,-0.375);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("EgJ6A1WQgGgCgDgCIgHgHQgDgCgCgGIgCgJIgBgHIAAgGIAQgyIAEgLIADgLQALjaBkkLQA3iSAVhEQAmh3AOhlQAOhmgEiEQgDhXgOiYIgVjsQgLiGgChpIgGjqQgEiGAChlQACiKAJhkQAMiDAahsIA7jrQAniXAUhSIB1nVQAxjGBXkGQBSj4AyjNQApimBVkcQAbhaAgiCIA2jfIA4jeQAgh+AdhhQAehlADh/QABhSgMiVIgIh0QgHhDgUgrQgBgDABgGQAAgCACgGQABgEAEgEIAHgEIAIgCQAFABAEACIAIAFIAGAIIASAxIAAgBIAGgFQAEgEADgBIAIgDIAIABQAEAAAEABIAHAGIAIAHIALARIANAYIAJANIAGAEIAJAFIAIAHIAHAGIAFAIIAKAbIACAIIAAAXQAAALAGARQAIASAAAHIAAAMIgBALIgCALIgDAKIgDAMQgEAHABAEQALAnABA8QABAqgCAjIgCBTQgBAfgGAiIgPA6QgLAmgFAcIgDAeIgCAfIgIAsQgUDYhJDYQgTA5gKA6QgkDWhBDYIhREfQgTBAgPBPQgwDuhVEOQhrFUgwCoIhOEGQguCbgaBsQgxDQgbDNQgTCLAEDtQADDDAgDyQARCHAIBeQAKB9gCBoQgCCXgHBZQgJCFgYBsQguDTgrCZIgaBhQgoCOgUCQQgGAugKAeQgBADgEADIgHADQgCADgFgBIgHAAIgHgBIgGgDIgFgGIgDgFIgFgRQAHjrBYjyQAfhWAThXQAeiJAOhQQAVh3AHhkQANixgYjlQgHhHgSijQgRiYgIhSQgakTAPjBQAUkCA7jpIAtitQAWhPAvieQAvicAWhQQAniSBek6QBOkCAsjEQAGgdAFgnQBAjGAeiYQAYhzAvidQAuiZAYiBQAciZAriEQAbhTAHhfQAKh+Agh7IAFgXIAHhdIACgNIgCgoIgCgfIgDgVIgFgVIgPguIABAqQAEBrgFAwQgYD+g8C3QgmB1gaBrQhCEagyClQhfE8ggCCQg5DjhVD9QhVEAg0DYIhkGSQgSBLgkCMIg2DUQguC9gLEEQgEBlACCBIAFDlQACBjAJB7QAFBFAOCYQAPCjAEBSQAHCHgFBwQgGB1giCEQgaBmgxCFQguB+gbBhQggB4gLBsQgFA4gVBBQgHAVgJATIgHAHIgIAGIgJADIgKABQgDAAgGgDgEAIzgwWIAJgXIAEgMIADgMIAAgLIgEgFQgCgCABgCQABgEgEgIIgEgGQgEAhAAA0gEAIpgyTIAJAYIAAgDIABgJIADgKIgBgNIAAgCIgFgBIgKgHQgEgCgBgBIAIAYg");
	this.shape_13.setTransform(4.5333,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-342,138.3,683.3);


(lib.PuppetShape_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WarpedAsset_1("synched",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EgJIA1SIgJgDIgIgGIgFgIIgDgHIgCgGIgBgHIgChFQhHj0AJkEQAIjpAwjtQAwjpA4juQA0jkBQjmQBPjiA/jYQBBjbAwjsQAwjnAAjsQABjUgHkIQgGjpAQjyQAPj2AIjfQAIjnAxjpQAyjhBajiQBajfB4jHQB7jNAyjsQAXhsAKh3IACgIIAFgIQADgDAEgBQAFgCAEAAIAIACQAFACACACQAEAEABAFIADAJIAAA0IABgBIAHgDIAIgBIAIABIAIADIAHAFIAFAHIAEAKIAEAUIACASIAFAZIADAHIAFAIIAGASIAAAJIgEAdIgDAIQgBAFgDAEIgFALQgFAKABAOQAAAMgBANIgEAXIgKAdQgDAHAAADQAAAygNAwQgLApgMAhIgcBOQgKAegPAeQgLATgUAgQgVAjgMAYIgKAbIgLAeIgSApQhPDWheC+QgZAzgOA6Qg0DOgoDaQgaCRgHCPQgDBGAEBLQAPECgDEDQgEESACD6QABEJgeEWQgYDZhADLQg3C2g+C6QhGDQg3DZQg7DqhCDQQhHDlgTDsQgPC1AUC7IALBkQAQCRAkCPQAMAuACAeQAAADgDAEIgEAGIgGAFIgHADIgHABIgHgBIgGgDIgFgEIgLgOQhWjogEj4IgEi3QgIjoA3jfQAjiPBEkFQBDj9A5jMQA9jaBPjkQBSjqAmjtQAOhPAIhdQAVjngGj6QgFjYABkBQAAj6gJjYQgBgegEgmQALjJAMigQALiPAniJQAfhvA0itQAqiNBKiFQAthRAdhXQAph5BChtIAIgPIAEgGIAjhYIAFgLIAXhZQACgIABgOIADghIABgXQABgFADgFIAIgZIADgKIACgKIACguQgZCYg9CQQhXDShsDCQg5BmgrBtQhWDZgwDgQgvDggIDjQgIDwgPD7QgPDvAID4QAHDIgCDTQgCDcgnDcQgpDkhDDeQhHDrhGDMQhFDLg5DdQg9DsgxDsQgzDwgND0QgMDuA3DpQAPA7ADBBQABAXgDAVIgEAJIgGAJIgHAGIgJADIgKABIgJgBgEAJOgxkIABgCIAEgJIAFgIIAFgMIAAgDIgCgDIgEgJIgCgGg");
	this.shape.setTransform(0.0494,0.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("EgJOA1TIgJgEIgHgGIgFgIIgEgHIgBgFIgBgSIAAgXIgBgkQhDj3ARkAQANjMAzkHIBdnWQAwjqBIjjQBHjgA9jcQA0i/A5kJQAwjpAFjpQAEjYgCkEQgBjxAUjpQAVjsAMjoQALjlAzjpQA0jnBXjbQBWjaB1jOQB2jMAqjvQAVh3AEhtIACgJIAEgHQADgDAEgCIAIgCQAFAAAEABQAFADACACQAFAFABADIADAJIABA0IACgBIAHgDQAEgCAEAAIAIABIAIADIAHAEIAFAHIAFAKIAFATIABAKIAEAaIADAHIAEAHIAFAIIAHASIABAJIgDAdIgLAcQgEALABAOQABAOgBALIgDAXQgBAEgCAGIgHAUQgDAGAAAEQACAygMAwQgKArgLAgIgaBOQgLAjgNAaQgKAUgUAgQgXApgIASIgKAcIgKAeIgEAKIgEALIgKAUQhGDMhiDJQgaA3gNA2QgzDSgqDWQgcCMgJCUQgEBIADBIQAKECgJEEQgIEUgFD3QgEEBgjEcQgaDWg8DNIhwFwQhADRgxDaQg0Dtg7DOQg+DZgYD5QgSC5AOC3IAIBkQALCMAiCTQALAuABAfQABADgEAEQAAACgEAEQgCADgEACIgHACIgHABIgHgBIgGgDIgFgEIgFgGIgFgIQhRjqACj3IABi3QgBjgA0jkIBdmVQA3jwA3jbQA5jlBIjbQBLjhAsj1QAMhMALhgQAZjpAAj3QAAjHAGkSQAFj5gFjZQgBgegDglQAMi0AQi1QANiNAniJIBTkcQAqiNBIiFQArhQAchYQAmh5BBhwIAFgIIACgGIAEgGIAghZIAFgLIAKgnIALgzIACgWIABghIABgXQAAgEADgGIADgIIACgHIAGgUIACgLIABgtQgYChg2CJQhWDdhlC5Qg7BugnBmQhUDZgxDgQgxDfgMDjQgMDegUENQgVDzAEDzQADDHgFDTQgFDZgqDeQgsDug8DTQg+DehFDbQhBDSgxDYQgsDBg3EYQg0EKgSDZQgUDvA0DnQAOA9ABA/QAAAagDARIgDAKIgHAIQgEAFgDABIgJADIgKABQgFAAgEgBgEAJJgxjIABgEIAJgSIAEgMIABgDIgDgDIgHgOg");
	this.shape_1.setTransform(0.529,0.025);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("EgJTA1UIgJgEIgHgGIgFgIIgDgHIgBgGIgBhMQhAj7AZj8QARiwA4kfQAThhAYiJIAojsQApjvBCjgQBEjsA1jSQAniaBCkwQAyjqAIjnQAJkEACjYQADjmAajzQAajyAPjhQARjnAzjmQA3jtBSjUQBXjfBvjKQBwjMAijxQATiCgChjIACgIQABgFADgDQADgEAEgBIAIgDIAIABIAIAEIAGAIIADAKIAEA0IABgBIAHgEIAIgCQADgBAFABIAIADIAHAEIAFAHIAGAJIADAKIAHAmIADAHIACAHIAEAHIAGAHIAIASIABASIgBAUIgCAJIgIAUQgEANACAMQACAMgBANIgDAXIgFAUIgEAKQgDAHAAADQADAxgLAyQgJAsgKAgIgXBOQgLAkgMAZIgcA1QgVAlgKAYIgSA6IgRApQhCDLhhDMQgZAzgOA6QgzDXgrDRQgcCIgNCXQgFBEABBMQAGD/gOEHQgQEdgJDtQgJD1goEnQgdDYg4DJQgkB7hGD2Qg7DRgqDbQgvD6gzDDQg1DLgeEHQgWC/AKCwIAFBkQAICOAeCSQAJArACAiQAAACgDAFIgFAGQgDADgDABIgHACIgHABIgHgBIgGgDIgFgEIgEgGIgGgJQhMjtAKj0IAFi2QAFjaAxjoQAvjdAki4QA1kKAsjDQAxjhBGjgQBHjhAuj2QAPhVAKhXQAejzAEjsQAEi5AMkfQAKjwAAjiQgBgigCgiQANicAVjLQAOiNAniJIBSkbQApiLBHiHQAphOAbhbQAjh3A/hzIAKgVIAHgXIAGgSIAWg8IAThaIABgWQABgRgBgRIAAgWIACgLIAJgYIACgLIADgKIAAgMIgBgLIgBgWQgXCtguB+QhRDhhiC4Qg3BpgqBsQhQDUgzDkQg0DogPDaQgQDkgaEGQgZDwgBD1QgBDAgJDaQgJDbgrDaQgwD8g0DFQg7Dig+DYQg6DKgtDjQgPBLhIGQIgqDxQgWCHgMBqQgbDuAwDmQAMA7ABBBQAAAYgEATQgBAEgDAFIgGAJIgIAFQgDACgGABIgJABIgKgBgEAJGgxkIABgFIAIgRIACgEIACgJIAAgDIgCgDIgGgIIgDgGg");
	this.shape_2.setTransform(0.9359,-0.0562);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("EgJXA1UIgJgEIgHgGQgCgCgDgGIgDgHIgBgGIgBgIIABgJIAAgYIABgXIAAgMQg8j7Agj8QAMhiAZiEIAsjlQAUhiAUiHIAijtQAjj2A6jbQA2jQA5jwQAVhcAeiJIAxjmQA0juALjjQANj2AIjmQAHjkAfj0QAhkCASjQQATjhA1jqQA4jtBQjTQBRjYBujSQBqjMAbj0QAQiMgGhZIACgIQAAgDAEgFIAGgGIAIgDIAJABIAHAEIAGAIIAEAJIAFA0IACgBIAGgEIAIgCQAGgBADABIAIACIAHAEQACABADAFIAGAJIAGAUIAEASIAFARIADAHIAEAGIAGAIIAJARIACAJIAAAdIgCAIIgDAJIgEAMQgDANACANQACASAAAHIgDAXIgFAUIgDAKQgDAHAAADQAEAygKAxQgHAogKAkIgVBQQgIAfgOAeQgIATgTAjQgTAkgJAZIgeBZIgEALQg8DIhiDRQgZA1gNA4QgtDBgyDnQgeCKgPCUQgGBGAABLQABEHgUD+QgTDsgSEeQgNDaguE/QgeDXg3DJQgkCCg+DvQg1DNgkDhQgoEDgsC9QgrC0glEfQgZC/AECuIADBkQADCQAcCQQAIAtAAAgQAAADgDAEIgFAGQgDADgDABIgHACIgHABIgHgBIgGgEIgFgEIgEgGIgFgJQhHjvARjzIAKi1QAKjRAvjuQAmjBAkjUQAvkfAiiwQAsjpBBjbQBBjbAxj9QAPhNANheQAjkBAJjeQAIjKASkNQARj/ACjSQABgcgDgoIAolmQAPiJApiMIBRkbQAoiMBEiGQAohOAahcQAih5A7hzIAKgVIALgpIAGgUIALgdIAEgLIAHgnIAJg0IAAgWIgCg4QAAgFADgFIACgIIADgHIAGgVIACgKIAAgMIgCgLIAAgMIgBgHQgLBWgMA+QgQBSgWBDQhODphdC0Qg1BngqBuQhMDMg2DsQg2DqgSDYQgTDaghEOQgeDzgGDyQgECzgODmQgMDWgsDfQg3ETgqCtQhLEwgkCLQg2DQgkDfIgmDtIgmDvIgrDyQgaCUgOBcQgiDtAsDlQALA6gBBCQgBAagDARIgEAJIgHAJIgIAFIgJADIgJABIgJgCgEAJDgxmIABgFIAIgSIABgEIACgIIAAgDIgDgDQgEgEgCgEIgDgFg");
	this.shape_3.setTransform(1.3435,-0.125);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("EgJdA1UIgIgEIgHgGIgFgIIgDgHIgBgGIAAgIIAAgKIACguIABgMQg4j7Anj7QAOhaAdiKQAoi9AHgmQAThlARiFQAJhCATiqQAdj8AyjXQAvjJA1j6IAvjlIAxjnQA1jyAPjfQAUkTAKjIQANjpAkjuQAnkGAUjLQAVjZA5jxQA7j4BLjHQBRjdBnjPQBkjKAVj3QAGhJABgqQAChAgGgzQAAgDABgFQABgEADgEIAGgGIAIgDIAJABQAEABAEACIAGAIIAEAJIAEAaIADAZIABgBIAHgEQAFgCADAAIAIgBIAIACIAIAEIAFAGIAGAJIAKAdIACAJIACAJIAGAOIAFAGIAGAHIAGAJIAEAIIACAJIABAdIgHAdQgDAMADAPQACAOAAALIgCAXIgKAkQgCADABACQAFAygIAxQgJAxgHAbIgTBQQgIAhgMAdQgFAOgVAoQgTAngIAXQgFATgEAJIgHAfIgLAfIgFAKQg3DHhiDVQgXAzgOA6QguDGgyDiQgfCIgRCWQgIBIgBBJQgEEAgaEEQgeEwgSDZQgKB5gUCUQgNBhgaCqQghDeg0DBQgiB9g5D1QgvDIgdDnQggEDgoC+QgVBkgUCEIgjDsQgcDEgBCpIAABjQAACPAXCSQAHAsAAAgQAAADgDAEIgFAGQgDADgEABIgGACIgIAAIgGgBIgHgDIgEgFIgJgPQhCjvAYj0QAJhaAGhaQAOi+Avj/QAji/AcjWQAqkvAZihQAojyA6jUQA+jfAzj5QAOhGAQhmQAokJANjVQAMi6AYkcQAWj0AHjdQACgcgCgnIAtlmQAQiIApiMQAuifAih7QAoiOBCiFQAphSAWhZQAfh4A4h1IAFgJIAFgNIAahaQAAgEAEgIQACgLAEgcIAFgeIACgWQABgHgBgPIgCghIgCgWQAAgFACgGIACgHIADgIIAGgVIACgKIAAgMIgCgLQABgDgCgJIgBgJIAAgBQgKBfgJA5QgOBTgVBDQhJDthZCyQg2BsgmBqQhLDQg3DoQg3DogWDaQgYDjgmEEQgjDzgLDxQgIC2gSDiQgQDXgtDdQhFFRgZBuIhkG+QgvDLgeDlIgfDuQgTCPgPBhQgOBZgeCZQgiCugLBBQgpDvAnDiQAKA4gCBEQgBAYgEASQgBAFgDAFIgHAIIgIAFQgEACgFABIgJAAIgKgCgEAJAgxoIAAgEIADgKIAFgJIABgEIABgIIAAgDIgDgDIgGgIIgDgFIACA2g");
	this.shape_4.setTransform(1.7952,-0.175);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("EgJiA1VIgJgFIgHgGIgEgJQgCgCgBgFIgBgFIADg1IABgMIABgLQgyj8Atj5QAPhPAiiUQAjiYAOhJQAThlAOiEQAIhHAOimQAWkBArjTQAni/AykHIAsjmQAaiGAVhhQA2jyAUjfQAaknANi0QASjnApjvQAskCAXjNQAZjaA7jwQA+j7BFjDQBPjaBkjTQBejHANj8QAFhRAAgiQAAhBgHgyIABgIQAAgEAEgEQABgDAFgDQADgCAEgBIAJAAQAFABADACIAGAIQADAEACAFIAJAzIABgBIAGgEIAIgDIAIgBIAIACIAIADIAFAGIAHAJIAIATIACAJIADAJIACAJIAHAOIAFAGIAGAHIAGAIIAFAJIACAIIADAdIgBAJIgFAVQgDANADANQADAQAAAKIgCAXIgFAUIgDAKQgDAHAAAEQAHAwgHAzQgFAkgJApIgRBQQgGAfgNAgIgYA3QgTAngHAXIgPA7IgLAfIgEALQg1DLheDSQgYA3gNA3IhhGoQgeCEgVCaQgJBDgDBOQgID6ghEKQgoFNgUC7QgMBzgYCYIgpELQgjDXg0DHQgjCJgxDpQgpDLgVDlQgaETggCwQgRBdgVCNIgjDrQgfDKgGCiIgDBjQgFCOAUCTQAGArgBAiQAAACgEAEIgFAGQgCACgEACIgHACIgHAAIgHgBIgGgEIgFgFIgJgPQg6jvAfj0QALhdAIhWQAQipAvkSQAgi3AXjeQAhlDATiPQAfjzA3jVQA7jgA0j5QAOhFARhmQAukOARjQQAQi4AgkdQAcj6ALjWQACgegBgmQAfjVATiQQARiIApiLQAuibAih/QAmiMBBiIQAnhRAVhaQAdh5A1h2IAEgJIACgGIADgHIAUhPIADgLIAEgMIAJhGIACgWIgBgWIgDghIgCgWQgBgEACgHIAGgPIAGgVIACgLIAAgLIgCgGQgBgDAAgCQABgDgCgJIgCgIQgLBzgFAjQgMBWgSBBQhEDvhWCzQg0BtgmBqQhFDGg7DyQg5DrgaDWQgaDcguELQgoD9gPDmQgNC2gVDhQgUDTgvDgIhaG/QgfCVg6EqQgoDKgZDoIgYDvQgOCLgPBmQgPBjgeCPIgyDuQgwDtAiDiQAJA5gEBDQgCAbgEAQQgBADgDAGIgHAIIgIAFIgJACIgKABgEAI9gxpIAAgFIADgJIAEgJIABgEIABgJIAAgDIgDgCIgHgIIgEgGIAFA3g");
	this.shape_5.setTransform(2.2411,-0.2083);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("EgJeA1WQgGAAgEgCIgIgEIgHgHIgEgIIgDgHIAAgGIAAgIIAGhEQgsj8A0j4QAOhAAnigQAjiNAQhUQAThkAMiEQAGhJAKikQAPkHAljPIBNnIIAojnQAYiDAXhkQA4j5AXjZIAwnaQAXjkAujxQAvj2AcjYQAdjcA8jsQBBkEBBi6QBPjgBcjPQBXjBAJkDQADhYgBgbQgBhCgJgxQAAgCABgGIADgIIAGgGQAEgDAEgBQAEgBAFABQAFABACACIAHAHQAEAGABAEIAKAzIABgCIAHgEIAHgDIAIgBIAJABIAHADIAGAGIAHAJIAIASIADAKIADAIIADAJIAHAOIAFAGIAHAHIALAQIACAIIAEAdIgBAJIgBAJIgDAMQgCANADAOQAEAOAAALIgCAXIgCALIgCAKIgDAKQgEAHABAEQAHAsgGA3QgFAqgGAjIgQBRQgHAkgKAbQgJAYgOAfQgTAqgGAVIgHAcIgKAqIgGAVIgEALQgxDMhdDTQgXA1gNA6QgxDfgwDJQghCHgWCXQgKBFgEBLQgOEAgnEEQgvFGgZDAQgOBugbCdIguEKQgjDPgzDPQgkCQgoDiQgkDIgODqQgREQgcC0QgMBJgWChQgWCZgNBSQgjDPgKCdIgGBjQgICOAPCTQAFAsgDAhQAAACgDAEIgGAGIgGAEIgHABIgHAAIgHgCIgGgDIgEgFIgEgGIgFgJQgzjxAljzQAPhbAJhXQALhhATh8IAkjcQAbipASjsQAXlAAPiTQAZj6AyjQQA6jxAyjqQAQhOARhdQA0kbAVjCQAQiTAqlBQAij5AQjWQACgeAAgmQAjjUAUiQQATiHApiMQAxilAeh0QAliNA+iIQAmhSAThaQAah3Azh5IAEgJIAFgNIAEgXQACgLACgIIAFgUIAFgSIADgMIADgLIAFgoIADgfIABgVQAAgHgCgPIgEghIgDgWIgFAyQgKBYgQBAQg+DxhTC0Qg0BvgkBpQhCDCg9D2Qg8DygcDOQgeDbgzELQguD7gUDnQgSDKgYDNQgVDFgyDtQgUBegZCBIgqDfQgMBDhCF+QgiDIgSDsIgSDwQgLCKgPBnQgOBngfCMQgRBQgmCdQg2DtAdDhQAHA4gFBDQgBAVgGAWQgBADgEAFIgHAIIgIAFIgJADIgCAAIgHgBgEAIzgv/IABgFIACgHIADgIQABgEADgHIACgKIACgLIAAgMIgCgFQgBgDAAgDIgBgLIgCgHIgIBdgEAI6gxsIAAgEIAGgTIABgEIABgJIgBgCIgDgDIgHgHIgEgFIAHA1g");
	this.shape_6.setTransform(2.6719,-0.2417);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("EgJlA1XIgJgCIgIgFIgHgHIgEgJIgCgHIgBgGIABgRIADgXIAEgjQgnj6A8j5QAJgnAxi3QAkiHAQhYQAThlAJiDQAGhSAGibQAIkIAdjQQAqkwAYiaQAsksAmikQA5j6AbjYIA6naQAcjjAzjxQA4kNAcjAQAfjQA/j3QBGkPA7itQBOjlBWjMQBRi/ACkHQABhXgBgcQgChCgMgwQAAgDABgGIADgIQACgDAEgDIAIgEQAEgBAEABQAGABACACQAGAFABACIAFAJIAMAyIABgBIAGgFIAHgDIAJgBIAIABQAGABACACIAGAGIAGAIIAKASIAGASIAHAQQABAEADACIAFAGIAHAGIAMAQIADAJIAFAcIgBAJIgBAJIgCAMQgCAMAEAPQAFAQAAAKIgCAXIgHAfQgEAHABAEQAIAtgFA2QgEArgGAiIgNBRQgGAkgJAcQgJAZgNAfQgRApgHAWIgMA8IgNAqQgsDNhcDVQgXA2gMA5QguDUg1DUQgfB/gbCfQgMBEgFBNQgSDyguERQg0EzghDSQgQBngeCjIgxEKQgkDHgyDWQgiCLgjDoQgeDHgHDrQgIEZgYCtIgfDrQgSCMgRBgQglDQgPCbIgIBjQgNCOALCSQADArgDAiIgEAGIgFAGQgDACgEABQgDACgEAAIgHAAIgHgCIgGgEIgEgFIgDgGIgFgKQgsjwAtjzQARheALhTQALhXAViFIAjjcQAaisALjpQAOlPAJiEQARj6AujTIBqnbQARhOASheQA8k2AWimQAUibAyk5QAoj7ATjTQADgeABgmQAnjSAViRQAUiGAqiMQAtiYAhiCQAkiLA9iKQAkhSAShbQAWh5Axh5IAIgWIAThbIADgMIADgoIADgfIAAgVIgCgWQgBgOgFgTIgDgUIgEAwQgIBagOA+Qg5D4hPCwQgwBtgkBsQg/C+hAD7Qg+DzggDNQgiDgg4EFQgyDygbDuQgUC2geDhQgXC8g1D1QggCWgzEpQgUB4gvFKQgbDDgMDyIgMDxQgICJgOBqQgNBpggCKIg8DrQg8DsAXDgQAGA2gHBGQgCAXgGATQgBAEgEAFIgHAHIgIAFIgJACIgDAAIgHAAgEAIxgwGIADgHIADgIIADgLIADgLIACgLIAAgLIgCgFQgCgEABgCQAAgDgCgJIgCgIIAAgBIgHBbgEAIxgyIIAFAaIAAgEIACgKIADgJIABgEIABgJIgBgCIgLgKIgEgFIAEAbg");
	this.shape_7.setTransform(3.2188,-0.2667);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("EgJsA1XQgGgBgDgCIgIgFIgGgHIgGgQIAAgGIAAgHIAJhDQgej7BCj3IA+jcQAkiDARhbQAThlAHiEQAEhUABiZQADkTAWjGIAajlQAPiJAMheQAmklAnitQA8kAAdjSIBFnZQAgjgA5jzQA6kAAhjLQAjjSBBj0QBNkmAxiWQBQjyBNjBQAqhnAQh5QAPhogBh/QAAhigCgRQgDhDgNgvQgBgDACgGQAAgCACgGQADgEADgCIAHgEQAFgBAEABQAGAAACACQAFAEACADQAEAEACAFIAMAyIABgBIAHgFIAHgEIAIgBIAJABIAHADIAGAFIAIAIIAJASIADAJIAEAJIAHAPQABAEADADIAGAFIAHAGIAMAQIADAIIAFASQACAGAAAEIAAAJIgBAJIgCANQgBAOAEANQAFASAAAHIgCAYIgBAKIgGAVQgDAHAAAEQAJAtgEA2QgCAngGAmIgLBSQgFAjgJAdQgGATgPAlQgQApgGAXIgFAdIgGAfIgMArQgoDOhaDWQgWA4gMA3QgqDHg6DiQggCDgdCbQgNBGgHBLQgXD3g0ELQhGFpgbCbQgQBggjCpQgnC6gOBPQgoDWguDHQggCOgdDlQgZDHACDsQAAEagVCtIgbDrQgQCIgTBlQglDMgVCfIgLBiQgSCMAGCVQACAugFAfQAAADgDADQgCADgEACQgDADgEABIgHABIgHAAIgHgCIgGgFIgDgFIgIgPQgkjxA1jzQAVhiAKhOQAKhHAYiUQAYiPAKhNQAZiwADjlIAEjpQACiJAEhiQALkAApjNQAmi9BAkhIAlirIAxjuQAaiGARhoQAaipA2kqQAuj+AXjPQAEgdACgmQApjHAYibQAViHAqiMQAwiiAeh3QAhiLA7iLQAjhQARheQAUh6Ath5IAGgQIACgHIARhcIADgMIAEhGQABgIgBgOIgJg2IgFgUIgCAwQgHBdgLA8Qg0D4hLCyQgxB0ghBmQg5C0hFEGQhADxgiDPQglDWg+ENQg5D0geDsQgPBqgsErQgZCug4ECQgmCrgpEUQgTCEglFAQgVC+gFD5IgGDxQgGCIgMBsQgNBsghCHQgQA/gvCsQhDDxARDaQAFA1gJBGQgDAYgHASQgBAEgEAFIgHAHIgJAEIgJACIgCABIgIgBgEAIugwJIADgHIADgIIAHgVIACgLIAAgMIgDgFQgBgDAAgCQABgEgDgIIgCgIIgHBZgEAIygxwIAAgEQAAgFACgFIADgJIAAgEIABgJIgBgCIgDgDIgIgHIgFgFIALA1g");
	this.shape_8.setTransform(3.75,-0.2917);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("EgJuA1XQgGgBgDgCQgFgCgDgDIgHgHIgCgJIgDgHIAAgGIAAgIIADgJIAJg6QgXj2BIj5QAtiSAVhJQAlh/AQheQAThmAEiDQAEhWgCiXQgFkYAQjCIAUjmQALiGAKhiQAfkeAqi2QBBkaAdi5QAZibA1k9QAkjcA/j1QA+j7AmjQQAmjQBDj1IA8jdQAiiAAeheQBQj9BFi4QAnhnAOh6QAMhlgEiCIgDhzQgEhDgPguQgBgDACgGQgBgDADgFQABgEAFgDIAHgEQADgBAFABQAFAAADACIAIAGIAGAJIANAyIABgBIAGgFIAIgEQAEgCAEAAIAIACQAFAAADACIAGAFQAEAEADAEIAKASIAFAJIADAIIAHAQIAEAGIAOALQAEAEADAEIAFAHIAHARIAEATIgCAfQAAAKAEARQAGARAAAJIgCAXIgBAKIgGAVQgDAIAAADQAJAsgCA3QgDAygEAcIgJBSQgDAfgJAhQgHAXgNAiQgPAogGAYIgFAdIgEAfIgJAhIgCAKQglDRhXDWQgUA0gNA8QgvDfg1DKQggB9ghCiQgOBAgIBQQgdD3g6EKQhBEkgsDeQgRBXgoCyQgoCugRBaQgiCtgyDwQgfCLgVDpQgTDBAHDzQADCIAABcQgCB8gJBnQgQCkgIBJQgPCEgUBpQgnDKgaChIgOBiQgWCPABCSQABAsgGAhQgBACgEAEIgFAEQgDADgEABIgHABIgHgBIgHgCIgFgFIgEgFIgDgGIgEgKQgcjwA7jzQAXhaANhVIAljbQAWiEALhXQAWiwgCjlIgDjpQgCiLABhgQAEkHAjjIQAljPA+kRIAmisIA1juQAfiJAShkQAYiGBDlLQAzj6AdjSQAEgiACgiQAvjPAYiSQAWiGAqiMQAuiYAfiBQAhiNA4iKQAihVAOhaQARh5Ash8IADgJIABgHIACgGIANhRIACgMIADgMIACgoIAAgfIAAgVIgEgWIgLgyIgCAuQgEBfgLA6QgsD6hKC0QgvBzggBoQg3C6hFEAQhED8gkDDQgpDghCEDQg+DygkDsIhCGVQgeC0g5D7QgoC1giEKQgTCPgZE3QgQC7ABD8QABCygCBAQgCCIgMBtQgLBugjCGQgTBOgvCdQhJDzALDWQADA4gLBDQgEAXgHASQgBAEgEAFIgHAHIgJAEQgEACgFAAIgDAAIgHgBgEAIwgwMIAJgYIACgLIADgMIAAgLIgDgFQgBgDAAgCQABgDgDgJIgDgIQgCAXgDBBgEAIygxxIAAgFIABgKIAEgJIAAgEIABgJIgBgCIgEgCIgJgHIgEgFIAMA1g");
	this.shape_9.setTransform(3.9,-0.3137);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("EgJxA1XIgJgDIgIgGIgGgHQgBgCgCgHIgCgIIAAgFIABgIIAMg3IACgLQgPjzBPj7QAviRAWhIQAlh9ARhgQARhmADiDQAChWgGiXQgLkhALi5IAMjoQAIiFAIhkQAYkdAri5QBHkuAdilQAcibA8k8QAojVBEj7QBEj9ApjNQAnjJBGj7IA8jcQAjiHAbhYQBRkOA8ipQAlhmALh7QAJhigGiGIgFhzQgFhCgQguQgBgDABgGQAAgDADgFQABgEAEgDIAHgEIAJgBQAFAAADACQAFADADAEIAFAIIAPAyIABgBIAGgGIAHgDQAEgCAEAAIAJABQAEAAADACIAHAFIAHAIIALARIAPAhIAFAGIAFAFIAQANIAGAHIAEAIIAIAcIgBAfQgBAMAFAPQAGASABAIIgCAXIgCAKIgFAVQgEAIABADQAKAsgCA3QgCAzgDAbIgHBSQgEAlgIAbQgFAVgNAlQgOAngFAZIgFAdIgEAgIgHAgIgDALQghDShTDXQgVA3gLA6QgrDTg5DXQgeBsgoCzQgPBIgKBIQggDuhDESQhWFngjCaQgOBEgwDDQgoClgUBjQhAE6gTBjQgcCOgPDnQgNC9AND4QAICHABBcQACB9gHBoQgMCbgIBSQgOCEgVBqIhHFrIgSBiQgaCNgECTQgBArgHAhQAAADgFADQgBADgEACIgHADIgHABIgHgBIgHgDIgFgEIgEgFIgDgHIgDgKQgUjuBDj0QAYhXAQhXIAmjaQAVh9ALheQAUivgIjmIgKjqQgFiNgCheQgEkJAfjIQAijdA9kEIAoitIA5jtQAiiNAThgQAgieBGkyQA6j7AhjQQAFgiACghQA0jNAZiUQAWh9AsiUQAtiUAeiGQAfiOA2iKQAhhWALhaQAQh5Aoh9IAHgWIAMhdQAAgEADgIIAAhHIgBgVIgEgWQgBgJgHgXIgEgRIgBAtQgCBigJA4QgoD7hGC0QguB5gdBjQgZBYglCGIg8DdQhJEGglC6QgtDghHEBQhED3goDmIhLGUQgZCNhCEiQgsC/gbEAQgLBjgICAQgEA1gJCvQgKCwAHEJQAFCxAABBQgBCIgKBtQgKBwgiCGQgWBWgvCUQhPD3ADDRQABA4gNBCQgEAWgIATIgGAJIgIAHIgIAEIgKABIgJgBgEAIxgwQIABgEIAIgTIADgLIACgLIAAgMIgDgFQgCgCABgDQAAgCgDgJIgCgHQgDAdgCA4gEAIrgyOIAHAYIAAgCIABgKIADgJIABgEIgBgJIAAgCIgEgCIgJgHIgFgFIAHAag");
	this.shape_10.setTransform(4.0625,-0.3333);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("EgJ0A1XIgJgEIgIgFIgFgIIgDgJIgCgHIAAgGIABgIIALgrIADgMIADgLQgHjsBWj/IBIjYQAlh6AQhiQARhmAAiDQAAhZgIiVQgRkpAEiyIAHjoQAEiGAGhjQAIiIAMhlQAQiAAZhsIA3jpQAfiEAUhmIBhnXQArjPBLj/QBKj/ArjJQAni4BMkMQAUhIAniUQAmiSAWhNQBRkfA0iaQAihmAJh8QAGhegIiKIgGhzQgGhDgRgtQgBgCABgGQAAgEACgFQACgEADgCQAEgEAEgBIAIgBQAFAAADACIAIAGIAGAJIAQAxIABgBIAGgFQADgDADgBQAFgCAEAAIAIAAIAIACIAGAFQAFAEADAEIALARIAMAaIAIAMIAOALQAHAFABACIAGAHIAFAIIAJAbIAAAfQgBAMAGAPQAGAUABAGIgCAXIgHAgQgEAHAAAEQALApgBA6QgBAzgCAbIgGBSQgCAhgIAfQgFAXgMAjQgLAhgHAgIgEAeIgIA1IgFAWQgdDVhQDWQgUA2gLA7QgoDTg9DYQgXBUgyDLQgQBEgMBMQgmDzhIEMQhcFagnClQgNA1g3DSQgrCigVBmQgtDNglDPQgZCOgJDpQgIC9AVD4QALCGADBdQAFB9gGBoQgICZgIBVQgMCEgWBrQgzD2gaB1IgVBiQgeCNgKCSQgDAsgIAhQAAACgEAEIgGAEIgIADIgHAAIgHgBIgGgDIgFgEIgEgGIgGgQQgKjuBKjzQAbhaAQhTQAgitAIgtQAVh7AKhgQASiwgOjlIgPjqQgJiQgEhbQgMkLAajHQAejtA8j3IAqitQANg4Awi1QAmiSAUhbQAdiBBTlNQBCkCAkjIQAFgdADgnQA3jIAciXQAXh9AsiUQAvibAah/QAeiPAziLQAfhTAKhdQAOh7Alh8IAGgXIAGg+IACgKIADgVIACgMIAAgoIgBgfQABgHgCgOIgFgWIgIggIgFgRIAAAuQAABkgIA1QgjD+hCC0QgtB8gaBiQhPEogqCUQhNEOgmCxQgyDihMD/QhID3gtDkIgpDLIgqDIQgTBbgcB9IgyDWQgsC9gWEDQgJBigFCBIgHDlQgFCfAOEaQAICoABBLQADCHgJBvQgJBygiCFQgYBdgwCNQhUD6gEDMQgCA3gPBDQgGAYgIARQgCAEgEAEIgIAHQgFADgDAAIgKABIgBAAIgIgBgEAIxgwQIACgFIAEgJIAHgWIABgGQACgDgBgCIAAgMIgDgFQgCgCABgDQAAgCgDgJIgDgHQgDAfgCA4gEAIqgyPIAIAYIAAgDIABgJIADgKIAAgEIAAgJIgBgCIgEgCIgJgGQgEgCgBgDQACALAFAPg");
	this.shape_11.setTransform(4.225,-0.3533);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("EgJ4A1WIgIgDIgIgGIgFgIIgDgJIgBgIIAAgGIACgHIAThBQACjlBdkEQA4ieASg4QAmh5AOhkQAQhmgCiDQgBhZgMiVQgMidgEhQQgIiEABhqIAAjpQAAiIAEhjQAFiIALhlQANiBAahtIA6jpQAiiMAUheIBsnWQAsjDBTkKQBNj4AvjPQAoixBQkRQAZhUAiiIQAqiqAPg1IA8jeQAih7AghiQAfhmAGh+QAEhYgLiPIgGhzQgGhDgTgtQgBgCABgGQgBgDADgGQABgEAEgCQAEgFADAAIAIgBQAFAAADACQAHADABADQAFAGABACIAJAYIAJAZIAAgBIAGgGIAGgEIAJgCIAIAAIAIACQAEACADADIAHAIIAQAZIAEAJIAEAIIAJAMIAGAFIAIAFIAIAHIAGAHIAFAIIAKAbIABAIIAAAXQAAANAGAOQAHATAAAHIgCAXIgBALIgGAVQgEAIABADQAKAmABA9QAAAqgCAkIgEBSQgCAggGAhQgFASgLAoQgNAlgEAcIgGAzIgBALIgIArQgaDahMDUQgSA2gLA8QgnDTg+DZQgXBNg3DSQgQBCgOBOQgrDuhPEQQheFBgyC8IhJEGQgsCegYBpQgvDYgfDFQgOBUgFBmQgEBLgBBzQgDC/AaD2QAPCIAFBcQAIB9gEBoQgFCVgHBaQgMCEgXBsQgrDQgnCbIgYBiQgjCPgPCQQgFAqgJAiQgBACgDADQgDADgEACIgHACIgHAAIgHgBIgGgDIgGgFIgDgGIgCgGIgDgKQgBjtBQjyQAdhXAShWQAeiVAMhEQAVh5AIhjQAQiugSjoIgVjpQgNiSgHhZQgSkTAUjAQAaj1A6jyIAtitQAShIAuilQAriYAUhUQAkiRBYk9QBGj6ApjOQAGghAEgiQA8jLAciUQAXh0AuidQAuiYAaiCQAciTAwiIQAchRAKhgQALh6Ajh+IAEgQIABgHIAJhdIACgMIgChIIgCgVIgFgVIgKggIgEgPIABAsQABBmgGAzQgdD8g/C4QgpB2gbBpQhMEtgrCQQhQETgpCsQgzDfhTEBQhOD7gxDfIhbGTQggCQhHEcQgsC6gSEGQgGBkgBCBQgCA5AACsQAACeAVEcQALChADBTQAFCGgIBxQgHBzgiCEQgZBigxCIQgqB7gYBlQgdB4gHBtQgDA4gSBCQgHAWgIASQgDAEgEAEIgIAGIgJAEIgJAAIgKgCgEAIygwUIAKgXIAGgXIAAgMIgEgEQgDgDABgCQACgDgCgEIgCgFIgEgHQgDAhgBA1gEAIqgyRIAJAZIgBgEIABgKIACgJIABgEIgBgJIgBgCIgNgIQgFgCAAgCQACAKAGAPg");
	this.shape_12.setTransform(4.4,-0.375);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("EgJ6A1WQgGgCgDgCIgHgHQgDgCgCgGIgCgJIgBgHIAAgGIAQgyIAEgLIADgLQALjaBkkLQA3iSAVhEQAmh3AOhlQAOhmgEiEQgDhXgOiYIgVjsQgLiGgChpIgGjqQgEiGAChlQACiKAJhkQAMiDAahsIA7jrQAniXAUhSIB1nVQAxjGBXkGQBSj4AyjNQApimBVkcQAbhaAgiCIA2jfIA4jeQAgh+AdhhQAehlADh/QABhSgMiVIgIh0QgHhDgUgrQgBgDABgGQAAgCACgGQABgEAEgEIAHgEIAIgCQAFABAEACIAIAFIAGAIIASAxIAAgBIAGgFQAEgEADgBIAIgDIAIABQAEAAAEABIAHAGIAIAHIALARIANAYIAJANIAGAEIAJAFIAIAHIAHAGIAFAIIAKAbIACAIIAAAXQAAALAGARQAIASAAAHIAAAMIgBALIgCALIgDAKIgDAMQgEAHABAEQALAnABA8QABAqgCAjIgCBTQgBAfgGAiIgPA6QgLAmgFAcIgDAeIgCAfIgIAsQgUDYhJDYQgTA5gKA6QgkDWhBDYIhREfQgTBAgPBPQgwDuhVEOQhrFUgwCoIhOEGQguCbgaBsQgxDQgbDNQgTCLAEDtQADDDAgDyQARCHAIBeQAKB9gCBoQgCCXgHBZQgJCFgYBsQguDTgrCZIgaBhQgoCOgUCQQgGAugKAeQgBADgEADIgHADQgCADgFgBIgHAAIgHgBIgGgDIgFgGIgDgFIgFgRQAHjrBYjyQAfhWAThXQAeiJAOhQQAVh3AHhkQANixgYjlQgHhHgSijQgRiYgIhSQgakTAPjBQAUkCA7jpIAtitQAWhPAvieQAvicAWhQQAniSBek6QBOkCAsjEQAGgdAFgnQBAjGAeiYQAYhzAvidQAuiZAYiBQAciZAriEQAbhTAHhfQAKh+Agh7IACgJIADgOIAHhdIACgNIgCgoIgCgfIgDgVIgFgVIgPguIABAqQAEBrgFAwQgYD+g8C3QgmB1gaBrQhCEagyClQhfE8ggCCQg5DjhVD9QhVEAg0DYIhkGSQgSBLgkCMIg2DUQguC9gLEEQgEBlACCBIAFDlQACBjAJB7QAFBFAOCYQAPCjAEBSQAHCHgFBwQgGB1giCEQgaBmgxCFQguB+gbBhQggB4gLBsQgFA4gVBBQgHAVgJATIgHAHIgIAGIgJADIgKABQgDAAgGgDgEAIzgwWIAJgXIAEgMIADgMIAAgLIgEgFQgCgCABgCQABgEgEgIIgEgGQgEAhAAA0gEAIpgyTIAJAYIAAgDIABgJIADgKIgBgNIAAgCIgFgBIgKgHQgEgCgBgBIAIAYg");
	this.shape_13.setTransform(4.5333,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-67.8,-342,138.3,683.3);


(lib.Symbol5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AgOAkIgHgEQgNgIgDgPQgEgNAIgNQAHgNAOgFQAMgEAOAEQAPAEAHAOIADAHIAAACIAAACIABADIAAACQAAAIgEAIQgDAHgHAGQgFAFgHACQgGACgGABIgCAAQgHAAgHgCg");
	this.shape.setTransform(31.1443,-5.19);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29));

	// Layer_1
	this.instance = new lib.PuppetShape_33("synched",1,false);
	this.instance.setTransform(33.75,202.6);

	this.instance_1 = new lib.PuppetShape_30("synched",1,false);
	this.instance_1.setTransform(33.75,202.6);
	this.instance_1._off = true;

	this.instance_2 = new lib.PuppetShape_31("synched",1,false);
	this.instance_2.setTransform(33.75,202.6);
	this.instance_2._off = true;

	this.instance_3 = new lib.PuppetShape_32("synched",1,false);
	this.instance_3.setTransform(33.75,202.6);
	this.instance_3._off = true;

	this.instance_4 = new lib.PuppetShape_29copy("synched",1,false);
	this.instance_4.setTransform(33.75,202.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},6).to({state:[{t:this.instance_2}]},8).to({state:[{t:this.instance_3}]},7).to({state:[{t:this.instance_4}]},7).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},6).wait(23));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},6).to({_off:true},8).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},8).to({_off:true},7).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(14).to({_off:false},7).to({_off:true},7).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13.5,-9.4,112.5,416.5);


(lib.Symbol4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PuppetShape_22("synched",1,false);
	this.instance.setTransform(72.65,277.95);

	this.instance_1 = new lib.PuppetShape_14("synched",1,false);
	this.instance_1.setTransform(72.65,277.95);
	this.instance_1._off = true;

	this.instance_2 = new lib.PuppetShape_16("synched",1,false);
	this.instance_2.setTransform(72.65,277.95);
	this.instance_2._off = true;

	this.instance_3 = new lib.PuppetShape_21("synched",1,false);
	this.instance_3.setTransform(72.65,277.95);
	this.instance_3._off = true;

	this.instance_4 = new lib.PuppetShape_5copy3("synched",1,false);
	this.instance_4.setTransform(72.65,277.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},6).to({state:[{t:this.instance_2}]},9).to({state:[{t:this.instance_3}]},7).to({state:[{t:this.instance_4}]},7).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},6).wait(24));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},6).to({_off:true},9).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},9).to({_off:true},7).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(15).to({_off:false},7).to({_off:true},7).wait(1));

	// Layer_2
	this.instance_5 = new lib.PuppetShape_26("synched",1,false);
	this.instance_5.setTransform(157,203.8);

	this.instance_6 = new lib.PuppetShape_23("synched",1,false);
	this.instance_6.setTransform(157,203.8);
	this.instance_6._off = true;

	this.instance_7 = new lib.PuppetShape_24("synched",1,false);
	this.instance_7.setTransform(157,203.8);
	this.instance_7._off = true;

	this.instance_8 = new lib.PuppetShape_25("synched",1,false);
	this.instance_8.setTransform(157,203.8);
	this.instance_8._off = true;

	this.instance_9 = new lib.PuppetShape_9copy2("synched",1,false);
	this.instance_9.setTransform(157,203.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},6).to({state:[{t:this.instance_7}]},8).to({state:[{t:this.instance_8}]},7).to({state:[{t:this.instance_9}]},8).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},6).wait(24));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:false},6).to({_off:true},8).wait(16));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(6).to({_off:false},8).to({_off:true},7).wait(9));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(14).to({_off:false},7).to({_off:true},8).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.6,-18,282.1,581.7);


(lib.Symbol3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AgGBDIgDgBIgEgBIgEAAIgEgCIgDgBIgEgBIgDgCIgDgCIgDgCIgCgDIgDgCIgCgDIgCgCIgCgDIgCgCIgCgDIgBgDIgCgDIgBgDIgBgDIgBgDIAAgCIgBgEIAAgDIAAgHIAAgGIAAgGIAAgDIABgDIACgDIABgDIACgDIABgDIACgDIACgDIACgCIACgDIACgCIACgDIADgCIADgCIADgDIADgCIACgCIADgDIAEgCIADgCIADgCIAEgBIADgCIADgBIADAAIACgBIAEAAIADgBIADAAIAEAAIAEABIAEABIADABIAEABIADACIADACIADABIACACIADACIACADIACACIADADIABADIACADIADAHIABAIIABAIIAAAIIgBAHIgBAGIgBADIgBADIgCADIgBADIAAABIgBADIgBAEIgCADIgBADIgBADIgCADIgCADIgCADIgCADIgCADIgDACIgCADIgDACIgDACIgDACIgDABIgDACIgEABIgDABIgEABIgEAAIgEABIgEAAg");
	this.shape.setTransform(61.7625,1.225);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29));

	// Layer_1
	this.instance = new lib.PuppetShape_27("synched",1,false);
	this.instance.setTransform(60.4,275.8);

	this.instance_1 = new lib.PuppetShape_9("synched",1,false);
	this.instance_1.setTransform(60.4,275.8);
	this.instance_1._off = true;

	this.instance_2 = new lib.PuppetShape_19("synched",1,false);
	this.instance_2.setTransform(60.4,275.8);
	this.instance_2._off = true;

	this.instance_3 = new lib.PuppetShape_20("synched",1,false);
	this.instance_3.setTransform(60.4,275.8);
	this.instance_3._off = true;

	this.instance_4 = new lib.PuppetShape_5copy4("synched",1,false);
	this.instance_4.setTransform(60.4,275.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},6).to({state:[{t:this.instance_2}]},8).to({state:[{t:this.instance_3}]},7).to({state:[{t:this.instance_4}]},7).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},6).wait(23));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},6).to({_off:true},8).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},8).to({_off:true},7).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(14).to({_off:false},7).to({_off:true},7).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.8,-13,236,567.5);


(lib.Symbol2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AABA3IgCAAIgDgBIgDAAIgCgBIgBAAIgDAAIgDAAIgDgBIgCgBIgDgBIgDgBIgFgCIgCgBIgCgCIgDgCIgCgBIgCgCIgCgBIgCgCIgBgDIgCgCIgCgCIgBgBIgBgDIgBgDIgCgCIAAgDIgBgDIgBgDIAAgCIAAgDIgBgDIAAgDIABgCIAAgDIABgCIACgGIABgDIABgCIABgDIABgCIACgCIABgCIACgDIACgCIABgBIACgCIACgCIACgCIACgBIADgCIACAAIACgBIADgCIACgBIADgBIACgBIADAAIACgBIADAAIADAAIACgBIADgBIACgBIACAAIADgBIADAAIACAAIADAAIADAAIADAAIACABIADABIAFABIACABIADABIACABIACACIACABIACACIACABIACACIACADIABACIACABIABACIACADIABADIABACIACACIABAEIABACIAAACIABACIAAADIAAADIABADIgBACIAAACIAAADIAAADIgBACIgBADIgBADIgCADIgBACIgCACIgEAEIgCACIgCABIgCACIgCACIgCACIgCABIgCABIgBABIgCACIgBABIgCADIgCABIgCABIgDACIgCABIgCABIgDABIgCABIgDABIgCAAIgDABIgDAAg");
	this.shape.setTransform(51.575,-4.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(30));

	// Layer_1
	this.instance = new lib.PuppetShape_11("synched",1,false);
	this.instance.setTransform(51.2,212.1);

	this.instance_1 = new lib.PuppetShape_12("synched",1,false);
	this.instance_1.setTransform(51.2,212.1);
	this.instance_1._off = true;

	this.instance_2 = new lib.PuppetShape_13("synched",1,false);
	this.instance_2.setTransform(51.2,212.1);
	this.instance_2._off = true;

	this.instance_3 = new lib.PuppetShape_14copy("synched",1,false);
	this.instance_3.setTransform(51.2,212.1);
	this.instance_3._off = true;

	this.instance_4 = new lib.PuppetShape_19copy("synched",1,false);
	this.instance_4.setTransform(51.2,212.1);
	this.instance_4._off = true;

	this.instance_5 = new lib.PuppetShape_28copy("synched",1,false);
	this.instance_5.setTransform(51.2,212.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},8).to({state:[{t:this.instance_2}]},7).to({state:[{t:this.instance_3}]},8).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},5).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},8).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},8).to({_off:true},7).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(8).to({_off:false},7).to({_off:true},8).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(15).to({_off:false},8).to({_off:true},1).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(23).to({_off:false},1).to({_off:true},5).wait(1));

	// Layer_2
	this.instance_6 = new lib.PuppetShape_15("synched",1,false);
	this.instance_6.setTransform(114.45,226.1);

	this.instance_7 = new lib.PuppetShape_17("synched",1,false);
	this.instance_7.setTransform(114.45,226.1);
	this.instance_7._off = true;

	this.instance_8 = new lib.PuppetShape_18("synched",1,false);
	this.instance_8.setTransform(114.45,226.1);
	this.instance_8._off = true;

	this.instance_9 = new lib.PuppetShape_16copy("synched",1,false);
	this.instance_9.setTransform(114.45,226.1);
	this.instance_9._off = true;

	this.instance_10 = new lib.PuppetShape_20copy("synched",1,false);
	this.instance_10.setTransform(114.45,226.1);
	this.instance_10._off = true;

	this.instance_11 = new lib.PuppetShape_27copy("synched",1,false);
	this.instance_11.setTransform(114.45,226.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},8).to({state:[{t:this.instance_8}]},7).to({state:[{t:this.instance_9}]},8).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},5).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},8).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).to({_off:false},8).to({_off:true},7).wait(15));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(8).to({_off:false},7).to({_off:true},8).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(15).to({_off:false},8).to({_off:true},1).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(23).to({_off:false},1).to({_off:true},5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.1,-13.1,171.1,474);


(lib.Symbol1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AAEA0IgDAAIgDAAIgEAAIgEgBIgIgCIgEgBIgDgCIgEgCIgDgCIgDgCIgDgDIgDgDIgDgCIgCgEIgCgDIgCgCIAAgBIgCgEIgCgDIgBgEIgBgEIgBgEIAAgDIAAgEIAAgEIABgEIABgEIABgDIACgDIACgEIABgDIADgCIACgEIADgDIACgCIADgCIADgCIAEgCIADgBIAEgBIADgBIAEAAIADAAIADAAIADgBIADAAIADgBIADgBIAEAAIADAAIAEABIAEABIADABIADABIAEABIAEACIADACIADACIADADIACACIACACIADADIACADIABADIACADIACADIABADIABAEIABADIAAAEIAAAEIAAADIAAAEIAAADIgBAEIgBADIgBAEIgCAEIgBACIgCAEIgDADIgDADIgCAEIgDACIgEACIgDACIgDACIgEACIgEABIgDABIgEAAIgEAAIgEAAIgCAAg");
	this.shape.setTransform(48.2875,-2.45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(30));

	// Layer_1
	this.instance = new lib.PuppetShape_10("synched",1,false);
	this.instance.setTransform(51.95,260.1);

	this.instance_1 = new lib.PuppetShape_6("synched",1,false);
	this.instance_1.setTransform(51.95,260.1);
	this.instance_1._off = true;

	this.instance_2 = new lib.PuppetShape_7("synched",1,false);
	this.instance_2.setTransform(51.95,260.1);
	this.instance_2._off = true;

	this.instance_3 = new lib.PuppetShape_8("synched",1,false);
	this.instance_3.setTransform(51.95,260.1);
	this.instance_3._off = true;

	this.instance_4 = new lib.PuppetShape_9copy("synched",1,false);
	this.instance_4.setTransform(51.95,260.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},6).to({state:[{t:this.instance_2}]},8).to({state:[{t:this.instance_3}]},7).to({state:[{t:this.instance_4}]},8).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},6).wait(24));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},6).to({_off:true},8).wait(16));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},8).to({_off:true},7).wait(9));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(14).to({_off:false},7).to({_off:true},8).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42,-7.7,186,525.8000000000001);


// stage content:
(lib.seaweed_farm_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buoy_R
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AAAMnIgkgBQgqgCgpgGQhOgLhKgdQhIgchFgiQhdguhIhKQg8g9gxhHQhBhggghwQgghxADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwIAOgHIABAAQAegOAggJQByghB3ADQB3ACByAgQBzAgBjBBQBlBCBKBfQBJBdAwBuQAwBtAQB3QARB1gUB3QgTB2grBwQgrBwhMBdQgTAWgWATQhRBCheAvQhPAnhYAOQhZAOhaAAIg7gBg");
	this.shape.setTransform(1717.3153,213.7147);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIABABIgBgBIAAgBIAAABQhHhbgyhnQg1hugQh5QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAjssGQggAJgeANIgBABIgOAGQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB1AgBxQAgBvBBBgQAxBHA8A9QBIBKBdAvQBFAiBIAcQBKAcBOAMQApAGAqABIAlABQB3AGB2gSQBYgOBPgoQBegvBRhCQAWgSATgXQBMhdArhvQArhwATh3QAUh2gRh1QgQh3gwhuQgwhthJheQhKhehlhCQhjhBhzggQhyghh3gCIgRAAQhuAAhqAfgAqtItIABABIgBgCIAAABgAqqIxIAAAAg");
	this.shape_1.setTransform(1717.4473,213.4796);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAAMnIgkgBQgqgCgpgGQhOgLhKgdQhIgchFgiQhdguhIhKQg8g9gxhHQhBhggghwQgghxADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJQByghB3ADQB3ACByAgQBzAgBjBBQBlBCBKBfQBJBdAwBuQAwBtAQB3QARB1gUB3QgTB2grBwQgrBwhMBdQgTAWgWATQhRBCheAvQhPAnhYAOQhZAOhaAAIg7gBg");
	this.shape_2.setTransform(1717.3153,216.1647);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCQhHhbgyhnQg1hugQh5QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAjssGQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB1AgBxQAgBvBBBgQAxBHA8A9QBIBKBdAvQBFAiBIAcQBKAcBOAMQApAGAqABIAlABQB3AGB2gSQBYgOBPgoQBegvBRhCQAWgSATgXQBMhdArhvQArhwATh3QAUh2gRh1QgQh3gwhuQgwhthJheQhKhehlhCQhjhBhzggQhyghh3gCIgRAAQhuAAhqAfg");
	this.shape_3.setTransform(1717.4473,215.9296);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgigBIgCAAQgpgCgogGIgCAAQhNgMhKgbIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAfgJIABAAQByghB2ADIABAAQB2ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAABQARB1gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_4.setTransform(1717.3153,245.6147);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIABAAIgBgBIAAAAIAAAAQhGhZgyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIACAAQAoAGApABIACAAIAjABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh2IAAgBQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_5.setTransform(1717.4473,245.3796);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgBAAQgpgCgpgGIgBAAQhNgLhKgcIgBgBQhHgbhFgiIgBgBQhcguhIhJIgBgBQg8g9gwhGIgBgBQhAhgghhvIAAgBQgghwADh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgUAfgKIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_6.setTransform(1717.3153,243.4647);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAABIAAgBIgBgBIAAABQhFhagyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgDBzAgBxIAAABQAhBvBABfIABABQAwBHA8A8IABABQBIBKBcAuIABABQBFAhBHAcIABABQBKAbBNAMIABAAQApAGApABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh1IAAgCQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_7.setTransform(1717.4473,243.2296);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgBAAQgqgCgogGIgBAAQhNgMhKgbIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAfgJIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAABQARB1gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_8.setTransform(1717.3153,241.3647);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIAAgBIgBAAIAAAAQhFhZgyhmIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh2IAAgBQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_9.setTransform(1717.4473,241.1296);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgLhKgcIgBgBQhIgbhEgiIgBgBQhdguhIhJIgBgBQg7g9gwhGIgBgBQhAhgghhvIAAgBQgghwADh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAABQgTB2gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_10.setTransform(1717.3153,239.2147);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIAAgBIgBAAIAAAAQhFhZgyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBxIAAABQAhBvBABfIABABQAwBHA7A8IABABQBIBKBdAuIABABQBEAhBIAcIABABQBKAbBMAMIACAAQAoAGApABIACAAIAkABIABAAQB3AGB1gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh1IAAgBQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAJguAUg");
	this.shape_11.setTransform(1717.4473,238.9796);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgMhKgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBAIABABQBkBCBJBeIABABQBJBdAvBtIABABQAvBtARB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhMBdIgBABQgSAWgWASIgBABQhQBBheAvIgBABQhOAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_12.setTransform(1717.3153,237.1147);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIgBgBQhFhagyhlIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIABAAQB3AGB1gSIABAAQBXgPBOgnIABgBQBeguBQhCIABgBQAWgSASgWIABgBQBMhcArhvIABgBQAqhwATh1IAAgCQAUh1gRh1IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhJhehkhBIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAIguAVg");
	this.shape_13.setTransform(1717.4473,236.8796);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhMgLhKgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_14.setTransform(1717.3153,234.9647);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIgBgBIAAAAIAAAAQhFhZgyhmIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAJguAUg");
	this.shape_15.setTransform(1717.4473,234.7296);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhMgMhKgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAvgVAdgJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_16.setTransform(1717.3153,232.8647);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIAAgBIAAABQhFhagyhlIgBgDQg0htgRh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgdAIgvAVg");
	this.shape_17.setTransform(1717.4473,232.6296);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhNgLhJgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAvgVAdgJIABAAQBzghB2ADIABAAQB2ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAABQARB1gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_18.setTransform(1717.3153,230.7147);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBQhFhagyhlIgBgDQg1htgQh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChzAhIgBAAQgdAIgvAVg");
	this.shape_19.setTransform(1717.4473,230.4796);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhNgMhJgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgWAcgIIABAAQBzghB2ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAABQARB1gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_20.setTransform(1717.3153,228.6147);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAgBIgBgBQhFhZgyhmIgBgDQg1hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_21.setTransform(1717.4473,228.3796);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgLhJgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgVAcgJIABAAQBzghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBJBeIABABQBJBdAvBtIABABQAwBtAQB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhMBdIgBABQgSAWgWASIgBABQhQBBheAvIgBABQhOAmhXAOIgBAAQhZAOhaAAIg6gBg");
	this.shape_22.setTransform(1717.3153,226.4647);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBAAIAAgBIgBgBIAAABQhEhagyhmIgBgDQg1hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIABAAQApAGApABIABAAIAlABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBeguBQhCIABgBQAWgSASgWIABgBQBMhcArhvIABgBQAqhwATh1IAAgCQAUh2gRh0IAAgBQgQh3gwhtIgBgBQgvhthJhdIgBgBQhJhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_23.setTransform(1717.4473,226.2296);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgMhJgcIgBgBQhIgbhEgiIgBgBQhdguhIhJIgBgBQg7g9gwhGIgBgBQhBhggghvIAAgBQgghwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgWAcgIIABAAQBzghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAACQARB0gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhaAAIg6gBg");
	this.shape_24.setTransform(1717.3153,224.3647);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhEhZgyhmIgBgDQg1htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB0AgBxIAAABQAgBvBBBfIABABQAwBHA7A8IABABQBIBKBdAuIABABQBEAhBIAcIABABQBJAcBNAMIABAAQApAGApABIABAAIAlABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh1IAAgCQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_25.setTransform(1717.4473,224.1296);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgLhKgcIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAACQgTB1grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_26.setTransform(1717.3153,222.2147);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhZgyhmIgBgDQg0hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQApAGApABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh0IAAgCQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAIgxAVg");
	this.shape_27.setTransform(1717.4473,221.9796);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgqgCgogGIgBAAQhNgMhKgcIgBgBQhHgbhFgiIgBgBQhcguhIhJIgBgBQg8g9gwhGIgBgBQhAhggghvIAAgBQgghwADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAABQgTB2grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_28.setTransform(1717.3153,220.1147);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhagyhlIgBgDQg0htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB0AgBxIAAABQAgBvBABfIABABQAwBHA8A8IABABQBIBKBcAuIABABQBFAhBHAcIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh1IAAgBQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAHgxAWg");
	this.shape_29.setTransform(1717.4473,219.8796);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#FFFFFF").s().p("AAAMnIAAAAIgkgBIgBAAQgqgCgogGIgBAAQhNgLhKgcIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAACQgTB1grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_30.setTransform(1717.3153,217.9647);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhZgyhmIgBgDQg0htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB2AGB2gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh0IAAgCQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAIgxAVg");
	this.shape_31.setTransform(1717.4473,217.7296);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1,p:{y:213.4796}},{t:this.shape,p:{y:213.7147}}]}).to({state:[{t:this.shape_3,p:{y:215.9296}},{t:this.shape_2,p:{y:216.1647}}]},1).to({state:[{t:this.shape_3,p:{y:218.3296}},{t:this.shape_2,p:{y:218.5647}}]},1).to({state:[{t:this.shape_3,p:{y:220.7796}},{t:this.shape_2,p:{y:221.0147}}]},1).to({state:[{t:this.shape_3,p:{y:223.1796}},{t:this.shape_2,p:{y:223.4147}}]},1).to({state:[{t:this.shape_3,p:{y:225.6296}},{t:this.shape_2,p:{y:225.8647}}]},1).to({state:[{t:this.shape_3,p:{y:228.0296}},{t:this.shape_2,p:{y:228.2647}}]},1).to({state:[{t:this.shape_3,p:{y:230.4796}},{t:this.shape_2,p:{y:230.7147}}]},1).to({state:[{t:this.shape_3,p:{y:232.9296}},{t:this.shape_2,p:{y:233.1647}}]},1).to({state:[{t:this.shape_3,p:{y:235.3296}},{t:this.shape_2,p:{y:235.5647}}]},1).to({state:[{t:this.shape_3,p:{y:237.7796}},{t:this.shape_2,p:{y:238.0147}}]},1).to({state:[{t:this.shape_3,p:{y:240.1796}},{t:this.shape_2,p:{y:240.4147}}]},1).to({state:[{t:this.shape_3,p:{y:242.6296}},{t:this.shape_2,p:{y:242.8647}}]},1).to({state:[{t:this.shape_3,p:{y:245.0296}},{t:this.shape_2,p:{y:245.2647}}]},1).to({state:[{t:this.shape_1,p:{y:247.4796}},{t:this.shape,p:{y:247.7147}}]},1).to({state:[{t:this.shape_5},{t:this.shape_4}]},1).to({state:[{t:this.shape_7},{t:this.shape_6}]},1).to({state:[{t:this.shape_9},{t:this.shape_8}]},1).to({state:[{t:this.shape_11},{t:this.shape_10}]},1).to({state:[{t:this.shape_13},{t:this.shape_12}]},1).to({state:[{t:this.shape_15},{t:this.shape_14}]},1).to({state:[{t:this.shape_17},{t:this.shape_16}]},1).to({state:[{t:this.shape_19},{t:this.shape_18}]},1).to({state:[{t:this.shape_21},{t:this.shape_20}]},1).to({state:[{t:this.shape_23},{t:this.shape_22}]},1).to({state:[{t:this.shape_25},{t:this.shape_24}]},1).to({state:[{t:this.shape_27},{t:this.shape_26}]},1).to({state:[{t:this.shape_29},{t:this.shape_28}]},1).to({state:[{t:this.shape_31},{t:this.shape_30}]},1).to({state:[{t:this.shape_3,p:{y:215.6296}},{t:this.shape_2,p:{y:215.8647}}]},1).wait(1));

	// buoy_L
	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#FFFFFF").s().p("AAAMnIgkgBQgqgCgpgGQhOgLhKgdQhIgchFgiQhdguhIhKQg8g9gxhHQhBhggghwQgghxADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwIAOgHIABAAQAegOAggJIAmgKQAhgHAhgFQBAgKBBACQA1ABA1AHQBAAJA/ARQBzAgBjBBQA0AiAtAqQAqAnAkAuQBJBdAwBuQAwBtAQB3QARB1gUB3QgTB2grBwQgrBwhMBdQgTAWgWATQhRBCheAvQhPAnhYAOQhZAOhaAAIg7gBg");
	this.shape_32.setTransform(163.9153,254.0647);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIABABIgBgBIAAgBIAAABQhHhbgyhnQg1hugQh5QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVQBQAoBFA6QAWATAVAVQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAiFsdQghAFggAIIgmAKQggAJgeANIgBABIgOAGQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB1AgBxQAgBvBBBgQAxBHA8A9QBIBKBdAvQBFAiBIAcQBKAcBOAMQApAGAqABIAlABQB3AGB2gSQBYgOBPgoQBegvBRhCQAWgSATgXQBMhdArhvQArhwATh3QAUh2gRh1QgQh3gwhuQgwhthJheQgkgugqgnQgtgpg0giQhjhBhzggQg/gShAgJQg1gHg1gBIgRAAQg5AAg4AIgAqtItIABABIgBgCIAAABgAqqIxIAAAAg");
	this.shape_33.setTransform(164.0473,253.8296);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#FFFFFF").s().p("AAAMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhNgMhJgcIgCgBQhHgbhEgiIgCgBQhcguhHhJIgCgCQg7g8gwhGIgBgCQhAhfgghvIgBgCQgfhwADh0QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAmgKQAggHAhgFQBAgKBCACIAEAAQAzABAzAGQBAAJA/ASIAGACQBvAgBhA/IAGAEQAwAgAqAnQArAnAkAuIACACQBIBdAvBsIABACQAvBtAQB2IAAADQARBzgUB1IAAADQgTB1grBvIgBACQgrBuhLBcIgCACQgSAWgVARIgCACQhQBBhdAuIgCABQhOAnhXAOIgCAAQhYAOhaAAIg6gBg");
	this.shape_34.setTransform(163.9149,256.5132);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#000000").s().p("AAkNqIgEAAQhNAAhMgKIgEgBQhOgKhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgtIgEgCQhAgtgug/IgDgEIgBgCIgBgBIAAAAIgCgCIAAAAIAAgBIAAABIgBgBIgBgBIgBgBQhEhZgyhmIgCgEQgzhsgQh3QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABAAQBQAoBEA6QAWATAVAUIADADQAqAqAiAxIADAAIADAAIABAAIADAAIABAAIACABIACABIABAAIABABIACAAIABABIABAAIACABIABABIABABIABAAIABABIABACIABACQBEBcAtBoIACAEQAvBwASB3IABAFQASB3gUB5IgBAFQgJA9gOA8IgBAEQgaB0g6BoIgCAEQg3BkhRBQIgDADQgnAmguAbIgEACQhkA4htAlIgEABQhTAdhZAEIgEAAIg2ABIg1gBgAiFsdQghAFggAIIgmAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB0AfBwIABACQAgBuBABfIABACQAwBGA7A8IACACQBHBJBcAvIACABQBEAhBHAcIACABQBJAcBNAMIACAAQAoAGApABIACAAIAjABIACAAQB2AGB1gSIACAAQBXgPBOgmIACgBQBdgvBQhAIACgCQAVgSASgVIACgCQBLhcArhvIABgCQArhvATh0IAAgDQAUh1gRh0IAAgDQgQh2gvhsIgBgCQgvhthIhcIgCgCQgkgugrgnQgqgogwggIgGgEQhhg/hvggIgGgCQg/gShAgIQgzgHgzgBIgEAAIgSAAQg5AAg3AIg");
	this.shape_35.setTransform(164.0483,256.2796);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgCAAQgpgCgogGIgCAAQhMgMhJgcIgCgBQhHgbhEgiIgCgBQhcguhIhJIgCgCQg7g8gwhGIgBgCQhAhfgghuIgBgCQgfhwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAmgKQAggHAhgFQBAgKBCACIAEAAQAzABAzAHQBAAIA/ASIAFACQBwAgBhA/IAFAEQAxAgAqAnQAqAnAkAuIACADQBJBcAvBtIABACQAvBsAQB2IAAADQARBzgUB2IAAACQgTB1grBvIgBACQgrBvhLBcIgCACQgSAVgVASIgCACQhQBAhdAvIgCABQhOAmhWAOIgCAAQhZAOhZAAIg6gBg");
	this.shape_36.setTransform(163.9149,258.9132);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#000000").s().p("AAkNqIgEAAQhNAAhMgKIgEgBQhOgKhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgsIgEgCQg/gtgug/IgDgEIgCgCIgBgBIAAAAIgBgCIAAAAIgBgBIAAAAIAAAAIgBgBIgBgBIgBgBQhEhZgxhlIgCgEQg0hsgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABABQBPAoBEA5QAXATAVAUIADADQAqAqAhAxIAEAAIADAAIABAAIADABIABAAIACABIACAAIABAAIABABIABAAIACABIABAAIACABIAAABIACABIABAAIABABIABACIABACQBDBcAuBoIACAEQAvBwASB3IABAFQASB3gUB5IgBAFQgJA9gOA8IgBAEQgaB0g5BoIgCAEQg3BkhRBQIgDADQgnAmgvAbIgEACQhkA4htAmIgEABQhTAchZAEIgEAAIg2ABIg1gBgAiFsdQghAFggAIIgmAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB0AfBwIABACQAgBvBABfIABACQAwBGA7A8IACACQBIBJBcAuIACABQBEAhBHAcIACABQBJAcBMAMIACAAQAoAGApABIACAAIAkABIABAAQB2AGB2gSIACAAQBWgOBOgnIACgBQBdguBQhBIACgCQAVgRASgWIACgCQBLhcArhuIABgCQArhvATh1IAAgDQAUh1gRh0IAAgCQgQh2gvhtIgBgCQgvhshJhdIgCgCQgkgugqgnQgqgogxggIgFgEQhhg/hwgfIgFgCQg/gShAgJQgzgGgzgCIgEAAIgSAAQg5AAg3AIg");
	this.shape_37.setTransform(164.0483,258.6796);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgCAAQgpgCgogGIgCAAQhMgMhJgcIgCgBQhHgbhEgiIgCgBQhcguhIhJIgCgCQg6g8gxhGIgBgCQhAhfgghuIgBgCQgfhwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAmgKQAggHAhgFQBAgKBBACIAEAAQA0ABAzAGQA/AJA/ASIAGACQBvAfBhA/IAGAEQAxAgAqAoQAqAnAkAuIACACQBJBdAvBsIABACQAvBtAQB2IAAACQARB0gUB1IAAADQgTB1grBvIgBACQgrBuhLBcIgCACQgRAWgWARIgCACQhQBBhdAuIgCABQhOAnhWAOIgCAAQhZAOhZAAIg6gBg");
	this.shape_38.setTransform(163.9149,261.3632);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#000000").s().p("AAkNqIgEAAQhMAAhNgKIgEgBQhNgKhKgaIgEgCQhJgahGgkIgEgCQhFgkhAgsIgEgCQhAgtgug/IgDgEIgCgCIAAgBIgBAAIgBgCIABAAIgBgBIgBAAIAAAAIgBgBIgBgBIgBgBQhEhZgxhlIgCgEQg0hsgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABAAQBPAoBEA6QAXASAUAVIAEADQAqAqAhAxIAEAAIADAAIAAAAIAEAAIAAAAIADABIABABIABAAIACABIABAAIACABIAAAAIACABIABAAIABABIABABIABABIACACIABACQBDBbAuBpIACAEQAvBvASB3IABAFQASB4gUB4IgBAFQgJA9gOA9IgBAEQgaB0g5BoIgCAEQg3BjhRBQIgDADQgnAngvAbIgEACQhkA4hsAlIgEABQhUAdhZAEIgEAAIg1ABIg2gBgAiFsdQghAFggAIIgmAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB0AfBwIABACQAgBvBABfIABACQAxBGA6A8IACACQBIBIBcAvIACABQBEAhBHAcIACABQBJAcBMAMIACAAQAoAGApABIACAAIAkABIABAAQB2AGB2gSIACAAQBWgPBOgmIACgBQBdgvBQhAIACgCQAWgSARgVIACgCQBLhcArhvIABgCQArhvATh1IAAgCQAUh1gRh0IAAgDQgQh2gvhsIgBgCQgvhthJhcIgCgDQgkgugqgnQgqgngxggIgGgEQhhg/hvggIgGgCQg/gSg/gIQgzgHg0gBIgEAAIgSAAQg4AAg3AIg");
	this.shape_39.setTransform(164.0483,261.1296);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgDAAQgpgCgngGIgDAAQhMgLhJgcIgCgBQhHgchEghIgCgBQhcgvhIhJIgCgCQg6g8gwhGIgBgCQhBhfgfhuIgBgCQgghwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAhgHAhgFQBAgJBBABIAEAAQA0ABAyAHQBAAIA/ASIAGACQBvAgBhA+IAGAEQAwAgArAoQAqAnAkAuIACACQBIBdAvBsIABACQAwBtAQB2IAAADQARBzgUB1IAAADQgTB1gqBvIgBACQgsBuhLBcIgCACQgRAWgWASIgCABQhQBBhdAvIgCABQhOAmhWAOIgCAAQhYAOhaAAIg6gBg");
	this.shape_40.setTransform(163.9151,263.7687);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#000000").s().p("AAlNqIgFAAQhMAAhMgJIgFgBQhNgLhKgaIgEgCQhJgahGgkIgEgCQhFgkhAgsIgEgCQhAgtgug+IgDgEIgBgCIgBgBIAAgBIgCgBIAAgBIgBgBIgBgBIAAAAIgBgBQhFhZgxhlIgCgEQg0hsgQh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAWAKAVALIABABQBPAnBEA6QAWATAVAUIADADQAqAqAiAxIADABIADgBIABAAIADABIABAAIACABIACAAIABAAIACABIABAAIABABIABAAIACABIABABIABABIABAAIABABIABACIACACQBDBbAuBpIACAEQAvBvASB3IABAFQASB4gTB4IgBAFQgKA9gOA9IgBAEQgaB0g5BoIgCAEQg3BjhRBRIgDADQgnAmgvAbIgEACQhkA4hsAmIgEABQhUAchYAEIgFAAIg1ABIg1gBgAiFscQghAEghAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDBzAgBwIABACQAfBvBBBfIABACQAwBGA6A8IACACQBIBJBcAuIACABQBEAiBHAbIACABQBJAcBMAMIADAAQAnAGApABIADAAIAjABIABAAQB3AGB1gSIACAAQBWgOBOgnIACgBQBdgvBQhAIACgCQAWgSARgVIACgCQBLhcAshvIABgCQAqhvATh0IAAgDQAUh1gRh0IAAgDQgQh2gwhsIgBgCQgvhthIhcIgCgCQgkgvgqgnQgrgngwggIgGgEQhhg/hvggIgGgBQg/gShAgJQgygGg0gCIgEAAIgMAAQg8AAg5AJg");
	this.shape_41.setTransform(164.0473,263.5296);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgDAAQgogCgogGIgDAAQhMgMhJgbIgCgBQhHgchEghIgCgBQhcgvhIhJIgCgCQg6g8gwhGIgBgCQhBhfgfhuIgBgCQgghwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAhgHAggFQBAgKBCACIADAAQA0ABAzAHQBAAIA+ASIAGABQBwAgBgA/IAGAEQAxAgAqAnQArAnAkAvIACACQBIBcAvBtIABACQAwBsAQB2IAAADQARB0gUB1IAAADQgTB0gqBvIgBACQgsBvhLBcIgCACQgRAVgWASIgCACQhQBBhdAuIgCABQhOAnhWAOIgCAAQhYAOhaAAIg6gBg");
	this.shape_42.setTransform(163.9151,266.2132);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#000000").s().p("AAlNqIgEAAQhNAAhMgJIgEgBQhOgLhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgsIgEgCQg/gtgvg+IgDgEIgBgCIgBgBIgBgCIAAAAIgBgBIgBgBIgBgBIAAAAIgBgBIAAAAQhFhZgxhlIgCgEQg0hsgQh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAWAKAVALIABAAQBPAoBEA5QAWATAVAVIADADQAqApAiAxIADABIADAAIABAAIADABIABAAIACAAIABABIACAAIABABIABAAIACAAIABAAIACACIAAAAIACABIAAAAIACACIABABIACACQBDBcAuBoIACAEQAvBwASB3IABAEQASB4gTB5IgBAEQgKA+gOA8IgBAEQgaB0g5BoIgCAEQg3BkhRBQIgDADQgmAmgvAbIgEACQhkA5htAlIgEABQhTAdhZAEIgEAAIg2ABIg1gBgAiGsdQggAFghAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDBzAgBwIABACQAfBvBBBfIABACQAwBGA6A8IACACQBIBJBcAuIACABQBEAiBHAbIACABQBJAcBMAMIADAAQAoAGAoABIADAAIAjABIABAAQB3AGB1gSIACAAQBWgOBOgnIACgBQBdgvBQhBIACgBQAWgSARgWIACgCQBLhcAshuIABgCQAqhvATh1IAAgDQAUh1gRhzIAAgDQgQh2gwhtIgBgCQgvhshIhdIgCgCQgkgugrgnQgqgogxggIgGgEQhgg+hwggIgGgCQg+gShAgIQgzgGgzgCIgEAAIgSAAQg5AAg3AIg");
	this.shape_43.setTransform(164.0473,265.9796);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhNgLhJgcIgCgBQhHgchEghIgCgBQhcguhHhJIgCgCQg7g8gwhGIgBgCQhBhfgfhvIgBgCQgghwADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAhgFQBAgJBCABIADAAQA0ABAzAHQBAAIA+ASIAGACQBvAfBhA/IAGAEQAxAgAqAnQAqAnAkAvIADACQBIBdAvBsIABACQAwBtAQB2IAAACQARB0gUB1IAAADQgTB1gqBvIgBACQgsBuhKBcIgCACQgSAWgVASIgCABQhQBBhdAvIgCABQhOAmhXAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_44.setTransform(163.9151,268.6187);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#000000").s().p("AAlNqIgEAAQhMAAhNgJIgEgBQhOgKhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgsIgEgDQg/gsgug/IgDgEIgCgBIAAgBIgBgBIgBgBIgBgCIgBAAIgBgCIgBgBQhEhZgyhlIgCgEQg0hsgQh2IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAWAKAVALIABABQBPAnBDA5QAXATAVAVIADADQAqApAiAxIADACIADgBIABAAIADABIAAAAIADABIABAAIACAAIABABIABAAIACABIAAAAIACABIABAAIABABIABAAIACACIABABIABACQBEBcAtBoIACAEQAwBwASB3IABAEQASB4gTB5IgBAEQgKA+gOA8IgBAEQgaB0g5BoIgCAEQg3BkhQBQIgDADQgnAmgvAcIgEACQhkA4htAmIgEABQhTAchZAEIgEAAIg2ABIg1gBgAiGscQghAEggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIABACQAfBuBBBfIABACQAwBGA7A8IACACQBHBJBcAuIACABQBEAiBHAbIACABQBJAcBNAMIACAAQAoAGApABIACAAIAjABIACAAQB2AGB1gSIACAAQBXgOBOgnIACgBQBdgvBQhAIACgCQAVgSASgVIACgCQBKhcAshvIABgCQAqhvATh1IAAgCQAUh2gRhzIAAgDQgQh2gwhsIgBgCQgvhthIhcIgDgDQgkgugqgnQgqgogxggIgGgEQhhg+hvggIgGgBQg+gShAgJQgzgGgzgCIgEAAIgNAAQg7AAg6AJg");
	this.shape_45.setTransform(164.0473,268.3796);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgLhKgcIgCgBQhHgchEghIgCgBQhcguhHhJIgCgCQg7g8gwhGIgBgCQhBhfgfhvIgBgCQgfhwAChzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAhgFQBAgJBBABIAEAAQA0ABAzAHQA/AIA/ASIAFABQBwAgBhA/IAFADQAxAhArAnQAqAnAkAuIADADQBIBcAvBtIABACQAwBsAQB2IAAADQARB0gUB1IAAACQgTB1gqBvIgBACQgrBvhLBcIgCACQgSAVgVASIgCACQhQBBhdAuIgCABQhOAnhXAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_46.setTransform(163.9188,271.0687);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#000000").s().p("AAmNqIgFAAQhMAAhMgJIgFgBQhNgKhKgaIgEgCQhJgahGgkIgEgCQhFgkhAgsIgEgDQhAgsgug/IgDgEIgBgBIgBgBIAAAAIgBgCIgCgCIAAAAIgCgCIAAgBIgBAAQhEhYgyhmIgCgEQgzhsgRh2IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAWAKAVALIABAAQBPAoBDA5QAXATAUAUIAEADQAqAqAiAxIADACIADgBIAAAAIAEABIAAAAIADAAIABABIABAAIACABIABAAIACAAIAAAAIACACIABAAIABABIABAAIABABIACACIABACQBEBbAtBpIACAEQAwBvASB3IABAFQASB4gTB4IgBAFQgKA9gOA9IgBAEQgZB0g6BoIgCAEQg2BkhRBQIgDADQgnAmgvAbIgEACQhkA5hsAlIgEABQhUAdhYAEIgFAAIg1ABIg1gBgAiGscQghAEggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgCB0AfBwIABACQAfBuBBBfIABACQAwBGA7A8IACACQBHBJBcAuIACABQBEAiBHAbIACABQBKAcBMAMIACAAQAoAGApABIACAAIAjABIACAAQB2AGB1gSIACAAQBXgOBOgnIACgBQBdgvBQhBIACgBQAVgSASgWIACgCQBLhcArhuIABgCQAqhvATh1IAAgDQAUh1gRh0IAAgCQgQh2gwhtIgBgCQgvhshIhdIgDgCQgkgugqgnQgrgogxggIgFgEQhhg/hwgfIgFgCQg/gSg/gIQgzgGgzgCIgFAAIgMAAQg8AAg5AJg");
	this.shape_47.setTransform(164.0473,270.8296);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgMhKgbIgCgBQhHgchEghIgCgBQhcgvhHhIIgCgCQg7g8gwhGIgBgCQhBhfgfhvIgBgCQgfhwAChzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAggFQBAgKBCACIAEAAQAzABAzAGQBAAIA+ASIAGACQBvAfBhA/IAGAEQAxAgAqAoQArAnAkAuIADACQBIBdAvBsIABACQAvBtARB2IAAACQARB0gUB1IAAADQgTB1gqBvIgBACQgrBuhLBcIgCACQgSAWgVASIgCABQhQBBhdAvIgCABQhOAnhXAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_48.setTransform(163.9188,273.5132);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#000000").s().p("AAmNqIgEAAQhNAAhMgJIgEgBQhOgLhJgaIgEgBQhKgahFgkIgEgCQhGgkhAgsIgEgDQhAgsgug/IgDgEIgBgBIgBgBIgBgCIAAAAIgCgCIAAgBIAAABIgCgCIAAgBIgBAAIAAAAQhEhYgyhmIgCgEQgzhsgRh2IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABAAQBPAoBDA5QAWASAVAVIAEADQAqAqAiAwIACACIADAAIABAAIADAAIABAAIACABIABAAIACABIABAAIACAAIABABIABAAIACABIAAAAIACABIAAABIACABIACACIABABQBDBcAuBoIACAEQAvBvATB4IABAEQASB4gTB5IgBAEQgKA9gOA9IgBAEQgZB0g6BoIgCAEQg2BkhRBQIgDADQgnAnguAbIgEACQhkA4htAmIgEABQhTAchZAFIgEAAIg2ABIg1gBgAiHsdQggAFggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgCB0AfBwIABACQAfBuBBBfIABACQAwBGA7A8IACACQBHBJBcAuIACABQBEAiBHAbIACABQBKAcBMAMIACAAQAoAGApABIACAAIAjABIACAAQB2AGB1gSIACAAQBXgPBOgnIACgBQBdguBQhBIACgCQAVgSASgVIACgCQBLhcArhvIABgCQAqhvATh1IAAgCQAUh1gRh0IAAgDQgRh2gvhsIgBgCQgvhthIhcIgDgDQgkgugrgnQgqgngxghIgGgDQhhg/hvggIgGgBQg+gShAgIQgzgHgzgBIgEAAIgSAAQg5AAg3AIg");
	this.shape_49.setTransform(164.0473,273.2796);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgigBIgDAAQgpgCgngGIgDAAQhMgLhJgcIgCgBQhHgchEghIgCgBQhcguhIhJIgCgCQg7g8gwhGIgBgCQhBhfgfhuIgBgCQgfhwACh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAggFQBAgJBCABIAEAAQAzABAzAGQBAAJA+ASIAFABQBwAfBhA/IAFAEQAyAgAqAoQArAnAkAuIACADQBJBcAvBtIABACQAvBsARB2IAAACQARB0gUB2IAAACQgTB1gqBvIgBACQgrBvhLBcIgCACQgSAVgVASIgCACQhQBAhdAvIgCABQhOAnhWAOIgCAAQhZAOhZAAIg6gBg");
	this.shape_50.setTransform(163.9188,275.9187);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#000000").s().p("AAmNqIgEAAQhMAAhNgJIgEgBQhOgKhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgsIgEgCQhAgtgug+IgDgEIgBgBIAAgBIgBgBIgBgBIgCgDIAAAAIAAAAIgCgCIAAAAQhFhZgxhlIgCgEQg0hsgRh2IAAgEQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABAAQBOAoBEA5QAWASAVAVIADADQAqAqAiAwIADADIADgBIABAAIADAAIADABIABAAIACABIABAAIACABIABAAIAAAAIACABIABAAIABABIABABIACABIABACIACABQBDBcAuBoIACAEQAvBvATB4IABAEQASB4gTB5IgBAEQgKA9gOA9IgBAEQgZB0g5BoIgCAEQg3BkhRBQIgDADQgnAnguAbIgEACQhkA4htAmIgEABQhTAdhZAEIgEAAIg2ABIg1gBgAiHscQggAEggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgCBzAfBwIABACQAfBvBBBfIABACQAwBGA7A8IACACQBIBIBcAuIACABQBEAiBHAbIACABQBJAcBMAMIADAAQAnAGApABIADAAIAjABIABAAQB3AGB1gSIACAAQBWgPBOgmIACgBQBdgvBQhBIACgBQAVgSASgWIACgCQBLhcArhuIABgCQAqhvATh2IAAgCQAUh1gRh0IAAgCQgRh2gvhtIgBgCQgvhshJhdIgCgDQgkgugrgnQgqgngyghIgFgDQhhg/hwgfIgFgCQg+gShAgIQgzgHgzgBIgEAAIgNAAQg7AAg6AJg");
	this.shape_51.setTransform(164.0473,275.6796);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgigBIgDAAQgogCgogGIgDAAQhMgMhJgbIgCgBQhHgchEghIgCgBQhcguhIhJIgCgCQg7g8gwhGIgBgCQhBhfgfhuIgBgCQgfhwACh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAggFQBAgKBBACIAFAAQAzABAzAGQA/AIA/ASIAFACQBvAfBiA/IAFADQAxAhArAnQArAnAkAuIACADQBJBdAvBsIABACQAvBtARB2IAAACQARB0gUB1IAAACQgTB2gqBvIgBACQgrBuhLBcIgCACQgSAWgVASIgCABQhQBBhdAvIgCABQhOAnhWAOIgCAAQhZAOhZAAIg6gBg");
	this.shape_52.setTransform(163.9188,278.3632);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#000000").s().p("AAnNqIgFAAQhMAAhMgJIgFgBQhNgKhKgaIgEgCQhJgahGgkIgEgCQhFgkhAgsIgEgCQhAgtgvg+IgDgEIgBgBIAAgBIgBgCIAAAAIgDgDIAAAAIAAAAIgCgCIABABIgBgBIAAgBIAAABQhFhZgxhlIgCgEQg0hsgRh2IAAgEQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnIArAVIABAAQBOAoBEA4QAWATAUAUIAEADQAqAqAiAxIADACIADAAIAAAAIAEAAIAAAAIADABIABAAIABABIACAAIABAAIACABIAAAAIACABIACABIABAAIABABIACACIACACQBDBbAuBpIACAEQAvBvATB3IABAFQASB3gTB5IgBAFQgKA9gOA9IgBAEQgZB0g5BoIgCAEQg3BkhRBQIgDADQgmAmgvAcIgEACQhkA4hsAmIgEABQhUAchYAFIgFAAIg1ABIg1gBgAiHsdQggAFggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgCBzAfBwIABACQAfBvBBBfIABACQAwBGA7A8IACACQBIBIBcAuIACABQBEAiBHAbIACABQBJAcBMAMIADAAQAoAGAoABIADAAIAjABIABAAQB3AGB1gSIACAAQBWgPBOgnIACgBQBdguBQhBIACgCQAVgSASgVIACgCQBLhcArhvIABgCQAqhvATh1IAAgCQAUh2gRh0IAAgCQgRh2gvhsIgBgCQgvhthJhcIgCgDQgkgugrgnQgrgogxggIgFgEQhig/hvgfIgFgBQg/gSg/gIQgzgHgzgBIgFAAIgSAAQg4AAg3AIg");
	this.shape_53.setTransform(164.0473,278.1296);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#FFFFFF").s().p("AADMnIgDAAIgigBIgDAAQgogCgogGIgDAAQhMgLhJgcIgCgBQhHgbhEgiIgCgBQhcguhIhJIgCgCQg7g8gwhGIgBgCQhAhfgghuIgBgCQgfhwAChzIAAgDQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAggFQBAgJBBABIAEAAQA0ABAyAHQBAAIA+ASIAGABQBvAfBhA/IAGADQAxAhArAnQAqAnAkAvIADACQBJBdAvBsIABACQAvBtARB2IAAACQARB0gUB1IAAADQgTB1gqBvIgBACQgrBuhLBcIgCACQgSAWgVASIgCABQhQBBhdAvIgCABQhOAnhWAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_54.setTransform(163.9189,280.7687);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#000000").s().p("AAnNqIgFAAQhMAAhMgJIgFgBQhNgKhKgaIgEgCQhJgahGgkIgEgCQhFgkhAgrIgEgDQhAgsgug+IgDgEIgBgCIgBgBIgBgBIAAgBIgDgCIAAgBIgBgBIAAAAIAAgBIgBAAIAAAAQhFhYgxhlIgCgEQg0hsgQh3IgBgEQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAVAKAVALIABAAQBPAoBDA4QAWATAVAVIAEADQAqApAiAxIACADIADgBIABAAIADABIABAAIACAAIABAAIACABIACAAIABABIABAAIABAAIACABIAAAAIACABIAAAAIACACIACABIACACQBDBbAuBpIACAEQAvBvASB3IABAEQATB4gTB5IgBAEQgJA+gOA9IgBAEQgaB0g5BoIgCAEQg3BkhQBQIgDADQgnAmgvAcIgEACQhkA4hsAmIgEABQhUAdhYAEIgFAAIg1ABIg1gBgAiHscQggAEggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgCBzAfBwIABACQAgBvBABfIABACQAwBGA7A8IACACQBIBJBcAuIACABQBEAhBHAcIACABQBJAbBMAMIADAAQAoAGAoABIADAAIAjABIACAAQB2AGB1gSIACAAQBWgOBOgnIACgBQBdgvBQhBIACgBQAVgTASgVIACgCQBLhcArhvIABgCQAqhvATh1IAAgCQAUh2gRhzIAAgDQgRh2gvhsIgBgCQgvhthJhcIgDgDQgkgugqgnQgrgogxggIgGgEQhhg+hvggIgGgBQg+gShAgIQgygGg0gCIgEAAIgMAAQg8AAg5AJg");
	this.shape_55.setTransform(164.047,280.5296);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#FFFFFF").s().p("AADMnIgDAAIgigBIgDAAQgogCgogGIgDAAQhMgLhJgcIgCgBQhHgbhEgiIgCgBQhcguhIhJIgCgCQg6g8gxhGIgBgCQhAhfgghuIgBgCQgfhwAChzIAAgDQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAggHAfgFQBAgJBCABIAEAAQAzABAzAGQBAAIA+ASIAFABQBwAgBhA+IAFAEQAxAgArAoQArAnAkAuIADADQBJBcAvBtIABACQAvBsARB2IAAADQARB0gUB1IAAACQgTB1gqBvIgBACQgrBvhLBcIgCACQgRAVgWATIgCABQhQBBhdAvIgCABQhOAnhWAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_56.setTransform(163.9189,283.2187);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#000000").s().p("AAoNqIgFAAQhMAAhMgJIgFgBQhOgKhJgaIgEgCQhKgahFgkIgEgCQhGgkhAgrIgEgDQhAgsgug+IgDgEIgBgCIAAgBIgCgBIAAAAIgCgDIgBgBIgBgBIAAgBIgBAAIAAAAQhFhYgxhlIgCgEQg0hsgQh3IgBgEQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAVAKAVALIABAAQBPAnBDA5QAWATAVAUIAEADQAqAqAiAwIACAEIADgBIABAAIADAAIADABIABAAIACABIABAAIACAAIABAAIAAAAIACACIABAAIABABIABAAIACABIACACIACABQBDBcAuBoIACAEQAvBvASB4IABAEQATB4gTB5IgBAEQgJA9gOA9IgBAEQgaB0g5BoIgCAEQg3BkhQBRIgDADQgnAmguAbIgEACQhkA5htAmIgEABQhTAchYAFIgFAAIg1ABIg1gBgAiIscQgfAEggAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgCBzAfBwIABACQAgBvBABfIABACQAxBGA6A8IACACQBIBIBcAvIACABQBEAhBHAcIACABQBJAbBMAMIADAAQAoAGAoABIADAAIAjABIACAAQB2AGB1gSIACAAQBWgPBOgnIACgBQBdgvBQhBIACgBQAWgSARgWIACgCQBLhcArhuIABgCQAqhvATh1IAAgDQAUh1gRh0IAAgCQgRh2gvhtIgBgCQgvhshJhdIgDgCQgkgvgrgnQgrgngxghIgFgDQhhg/hwgfIgFgBQg+gShAgIQgzgHgzgBIgEAAIgNAAQg7AAg6AJg");
	this.shape_57.setTransform(164.047,282.9796);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#FFFFFF").s().p("AADMnIgDAAIghgBIgDAAQgpgCgngGIgDAAQhMgLhKgcIgCgBQhHgbhEgiIgCgBQhcguhHhIIgCgCQg7g8gxhGIgBgCQhAhfgghvIgBgCQgfhwAChzIAAgDQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJIAlgKQAfgHAggFQBAgJBCABIAEAAQAzABAzAHQBAAIA+ASIAFABQBvAfBiA+IAFAEQAxAgArAoQArAnAkAuIADADQBJBdAvBsIABACQAvBtARB2IAAACQARB0gUB1IAAACQgTB2gqBvIgBACQgrBuhKBcIgCACQgSAWgVASIgCABQhQBBhdAvIgCABQhOAnhXAOIgCAAQhYAOhZAAIg6gBg");
	this.shape_58.setTransform(163.9189,285.6187);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#000000").s().p("AAoNqIgFAAQhMAAhMgJIgFgBQhOgKhJgaIgEgBQhKgahFgkIgEgCQhGgkhAgsIgEgDQg/gsgvg+IgDgEIgBgBIAAgBIgBgBIgBgBIgCgDIgBAAIgBgCQhFhZgyhlIgCgEQg0hsgQh2IgBgFQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQBgATBYAnQAVAKAVALIABAAQBPAoBDA4QAWATAVAUIADADQAqAqAjAwIACAEIADgBIABAAIADABIAAAAIADAAIABAAIACABIABAAIABABIACAAIAAAAIACABIACABIABAAIACABIABACIACABQBDBcAuBoIACAEQAwBvASB4IABAEQATB4gTB5IgBAEQgJA9gOA9IgBAEQgaB0g5BoIgCAEQg2BkhRBRIgDADQgmAmgvAcIgEACQhkA4htAmIgEABQhTAdhYAEIgFAAIg1ABIg1gBgAiIscQggAEgfAIIglAKQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAADQgCBzAfBwIABACQAgBuBABfIABACQAxBGA7A8IACACQBHBJBcAuIACABQBEAhBHAcIACABQBKAbBMAMIADAAQAnAGApABIADAAIAiABIACAAQB3AGB0gSIACAAQBXgOBOgnIACgBQBdgvBQhBIACgBQAVgTASgVIACgCQBKhcArhvIABgCQAqhvATh1IAAgCQAUh2gRh0IAAgCQgRh2gvhsIgBgCQgvhthJhcIgDgDQgkgvgrgnQgrgngxghIgFgDQhig/hvgfIgFgBQg+gShAgIQgzgGgzgCIgEAAIgNAAQg7AAg6AJg");
	this.shape_59.setTransform(164.047,285.3796);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#FFFFFF").s().p("AAAMnIgkgBQgqgCgpgGQhOgLhKgdQhIgchFgiQhdguhIhKQg8g9gxhHQhBhggghwQgghxADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwIAOgHIABAAQAegOAggJQByghB3ADQB3ACByAgQBzAgBjBBQBlBCBKBfQBJBdAwBuQAwBtAQB3QARB1gUB3QgTB2grBwQgrBwhMBdQgTAWgWATQhRBCheAvQhPAnhYAOQhZAOhaAAIg7gBg");
	this.shape_60.setTransform(163.9153,288.0647);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIABABIgBgBIAAgBIAAABQhHhbgyhnQg1hugQh5QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAjssGQggAJgeANIgBABIgOAGQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB1AgBxQAgBvBBBgQAxBHA8A9QBIBKBdAvQBFAiBIAcQBKAcBOAMQApAGAqABIAlABQB3AGB2gSQBYgOBPgoQBegvBRhCQAWgSATgXQBMhdArhvQArhwATh3QAUh2gRh1QgQh3gwhuQgwhthJheQhKhehlhCQhjhBhzggQhyghh3gCIgRAAQhuAAhqAfgAqtItIABABIgBgCIAAABgAqqIxIAAAAg");
	this.shape_61.setTransform(164.0473,287.8296);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgigBIgCAAQgpgCgogGIgCAAQhNgMhKgbIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAfgJIABAAQByghB2ADIABAAQB2ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAABQARB1gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_62.setTransform(163.9153,285.9647);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIABAAIgBgBIAAAAIAAAAQhGhZgyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIACAAQAoAGApABIACAAIAjABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh2IAAgBQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_63.setTransform(164.0473,285.7296);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgBAAQgpgCgpgGIgBAAQhNgLhKgcIgBgBQhHgbhFgiIgBgBQhcguhIhJIgBgBQg8g9gwhGIgBgBQhAhgghhvIAAgBQgghwADh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgUAfgKIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_64.setTransform(163.9153,283.8147);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAABIAAgBIgBgBIAAABQhFhagyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAACQgDBzAgBxIAAABQAhBvBABfIABABQAwBHA8A8IABABQBIBKBcAuIABABQBFAhBHAcIABABQBKAbBNAMIABAAQApAGApABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh1IAAgCQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_65.setTransform(164.0473,283.5796);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgBAAQgqgCgogGIgBAAQhNgMhKgbIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAfgJIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAgBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtARB2IAAABQARB1gUB2IAAABQgTB2gqBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_66.setTransform(163.9153,281.7147);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIAAgBIgBAAIAAAAQhFhZgyhmIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgPBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQAqhwATh2IAAgBQAUh2gRh0IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgfAJgtAUg");
	this.shape_67.setTransform(164.0473,281.4796);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgLhKgcIgBgBQhIgbhEgiIgBgBQhdguhIhJIgBgBQg7g9gwhGIgBgBQhAhgghhvIAAgBQgghwADh0IAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAABQgTB2gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg6gBg");
	this.shape_68.setTransform(163.9153,279.5647);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIAAgBIgBAAIAAAAQhFhZgyhlIgBgDQg0htgRh3IAAgDQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBxIAAABQAhBvBABfIABABQAwBHA7A8IABABQBIBKBdAuIABABQBEAhBIAcIABABQBKAbBMAMIACAAQAoAGApABIACAAIAkABIABAAQB3AGB1gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh1IAAgBQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAJguAUg");
	this.shape_69.setTransform(164.0473,279.3296);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#FFFFFF").s().p("AACMnIgCAAIgjgBIgCAAQgpgCgogGIgCAAQhMgMhKgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBAIABABQBkBCBJBeIABABQBJBdAvBtIABABQAvBtARB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhMBdIgBABQgSAWgWASIgBABQhQBBheAvIgBABQhOAnhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_70.setTransform(163.9153,277.4647);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIgBgBQhFhagyhlIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIABAAQB3AGB1gSIABAAQBXgPBOgnIABgBQBeguBQhCIABgBQAWgSASgWIABgBQBMhcArhvIABgBQAqhwATh1IAAgCQAUh1gRh1IAAgBQgRh3gvhtIgBgBQgvhthJhdIgBgBQhJhehkhBIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAIguAVg");
	this.shape_71.setTransform(164.0473,277.2296);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhMgLhKgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADhzIAAgCQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAugVAegJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_72.setTransform(163.9153,275.3147);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAAAIgBgBIAAAAIAAAAQhFhZgyhmIgBgDQg0hsgRh4IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgeAJguAUg");
	this.shape_73.setTransform(164.0473,275.0796);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhMgMhKgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhAhfghhvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAvgVAdgJIABAAQByghB3ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAvBtARB3IAAABQARB0gUB2IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_74.setTransform(163.9153,273.2147);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIAAgBIAAABQhFhagyhlIgBgDQg0htgRh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAhBvBABgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBKAcBMAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgRh2gvhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh3gChyAhIgBAAQgdAIgvAVg");
	this.shape_75.setTransform(164.0473,272.9796);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhNgLhJgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAvgVAdgJIABAAQBzghB2ADIABAAQB2ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAABQARB1gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_76.setTransform(163.9153,271.0647);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBQhFhagyhlIgBgDQg1htgQh3IAAgCQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChzAhIgBAAQgdAIgvAVg");
	this.shape_77.setTransform(164.0473,270.8296);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgjgBIgCAAQgpgCgogGIgCAAQhNgMhJgbIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgWAcgIIABAAQBzghB2ADIABAAQB2ACByAgIABAAQByAgBjBBIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAABQARB1gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_78.setTransform(163.9153,268.9647);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIAAgBIgBgBQhFhZgyhmIgBgDQg1hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIACAAQAoAGApABIACAAIAkABIAAAAQB3AGB2gSIABAAQBXgPBOgmIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh2IAAgBQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh2gCIgBAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_79.setTransform(164.0473,268.7296);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgLhJgcIgBgBQhIgchEghIgBgBQhdguhIhKIgBgBQg7g8gwhHIgBgBQhBhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgVAcgJIABAAQBzghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBJBeIABABQBJBdAvBtIABABQAwBtAQB2IAAACQARB0gUB2IAAABQgTB2gqBvIgBABQgrBvhMBdIgBABQgSAWgWASIgBABQhQBBheAvIgBABQhOAmhXAOIgBAAQhZAOhaAAIg6gBg");
	this.shape_80.setTransform(163.9153,266.8147);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBAAIAAgBIgBgBIAAABQhEhagyhmIgBgDQg1hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAABQgDB0AgBwIAAABQAgBvBBBgIABABQAwBGA7A9IABABQBIBJBdAuIABABQBEAiBIAbIABABQBJAcBNAMIABAAQApAGApABIABAAIAlABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBeguBQhCIABgBQAWgSASgWIABgBQBMhcArhvIABgBQAqhwATh1IAAgCQAUh2gRh0IAAgBQgQh3gwhtIgBgBQgvhthJhdIgBgBQhJhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_81.setTransform(164.0473,266.5796);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgMhJgcIgBgBQhIgbhEgiIgBgBQhdguhIhJIgBgBQg7g9gwhGIgBgBQhBhggghvIAAgBQgghwADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAwgWAcgIIABAAQBzghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBBBJBeIABABQBJBdAvBtIABABQAwBtAQB3IAAACQARB0gUB1IAAACQgTB1gqBwIgBABQgrBvhMBcIgBABQgSAWgWASIgBABQhQBCheAuIgBABQhOAnhXAOIgBAAQhZAOhaAAIg6gBg");
	this.shape_82.setTransform(163.9153,264.7147);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhEhZgyhmIgBgDQg1htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB0AgBxIAAABQAgBvBBBfIABABQAwBHA7A8IABABQBIBKBdAuIABABQBEAhBIAcIABABQBJAcBNAMIABAAQApAGApABIABAAIAlABIAAAAQB3AGB2gSIABAAQBXgOBOgnIABgBQBegvBQhBIABgBQAWgSASgWIABgBQBMhdArhvIABgBQAqhvATh1IAAgCQAUh2gRh0IAAgCQgQh2gwhtIgBgBQgvhthJhdIgBgBQhJhehkhCIgBgBQhjhAhyggIgBAAQhyghh1gCIgCAAQh2gChzAhIgBAAQgcAIgwAVg");
	this.shape_83.setTransform(164.0473,264.4796);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgpgCgpgGIgBAAQhNgLhKgcIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAACQgTB1grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_84.setTransform(163.9153,262.5647);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhZgyhmIgBgDQg0hsgQh4IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQApAGApABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh0IAAgCQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAIgxAVg");
	this.shape_85.setTransform(164.0473,262.3296);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#FFFFFF").s().p("AABMnIgBAAIgkgBIgBAAQgqgCgogGIgBAAQhNgMhKgcIgBgBQhHgbhFgiIgBgBQhcguhIhJIgBgBQg8g9gwhGIgBgBQhAhggghvIAAgBQgghwADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAABQgTB2grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhYAOhaAAIg6gBg");
	this.shape_86.setTransform(163.9153,260.4647);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhagyhlIgBgDQg0htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB0AgBxIAAABQAgBvBABfIABABQAwBHA8A8IABABQBIBKBcAuIABABQBFAhBHAcIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB3AGB1gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh1IAAgBQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAHgxAWg");
	this.shape_87.setTransform(164.0473,260.2296);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#FFFFFF").s().p("AAAMnIAAAAIgkgBIgBAAQgqgCgogGIgBAAQhNgLhKgcIgBgBQhHgchFghIgBgBQhcguhIhKIgBgBQg8g8gwhHIgBgBQhAhfgghvIAAgBQgghxADh0IAAgBQAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAxgWAcgIIABAAQByghB2ADIACAAQB1ACByAgIABAAQByAhBjBAIABABQBkBCBKBeIABABQBJBdAvBtIABABQAvBtAQB2IAAACQARB0gUB2IAAACQgTB1grBvIgBABQgrBvhLBdIgBABQgSAWgWASIgBABQhRBBhdAvIgBABQhPAmhXAOIgBAAQhZAOhZAAIg7gBg");
	this.shape_88.setTransform(163.9153,258.3147);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCIgBgBIgBgBQhFhZgyhmIgBgDQg0htgQh3IAAgBQgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAk5rpQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6IAAAAQgDB1AgBwIAAABQAgBvBABgIABABQAwBGA8A9IABABQBIBJBcAuIABABQBFAiBHAbIABABQBKAcBNAMIABAAQAoAGAqABIABAAIAkABIABAAQB2AGB2gSIABAAQBXgOBPgnIABgBQBdguBRhCIABgBQAWgSASgWIABgBQBLhcArhvIABgBQArhwATh1IAAgCQAUh1gRh0IAAgCQgQh3gvhtIgBgBQgvhthJhdIgBgBQhKhehkhBIgBgBQhjhBhyggIgBAAQhyghh1gCIgCAAQh2gChyAhIgBAAQgcAIgxAVg");
	this.shape_89.setTransform(164.0473,258.0796);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#FFFFFF").s().p("AAAMnIgkgBQgqgCgpgGQhOgLhKgdQhIgchFgiQhdguhIhKQg8g9gxhHQhBhggghwQgghxADh1QAEh5Alh0QAmh1BFhkQBEhjBbhOQBYhKBpgwQAtgVAggJQByghB3ADQB3ACByAgQBzAgBjBBQBlBCBKBfQBJBdAwBuQAwBtAQB3QARB1gUB3QgTB2grBwQgrBwhMBdQgTAWgWATQhRBCheAvQhPAnhYAOQhZAOhaAAIg7gBg");
	this.shape_90.setTransform(163.9153,256.2147);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#000000").s().p("AAjNqQhOAAhPgKQhPgKhMgbQhLgbhIglQhHglhCguQhCgtgwhBIgEgGIgBgBIgBAAIgBgCQhHhbgyhnQg1hugQh5QgRh6AUh6QAUh7AwhzQAthsBLhaQBMhcBehIQBdhGBsgrQBwgtB5gGQB6gHB4AYQB3AYBsA3QBrA2BVBUQAsArAjAzIADgBIAEAAIADABIAEABIACAAIADABIACABIACACIACABIACACQBFBdAuBrQAxBxASB5QATB6gUB7QgKBAgOA/QgaB2g7BqQg3BmhTBRQgoAogxAcQhmA6huAmQhWAdhbAEIg3ABIg4gBgAjssGQggAJgtAUQhpAwhYBLQhbBNhEBjQhFBlgmB0QglB0gEB6QgDB1AgBxQAgBvBBBgQAxBHA8A9QBIBKBdAvQBFAiBIAcQBKAcBOAMQApAGAqABIAlABQB3AGB2gSQBYgOBPgoQBegvBRhCQAWgSATgXQBMhdArhvQArhwATh3QAUh2gRh1QgQh3gwhuQgwhthJheQhKhehlhCQhjhBhzggQhyghh3gCIgRAAQhuAAhqAfg");
	this.shape_91.setTransform(164.0473,255.9796);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_33},{t:this.shape_32}]}).to({state:[{t:this.shape_35},{t:this.shape_34}]},1).to({state:[{t:this.shape_37},{t:this.shape_36}]},1).to({state:[{t:this.shape_39},{t:this.shape_38}]},1).to({state:[{t:this.shape_41},{t:this.shape_40}]},1).to({state:[{t:this.shape_43},{t:this.shape_42}]},1).to({state:[{t:this.shape_45},{t:this.shape_44}]},1).to({state:[{t:this.shape_47},{t:this.shape_46}]},1).to({state:[{t:this.shape_49},{t:this.shape_48}]},1).to({state:[{t:this.shape_51},{t:this.shape_50}]},1).to({state:[{t:this.shape_53},{t:this.shape_52}]},1).to({state:[{t:this.shape_55},{t:this.shape_54}]},1).to({state:[{t:this.shape_57},{t:this.shape_56}]},1).to({state:[{t:this.shape_59},{t:this.shape_58}]},1).to({state:[{t:this.shape_61},{t:this.shape_60}]},1).to({state:[{t:this.shape_63},{t:this.shape_62}]},1).to({state:[{t:this.shape_65},{t:this.shape_64}]},1).to({state:[{t:this.shape_67},{t:this.shape_66}]},1).to({state:[{t:this.shape_69},{t:this.shape_68}]},1).to({state:[{t:this.shape_71},{t:this.shape_70}]},1).to({state:[{t:this.shape_73},{t:this.shape_72}]},1).to({state:[{t:this.shape_75},{t:this.shape_74}]},1).to({state:[{t:this.shape_77},{t:this.shape_76}]},1).to({state:[{t:this.shape_79},{t:this.shape_78}]},1).to({state:[{t:this.shape_81},{t:this.shape_80}]},1).to({state:[{t:this.shape_83},{t:this.shape_82}]},1).to({state:[{t:this.shape_85},{t:this.shape_84}]},1).to({state:[{t:this.shape_87},{t:this.shape_86}]},1).to({state:[{t:this.shape_89},{t:this.shape_88}]},1).to({state:[{t:this.shape_91},{t:this.shape_90}]},1).wait(1));

	// buoy_R_handle
	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#FFFFFF").s().p("AgtBwQgOgCgDgCIgPgKIgMgHQgIgEgDgFIgFgKIgEgKIgKgQIgEgOIgFgNIgBgNIgCgLQgCgHABgFIAFgTIAJgXIAJgRQADgKAEgDQABgBANgEIAPgGIAOgDQAPgCAdgHIANgBIABAAQAFADAGAAIAYADQANACANADQAOADANAFQAMAEALAIIACACIADACIACACIACACIACACIACADIABACIACADIABADIABADIABADIABADIABADIABADIABAEIAAADIAAADIABAEIAAAEIAAADIAAAEIgBADIAAAEIAAADIgBADIgBADIAAADIgBACIgBADIgCADIgBACIgCADIgCADIgCADIgCADIgCACIgCACIgCADIgDACIgCACIgCADIgDACIgMAIIgVAMIgcAPQgMAHgNADIgdAGIgDABIgCACIgDABIgCACIgCACIgCACIgCACIgBACIgCADIgBADIgBACIAAADIAAACIgLgCgAgEg5QgTABghASQgIAEgEAEQgPAMABAcQAAAKACAFQABAGAEAFIAAAAQABAGAFAGIAMAIIAOAEIAbAFIAQADIADAAIABAAIACAAIACAAIADAAIACAAIACAAIAFgCIANgHIALgJIANgKQAGgEAFgGIAKgNIABgCIABgCIABgDIABgCIABgDIABgCIABgDIAAgCIABgCIAAgDIAAgDIAAgCIAAgDIAAgCIgBgDIAAgCIgBgDIgBgCIgBgCIgCgDIgBgCIgDgEIgEgDIgEgDIgEgDIgEgDIgCgBIgKgDIgKgDIgDAAIgGgCIgIABIgFAAIgCAAIgSABg");
	this.shape_92.setTransform(1626.2924,222.5966,1,1,-161.0613);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#000000").s().p("AhXCRIgPgJIgTgMIgLgIQgKgJgHgOIgJgUIgIgQIgJgaIgCgLQgDgagBgPQAAgKACgHIAGgNIAHgVIAJgQQAHgSAGgIQAIgKAWgIIAZgIIAfgGIAXgFIAWgCIAUAAQAPgBAIAEQAsgBAqAUQAwAXANAzQAPA4gfAwQgdAugxAcQgoAXgrAFIgCABIgLADIgRABQgmAAgTgJgAgYhwQgdAHgPACIgNADIgPAGQgNAEgCABQgDADgDAKIgJARIgKAXIgFATQAAAFABAHIACALIACANIAEANIAFAOIAJAQIAEAKIAFAKQAEAFAHAEIANAHIAPAKQADACANACIALACIAAgCIABgDIABgCIABgDIABgDIACgCIACgCIABgCIACgCIADgCIACgBIADgCIACgBIAdgGQAOgDAMgHIAcgPIAVgMIAMgIIACgCIADgDIACgCIACgCIADgDIACgCIACgCIACgDIACgDIABgDIACgDIACgCIABgDIABgDIABgCIABgDIABgDIAAgDIABgDIAAgEIAAgDIAAgEIAAgDIAAgEIAAgEIAAgDIgBgDIgBgEIAAgDIgBgDIgBgDIgBgDIgCgDIgBgDIgBgDIgCgCIgCgDIgCgCIgCgCIgCgCIgCgCIgCgCQgLgIgNgEQgNgFgNgDQgNgDgOgCIgYgDQgFAAgGgDIAAAAIgOABgAACBEIgCAAIgBAAIgDAAIgBAAIgCAAIgRgDIgbgFIgOgEIgMgIQgGgGAAgGIAAAAQgEgFgCgGQgBgFAAgKQgBgcAOgMQAEgEAIgEQAhgSAUgBIASgBIABAAIAGAAIAHgBIAHACIACAAIALADIAJADIADABIAEADIAEADIAEADIADADIADAEIACACIABADIABACIABACIABADIABACIAAADIABACIAAADIAAACIAAADIgBADIAAACIgBACIAAADIgBACIgBADIgBACIgBADIgCACIgBACIgKANQgEAGgGAEIgNAKIgMAJIgNAHIgEACIgCAAIgDAAgAgzgKIgGAEQgBACgBAEQgDAPAFAFQAOAGAOgBIAGgBIACgBIAAAAIACgCIACgCIAGgEIAIgDIAHgFIAIgEIAHgEIACgCIACgBIACgCIACgCIACgCIACgCIABgCIACgCIgBgCIgCgBIgBgBIgCgCIgDgBIgDgBIgCgCIgDgBIgIAAIgJAAIgBAAQgSAAggARg");
	this.shape_93.setTransform(1625.5073,222.2969,1,1,-161.0613);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_93},{t:this.shape_92}]}).wait(30));

	// buoy_L_handle
	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#FFFFFF").s().p("AgtBwQgOgCgDgCIgPgKIgMgHQgIgEgDgFIgFgKIgEgKIgKgQIgEgOIgFgNIgBgNIgCgLQgCgHABgFIAFgTIAJgXIAJgRQADgKAEgDQABgBANgEIAPgGIAOgDQAPgCAdgHIANgBIABAAQAFADAGAAIAYADQANACANADQAOADANAFQAMAEALAIIACACIADACIACACIACACIACACIACADIABACIACADIABADIABADIABADIABADIABADIABADIABAEIAAADIAAADIABAEIAAAEIAAADIAAAEIgBADIAAAEIAAADIgBADIgBADIAAADIgBACIgBADIgCADIgBACIgCADIgCADIgCADIgCADIgCACIgCACIgCADIgDACIgCACIgCADIgDACIgMAIIgVAMIgcAPQgMAHgNADIgdAGIgDABIgCACIgDABIgCACIgCACIgCACIgCACIgBACIgCADIgBADIgBACIAAADIAAACIgLgCgAgEg5QgTABghASQgIAEgEAEQgPAMABAcQAAAKACAFQABAGAEAFIAAAAQABAGAFAGIAMAIIAOAEIAbAFIAQADIADAAIABAAIACAAIACAAIADAAIACAAIACAAIAFgCIANgHIALgJIANgKQAGgEAFgGIAKgNIABgCIABgCIABgDIABgCIABgDIABgCIABgDIAAgCIABgCIAAgDIAAgDIAAgCIAAgDIAAgCIgBgDIAAgCIgBgDIgBgCIgBgCIgCgDIgBgCIgDgEIgEgDIgEgDIgEgDIgEgDIgCgBIgKgDIgKgDIgDAAIgGgCIgIABIgFAAIgCAAIgSABg");
	this.shape_94.setTransform(249.7938,261.0125);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#000000").s().p("AhXCRIgPgJIgTgMIgLgIQgKgJgHgOIgJgUIgIgQIgJgaIgCgLQgDgagBgPQAAgKACgHIAGgNIAHgVIAJgQQAHgSAGgIQAIgKAWgIIAZgIIAfgGIAXgFIAWgCIAUAAQAPgBAIAEQAsgBAqAUQAwAXANAzQAPA4gfAwQgdAugxAcQgoAXgrAFIgCABIgLADIgRABQgmAAgTgJgAgYhwQgdAHgPACIgNADIgPAGQgNAEgCABQgDADgDAKIgJARIgKAXIgFATQAAAFABAHIACALIACANIAEANIAFAOIAJAQIAEAKIAFAKQAEAFAHAEIANAHIAPAKQADACANACIALACIAAgCIABgDIABgCIABgDIABgDIACgCIACgCIABgCIACgCIADgCIACgBIADgCIACgBIAdgGQAOgDAMgHIAcgPIAVgMIAMgIIACgCIADgDIACgCIACgCIADgDIACgCIACgCIACgDIACgDIABgDIACgDIACgCIABgDIABgDIABgCIABgDIABgDIAAgDIABgDIAAgEIAAgDIAAgEIAAgDIAAgEIAAgEIAAgDIgBgDIgBgEIAAgDIgBgDIgBgDIgBgDIgCgDIgBgDIgBgDIgCgCIgCgDIgCgCIgCgCIgCgCIgCgCIgCgCQgLgIgNgEQgNgFgNgDQgNgDgOgCIgYgDQgFAAgGgDIAAAAIgOABgAACBEIgCAAIgBAAIgDAAIgBAAIgCAAIgRgDIgbgFIgOgEIgMgIQgGgGAAgGIAAAAQgEgFgCgGQgBgFAAgKQgBgcAOgMQAEgEAIgEQAhgSAUgBIASgBIABAAIAGAAIAHgBIAHACIACAAIALADIAJADIADABIAEADIAEADIAEADIADADIADAEIACACIABADIABACIABACIABADIABACIAAADIABACIAAADIAAACIAAADIgBADIAAACIgBACIAAADIgBACIgBADIgBACIgBADIgCACIgBACIgKANQgEAGgGAEIgNAKIgMAJIgNAHIgEACIgCAAIgDAAgAgzgKIgGAEQgBACgBAEQgDAPAFAFQAOAGAOgBIAGgBIACgBIAAAAIACgCIACgCIAGgEIAIgDIAHgFIAIgEIAHgEIACgCIACgBIACgCIACgCIACgCIACgCIABgCIACgCIgBgCIgCgBIgBgBIgCgCIgDgBIgDgBIgCgCIgDgBIgIAAIgJAAIgBAAQgSAAggARg");
	this.shape_95.setTransform(250.6336,261.0412);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_95},{t:this.shape_94}]}).wait(30));

	// weed
	this.instance = new lib.Symbol3();
	this.instance.setTransform(653.75,549.15,1,1,0,0,0,29.8,272.3);

	this.instance_1 = new lib.Symbol5();
	this.instance_1.setTransform(389.45,501.65,1,1,0,0,0,44.6,199);

	this.instance_2 = new lib.Symbol1();
	this.instance_2.setTransform(1140.65,548.7,1,1,0,0,0,42.2,255);

	this.instance_3 = new lib.Symbol5();
	this.instance_3.setTransform(1243.4,470.9,1,1,0,0,0,33.8,203.8);

	this.instance_4 = new lib.Symbol4();
	this.instance_4.setTransform(966.1,616.85,1,1,0,0,0,106.2,280);

	this.instance_5 = new lib.Symbol3();
	this.instance_5.setTransform(1391.15,524.35,1,1,0,0,0,60.4,277.1);

	this.instance_6 = new lib.Symbol2();
	this.instance_6.setTransform(815.65,527.65,1,1,0,0,0,59.2,228.2);

	this.instance_7 = new lib.Symbol1();
	this.instance_7.setTransform(529.25,549.8,1,1,0,0,0,52,260.4);

	this.instance_8 = new lib.Symbol1();
	this.instance_8.setTransform(1500.6,506.9,1,1,0,0,0,42.2,255);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8,p:{x:1500.6,y:506.9}},{t:this.instance_7,p:{y:549.8,x:529.25}},{t:this.instance_6,p:{y:527.65,x:815.65}},{t:this.instance_5,p:{y:524.35}},{t:this.instance_4,p:{x:966.1,y:616.85}},{t:this.instance_3,p:{y:470.9}},{t:this.instance_2,p:{y:548.7,x:1140.65}},{t:this.instance_1,p:{y:501.65}},{t:this.instance,p:{x:653.75,y:549.15}}]}).to({state:[{t:this.instance_8,p:{x:1500.55,y:504.5}},{t:this.instance_7,p:{y:549.45,x:529.25}},{t:this.instance_6,p:{y:527.3,x:815.65}},{t:this.instance_5,p:{y:524.35}},{t:this.instance_4,p:{x:966.6,y:611.05}},{t:this.instance_3,p:{y:474.15}},{t:this.instance_2,p:{y:548.95,x:1140.65}},{t:this.instance_1,p:{y:498.3}},{t:this.instance,p:{x:655.15,y:551.15}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:502.85}},{t:this.instance_7,p:{y:549.05,x:529.25}},{t:this.instance_6,p:{y:526.9,x:816.15}},{t:this.instance_5,p:{y:525.65}},{t:this.instance_4,p:{x:966.1,y:606.45}},{t:this.instance_3,p:{y:476.2}},{t:this.instance_2,p:{y:549.2,x:1140.65}},{t:this.instance_1,p:{y:495.55}},{t:this.instance,p:{x:655.65,y:553}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:500.5}},{t:this.instance_7,p:{y:550.45,x:529.25}},{t:this.instance_6,p:{y:523.9,x:816.15}},{t:this.instance_5,p:{y:526.1}},{t:this.instance_4,p:{x:966.1,y:602.45}},{t:this.instance_3,p:{y:478.45}},{t:this.instance_2,p:{y:549.7,x:1140.65}},{t:this.instance_1,p:{y:492.5}},{t:this.instance,p:{x:655.65,y:554.9}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:498.85}},{t:this.instance_7,p:{y:550.95,x:529.25}},{t:this.instance_6,p:{y:524.3,x:817.7}},{t:this.instance_5,p:{y:526.9}},{t:this.instance_4,p:{x:965.6,y:598.55}},{t:this.instance_3,p:{y:481.9}},{t:this.instance_2,p:{y:548.7,x:1140.65}},{t:this.instance_1,p:{y:489.5}},{t:this.instance,p:{x:655.7,y:556.65}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:496.9}},{t:this.instance_7,p:{y:553.35,x:529.25}},{t:this.instance_6,p:{y:523.2,x:818.2}},{t:this.instance_5,p:{y:528.15}},{t:this.instance_4,p:{x:966.1,y:593.95}},{t:this.instance_3,p:{y:483.65}},{t:this.instance_2,p:{y:549.45,x:1140.65}},{t:this.instance_1,p:{y:486.5}},{t:this.instance,p:{x:655.7,y:558.55}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:495.6}},{t:this.instance_7,p:{y:553.15,x:529.25}},{t:this.instance_6,p:{y:523,x:818.2}},{t:this.instance_5,p:{y:529.4}},{t:this.instance_4,p:{x:966.1,y:590.25}},{t:this.instance_3,p:{y:486.9}},{t:this.instance_2,p:{y:549.7,x:1140.65}},{t:this.instance_1,p:{y:483.4}},{t:this.instance,p:{x:655.7,y:560.4}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:493.6}},{t:this.instance_7,p:{y:553.9,x:529.25}},{t:this.instance_6,p:{y:521.5,x:818.7}},{t:this.instance_5,p:{y:529.9}},{t:this.instance_4,p:{x:966.6,y:584.25}},{t:this.instance_3,p:{y:489.15}},{t:this.instance_2,p:{y:549.75,x:1140.65}},{t:this.instance_1,p:{y:480.55}},{t:this.instance,p:{x:655.7,y:562.3}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:491.85}},{t:this.instance_7,p:{y:554.85,x:529.25}},{t:this.instance_6,p:{y:520.2,x:818.7}},{t:this.instance_5,p:{y:531.15}},{t:this.instance_4,p:{x:966.6,y:579.2}},{t:this.instance_3,p:{y:492.05}},{t:this.instance_2,p:{y:549.45,x:1140.65}},{t:this.instance_1,p:{y:477.5}},{t:this.instance,p:{x:655.7,y:563.9}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:490.1}},{t:this.instance_7,p:{y:554.85,x:529.25}},{t:this.instance_6,p:{y:519.65,x:818.7}},{t:this.instance_5,p:{y:532.6}},{t:this.instance_4,p:{x:966.6,y:574.15}},{t:this.instance_3,p:{y:494.5}},{t:this.instance_2,p:{y:549.45,x:1140.65}},{t:this.instance_1,p:{y:474.5}},{t:this.instance,p:{x:655.7,y:565.8}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:488.35}},{t:this.instance_7,p:{y:555.6,x:529.25}},{t:this.instance_6,p:{y:517.75,x:818.7}},{t:this.instance_5,p:{y:533.4}},{t:this.instance_4,p:{x:966.6,y:568.5}},{t:this.instance_3,p:{y:496.4}},{t:this.instance_2,p:{y:550.2,x:1140.65}},{t:this.instance_1,p:{y:471.5}},{t:this.instance,p:{x:655.7,y:567.85}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:486.35}},{t:this.instance_7,p:{y:556.4,x:529.25}},{t:this.instance_6,p:{y:516.85,x:818.7}},{t:this.instance_5,p:{y:534.6}},{t:this.instance_4,p:{x:966.6,y:562.45}},{t:this.instance_3,p:{y:498.7}},{t:this.instance_2,p:{y:549.7,x:1140.65}},{t:this.instance_1,p:{y:468.4}},{t:this.instance,p:{x:655.7,y:569.55}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:484.6}},{t:this.instance_7,p:{y:556.75,x:529.25}},{t:this.instance_6,p:{y:516.45,x:818.7}},{t:this.instance_5,p:{y:535.9}},{t:this.instance_4,p:{x:966.6,y:557.95}},{t:this.instance_3,p:{y:501.45}},{t:this.instance_2,p:{y:549.7,x:1140.65}},{t:this.instance_1,p:{y:465.05}},{t:this.instance,p:{x:655.7,y:571.7}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:482.85}},{t:this.instance_7,p:{y:556.65,x:529.25}},{t:this.instance_6,p:{y:514,x:818.7}},{t:this.instance_5,p:{y:536.85}},{t:this.instance_4,p:{x:966.6,y:552.95}},{t:this.instance_3,p:{y:503.4}},{t:this.instance_2,p:{y:549.7,x:1140.65}},{t:this.instance_1,p:{y:462.3}},{t:this.instance,p:{x:655.7,y:573.45}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:480.6}},{t:this.instance_7,p:{y:556.8,x:529.25}},{t:this.instance_6,p:{y:514,x:818.2}},{t:this.instance_5,p:{y:538.85}},{t:this.instance_4,p:{x:966.1,y:548.75}},{t:this.instance_3,p:{y:505.95}},{t:this.instance_2,p:{y:549.15,x:1141.15}},{t:this.instance_1,p:{y:459.05}},{t:this.instance,p:{x:655.7,y:575.45}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:482.1}},{t:this.instance_7,p:{y:553.4,x:529.25}},{t:this.instance_6,p:{y:514,x:818.65}},{t:this.instance_5,p:{y:536.4}},{t:this.instance_4,p:{x:966.55,y:550.8}},{t:this.instance_3,p:{y:502.9}},{t:this.instance_2,p:{y:548,x:1140.9}},{t:this.instance_1,p:{y:460.75}},{t:this.instance,p:{x:655.7,y:572.6}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:483.85}},{t:this.instance_7,p:{y:549.7,x:529.25}},{t:this.instance_6,p:{y:514,x:818.65}},{t:this.instance_5,p:{y:534}},{t:this.instance_4,p:{x:966.55,y:553.95}},{t:this.instance_3,p:{y:499.9}},{t:this.instance_2,p:{y:547.45,x:1140.65}},{t:this.instance_1,p:{y:462.15}},{t:this.instance,p:{x:655.7,y:569.55}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:485.1}},{t:this.instance_7,p:{y:546.75,x:529.25}},{t:this.instance_6,p:{y:514,x:819.6}},{t:this.instance_5,p:{y:533.4}},{t:this.instance_4,p:{x:965.5,y:556}},{t:this.instance_3,p:{y:496.45}},{t:this.instance_2,p:{y:546.35,x:1140.65}},{t:this.instance_1,p:{y:464.05}},{t:this.instance,p:{x:655.7,y:566.55}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:486.6}},{t:this.instance_7,p:{y:544.15,x:529.25}},{t:this.instance_6,p:{y:516.1,x:819.65}},{t:this.instance_5,p:{y:531.65}},{t:this.instance_4,p:{x:965.5,y:560.3}},{t:this.instance_3,p:{y:493.45}},{t:this.instance_2,p:{y:545.7,x:1140.65}},{t:this.instance_1,p:{y:465.75}},{t:this.instance,p:{x:655.7,y:563.55}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:488.35}},{t:this.instance_7,p:{y:540.1,x:529.25}},{t:this.instance_6,p:{y:517.55,x:819.65}},{t:this.instance_5,p:{y:530.4}},{t:this.instance_4,p:{x:964.55,y:564.45}},{t:this.instance_3,p:{y:490.4}},{t:this.instance_2,p:{y:544.7,x:1140.65}},{t:this.instance_1,p:{y:467.8}},{t:this.instance,p:{x:655.7,y:560.65}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:489.85}},{t:this.instance_7,p:{y:535.95,x:529.25}},{t:this.instance_6,p:{y:518.5,x:819.65}},{t:this.instance_5,p:{y:528.9}},{t:this.instance_4,p:{x:964.5,y:566.8}},{t:this.instance_3,p:{y:487.15}},{t:this.instance_2,p:{y:544.45,x:1140.65}},{t:this.instance_1,p:{y:469.15}},{t:this.instance,p:{x:655.7,y:557.65}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:491.1}},{t:this.instance_7,p:{y:533.45,x:529.25}},{t:this.instance_6,p:{y:518.5,x:820.15}},{t:this.instance_5,p:{y:527.65}},{t:this.instance_4,p:{x:963.5,y:563.8}},{t:this.instance_3,p:{y:484.15}},{t:this.instance_2,p:{y:542.25,x:1140.65}},{t:this.instance_1,p:{y:471.4}},{t:this.instance,p:{x:655.7,y:555.05}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:493.1}},{t:this.instance_7,p:{y:529.55,x:529.25}},{t:this.instance_6,p:{y:520.5,x:820.15}},{t:this.instance_5,p:{y:525.6}},{t:this.instance_4,p:{x:962.5,y:566}},{t:this.instance_3,p:{y:480.9}},{t:this.instance_2,p:{y:541.7,x:1140.65}},{t:this.instance_1,p:{y:473.15}},{t:this.instance,p:{x:655.7,y:552.05}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:494.35}},{t:this.instance_7,p:{y:526.55,x:529.25}},{t:this.instance_6,p:{y:521,x:820.15}},{t:this.instance_5,p:{y:525.15}},{t:this.instance_4,p:{x:962.5,y:568.5}},{t:this.instance_3,p:{y:478.25}},{t:this.instance_2,p:{y:540.7,x:1140.65}},{t:this.instance_1,p:{y:474.65}},{t:this.instance,p:{x:655.7,y:549}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:495.85}},{t:this.instance_7,p:{y:523.2,x:529.25}},{t:this.instance_6,p:{y:522.25,x:820.65}},{t:this.instance_5,p:{y:523.35}},{t:this.instance_4,p:{x:961.5,y:568.5}},{t:this.instance_3,p:{y:474.2}},{t:this.instance_2,p:{y:539.95,x:1140.65}},{t:this.instance_1,p:{y:477}},{t:this.instance,p:{x:655.7,y:546.75}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:498.1}},{t:this.instance_7,p:{y:520.05,x:529.25}},{t:this.instance_6,p:{y:522.75,x:821.15}},{t:this.instance_5,p:{y:521.85}},{t:this.instance_4,p:{x:960.5,y:571.75}},{t:this.instance_3,p:{y:470.9}},{t:this.instance_2,p:{y:538.75,x:1140.65}},{t:this.instance_1,p:{y:478.75}},{t:this.instance,p:{x:655.7,y:543.25}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:499.6}},{t:this.instance_7,p:{y:516.7,x:529.25}},{t:this.instance_6,p:{y:523.95,x:822.65}},{t:this.instance_5,p:{y:521.35}},{t:this.instance_4,p:{x:959.5,y:578.45}},{t:this.instance_3,p:{y:467.4}},{t:this.instance_2,p:{y:536.95,x:1140.65}},{t:this.instance_1,p:{y:480.4}},{t:this.instance,p:{x:655.7,y:540.35}}]},1).to({state:[{t:this.instance_8,p:{x:1500.55,y:501.5}},{t:this.instance_7,p:{y:512.35,x:529.25}},{t:this.instance_6,p:{y:525.25,x:822.65}},{t:this.instance_5,p:{y:520.1}},{t:this.instance_4,p:{x:959.55,y:579.75}},{t:this.instance_3,p:{y:464.55}},{t:this.instance_2,p:{y:535.45,x:1140.65}},{t:this.instance_1,p:{y:482.4}},{t:this.instance,p:{x:655.7,y:537.45}}]},1).to({state:[{t:this.instance_8,p:{x:1500.7,y:502.9}},{t:this.instance_7,p:{y:510.4,x:529.25}},{t:this.instance_6,p:{y:525.85,x:821.35}},{t:this.instance_5,p:{y:518.35}},{t:this.instance_4,p:{x:958.55,y:584.25}},{t:this.instance_3,p:{y:461.15}},{t:this.instance_2,p:{y:533.2,x:1140.25}},{t:this.instance_1,p:{y:484.65}},{t:this.instance,p:{x:655.7,y:534.55}}]},1).to({state:[{t:this.instance_8,p:{x:1501.1,y:504.95}},{t:this.instance_7,p:{y:530.5,x:527.5}},{t:this.instance_6,p:{y:528.1,x:819.95}},{t:this.instance_5,p:{y:521.6}},{t:this.instance_4,p:{x:958.55,y:591.05}},{t:this.instance_3,p:{y:466.15}},{t:this.instance_2,p:{y:540.45,x:1140.65}},{t:this.instance_1,p:{y:492.25}},{t:this.instance,p:{x:655.7,y:541.95}}]},1).wait(1));

	// rope_VL
	this.instance_9 = new lib.PuppetShape_1("synched",1,false);
	this.instance_9.setTransform(189.75,602.2);

	this.instance_10 = new lib.PuppetShape_2("synched",1,false);
	this.instance_10.setTransform(189.75,602.2);
	this.instance_10._off = true;

	this.instance_11 = new lib.PuppetShape_3("synched",1,false);
	this.instance_11.setTransform(189.75,602.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9}]}).to({state:[{t:this.instance_10}]},14).to({state:[{t:this.instance_11}]},15).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({_off:true},14).wait(16));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:false},14).to({_off:true},15).wait(1));

	// rope_VR
	this.instance_12 = new lib.PuppetShape_1copy2("synched",1,false);
	this.instance_12.setTransform(1668.5,573.65,1,1,-14.9983);

	this.instance_13 = new lib.PuppetShape_2copy("synched",1,false);
	this.instance_13.setTransform(1668.5,573.65,1,1,-14.9983);
	this.instance_13._off = true;

	this.instance_14 = new lib.PuppetShape_3copy("synched",1,false);
	this.instance_14.setTransform(1668.5,573.65,1,1,-14.9983);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},14).to({state:[{t:this.instance_14}]},15).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true},14).wait(16));
	this.timeline.addTween(cjs.Tween.get(this.instance_13).to({_off:false},14).to({_off:true},15).wait(1));

	// rope_H
	this.instance_15 = new lib.PuppetShape_4copy("synched",1,false);
	this.instance_15.setTransform(938.65,274.6);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#00000C").s().p("AA8HfQhygFhxgNIgxgGQimgUikgdIhDgMQgxgJgxgKQh9gah9gdIgHgCIjMgvIhLgRQiWghiYgYIhKgLIjDgcIiUgWQg9gJg/gIQiBgQiCgKIhHgGIgGgBIhkgEIhdgDIhjgBQg6gBg6ABIg9ACIggABIguABQjDAIjCAQIhVAHIl1AfIhfAHIlqAeIhkAIQi1APi0ARIheAJQi9AQi/AKIhXAEQjEAGjEgRIhRgIQi7gTi5glQgugJgugNQi2g0ichvIhJg1IgvgkIgQgMIgEgEIgHgKIgDgOIAAAAIADgNIABgBIAHgKIAGgEIAFgCIANgDIAJABIAPAIQCeCEDBBPIAEACQBSAiBWASQB+AbB/ASIAQACQBnAPBoAHQBxAJBwACQB2ABB1gGQCHgICFgKIC7gQQCDgNCDgLICugOIEsgZIB8gLIFqggIBHgHQC7gSC9gJIBPgDQDzgJDyAKIAbACQCXAHCWARIAGABQBXAJBXAMIBDAKIETAoIBrAPIB8AUQBwATBwAZIBjAXIBzAbIAmAJIADABQCEAeCEAaIDFAmIAMADQCKAZCLAQQBfAMBfAHQDiAPDkgLIAHAAQDzgMDvgmIALgCIClgbQBTgOBSgQIBJgOIFxhEIBKgOQBXgRBXgTQCVghCVgmQB4geB3giIDMg3IEfhOQBzgfBzgbQB5gcB5gYQA5gMA6gHIADAAIANgDIAagEIAagEIAWgDIAWgEIAWgDIAVgDIABAAQCxgYCygLIBVgFQDDgIDDgBIB/AAIAzABQDaACDaAFIASABQDJAFDJgHIBXgEQC8gIC8gWQA7gGA7gIQC2gYCvgsIANgEIATgHIASgJIATgIIASgIIASgIIAXgKIANgGIAFgBIAJgEIADgBIAEgBIACgBIAFgCIADgCIAHACIACAAIAHAIIABAAIgBABIABABIAGAMIABADIgCAIIgBADIgHAJIAAABIgKAFQgyAhg1AZQgzAYg1ARQhEAWhIAKIgXADIiBAQIh6APIgZADIgEABIg4AHQjTAajSADIhQgBQjFgCjEgEIhSgCQi7gDi7ACIgXABQi2ACi2AHIhhAEQhBADg/AEQiLAJiLASIhHAJIgCAAQgxAGgyAIQikAZiiApIgFABQjUA2jSA3IgKADImaBuIgSAEQhhAahhAXQiVAjiUAhIiqAlQiTAfiSAcIgDABQjfArjiAhIgoAGQjHAcjJAPIgUACQiPAKiQAEQhcAAhbgFg");
	this.shape_96.setTransform(938.575,272.125);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#00000B").s().p("ABEHSIgHAAQhugFhtgLIgIgBIgxgFQingTikgZIg5gIIgKgCQgxgIgxgJQh5gWh6gYIgGgCIgCgBIgFAAIjMgpIhHgOIgEgBQiVgbiXgUIgDAAIhJgJIjCgXIgBAAIiUgSQg+gJg+gGIgDAAQh/gNiCgIIgCAAIhFgFIgDgBIgCAAIgHAAIhcgDIgHAAIhWgCIgHAAIhcAAIgHAAQg3AAg2ABIgHAAIg2ABIggABIgHAAIgnABIgHAAQjBAHi+ANIhVAGIgEAAIlxAaIhgAGIgBAAQi0AMi1ALIhjAGIloAXQgvAEguACIgBAAQi9ALi+AFIhWACIgBAAQjEAAjEgSIhPgJIgCAAQi7gUi5gjQgtgJgtgMIgCAAQi3gwifhmIhKgwIgEgDIgsgeIgGgDIgKgIIgEgEIgEgEIgEgGIgBgJIgBgEIAAgCIADgNIAAAAIAAgBIAIgJIAFgDIABgBIAFgCIANgDIAJACIAPAGQCjB5DCBJIABABIACABQBTAfBWARQB+AaB/ASIAQACIACAAQBnAOBmAIQBxAKBwAEQB2ADB1gCQCGgECFgHIC6gKQCDgKCBgHIADAAICugKQCUgJCVgLIACAAIB8gJIFlgaIAGgBIBGgGQC6gPC4gHIAHAAIBQgDQDtgHDvAHIAJgBIAbACQCRAECRAOIAGABIAEAAIAGABICtARIA9AHIAHABIERAiIABAAIBrAMIB8AQQBwAQBvAVIBkAUIBzAXIADAAIAjAIIADABIABAAIACABQCDAZCDAXIDFAiIAHABIAGABQCJAWCLAPQBfAKBgAHIALAAQDdANDegJIAIAAIALgBQDtgLDpggIALgBIABAAICkgYIANgBQBNgMBMgNIBJgMIAQgCIFig3IBKgLIAOgDQBQgMBQgPQCWgdCUghIAPgDQBxgaBwgcIDOg0IANgDIEShEQBzgdB0gbIAPgDQBxgZBygXQA6gLA5gIIADAAIALgCIADgBIAZgEIAagFIAWgDIAWgEIAWgDIAVgDIABAAQCwgaCygPIALgBIBKgGQDCgNDCgFIAJAAIB2gDIAygBIAKAAQDVgEDUAAIAKAAIAIAAQDJAADJgLIAJAAIBNgFQC8gMC8gWIAIgBIBugNQC3gYCwgoIAGgBIAHgCIASgHIATgIIASgIIATgHIARgHIAXgJIAOgFIAFgCIAIgCIABgBIADgBIAEgBIABAAIADgBIADgBIACgCIADABIAFACIABAAIAEADIADAFIABAAIgBABIABABIAEAHIACAFIABADIgBAEIgBAEIgBADIgDADIgEAFIAAABIgFADIgFADIgGAEQgxAbgyAWIgHACQgwAUgyAPIgGACQhCAThEAJIgIABIgQACIiAAPIgHABIhzAPIgGABIgTACIgEABIgBAAIgEAAIgzAGQjTAbjSAIIgDAAIhMABImIAEIgDAAIhOAAQi8ABi6AIIgWABIgBAAQi1AIi1ALIgCAAIhfAFIiAAKIgBABQiKALiKATIhGAKIgCAAQgyAHgxAIIgDAAQijAaihAoIgEABIgBAAImlBmIgCABIgKADQjLAyjKAwIgHACIgSAEQhhAXhhAUQiSAeiRAbIgHABIirAfQiNAaiOAWIgKACIgDABQjfAkjhAcIggAFIgJAAQjHAZjJANIgPACIgFAAQiQAJiQADQhYAAhYgEg");
	this.shape_97.setTransform(938.5,269.575);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#00000A").s().p("ABFHEIgHAAQhugFhugKIgIAAIgwgFQingRilgVIg5gHIgJgCIhigOQh6gTh6gUIgGgCIAAgBIgGgBIjMgiIhHgLIgFgBQiUgXiXgPIgDAAIhKgHQhhgIhggKIgBAAIiVgPQg9gGg+gFIgEAAQh/gLiBgGIgEAAIhDgDIgFgBIgBAAIgEAAIhegCIgHAAIhWAAIgHAAIhcAAIgHAAIhtABIgHAAIg2ABIgfABIgIAAIgmABIgIAAQjAAFi/ALIhVAEIgEAAIlyAVIhfAFIgBAAQi1AKi0AHIhkAEIloAOIhcADIgBAAQi8AFi+AAIhVAAIgCAAQjDgEjDgVIhPgJIgCAAQi7gWi6ggQgtgIgtgLIgDAAQi3gsiiheIhLgrIgEgDIgtgbIgGgEIgLgHIgDgDIgEgFIgEgFIgCgJIgBgEIAAgBIAAgCIADgNIABAAIAAgBIAHgIIAGgDIABgBIAFgCIANgDIAJABIAPAGQCnBuDDBDIACABIACAAQBSAdBYAQQB9AYCAASIAQACIABAAQBnAOBnAJQBwALBwAGQB1AGB2AAQCFgBCFgCQBdgCBcgDIEFgKIABAAICugGQCVgGCUgIIADAAIB8gHIFlgWIAGgBIBHgFQC5gMC6gFIAGAAIBPgCQDvgGDtADIAJAAIAcABQCSACCRALIAEABIAFAAIAFABICuAOIA8AGIAHAAIEQAbIACAAIBrAJIB7ANQBwAMBwASIBkAQIB0AUIABAAIAkAHIACABIABAAIAEABQCCAVCEAUIDGAdIAFABIAGABQCKATCLANQBgAJBfAGIALABQDdALDggIIAHAAIALgBQDtgJDqgbIAKgBIABAAICmgUIAMgBICZgVIBJgKIAQgCQCxgXCxgVIBLgJIANgCQBQgKBQgMQCWgYCVgdIAPgDQBxgWBygZIDNguIAPgEQCJgfCJggQB0gbB0gaIAOgCQBygZBygXQA5gLA7gJIACAAIAKgCIADAAIAagFIAagEIAWgEIAWgEIAWgDIAVgDIABgBQCwgbCwgTIALgBIBKgIQDCgSDBgKIAJAAIB1gGIAzgCIAKgBQDUgKDTgFIAKAAIAIAAQDIgFDJgQIAJAAIBNgGQC8gPC8gXIAIgBIBugNQC3gXCxgkIAGgBIAHgCIASgGIATgIIASgGIATgHIASgHIAXgIIAOgEIAEgBIAIgDIABgBIAEAAIADgBIACAAIACgBIADgBIADgBIACABIAFACIACAAIADADIAEAFIAAAAIAAABIABABIACAHIADAFIABADIgBAEIgCAEIgBADIgCADIgFAFIgBABIgEADIgFADIgGADQgxAZgzAUIgHACQgxASgyAOIgGABQhCAShFAJIgIABIgOACIiCAOIgGABIhzAPIgHABIgTACIgDABIgBAAIgEABIgyAGQjTAbjRAMIgFABIhLADQjDAIjEAFIgDAAIhOADQi6AGi6AMIgWACIgCAAQizAMi0APIgDABIheAHIiAANIgBAAQiKAPiKAUIhHALIgBAAIhjAPIgCAAQijAbihAlIgFABIgBAAQjUAzjSAvIgCABIgKADQjMAujLArIgGABIgSAEQhiAUhiARQiSAZiRAWIgHACIirAZQiNAViPASIgKABIgDABQjfAejiAXIgfAEIgJABQjIAUjJAMIgOABIgGAAQiQAIiQADQhYgBhYgDg");
	this.shape_98.setTransform(938.45,267.075);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#000009").s().p("ABGG2IgIAAQhtgEhugJIgIAAIgxgFQimgOimgSIg5gGIgKgBIhhgMQh6gPh7gRIgEgCIgBgBIgFAAIjNgcIhHgJIgEgBQiWgSiWgKIgDAAIhJgFIjCgNIgBAAIiUgLQg9gGg/gDIgDAAQiAgIiBgEIgDAAIhEgCIgEgBIgBAAIgEAAIhdAAIgHAAIhVAAIgIAAIhcABIgHABIhtABIgHAAIg2ABIggAAIgHAAIgnABIgIAAQjAAEi/AIIhVAEIgEAAIlyAPIhgAEIgBAAQi1AHi0AEIhjABQi0AEizABIhdABIAAAAQi9gBi8gFIhWgDIgBAAQjCgJjEgWIhPgKIgCAAQi8gXi6geQgtgIgtgKIgCAAQi4goilhUIhMgoIgEgCIgvgYIgFgDIgLgHIgEgDIgDgEIgFgGIgCgJIgBgEIAAgDIAEgNIAAAAIABgBIAHgIIAGgDIABgBIAFgCIANgCIAJABIAQAFQCpBiDFA9IACAAIACABQBTAaBYAPQB+AXCAARIAQACIABAAQBmAOBnAKQBwAMBwAIQB1AIB1AEIEJAEQBdABBdAAIEDgDIADAAICtgCQCUgDCVgGIADAAIB8gFIFmgRIAFgBIBHgEQC5gKC6gDIAGAAIBQgBQDugEDuAAIAJgBIAcABQCRAACSAJIAEABIAEgBIAGABICtAKIA9AEIAHABIEPATIACAAIBrAHIB7AJQBwAIBwAPIBkANIB0AQIACAAIAkAGIACABIAAAAIADAAQCDASCEARIDHAYIAFACIAGAAQCLARCLALQBfAIBgAFIAKAAQDeAKDfgHIAHAAIAMAAQDtgIDqgWIAKgBIABAAICmgQIAMgBICZgQIBKgIIAPgCQCygSCygQIBKgGIAOgCQBQgHBQgKQCWgSCVgZIAPgCQBygTBygXQBngTBngWIAPgDQCJgcCJgfIDpgxIAPgDIDkguQA6gMA6gJIACAAIAKgCIADAAIAZgFIAagFIAXgDIAVgEIAYgEIATgDIACgBQCwgdCvgXIALgBIBKgKQDBgWDAgPIAKgBIB1gJIAxgDIAKgBQDTgQDTgKIAKgBIAIAAQDJgKDIgUIAIAAIBNgIQC8gSC8gXIAIgBIBvgNQC3gXCxggIAGgBIAGgCIAUgFIASgHIATgGIASgFIASgGIAXgIIAOgEIAFgBIAIgCIABgBIADAAIAEgBIABAAIADgBIADAAIADgBIACABIAFADIABAAIAEADIADAFIAAAAIAAABIABABIACAHIACAFIABADIgBAEIgCAEIgBADIgCADIgFAFIAAABIgEADIgGACIgGAEQgyAWgzARIgIACQgwAQgyANIgHABQhCARhFAIIgIABIgPACIiBAOIgHABQg6AHg5AIIgGABIgTACIgEABIgBAAIgDAAIgyAGQjTAcjRASIgEAAIhKAFQjEANjEAKIgDAAIhNAFQi6AKi5ASIgWACIgCABQiyARi0ATIgCAAIheAKIh/APIgBABQiKARiKAWIhGALIgCAAQgxAHgyAJIgBAAQikAaihAmIgFABIgCAAQjUAxjTArIgCABIgJADQjNAqjNAlIgFABIgSADQhjAShhAOQiSAViSARIgHABIirATQiPAQiOAOIgKABIgCABQjgAXjiATIggADIgJAAQjHARjJAKIgQABIgEAAQiQAHiQACQhZAAhYgEg");
	this.shape_99.setTransform(938.4,264.525);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#000008").s().p("ABHGoIgHAAQhugEhugHIgIgBIgxgEQingMilgOIg5gFIgKgBIhigJIj2gaIgCgBIgBgBIgFgBIjNgVIhHgHIgEAAQiWgNiWgGIgDAAIhKgDQhggDhhgFIgBAAIiUgIIh8gGIgDABQiAgGiBgCIgDABIhEgBIgFgBIAAAAIgDAAIhdABIgHAAIhWABIgHABIhcABIgHAAIhuACIgHAAIg2ABIggAAIgHAAIgnABIgHAAQjAACjAAGIhVACIgEAAQi5AGi5AFIhgACIgBAAQi1AEi0ABIhkgBQi0AAiygEIhcgDIgBAAQi7gGi8gKIhWgFIgBAAQjCgNjDgZIhPgKIgCAAQi8gZi6gbQgugHgtgJIgCAAQi5glinhLIhOgkIgEgBIgvgWIgGgDIgLgGIgEgDIgEgEIgDgFIgEgJIAAgEIgBgEIAFgNIAAAAIABgBIAHgIIAFgCIACgBIAFgCIANgCIAJAAIAQAFQCtBVDHA4IABABIADAAQBTAYBYAOQB+AVCAARIAQACIABAAQBnAOBmALQBwANBwAKQB1ALB0AGIEKAMIC4AGIEDAEIACAAQBXACBXAAQCUABCVgEIADAAIB8gEQCzgFCzgHIAGAAIBHgDQC5gIC6gBIAGAAIBQgBQDvgCDugEIAJAAIAbAAQCSgCCRAGIADABIAEAAIAGAAICuAHIA8ACIAHABIEPAMIACAAIBrAEIB7AFQBwAFBwALIBjALIB1AMIACAAIAkAFIACAAIABAAIADABIEHAcIDHAUIAFABIAGAAQCLAOCLAJQBgAHBgAEIAKABQDeAIDfgGIAHAAIAMAAQDtgGDrgRIAKgBIABAAICmgMIANgBICZgNIBJgFIAQgCQCygNCxgKIBLgEIANgBQBRgEBQgHQCWgOCWgVIAOgCQBzgPBygTQBogSBogTIAOgCQCKgZCJgdIDqgwIAPgCIDkguQA6gLA6gJIACAAIAKgCIADgBIAagFIAagEIAWgEIAWgFIAWgDIAUgEIACAAQCvgfCvgbIALgCIBKgLQC/gbDBgTIAJgCIB0gMIAygEIALgBQDRgWDTgQIAKgBIAIAAQDHgQDIgXIAJgBIBNgJIF3gtIAIgBIBvgNQC3gWCzgcIAFgBIAHgCIATgEIASgGIATgGIATgFIARgFIAYgGIANgEIAGgBIAHgBIACgBIADAAIAEgBIABAAIACgBIAEABIADgBIACABIAFADIACAAIACADIAEAFIAAAAIAAABIAAABIADAHIABAFIABADIgBAEIgCAEIgBADIgCADIgFAFIAAABIgFADIgFACIgGADQgzAUg0APIgHACQgyAOgyAMIgHABQhCAPhFAIIgIAAIgPACIiBAOIgGABIh0APIgGABIgTACIgEABIgBAAIgCAAIgyAHQjTAcjRAWIgEABIhLAHQjDARjDAQIgCAAIhOAGQi5APi4AXIgWADIgCAAIllAtIgCABIheAMIh/ASIgBAAQiJAViJAWIhGAMIgCAAIhkAQIgBAAQijAciiAkIgFABIgBAAQjUAwjUAoIgCABIgKACQjOAnjNAfIgGABIgSACQhiAPhiALQiTAQiSAMIgHABIirAOIkdAVIgKABIgDAAQjgARjiAOIgfACIgJABQjIAMjKAIIgPABIgFAAQiQAGiQACQhZgBhYgDg");
	this.shape_100.setTransform(938.325,262.025);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#000007").s().p("ABIGbIgHAAQhugEhvgGIgIgBIgxgDIlMgVIg5gDIgKgBIhigHIj2gSIgBgCIgBAAIgFgBIjOgPIhHgFIgEAAQiVgIiXgCIgCABIhKgBQhhAAhggDIgBAAIiUgEQg+gCg/gCIgDABQiAgDiBABIgDAAIhEAAIgEAAIgBAAIgBAAIhdABIgIABIhVACIgIAAIhcADIgHAAIhtACIgHAAIg2ABIggAAIgHAAIgnAAIgIAAQjAABjAADIhVACIgEAAQi5ADi6ACIhfAAIgBAAQi1ACi0gDIhkgCQi0gFiygJIhcgFIgBAAQi7gMi7gPIhVgHIgBAAQjCgSjDgbIhPgKIgCAAIl3g0IhbgPIgBAAQi6gfiqhDIhPggIgEgCIgwgSIgGgCIgLgGIgEgDIgEgDIgEgFIgEgJIAAgEIgBgFIAFgNIABAAIAAgBIAIgIIAFgCIACAAIAFgCIANgDIAJABIAQAEQCxBKDIAyIABAAIADABQBUAUBYAOQB/ASCAASIAQACIABAAQBmAOBmAMIDgAaQB1ANB0AJIEIATQBdAIBcAEQCBAGCBAGIACAAQBXADBXACQCUADCVgBIADAAIB8gCQCzgCCzgEIAGgBIBHgCQC6gFC6ABIAGAAIBQAAQDvgBDugHIAJAAIAcgBQCRgECSAEIABABIAFgBIAGABICuACIA7ABIAHAAIEPAGIACAAIBqABIB7ABQBwACBwAHIBkAHIB2AJIABAAIAkAEIACABIABAAIADAAIEIAVIDHAQIAFABIAGAAQCLALCMAHQBfAGBgADIAKABQDfAGDfgEIAHAAIAMAAQDtgFDsgMIAJgBIACAAICmgIIAMgBICagIIBJgDIAQgCQCygICygEIBKgCIAOgBQBQgBBRgFQCWgICWgQIAPgCQBzgMBzgRQBogOBogQIAOgDQCKgWCKgbIDrgtIAPgCIDkguQA6gMA6gJIACAAIAKgCIADgBIAagFIAagFIAWgDIAWgFIAWgEIAUgEIACAAIFdg/IALgCIBJgMQC/ggDAgZIAJgBIB0gPIAygFIAKgCQDRgcDSgWIAKgBIAIAAQDHgVDHgbIAJgBIBNgLIF3gwIAIgBIBvgNQC3gWC0gYIAFgBIAHgBIATgEIATgFIASgEIATgFIARgEIAZgGIANgDIAFAAIAIgCIABgBIADAAIAEgBIACAAIACAAIAEABIADgBIACABIAFAEIABABIADACIADAFIAAABIAAAAIABABIACAHIABAFIABADIgBAEIgCAEIgCADIgCADIgFAFIAAABIgFADIgFACIgGADQgzARg1ANIgIABQgxAMgzALIgHABQhCANhFAIIgIAAIgPACIiCAOIgGABIh0APIgGABIgTACIgEABIgBAAIgBAAIgyAHImjA3IgEABIhLAJQjCAXjDAUIgCAAIhOAJQi4ATi3AcIgXAEIgCAAIljA2IgCABIheANIh+AVIgBAAIkSAwIhGAMIgCAAIhjARIgCAAQiiAdiiAjIgFABIgCAAQjVAujVAlIgCAAIgKACQjOAjjOAZIgGABIgSACQhjALhiAJQiTAMiSAHIgHAAIirAIIkeAMIgKABIgDAAInCAUIggABIgJABQjIAIjJAHIgPABIgFAAQiQAEiRABQhZAAhYgDg");
	this.shape_101.setTransform(938.275,259.45);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#000006").s().p("ABJGNIgHAAQhvgEhugFIgIAAIgxgCQingJilgHIg6gBIgJgBQgxgCgygDIj2gMIAAgBIAAAAIgGAAQhngGhngDIhHgCIgEAAQiWgEiWADIgDABIhJABQhhAChhAAIgBAAIiTgBIh9AAIgDAAQiAAAiBACIgDABIhEABIgEAAIgBAAIAAgBIheAEIgHABQgrACgrABIgHAAIhcADIgHAAIhuADIgHAAIg2AAIgfAAIgHAAIgnABIgIAAImBAAIhVAAIgEAAQi5AAi6AAIhggBIgBAAQi1AAi0gHIhjgFQi0gIiygPIhcgIIAAAAQi6gRi7gUIhWgJIAAAAQjCgYjCgcIhQgLIgCAAQi8gci7gXQgtgGgugGIgBAAQi7gdisg6IhRgbIgEgCIgxgQIgHgBIgLgGIgDgDIgFgCIgDgFIgFgJIAAgDIgBgHIAGgMIABgBIAAAAIAIgHIAFgDIACgBIAFgBIAOgCIAJAAIAPADQC1A/DJArIABABIADAAQBVATBYAMIEAAiIAQACIABAAIDLAbIDgAdQB1APBzAMIEIAcQBcAJBdAIQCAAKCCAIIACAAQBWAGBXADQCUAICVAAIADAAIB8ABQCzgBC0gBIAGgBIBHgBQC6gDC6AEIAGAAIBQAAQDvABDvgKIAJgBIAbgBQCSgGCRABIABAAIAFAAIAFAAICvgBIA6AAIAIAAIEOgBIACAAIBqgDIB7gCQBwgCBwAEIBkAFIB2AEIACAAIAjADIACABIABAAIADAAIEJAOIDHALIAFABIAGAAQCLAICMAGQBgAEBgADIAKAAQDfAGDfgEIAHAAIAMAAQDugCDrgIIAKAAIABAAICngFIAMAAICagFIBJgBIAQgBQCzgDCyACIBKAAIAOAAQBQABBQgCQCXgECXgLIAOgCQB0gJBzgNQBogMBpgOIAOgCQCLgTCLgZQB1gUB2gWIAOgDIDlgtQA6gLA6gKIACAAIAKgCIADAAIAagGIAagFIAWgEIAWgEIAXgFIAUgDIABgBIFchEIALgCIBJgPQC+glC/gcIAJgCIB0gSIAygHIAKgCQDQgiDSgbIAKgBIAIgBQDHgaDGgfIAJgBIBNgMQC6gcC8gYIAJgBIBvgOIFrgoIAGgBIAHgBIASgEIATgEIASgEIATgDIASgEIAZgFIAMgCIAGgBIAIgBIABgBIADABIAEgBIACAAIACgBIAEACIADAAIACABIAEADIACABIADADIACAFIAAAAIAAABIABABIACAGIABAGIABADIgCADIgCAFIgBADIgCADIgFAEIgBABIgEADIgFADIgHACQg0APg1ALIgIABIhlATIgHABQhCAMhFAHIgIAAIgQADQhAAFhBAHIgGABIh0AQIgGABIgTACIgEAAIgBAAIgBABIgyAGQjSAdjQAhIgFABIhKAKQjCAcjCAZIgCAAIhOAKQi3AZi3AgIgWAFIgCABIlhA9IgDABIhdARIh+AXIgBABIkSAzIhFANIgDAAIhjATIgBAAQiiAcijAjIgFABIgCAAQjVArjWAhIgCABIgKACQjPAfjOATIgGABIgTACQhiAIhjAFQiTAIiTACIgGAAIitACIkeAEIgKAAIgDAAQjgADjjAFIgfABIgJAAImSAKIgPAAIgEAAQiRADiQABQhagBhYgCg");
	this.shape_102.setTransform(938.2,256.9);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#000006").s().p("EgtsAGMIgmAAIgIAAImAgEIhWgBIgEAAQi6gCi5gDIhfgCIgCAAQi1gDi1gLIhjgGQizgNiygTIhbgLIgBAAIl0gwIhVgMIAAAAQjBgcjDgeIhPgMIgCAAQi8gci8gVIhbgMIgCAAQi7gYivgxIhTgXIgDgBIgzgOIgGgBIgLgFIgDgDIgFgCIgDgFIgFgIIgBgDIAAgBIAAgHIAGgMIAAgBIABAAIAIgHIAFgCIACgBIAFgCIANgCIAJABIAQADQC5AyDLAlIABABIACAAQBWAQBXALIECAhIAOACIACAAIDMAbQBwAQBuARQB2ARBzAQIEHAjQBcAMBbAKQCCAOCAALIACAAQBXAIBXAGQCUAKCVADIADAAIB9ACQCyADC1AAIAFgBIBHAAQC6ABC7AEIAFAAIBQABQDwADDugOIAJgBIAcgBQCSgJCSgBIAAABIAEAAIAGgBQBXgBBXgDIA7gCIAHAAIEOgJIACAAQA1gCA1gDIB6gFQBwgFBxAAIBjABIB3ABIABAAIAkABIADABIABAAIACAAIEJAHIDIAHIAFAAIAGAAQCMAGCLAEIDAAFIAKAAQDgAEDfgBIAHAAIALAAIHbgEIAJgBIABAAICnAAIAMAAICagBIBKAAIAQAAQCzACCyAHIBKADIAOAAQBQAEBRABQCWABCYgIIAOAAQB0gGB0gKQBpgJBqgMIAMgCQCMgQCLgWQB2gTB2gVIAPgDIDlgsIB0gVIACgBIAKgCIADgBIAagFIAagFIAVgEIAWgFIAXgEIAUgEIACgBQCugkCsgnIALgCIBJgQQC9goC+giIALgCIBzgVIAxgJIAKgCQDQgoDRggIAKgBIAIgBQDGgfDGgjIAJgCIBNgOQC6gfC8gYIAIgBIBwgNQC3gVC2gQIAFgBIAHAAIATgDIASgEIATgDIATgDIARgDIAZgDIANgCIAGgBIAHgBIACAAIACAAIAFAAIABgBIACABIAEABIAEAAIACABIAEAEIACABIACADIACAFIABAAIgBABIABABIACAGIABAGIAAADIgBAEIgCAEIgCADIgBADIgGAFIAAAAIgFADIgFACIgHADQg0ALg2AKIgHAAIhnARIgGABQhEAKhFAHIgIAAIgOABQhBAGhBAIIgGABQg7AGg5AJIgHABIgSACIgEABIgBAAIgyAGQjUAdjPAmIgEABIhJANQjCAgjCAeIgCABIhNALQi4Aei1AmIgWAEIgDABQivAkixAjIgCAAIhdATIh+AaIgBABQiIAdiIAbIhGAOIgCAAIhjASIgBAAQikAfiiAgIgFABIgBAAQjXArjWAdIgCAAIgKACQjQAcjQANIgFAAIgSABQhkAGhjACQiTAEiTgDIgHgBIisgDIkfgGIgKAAIgDAAQjggDjiAAIggAAIgJAAQjIABjKADIgPAAIgGAAQiPACiRABQhZgBhZgCIgHAAIjegHIgIgBIgwgCQingGimgDIg6gBIgJAAIhigCIj4gFIABgCIAAAAIgFAAIjOgDIhIABIgDAAQiXACiWAHIgCABIhKADQhgAEhhADIgBAAIiUADIh8ACIgEAAQiAADiAAFIgEAAIhEACIgEAAIAAAAIhcAFIgIABIhVAEIgIAAIhcAEIgIAAIhtACIgHAAIg2AAIggABIgIAAg");
	this.shape_103.setTransform(938.15,255.225);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#000005").s().p("EgtqAGcIgmAAIgIAAQjBgDjAgFIhWgCIgEAAQi6gEi5gGIhggDIgCAAQi1gGi0gOIhjgJQi0gQixgZIhbgNIgBAAIlyg7IhVgOQjBghjDggIhPgNIgCAAQi8gdi8gTIhcgKIgBAAQi8gVixgnIhUgTIgEgBIgzgLIgHgBIgLgEIgEgCIgEgCIgEgFIgFgIIAAgEIgBgIIAGgNIABAAIABgBIAIgGIAFgCIACgBIAFgBIANgCIAJAAIAQACQC9AoDMAeIABABIADAAQBWANBYAKQCAAPCBAQIAPACIABAAQBnAOBlAPQBwAQBvATIDoAmIEGArIC3AcQCBARCBAPIACAAQBWAKBXAHQCUAOCVAFIADAAIB9AEQCzAFC0ADIAGgBIBHABQC6ADC7AGIAFAAIBRACQDvAFDvgSIAJAAIAbgCQCTgLCSgEIgCABIAFAAIAGgBQBXgDBXgFIA6gEIAHAAIEOgQIACAAIBqgHIB6gJQBwgJBxgDIBjgCIB3gDIACAAIAkAAIACABIABAAIACAAQCFgBCFABIDIACIAFABIAGAAIEYAFIC/ACIALABQDfACDgAAIAHAAIAMAAQDuAADsADIAKAAIABAAICnADIAMAAICbAEIBJACIAQAAQCzAGCzANIBKAGIAOAAQBQAHBRADQCXAGCXgDIAPAAQB0gCB0gIQBqgGBqgKIANgBQCMgNCLgUQB3gRB2gVIAPgCQBzgVBzgWIBzgWIACgBIAKgCIADgBIAagFIAagFIAWgEIAWgFIAXgFIATgEIACgBQCugmCsgrIAKgCIBJgSQC8gtC+gmIAKgDIBzgYIAwgKIALgCQDPguDRglIAKgCIAIgBQDFgkDGgnIAJgCIBNgPQC5gjC8gYIAJgBIBvgOQC4gUC2gLIAFgBIAHgBIATgCIASgDIATgDIATgBIASgDIAYgCIAOgCIAFgBIAIAAIABAAIADAAIAFAAIABAAIACAAIAFACIADABIACABIAEAEIABABIADADIACAEIAAABIAAABIAAABIADAGIAAAGIAAADIgBADIgCAFIgCADIgCADIgFAEIAAABIgFADIgFABIgHADQg1AJg3AHIgHABIhnANIgHABQhDAJhGAGIgIAAIgPABQhBAGhAAHIgHABQg6AHg6AIIgGABIgSADIgEAAIgBAAIgBABIgxAGQjTAdjOArIgFABIhJAPQjBAljCAjIgCABIhNANQi3Aii0ArIgWAFIgEACQiuAoiwAnIgCABIhdAVIh9AdIgCAAQiGAgiJAcIhFAPIgCAAIhkATIgBAAIlGA+IgFABIgBAAQjXApjXAaIgCAAIgKABQjRAZjQAHIgGAAIgSAAQhkAEhjgBQiUgBiTgIIgHgBIisgJIkggPIgKAAIgCAAQjhgKjjgEIgfgBIgJAAQjJgEjKACIgPAAIgFAAIkhABIiygDIgHAAIjegFIgIgBIgwgBQiogFilABIg6AAIgKAAIhiABIj4ACIACgCIAAAAIgFAAQhnABhnADIhIADIgDAAQiXAHiWAMIgDAAIhJAGQhgAHhhAEIgBAAQhKAEhKADIh8AFIgEAAIkBANIgDAAIhEADIgEABIABgBIhdAHIgHAAQgrAEgrABIgHABIhcAEIgIABQg3ACg2AAIgHAAIg2AAIggAAIgIAAg");
	this.shape_104.setTransform(938.0875,255.675);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#000004").s().p("EgsLAGtIg2AAIggAAIgHAAIgnAAIgIAAQjBgGjAgGIhWgEIgEAAIl0gPIhfgEIgCAAQi1gJi0gRIhkgLQizgUixgfIhbgQIlyhFIhUgQIgBAAQjAgnjDggIhPgPIgCAAQi8gei8gRIhcgIIgCAAQi8gRi0geIhVgPIgFgBQgZgDgagEIgHAAIgLgEIgEgCIgFgDIgDgEIgGgIIAAgEIgBgKIAHgMIABgBIAAAAIAJgGIAFgCIACgBIAFAAIANgCIAJAAIAQABQDBAcDNAaIABAAIADABQBXAJBYAIQCBAOCBAQIAPACIABAAQBmANBlAQQBwASBvAVIDnAsIEGAxQBbATBcAPQCAAVCBATIACAAQBWALBXAKQCUAPCVAIIADAAIB9AGQCzAIC0AFIAGAAIBHACQC7AFC6AIIAGAAIBRADQDvAGDvgVIAJgBIAcgCQCSgNCSgGIgDABIAFgBIAGgBQBXgFBXgHIA7gEIAHgBIENgXIACAAIBqgKIB6gNQBwgMBwgHIBkgFIB4gHIABAAIAkAAIACAAIABAAIACAAQCFgFCFgCQBlgCBkAAIAFAAIAGAAIEYAAIC/ABIALAAIHAADIAHAAIAMAAQDuACDtAHIAJAAIACAAICnAHIAMABICbAHIBJAFIAQAAQCzAMCzASIBLAIIANABQBRAJBRAGQCXALCXABIAPAAQB1ABB1gEQBpgDBrgIIANgBQCMgKCMgSQB3gPB2gUIAPgDQB0gTBzgXIBzgWIACAAIAKgCIADgCIAagFIAagGIAWgDIAWgGIAXgFIATgEIACgBQCugnCqgvIALgDIBIgUQC8gxC9grIAKgDIBzgbIAwgMIALgCQDOg0DQgrIAKgCIAIgBQDFgpDGgrIAJgCIBMgRQC5glC8gZIAJgBIBvgNQC5gVC3gHIAEAAIAHgBIATgCIATgCIASgCIATgBIASgBIAZgCIANgBIAGgBIAHAAIACAAIADAAIAEAAIABAAIACABIAFACIADABIACABIAFAEIABACIACADIACAEIAAACIAAAAIABACIACAFIAAAFIAAADIgBAEIgDAEIgBAEIgCADIgFAEIgBAAIgFAEIgFABIgHACQg2AHg3AFIgIAAIhnAKIgHABQhEAHhFAGIgIAAIgPABQhBAGhBAHIgGABQg6AGg6AJIgGABIgTADIgEAAIgyAHQjTAejOAvIgEACIhJAQQjBArjBAnIgCABIhNAPQi2Aoi0AvIgWAGIgEACQitAsivAsIgCABIhdAWIh8AgIgCABQiGAiiJAeIhFAPIgCAAIhkAVIAAAAIlGA9IgFABIgCAAQjXAnjZAWIgCABIgKABQjRAUjRABIgGAAIgSAAQhkABhkgEQiUgFiTgNIgHgBIisgQIkhgXIgKgBIgCAAQjhgRjjgJIgggBIgJgBQjIgGjKgBIgPAAIgFAAIkigBIiygCIgHAAIjegEIgIAAIgxgCQingCimAFIg6ABIgKAAIhiADIj5AJIADgCIgEABQhoADhnAHIhIAFIgDABQiWALiXARIgCAAIhJAIQhhAJhhAIIgBAAIiUAKIh8AHIgEABIkAARIgEAAIhEAEIgEABIACgBIhcAIIgIABQgqAEgrADIgIAAIhcAFIgIAAQg2ADg3AAIgHAAgEgiCAE+IAAABIAAgBg");
	this.shape_105.setTransform(938.025,256.1);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#000003").s().p("EgsKAG+Ig2gBIggAAIgHAAIgnAAIgHAAQjCgGjAgKIhWgEIgEAAQi6gJi6gMIhggGIgCAAQi1gKi0gWIhjgMQi0gZiwgjIhbgTIAAAAIlwhQIhVgTQjAgqjCgkIhQgOIgCAAQi7ggi9gOIhdgHIgBAAQi9gNi3gUIhWgLIgFgBIg0gFIgHAAIgMgDIgEgCIgEgCIgDgEIgHgJIAAgDIgBgKIAHgNIABgBIABAAIAIgFIAGgDIACAAIAFgBIANgCIAJAAIAQABIGTAkIABAAIADAAICwAQQCBALCBAPIAPACIABAAQBmAOBmARQBvASBuAXIDnAxQCEAcCCAeQBaAVBcASQCAAZCAAVIACAAQBXAOBXALQCTAUCVAJIADAAIB+AIQCzALC1AHIAGAAIBHADQC6AIC7AKIAGAAIBQADQDwAIDvgZIAJAAIAcgDQCSgPCSgJIgDABIAEgBIAGAAQBYgHBXgKIA6gGIAHAAIENgeIACAAIBqgNIB5gQQBwgQBxgLIBkgIIB4gKIABAAIAkgCIACAAIABAAIACAAQCFgICGgFQBkgEBlgDIAFAAIAGAAQCMgDCMgBIDAgCIALABQDggBDgADIAHAAIALAAQDvADDtANIAKAAIABAAICnAKIANABICbAMIBJAGIAQABQC0AQCyAZIBLAKIANABQBRAMBRAJQCXAQCZAFIAOABQB2AEB1gBQBqgBBrgFIANgBQCNgHCMgPQB3gOB3gTIAPgCQB0gTBzgXIBzgXIACAAIAKgCIADgBIAagGIAagFIAWgFIAWgFIAWgFIAUgFIACgBQCtgpCqgzIAKgDIBJgVQC7g2C8gwIAKgDIBygeIAwgNIAMgDQDNg5DPgxIAKgCIAIgBIGKheIAJgCIBMgSQC4gpC9gZIAJgBIBvgOQC5gTC4gDIAEgBIAHAAIATgBIATgCIASgBIAUAAIARgBIAZgBIANAAIAGgBIAHAAIACAAIADABIAFAAIABAAIACABIAFACIADACIACABIAEAEIACACIACADIACAEIAAABIAAABIAAABIACAGIgBAGIAAADIgBADIgCAFIgCADIgCADIgFAEIgBABIgFADIgEABIgIACIhuAHIgIAAQg0ACg0AFIgHAAIiJALIgIABIgPABQhBAFhBAHIgGABQg7AHg6AIIgGABIgSADIgDAAIgCAAIgwAHQjTAejOA1IgFABIhJATQjAAvjAAsIgCABIhNASQi2AriyA1IgWAGIgEABQitAziuAvIgCABIhdAaIh8AiIgCAAQiGAliHAgIhGAPIgCAAIhkAVIAAAAQijAhijAcIgFABIgCAAQjXAmjaATIgCAAIgKAAQjSASjSgFIgGgBIgSAAQhkgDhkgGQiUgKiUgSIgHgBIitgVIkgghIgKgBIgDAAQjhgXjjgOIgggCIgJAAQjJgMjKgBIgPgBIgFAAIkigCIiygDIgHAAIjegCIgIgBIgxAAQioAAimAIIg6ADIgJAAIhjAGQh9AHh9AIIAFgBIABAAIgFAAQhoAHhnAKIhIAHIgDABQiXAQiWAVIgDABIhJAKQhgAMhhAJIgBAAQhKAIhKAGIh8AKIgEABIkBAWIgEAAIhDAGIgDABIgBAAIgBAAIACAAIADgBIhdAJIgIABQgrAFgrACIgHABIhcAGIgIAAQg3ADg3AAIgHAAg");
	this.shape_106.setTransform(937.975,256.525);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#000002").s().p("EgsJAHPIg2gBIgfAAIgIAAIgmgBIgIAAQjCgHjAgMIhXgFIgDAAQi7gMi6gOIhfgHIgCAAQi2gOi0gZIhjgPQizgciwgpIhbgVIlvhbIhUgVQi/gvjDglIhQgPIgCAAQi8gii9gMIhcgEIgCAAQi+gJi5gMIhYgHIgFAAQgagCgbAAIgGAAIgMgDIgEgCIgFgBIgDgFIgHgIIAAgDIgBgLIAHgNIABgBIABAAIAJgFIAGgCIABAAIAGgBIANgCIAJAAIAQAAQDIAFDQANIABAAIADABICwAMQCCAKCBAPIAQACIAAAAQBnAOBkAQQBwAUBuAZQB0AbBzAcQCCAfCCAiQBbAXBbAWQCAAcCAAZIACAAQBWAQBYANQCTAWCVAMIADAAIB9AKQC0ANC1AJIAGAAIBHAEIF1AXIAGAAIBRAEQDwAKDvgdIAJgBIAcgDQCRgRCRgLIABAAIACAAIAFgBQBYgIBXgMIA6gIIAHAAIENglIACAAQA0gHA1gJIB5gUQBwgTBxgOQAygHAygFQA8gHA9gGIABAAIAkgDIACAAIABAAIACgBQCGgLCFgIQBlgHBlgFIAFAAIAGAAQCMgGCNgDIC/gDIALAAQDggCDgAEIAIAAIALAAQDvAFDtARIAJABIACAAICnAOIANABICbAQIBKAIIAPACQC0AVCzAdIBMANIAMACQBSAPBRALQCXAVCYAKIAQABQB1AHB2ACQBrACBrgDIAMAAQCOgECMgOQB4gLB4gTIAPgCQB0gSBygXIB0gXIACgBIAJgCIAEgBIAZgFIAagGIAWgFIAWgFIAXgGIATgEIACgBQCugrCog3IAKgDIBJgYQC6g6C8g1IAKgDIByghIAwgPIALgDQDMg/DPg1IAKgDIAIgCIGJhmIAJgDIBMgTQC4gsC8gaIAJgBIBxgNQC4gTC5AAIAEAAIAHAAIATgBIASAAIATgBIAUABIARAAIAZAAIAOAAIAFgBIAHABIACAAIAEAAIAEABIABAAIACABIAFADIAEABIACABIAEAGIABABIACADIACAFIAAABIAAABIAAABIABAFIAAAGIAAADIgBADIgDAFIgCADIgCADIgFAEIgBABIgEADIgFABIgIACIhwACIgHgBQg1ABg0ADIgHABIiKAJIgIAAIgPABQhBAFhAAHIgHABQg7AHg5AIIgHABIgSADIgEABIgBAAIADgBIgzAHQjSAfjOA6IgFABIhIAUQi/A1jAAxIgDABIhMATQi1AwiyA6IgWAGIgFACQirA4iuAzIgBABIhdAcIh7AkIgDABQiFAoiHAhIhFAQIgCAAIhkAWIgBAAQijAhikAbIgEABIgCAAQjYAljbAOIgCAAIgKABQjTANjSgLIgGAAIgSgBQhlgFhkgKQiUgOiUgXIgHgCIiugaIkhgqIgJgBIgDgBQjhgejkgSIgfgCIgJgBQjJgPjLgEIgPAAIgFAAQiRgDiQgBIizgDIgIAAQhvgBhvAAIgIAAIgxAAQinACinALIg6AFIgKAAIhiAIIj7AXIAGgBIABgBIgEABQhoAKhoANIhIAKIgDAAQiXAWiWAaIgCAAIhKAMQhgAPhhAMIAAAAIiVARIh8ANIgEABIkBAaIgEABIhDAHIgBAAIACgBIhdALIgHABQgrAFgrADIgIABIhcAGIgIABQg3ADg3AAIgHAAgEgl0AGxIAEAAIgDAAIgBAAg");
	this.shape_107.setTransform(937.95,256.925);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#000001").s().p("EgsHAHiIg2gBIgggBIgIAAIgmAAIgIAAQjCgJjBgPIhVgGIgFAAQi6gPi6gQIhggJIgCAAQi1gQi0gcIhjgRQi0ggiwguIhagZIAAAAQi3gzi2gyIhVgXQi/g0jCgoIhPgPIgCAAQi8gii+gJQgugDgvgBIgBAAIl7gJIhZgCIgEAAQgcAAgbABIgHAAIgLgCIgFgCIgEgBIgEgEIgHgIIAAgEIgBgMIAIgMIABgBIABAAIAIgFIAGgCIACAAIAGgBIANgBIAJgBIAQAAQDNgHDQAHIABAAIADAAQBZADBYAGQCCAICCAQIAPACQBnANBlATQBvAUBuAaQB0AeByAeQCDAjCBAmQBaAbBbAXQB/AhCBAbIACAAQBWATBXAOQCUAaCUAOIAEAAIB+AMQC0AQC0ALIAGAAIBHAFIF3AbIAFAAIBQAFQDxALDvggIAJAAIAcgEQCRgTCRgOIABAAIABAAIAGgBQBYgKBWgOIA6gJIAHgBIEMgsIACAAIBqgSIB5gYQBwgXBxgRIBkgPQA8gJA9gIIABAAIAkgEIACAAIABAAIACgBQCFgPCHgLQBlgJBlgHIAEAAIAGgBQCNgJCMgEQBhgEBggCIAKABQDhgEDgAFIAIAAIAKABQDwAGDuAXIAJAAIACAAICoASIALACQBOAJBOAKIBKALIAPABQC1AaCzAkIBLAPIANACQBRASBRAOQCXAZCaAOIAPACQB2ALB2AFQBrAEBsAAIAMAAQCPgBCMgMQB4gKB4gRIAPgCQB0gSB0gXIBzgXIACgBIAJgCIADgBIAagGIAagFIAWgFIAWgGIAXgFIATgFIACgBQCtgtCog7IALgDIBIgZQC5hAC6g5IALgEIBygkIAvgPIALgEQDMhFDPg7IAKgDIAIgBIGHhwIAJgDIBNgVQC2gvC9gaIAJgBQA4gIA5gGQC4gSC6AFIAEgBIAHAAIATABIATAAIASAAIAUABIARABIAaABIANAAIAGAAIAHABIACAAIADABIAEAAIABAAIACABIAGAEIAEACIACABIADAFIABACIADADIABAEIAAABIAAABIAAABIACAGIgBAGIAAADIgBADIgEAFIgCADIgBADIgGAEIgBAAIgEADIgFABIgIACIhwgDIgIAAQg1gCg1ADIgHAAIiKAHIgIAAIgPABQhBAFhBAHIgHABQg6AGg6AJIgGABIgSADIgFAAIgCAAIADABIgwAGQjTAfjMA/IgGABIhIAXQi/A5jAA2IgCABIhMAVQi0A1iyA+IgVAHIgFACQirA9itA3IgBABIhcAeIh8AoIgCAAQiFAriHAiIhGARIgCAAIhjAWQijAiikAaIgFABIgCAAQjYAjjcALIgCAAIgKAAQjUAKjTgQIgGgBIgSgCQhlgIhlgMQiUgTiUgcIgHgCIitggIkigzIgKgBIgEgBQjggkjkgXIgggEIgIAAQjKgUjKgFIgQgBIgFAAQiQgDiSgCIizgCIgHAAQhvgChvACIgIAAIgyABQinADinAQIg6AFIgJABIhiALQh6ANh6APIABAAIgFAAIgEABIADgBQhnANhpARIhIAMIgCABQiXAaiXAeIgCABIhJAOQhgARhhAOIgBAAIiUAVIh9AQIgDABIkCAfIgDABIhEAIIgFABIhVALIgIABQgqAGgrADIgIABIhcAHIgIAAQg3AEg3AAIgHAAgEgl0AHBIAIgBIgGABIgCAAgEgl0AHBIAAAAg");
	this.shape_108.setTransform(937.9,257.155);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#000000").s().p("EgtjAH1IgugBQjwgNjtgWQjsgVjrgZQjpgXjkguQjhgujchFQjghGjghDQjlhFjrgsQjrgtjvgBQjvgBjvAIQgfABgfADIgVgEIgLgMIgBgRIAJgNIAQgGQDogWDqABQDlABDiAcQDYAbDSA4QD1BCDzBPQDYBGDcA1QDpA3DvAbQD0AbD1ATIHEAlQEcAZEagqQClgYClgTIgHABQB6gQB5gYIETg0QBzgVBxgbQBwgbBxgVQBvgVBwgRIAmgGIADAAQDtgiDugUQD2gVD1gFQDpgFDrAHQD0AIDzAcQBaALBbANQB7ARB6AVQDhAmDfA2QDwA7DzAdQDoAcDpADQEQAEELgmQC2gaCxgoQD8g6DxhbQDhhVDkhMQBWgdBWgfQDPhMDUhCQDMhADMg+QDghEDpggQDygiD1ALQBMAEBMAGIANADIALAHIAHALIADANIgDAMIgHALIgLAHIgNADIh5gJQg5gDg5ABQhJAChJAEQhNAEhLAJQg9AHg+AJIgYAEIAFgBQjwAfjmBNQjjBMjlBGQjpBHjiBXQirBCitA8IjYBLQjYBKjfAwQimAjioAZQjZAijcAHQjbAGjagXQkIgbkDg6Qjrg1jtgvQj3gwj6gdQjVgZjXgHQjtgIjtgBQhzgBh0ACQjiAFjgAcQi0AXi0AbIAKgBQiPAWiOAdQiYAgiYAjQiGAfiHAXQiKAXiLAUIkFAlIhJAKIAJgBIhkAPQgvAHgvAEQgyAFgyADQg6AEg7AAIhdgCg");
	this.shape_109.setTransform(937.85,257.1906);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#000001").s().p("EgsGAHbIhTgDIgLAAIgkgBIgLAAIhagGQi9gMi9gSIgIgBIhZgIIl4giIgGgBIhIgHQixgRitgeIgjgGIgDgBQjbgmjVg5IgIgBIgGgDQjeg7jeg6IgEgBIgBAAQjkg7jrgpIgBAAQjqgnjvgBIgBAAIgVAAQjggBjgACIgIAAIgDAAQgdAAgeADIgCAAIgSgFIgCgCIgDgCIgFgHIgBgBIgBgJIAAgHIAGgKIACgDIACgBIAIgDIAFgCIAEAAIABAAQDWgQDXACIAgAAIAEAAQDVADDVAVIAaADIADABQDWAXDQAwIADABIApAJQDgA2DcA9IACABIABAAQDWA8DcAsIACAAIAIADQDWArDaAYIAdACIAEAAQCdAQCeAOICrANIAGAAIEcAYIChAOIAHABQCTANCSgDQCEgCCFgRIAHAAQBogNBogKIBwgKIADAAIAGAAQBzgNBzgTIALgBIA9gKIDLggIALgBQBtgSBsgVIAEgBIAFgBQBsgWBsgRIAHgBQBrgSBtgOIAHgBIAfgFIADAAIACAAIAEgBIAGAAQDmgdDpgRIABAAIAEAAQDzgUDzgEIAIAAIA3gBQDKgBDKAEIAKAAQBPADBPAEQCgAJCfAQIAMABIA8AHIBtANIANABQB0APB0ARIAOABIBUAOQCwAcCuAkIANACIA/ANQCDAZCCARQBJAJBIAGIARACQCnAOCnAEQA5ACA5gBIAOAAQCrgBCrgRQBagJBcgNIAQgDQCXgWCVggIAqgJIASgDQDegyDVhJIAqgOIARgGQC6hCC9g6IA/gTIARgGQBOgYBNgaIARgGQBrgjBrghQBegdBfgbIARgEIEchRIBtgfIASgEQCcgsCggcQA9gKA+gJIAWgCIBcgMIBagHQArgEAqgBQArgCArAAIBYAAIAYABIAGAAIA8ABIBKAEIAMABIAFAAIAEABIAEABIAEACIAGAEIABAAIAEAFIADAFIABACIABADIABAHIAAABIAAAFIgBAHIgDAFIgEAGIgCABIgCACIgGAEIgDACIgIACIgFAAIgKAAIhrgFIgDAAQg3gCg3ACIgFAAIiMAIIgBAAIgwAEQg0AEgzAGQg+AHg8AKIgBAAIgYADIgBAAQhuAOhuAXQh8Abh5AmIgBAAQh5Alh4AjIjYA+Qh9Ajh7AmQhrAjhrAlQh6Ash9ApIhhAfIgBAAIi0A7IgmALQjQBDjWAsIgRAFQimAhinAaIgBAAIhkAOQinAXipAHQhPAEhPAAQiLgBiMgKQhqgJhqgNQibgSibgdIimggIjWgmIhQgOIgLgCQi7gfi8gXQg6gGg7gGIgGgBQi9gTi9gHIgrgCIgGAAQibgEiagDIh8gBIgmAAIgEAAQhrgBhsACIgMAAIgDAAQh1ACh0AIQhtAHhsAMIgwAGIj1AeIg5AIIgGABIgDAAQhSALhTANIg/ALIgDABIguAHIgCAAQiYAciXAfIg6ALQhpAThpAPIgEABQiBARiBAPIgPABIgFABIj/AdIgEAAIg/AGIgDABIgDAAIAGgBIACAAIgBAAIhfALIgFABIgkADIg0AGIgFgBIhcAFIgIABIhrABIgJAAg");
	this.shape_110.setTransform(937.7,256.15);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#000002").s().p("Egr+AHAIgJAAIhTgEIgLAAIgjgCIgLAAIhbgGQi8gOi9gRIgJgBIhZgIIl3ggIgGgBIhIgFQixgQiugZIgjgFIgDAAQjbghjVgvIgIgCIgFgBQjfgzjfgwIgCgBIgBAAQjlgyjrgjIgBAAQjqgjjvgCIgBAAIgVgBIm/gEIgIAAIgEgBQgdAAgdACIgDgBIgSgDIgCgCIgCgCIgGgGIgBgBIgCgKIAAgGIAHgLIACgCIACgBIAIgDIAFgCIADAAIABAAQDWgLDXADIAgABIAEAAQDVAEDUATIAbACIAEABQDVAUDQAoIAEAAIAoAIQDhAtDcA0IACAAIABAAQDWAyDcAmIACAAIAIACQDWAlDZAUIAfADIADAAIE7AaICrANIAGAAQCOALCOAMIChAPIAHABQCSAOCSAAQCEAACFgNIAHAAQBngKBogHIBxgHIgEABIAGAAIAGgBQBzgJBzgPIALgBIA9gIIDKgYIALgCQBugOBsgSIAEgBIAFAAQBsgTBsgOIAGgBQBsgPBtgMIAHgBIAfgEIADAAIACAAIAEgBIAGAAQDngZDogQIABAAIAEAAQDzgQDzgEIAIAAIA2gBQDKgBDLAEIAJAAQBQACBPAEQCgAHCfAPIALAAIA8AHIBuALIANABQB0AMB0AOIANACIBVALQCwAXCuAeIANADIA/AKQCCAUCDANQBIAGBIAFIARABQCmALCnAAQA5AAA4gBIAOAAQCsgECpgUQBbgJBbgOIAQgCQCXgYCWgeIAqgJIASgEQDdgvDXhEIAqgNIARgGQC7g8C+g2IA/gSIARgFQBOgWBOgXIARgFQBrghBsgeQBegaBfgYIARgEIEdhKIBtgdIASgEQCcgoCggbQA9gKA+gIIAWgDQAugGAvgFIBagJIBUgFIBWgEIBYgBIAYAAIAGAAIA8ABIBKABIANAAIAEABIAFAAIADABIAEACIAGADIABAAIAEAFIADAFIABABIACAEIACAHIAAABIgBAEIAAAHIgCAFIgEAFIgBACIgDACIgFAEIgEACIgHACIgEABIgKAAIhrgBIgDAAQg2AAg3ADIgFAAIiNAJIgBAAIgwAFQg0AEgzAGQg9AIg9AJIgBAAIgXADIgBAAIABAAQhwAPhuAWQh8AZh6AjIgBAAQh5Aih5AgQhsAdhtAbQh9Agh7AjQhrAfhrAiQh8Aoh9AmIhiAdIgBAAIi0A2IgmALIAAAAQjRA+jXArIgRAEQimAginAbIgBAAIhkAPQinAXioAKQhPAFhOABQiMACiKgHQhrgGhpgJQicgOiagYIimgaIjWggIhQgLIgLgCQi7gai8gTIh1gLIgGgBQi9gQi9gGIgrgCIgGAAQibgEiagCIh8AAIgmgBIgDAAQhrgBhsACIgNAAIgDAAQh0ABh0AHQhtAGhsALIgwAFIj1AbIg9AHIACAAIgCAAQhWAJhWAMIg/AJIgDABIgvAHIgCAAQiXAXiXAZIg6AKQhpAQhpALIgFAAQh/AOiBALIgPABIgGABIj9AUIgEAAIhDAFIAAAAIgCAAIACAAIAEgBIgBAAIhfAIIgEAAIglADIg0AEIgFAAIhcADIgIAAIgbAAIhQgBgAu/ECIAFgBIgDABIgCAAg");
	this.shape_111.setTransform(937.525,255.0813);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#000003").s().p("EgqUAGoQg2AAg1gCIgJgBIhTgEIgKgBIgkgCIgLgBIhbgHQi8gPi9gRIgIgBIhZgHQi8gQi8gNIgGgBIhIgFQiwgNiugUIgjgEIgEgBQjbgajVgnIgIgBIgFgBIm+hQIgDgBIgBAAQjlgojrgfIgBAAQjqgejvgDIgBAAIgVAAQjfgDjfgHIgIAAIgEgBQgdgBgdABIgDAAIgSgFIgCgCIgCgBIgGgHIgBgBIgCgKIAAgEIAHgLIACgCIABgBIAIgDIAGgCIADAAIABAAQDVgGDXAFIAgABIAEAAQDVAFDUAPIAbACIAEABQDVARDQAhIAEAAIApAHQDgAkDdApIACABIABAAQDWAoDbAfIACAAIAIABQDXAeDZASIAeACIAEAAIE6AYICrAMIAGAAQCOALCOAMIChAPIAHABQCSAPCSACQCEADCEgJIAHAAQBngGBngFIBxgDIgDABIAGgBIAGAAQBzgGBygLIALAAIA+gGIDKgSIALgBQBtgLBsgOIAEgBIAFAAQBsgPBtgMIAGAAIDZgXIAGgBIAggCIADgBIACAAIAEAAIAGgBQDngUDogOIABAAIAEAAQDzgPDzgDIAHAAIA3AAQDKgBDKADIAKAAQBPACBQADQCfAGCfAMIAMABIA7AFIBuAKIANABIDoAVIANABIBVAJQCwATCuAYIANACIA/AIQCCAQCCAIQBIAFBIACIARABQCmAGCmgDIBygDIAOgBQCqgHCqgVQBagLBbgOIAQgCQCXgYCWgdIAqgJIASgDQDeguDXg+IAqgNIASgFQC8g4C+gxIBAgQIARgFICcgpIARgEQBsgeBsgaIC+gtIARgEIEehDIBtgaIASgEQCdglCfgaIB8gSIAWgCIBcgLIBagKIBUgGQArgDArgCIBYgCIAYgBIAGAAIA8gBIBKAAIANgBIAEAAIAEABIAEAAIAEACIAGADIABAAIAEAEIAEAFIAAABIACAEIACAGIABABIAAAEIAAAHIgCAFIgDAGIgCABIgCACIgFAFIgDACIgHADIgEABIgKABIhqABIgDABQg2AAg3AFIgFAAIiMALIgBAAIgwAFQg0AFg0AGQg9AIg8AJIgBAAIgYADIABAAIABAAQhxAOhwAVQh8AYh6AgIgBAAQh5Agh6AdIjZAyQh+Ach7AgQhsAchsAeIj6BHIhiAbIgBABIi1AxIgmAKIAAAAQjSA5jWApIgRAEQinAfinAbIgBAAIhkAQQimAYipAMQhOAGhOADQiLAEiLgDQhqgDhpgGQibgJiagTIimgUIjXgZIhQgKIgKgBQi7gVi9gQIh0gJIgGgBQi9gNi9gFIgsgCIgFAAQibgDiagBIh8gBIgmgBIgDAAQhrgBhsACIgNAAIgDAAQh0ABh0AFQhtAFhsAKIgwAEIj1AYIg/AGIgBAAIgCAAIADAAIACgBIgBAAQhWAIhWAKIg/AIIgDABIgvAFIgCAAIkvAoIg6AHQhoAMhpAIIgFABQh/AJiAAHIgPABIgGAAIj9ANIgEAAIhEADIAEgBIgBAAIhgAEIgDABIglACIg0ACIgFgBIhcABIgEABIgEgBgEgiEAFNIgBAAIABAAg");
	this.shape_112.setTransform(937.375,253.9625);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#000004").s().p("EgoxAGSIhcgBIgIAAQg2gCg1gEIgJAAIhTgFIgKgBIgkgDIgLgBIhbgHIl4ghIgJgBIhZgHQi8gQi7gLIgGAAIhIgFQixgKiugRIgjgCIgEAAQjagVjWgeIgIgBIgGgBQjegfjfgdIgDgBIgBAAQjlgfjrgaIgBAAQjrgZjugDIgBAAIgVAAQjfgEjfgMIgHgBIgFgBIg5gBIgDAAIgSgFIgDgCIgBgBIgHgHIgBgBIgCgKIAAgFIAGgLIACgCIACAAIAHgDIAGgCIADAAIABAAQDWgCDWAHIAfABIAFAAQDVAIDUAMIAaACIAEABQDWANDRAaIAEAAIAoAGQDhAbDcAfIACAAIABAAQDXAeDbAYIACAAIAIABQDWAYDaAOIAeADIAEAAIE6AUICrAMIAGAAQCNAKCOANIChAPIAHABQCTAPCRAGQCDAFCEgFIAHAAQBngDBngCIBxgBIgDACIAGgBIAGAAQBzgBBygIIALAAIA+gEIDJgLIALgBQBtgHBtgKIAEgBIAFAAQBsgLBtgKIAGAAIDYgSIAHgBIAfgCIAEAAIACAAIAEAAIAGgBQDngQDogMIABAAIAEAAQDzgNDygCIAIAAIA3gBQDKAADKADIAJAAICfAEQCfAFCfAKIAMAAIA7AFIBuAHIANACIDoAQIANABIBVAHQCwANCuASIANABIA/AHQCCALCCAEQBIACBHABIARAAQClACCngHIBxgEIAOgBQCqgKCpgXQBbgMBagPIAQgCQCXgYCWgdIAqgIIASgDQDfgsDYg5IAqgMIARgFQC+gzC/gsIA/gPIASgDICcglIARgFQBsgZBtgYIC/goIARgDIEeg9IBtgWIATgFQCdghCfgZQA+gJA+gIIAWgDIBcgKIBagLIBUgHIBVgGIBZgEIAZgCIAGAAIA7gCIBKgCIAMgBIAEAAIAFAAIAEABIAEABIAGACIABAAIAEAFIAEADIABABIABAEIADAGIABABIAAAFIAAAGIgBAFIgCAGIgCABIgCACIgEAGIgDABIgIAEIgDABIgKACIhpAEIgEABQg2ACg2AFIgFAAIiMAOIgBAAIgwAFIhoAMQg9AIg8AIIgBAAIgYAEIABAAIABAAQhxAOhwATQh9AXh6AdIgBAAQh6Adh6AZIjaAtQh9Aah8AbQhtAZhsAbQh9Ahh/AfIhiAZIgBABIi2AsIglAKIgBAAQjSA0jXAnIgRAEQinAeinAcIgBAAIhkAQQimAZioAPQhOAHhPAEQiKAGiKAAQhqAAhpgCQiagEiagNIingQIjXgTIhQgHIgKgBQi6gQi9gNIh0gHIgHAAQi8gLi+gEIgrgBIgGAAIk1gEIh7AAIgmAAIgDAAQhrgChsABIgNAAIgCAAQh1ABh0AEQhsAEhtAJIgwADIj1AUIhBAGIADgBIgBAAIisAOIg/AGIgDAAIgvAFIgCAAIkvAeIg7AGQhoAJhoAEIgFABQh/AFiAADIgPAAIgGAAIj8AFIgEABIhEABIAAgBIADgBIgBAAIhgACIgDAAIglAAIg0ABIgFAAgAu+E4IgBAAIABAAg");
	this.shape_113.setTransform(937.225,252.8);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#000005").s().p("EggaAGAIgPAAIgGAAIj7gDIgEAAIhFgBIABgBIABgBIgBAAIhfgBIgEAAIglAAIg0gBIgEgBIhdgDIgHAAIhsgHIgJgBIhSgHIgLAAIgkgEIgKAAIhbgJQi8gSi9gQIgIgBIhZgHQi8gPi7gJIgGAAIhIgDQixgIiugMIgjgCIgEAAQjbgPjWgUIgIgBIgFAAIm+gqIgDgBIgBAAQjlgWjrgUIgBAAQjrgUjugFIgBAAIgVAAQjfgFjegQIgIgBIgEgBIg5gDIgDAAIgSgFIgDgCIgCgBIgGgHIgCgBIgCgKIAAgEIAGgLIACgCIACgBIAHgDIAGgBIADAAIABAAQDVADDWAJIAgABIAEAAQDVAJDUAKIAbABIAEAAQDWALDQASIAEAAIApAEQDhATDdAUIACABIABAAQDWAUDbARIACAAIAIAAQDXARDZAMIAfACIADAAQCdAICdAKICrALIAGAAQCNAKCOAMIChAQIAHABQCSAQCRAIQCDAICEgBIAHAAQBmAABnABIBwADIgCABIAGAAIAGAAQBzABBygDIALAAIA+gBIDJgFIALgBQBtgDBtgHIAEgBIAFAAQBsgHBtgGIAGgBIDZgNIAGAAIAggCIADAAIACAAIAEAAIAGgBQDngMDpgKIABAAIAEAAQDygLDzgBIAHAAIA3AAQDKAADKACIAJAAICfADQCfADCfAIIAMABIA7ADIBuAGIANABIDoALIANABIBVAEQCwAKCtAMIANABIBAADQCBAHCCAAICPgBIARAAQClgDCmgKIBxgHIAOgBQCqgNCogZQBagMBbgPIAQgDQCWgZCXgbIAqgIIASgDQDfgqDZg0IAqgLIASgEQC+guDAgoIA/gNIASgEICdggIARgDQBtgYBtgUIC/giIARgDIEfg1IBugVIASgEQCegeCfgYIB8gRIAWgCIBcgLIBagLIBUgIIBVgHIBYgGIAZgCIAGAAIA8gDIBJgFIANgBIAEgBIAFAAIADABIAEABIAGACIABAAIAEADIAEAEIABABIACAEIAEAFIAAABIABAEIABAHIgBAFIgCAGIgCABIgBADIgFAFIgCACIgHAEIgDACIgKACIhpAIIgEAAQg1AEg2AGIgFAAQhGAIhGAHIgBAAIgwAGIhoAMIh5ARIgBAAIgYADIgBAAIABABIABAAQhxAOhxASQh8AVh7AaIgBAAQh6Aah7AXIjaAnQh+AVh8AZQhtAVhtAYIj9A6IhjAWIgBAAIi2ApIgmAJIgBAAQjTAvjXAmIgRADIlNA5IgBAAIhkARQimAaioARQhOAIhOAGQiKAJiKAEQhpAChpABQiaABiagIIingKIjXgMIhQgFIgKgBQi6gLi9gJIh0gGIgHAAQi8gIi9gDIgsgBIgFAAIk1gDIh8AAIgmgBIgDAAQhqgBhtABIgNAAIgCAAQh0AAh0ADQhtADhsAHIgwADQh7AKh6AHIhBAEIACgBIgCAAIisALIg/AEIgDABIgvADIgCAAIkvAVIg7AEQhoAFhoACIgFAAIiQABIhugBg");
	this.shape_114.setTransform(937.125,252.1321);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#000006").s().p("A8YF2IgFAAQh/gCh+gGIgQAAIgFAAIj7gMIgFAAIhEgDIABAAIAAgCIgBAAIhggEIgDAAIglgBIg0gDIgFAAIhcgGIgIAAIhrgJIgJgBIhTgIIgKAAIgkgEIgKgBIhbgJQi8gTi8gQIgJgBIhZgHQi7gOi8gHIgGgBIhHgCQixgFivgIIgjgBIgEAAQjbgJjWgKIgIgBIgFAAIm/gXIgCAAIgBAAQjmgNjrgQIgBAAQjrgPjtgFIgCAAIgVgBQjfgGjdgUIgHgBIgFgBIg5gEIgDgBIgSgFIgDgBIgCgCIgHgGIgBgBIgDgKIAAgEIAHgLIACgCIABgBIAIgDIAGgBIADAAIAAAAIGrASIAgACIAEAAQDUAKDVAHIAbABIADAAQDXAIDQAKIAEAAIApACIG+AVIACAAIABAAIGyAVIACAAIAIAAQDWAKDaAJIAfABIADAAQCcAGCeAKICqAKIAGAAQCNAJCOANIChAQIAGABQCTARCRALQCCAKCEADIAHABQBmACBmAEIBwAGIgBACIAGAAIAGAAQByAFByAAIALABIA+AAIDKACIAKAAQBuAABsgEIAEAAIAFAAIDagHIAGAAIDYgIIAHgBIAfgBIAEAAIACAAIAEAAIAGAAIHQgRIABAAIADAAQDzgIDygBIAIAAIA2AAIGUACIAJAAICfACQCfACCgAGIALAAIA7ADIBuAEIANAAIDoAHIANAAIBVADQCwAECtAGIANABIA/ABQCCADCCgEICOgGIARgBQCkgHCmgNIBxgJIAOgBQCqgQCngbQBagNBagQIAQgCIEtg0IArgIIASgDQDfgoDagvIArgJIARgEQC/gpDBgjIBAgMIARgDICegcIARgDQBugUBtgRIDAgdIARgDQCQgWCPgYIBugTIATgDQCegbCfgXIB8gQIAVgDIBdgKIBZgMIBVgJIBUgIIBZgHIAZgDIAGAAIA7gFIBKgGIANgCIADgBIAFAAIAEAAIAEABIAGABIAAAAIAFAEIAEADIABABIACADIAFAGIAAABIABAEIABAGIgBAFIgBAGIgBACIgBACIgFAFIgCADIgHAEIgCACIgKADIhpALIgDABIhrALIgGABQhFAJhGAIIgBAAIgxAGIhnANIh5ARIgBAAIgYADIgBAAIABABQhxAOhwARQh+ATh7AXIAAAAQh7AYh7ATIjbAhQh+ATh9AUQhtAThtAVIj+AyIhkAUIgBAAIi3AlIgmAIIgBAAQjUAqjXAkIgRAEIlNA4IgCAAIhkARQimAbimAUQhPAJhOAHQiJALiJAIIjSAJQiaAGiagDIimgEIjXgGIhQgCIgKgBIl3gMIh1gEIgHAAQi8gFi9gCIgrgBIgGAAIk0gCIh8AAIgmgBIgDAAIjXgBIgNAAIgCAAQh1AAhzACQhtAChsAGIgxADQh6AIh6AFIhCADIABgBIgBAAIisAHIg/ADIgEAAIgvACIgCAAIkvAMIg6ACIh0ABIhcgBg");
	this.shape_115.setTransform(937,252.2194);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#000006").s().p("A5KFwQhogBhngFIgFAAQh/gHh+gJIgPgCIgGAAIj6gTIgEAAIhFgFIAAgBIgBgBIgBAAIhfgHIgEAAIgkgDIg1gEIgEAAIhcgIIgIgBIhrgLIgJgBIhSgIIgLgCIgkgDIgLgCIhagJQi8gVi9gQIgIAAIhZgHQi8gOi7gEIgFgBIhIgBIlggGIgjgBIgEAAQjbgDjWgBIgIAAIgGAAIm+gEIgDAAIgBAAQjlgEjrgKIgBAAQjsgLjtgGIgBAAIgVAAQjfgHjdgZIgHgBIgFgBIg5gGIgDgBIgSgFIgDgBIgCgCIgGgGIgCgBIgDgKIAAgEIAGgKIACgCIACgBIAHgDIAGgBIADAAIABAAIGqAZIAfACIAFAAQDUALDUAFIAbAAIAEABIGnAGIAEAAIApABQDhACDdAAIACAAIABAAQDXAADbADIACAAIAIAAQDXAEDZAGIAfAAIADAAQCdAFCdAIICrAKIAFAAQCNAJCOANQBQAHBQAKIAIABQCSARCQAOQCDAMCDAHIAHABQBlAFBmAIIBvAJIABABIAFAAIAGABQBzAIByAEIAKABIA+ADIDKAIIAKABQBtADBtAAIAEAAIAFAAQBtAABtgBIAGABIDZgEIAGAAIAgAAIADAAIACAAIAEgBIAHAAIHPgLIABAAIAEAAQDygGDzABIAHAAIA3gBIGUACIAJAAICeABQCfABCfAEIAMAAIA7ABIBuADIANAAQB0ACB0AAIANAAIBVAAIFdAAIANAAIBAgBQCBgBCBgJICOgKIAQgBQClgMClgQIBxgLIAOgCQCpgSCogdICzgfIAQgCIEtgzIArgHIASgDQDfgnDcgqIAqgHIASgEQDAglDBgeIBAgKIASgDICegXIARgDQBugRBugNIDBgZIARgCIEggnIBugQIASgDQCfgYCfgVIB8gQIAWgDIBcgLIBZgMIBUgKIBVgJIBYgJIAagDIAGgBIA7gFQAlgEAkgFIANgDIAEAAIAFAAIAEgBIAEABIAFABIABAAIAFADIAEADIABABIACADIAFAFIAAABIACAEIACAHIgBAFIgBAFIgBACIgBACIgDAGIgCADIgHAFIgDACIgKADIhnAOIgEABIhqAOIgFABQhGAKhGAJIgBAAIgwAHIhoANIh5ARIgBAAIgYADIgBAAQhxAOhwAQQh9ASh8AVIAAAAQh8AUh7AQIjcAcQh+APh+ARQhtAPhuATIj/ArIhkARIgBABIi4AfIgmAHIgBAAQjVAnjXAiIgRADQinAainAdIgBAAIhkASQilAdinAVQhOALhOAIQiJAOiJALIjRAPQiZALiaACIinACIjYABIhQgBIgJAAQi6gBi9gDIh0gBIgHAAQi9gDi9gBIgrgBIgFAAIk1AAIh8gBIgmAAIgCAAIjXgCIgNAAIgCAAQh0gBh1ABQhsABhsAFIgwACQh7AGh5AEIhDACIAAgBIgCAAIisADIg/ACIgDAAIgvAAIgCAAQiYADiYABIg6gBg");
	this.shape_116.setTransform(936.875,252.625);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#000007").s().p("Au/FvIgCgBIgBAAIisAAIg/AAIgEAAIgvAAIgCAAQiYgCiYgEIg6gDQhogEhmgJIgGAAQh+gKh+gOIgPgCIgFAAIj7gbIgDAAIhFgIIAAAAIgCgCIgBAAIhggKIgDAAIgkgEIg1gFIgFgBIhcgKIgHAAIhrgNIgJgCIhTgJIgKgCIgkgEIgLgBIhagLQi8gVi8gQIgJgBIhZgGQi7gNi8gDIgFAAIhIgBQixgBiuACIgjABIgFAAQjbADjXAIIgIAAIgFAAQjeAIjhAHIgCAAIgBAAQjmAGjrgGIgBAAInZgMIgBAAIgVgBQjfgHjcgeIgHgBIgFgBIg5gIIgDgBIgSgFIgDgBIgCgCIgHgFIgBgBIgDgLIAAgDIAGgKIACgCIABgBIAHgDIAGgBIADAAIABAAQDUASDVAOIAgACIAEAAQDVANDUABIAbAAIAEABQDWAADRgEIAEgBIApgBQDhgGDdgKIADgBIABAAQDWgJDcgEIACAAIAIAAQDWgDDaADIAeAAIAEAAQCdADCcAHICrAJIAFAAQCOAJCNANQBQAHBQAKIAHABIEjAjQCDAPCBAKIAHABQBmAIBlALIBvAMIACACIAFAAIAGABQByALByAIIAKABIA/AGIDJAPIAKAAQBtAHBtAEIAEAAIAFAAQBtAEBuACIAGAAQBrACBtgBIAHABIAgAAIADAAIACAAIAEgBIAHAAQDnAADngEIABAAIAFAAQDygEDzABIAGAAIA3AAQDKABDKAAIAJAAICeAAQCgAACeACIAMgBIA7ABIBuABIANAAQB0AAB0gDIANAAIBVgCIFdgLIANgBIBAgDQCAgGCCgNICNgOIAQgBIFJgkIBxgNIAPgCQCngVCogfICzggIAQgDQCWgaCXgYIArgHIASgDIG8hIIArgHIARgEQDBggDDgaIA/gIIASgCICfgUIASgCQBtgNBvgLIDCgTIAQgCQCRgPCRgRQA3gGA2gIIATgCIE+gpIB8gPIAVgDIBdgLIBZgNIBUgLIBUgKIBZgLIAagDIAFgBIA7gHQAmgEAkgGIANgEIAEAAIAFgBIADAAIAFAAIAFABIABAAIAFACIAEADIABABIADACIAEAGIABAAIACAFIADAGIgBAFIAAAGIgBABIgCADIgCAGIgCADIgGAFIgDACIgKAFIhnARIgDAAIhrARIgEABQhGALhHAKIgBAAIgvAHIhoAOIh5ARIgBAAIgYADIgBAAIAAAAIjiAdIj5AiIAAAAQh9ASh7ANIjdAWIj8AZQhuALhuAQIkBAlIhkAOIgBABIi6AbIglAGIgBAAImtBDIgRACQioAZinAeIAAAAIhkASQimAeilAYQhOALhOAKQiJARiIAOIjRAWQiZAQiaAHIimAHIjYAHIhQACIgJAAQi7AEi9AAIh0ABIgHAAIl6AAIgqgBIgGAAQiaABiaAAIh8gBIgmAAIgCAAIjXgCIgNAAIgCAAQh1gCh0AAQhsAAhtAEIgvACQh7AEh5ACIhDAAg");
	this.shape_117.setTransform(936.75,253.525);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#000008").s().p("AB3FyIgmAAIgDAAIjXgCIgNAAIgCAAIjogDQhtgChsADIgwABQh6ADh5gBIhDAAIgBAAIgCgBIgBAAIitgEIg/gBIgEAAIgvgCIgCAAQiYgGiYgJIg6gFQhogIhngLIgEgBQh+gOh9gSIgQgCIgFAAQh9gTh9gQIgEgBIhEgJIgBgBIgDgBIgBAAIhfgNIgEgBIgkgEIg1gHIgEgBIhcgMIgHgBIhsgPIgJgBIhSgLIgKgCIglgEIgLgCIhagLQi8gXi8gPIgIgBIhZgGQi8gNi7AAIgFgBIhIABQixABiuAHIgjABIgFAAQjcAJjWASIgIAAIgGAAQjeASjhAQIgDAAIgBAAQjkAPjsAAIgBAAQjrgBjugHIgBAAIgVgBQjfgJjbgiIgHgBIgFgBIg5gJIgDgBIgSgFIgDgCIgCgBIgHgGIgCgBIgDgKIAAgDIAFgKIACgCIACgBIAHgDIAGgBIADAAIABAAQDUAXDVAPIAfADIAFAAQDTAODWgBIAbgBIADABQDXgDDQgMIAFgBIAogCQDigPDegVIACAAIABAAQDWgTDcgLIACAAIAIgBQDXgKDaAAIAeAAIAEAAQCbABCdAHICrAJIAFAAQCOAICMANQBRAHBQAKIAHABIEiAmQCCASCCAOIAHACQBlALBlANIBuAQIAEABIAEABIAGABQByAOByAMIAKACIA+AHIDKAWIALABQBsAKBtAHIAEABIAFAAQBuAHBtAFIAGABQBsAEBsACIAHAAIAgABIAEAAIACAAIADAAIAHAAQDnADDogCIABAAIAEAAQDzgCDyACIAHAAIA2AAQDJACDLgBIAJAAICegBIE/gCIALAAIA7AAIBvgBIALgBQB1gCB0gFIANgBIBVgEQCvgKCugMIAMgBIBAgFQCBgKCBgRICNgSIAQgDIFIgrIBxgPIAOgCQCogZCnggICzgiIAQgCQCWgbCXgXIArgGIASgDQDfgiDeggIAqgGIASgDQDCgcDDgVIBAgGIASgCICfgPIASgCQBvgKBvgHIDBgOIARgCQCSgLCQgOQA3gFA4gGIASgCIE/glIB8gPIAVgCIBcgLIBagOIBUgMIBUgLIBYgMIAagEIAGgBIA7gIQAlgGAkgHIANgEIAFgBIAEAAIAEgBIAEAAIAFAAIABAAIAFACIAEADIACABIACACIAGAFIAAABIADAEIADAGIAAAFIAAAGIgBACIgBACIgDAGIgBADIgGAGIgDADIgKAFIhmAUIgEABIhpATIgFAAQhFANhGALIgCAAIgwAHIhnAPIh5ARIgBAAIgYADIgBAAIgBAAIgBAAIjiAcIj5AdQh9APh7AKIjeAQIj9ASQhvAJhuAMQiBAOiBARIhmANIgBAAIi4AWIgmAFIgCAAQjWAdjXAfIgRADQipAYimAeIgBAAIhkASQilAfilAaIicAYIkQAlIjQAcQiZAViaAMQhSAHhVAGIjYAOIhPAEIgKAAQi6AJi9ADIh0ADIgHAAQi9ADi8ABIgsAAIgEAAIk0ABIh8gBg");
	this.shape_118.setTransform(936.65,254.925);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#000009").s().p("AB2F6IgmAAIgCAAQhqAAhtgDIgNAAIgCAAIjogFQhtgChsABIgwABQh7ACh5gDIhCgCIgBAAIgEAAIgCAAQhWgDhWgFIg/gDIgDAAIgwgDIgCAAQiYgKiYgOIg6gHQhogLhmgPIgFgBQh9gRh9gXIgPgDIgHAAIj4grIgEgBIhEgLIgBgBIgFgBIgBAAIhfgQIgDAAIglgHIg0gIIgEgBIhdgOIgHAAIhrgSIgJgBIhSgNIgLgBIglgFIgKgCIhbgMQi7gYi8gPIgJAAIhYgGQi8gNi7ACIgFAAIhIABQixAEivAKIgjADIgEABQjcAOjWAbIgIAAIgHABQjeAbjhAaIgCAAIgBAAQjmAZjrAEIgBAAQjsAEjsgIIgBAAIgWgBQjfgJjbgnIgHgCIgEgBIg5gLIgDgBIgSgEIgDgCIgCgCIgHgFIgCgBIgEgLIAAgCIAGgKIABgBIACgBIAGgEIAHAAIADAAIABAAQDTAbDVASIAgADIAEAAQDUAQDUgFIAbgBIAFABQDWgHDRgTIAEAAIApgFQDigXDegfIACgBIABAAQDWgdDcgRIADAAIAHgBQDWgQDagDIAgAAIACAAQCdgBCcAFQBWAEBVAEIAFAAQCNAICOANQBQAHBQAKIAHABQCSATCQAXIEDAnIAHABQBlANBkARIBuASIAEACIAFABIAGACQByARBxAQIAKACIA/AKIDJAcIAKABQBtAOBtALIAEABIAFAAQBuAKBuAJIAGAAQBrAHBtAEIAGAAIAgABIAEABIACAAIAEgBIAGABQDnAHDoAAIABAAIAFAAQDyAADzADIAHAAIA1AAQDKADDKgDIAJAAICegBIE+gFIALAAIA7gCQA4AAA3gDIANAAQBzgFB0gHIAOgBIBVgHQCvgOCtgTIANgBIBAgHQCBgPCAgVICNgWIAQgDIFHgzIBxgSIAOgCQCngbCngiICygkIARgCQCVgaCXgXIArgGIATgDQDgggDfgbIAqgFIARgCQDDgYDFgQIBAgEIASgCICggKIARgCQBvgHBvgEIDDgJIARgBQCRgHCRgLIBugJIATgBQCggPCggSIB7gOIAWgDIBcgLIBZgNIBUgOIBUgMIBZgOIAagEIAGgBIA7gKIBJgPIAMgEIAFgBIAEgBIAEgBIAEAAIAGgBIABAAIAEACIAFADIACAAIACADIAGAEIABABIACAEIAEAGIABAFIAAAGIAAACIgBACIgDAGIgBAEIgFAGIgDADIgKAGIhmAYIgDAAIhpAVIgFABQhFAOhHALIgBAAIgwAIQgzAIg0AIIh5AQIgCAAIgXAEIgBAAIgCAAIAAAAQhxAOhyAMQh9ANh8AMIgBAAQh8ANh9AGIjeALIj+ALQhvAFhvAJQiBALiDANIhlAKIgBAAIi6AUIgmAEIgBAAQjXAYjYAcIgRADQioAWinAfIgBAAQgyAJgxAKQilAgilAdIicAaIkOArIjPAiQiaAaiaARIinASIjYAVIhQAGIgJAAQi6AOi8AHIh1AEIgHABQi8AFi9ACIgrAAIgFAAQibACiaAAIh7AAg");
	this.shape_119.setTransform(936.55,256.65);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#00000A").s().p("AB1GBIgmAAIgCAAQhqAAhtgDIgNAAIgCAAIjogGQhsgDhtgBIgwABQh6AAh5gFIhCgDIgCAAIgFgBIgBAAQhXgEhWgHIg/gEIgDgBIgwgEIgCAAQiYgNiYgUIg7gIQhngPhmgSIgFgBQh9gWh9gaIgPgDIgGgBIj4gzIgEAAIhEgOIgCgBIgEgCIgBAAIhggSIgDgBIglgHIg0gKIgEgBIhdgQIgHgBIhrgTIgJgCIhSgNIgKgCIglgFIgKgCIhbgNQi8gZi8gOIgIgBIhZgGQi7gLi7AEIgFAAIhIACQixAGivAOIgjAEIgFAAQjcAVjWAkIgIABIgGAAQjfAmjhAiIgCABIgBAAQjmAhjrAKIgBAAQjsAJjtgJIgBAAIgVgBQjfgKjagsIgHgCIgFgBIg5gMIgDgBIgSgFIgCgBIgDgCIgHgFIgCgBIgEgLIAAgBIAGgLIACgBIABgBIAGgDIAHAAIADAAIABAAQDTAgDUATIAgADIAEAAQDUARDVgHIAbgBIAEAAQDWgJDSgcIAEAAIApgGQDiggDegpIACgBIABAAQDWgmDcgZIACAAIAIgBQDXgXDagGIAegBIAEAAQCcgCCcAEQBWADBVAFIAFAAQCNAHCNAOQBQAHBQALIAHABQCSATCQAZIECAtIAHABQBlARBjATIBuAWIAFACIAFABIAGABIDjAqIAKACIA/AMIDJAiIAKACQBtARBtAPIAEABIAFAAQBtAPBvAKIAGABQBrAKBtAFIAGABIAgACIAEAAIACAAIAEAAIAGAAQDoAMDoACIABAAIAEAAQDyACDzADIAHAAIA1ABQDKADDKgDIAJAAICegDIE+gIIALgBIA7gCQA4gCA3gDIAMAAQB0gGB0gLIANgCIBWgIQCugUCtgXIANgDIBAgJQCBgTCAgaICMgaIAQgDQCjgfCkgcIBxgUIAOgCQCmgeCngjQBYgTBagSIAQgDQCVgcCYgVIArgGIASgCQDhgfDggVIAqgEIASgCQDDgTDFgLIBBgEIARAAQBQgEBRgDIASgBQBvgDBwgBIDDgDIARgBQCSgECSgIIBugGIATgCQCggLCfgRQA+gGA+gHIAWgDIBcgLIBZgOIBTgOIBUgOIBZgPIAagGIAGAAIA7gLQAkgHAlgKIANgFIAEgBIAEgBIAEgBIAEgBIAGAAIABAAIAEABIAGACIABAAIADACIAGAFIABAAIADAFIAEAGIABAFIABAGIgBABIAAADIgCAHIgBADIgFAHIgCADIgKAHQgzAOgzAMIgDABIhpAXIgFABQhFAQhGAMIgBAAIgwAIIhoAQIh5AQIgBAAIgYAEIgBAAIgCAAIAAAAQhxAOhyALQh+AMh8AJIgBAAQh9AJh9AEIjeAFIj/AEQhwAChvAGQiCAHiDAKIhmAIIgBAAIi7APIglADIgCAAQjYAUjXAbIgRACQipAWimAeIgBAAIhkAUQikAhilAfIibAcIkPAxQhnAThnAVQiZAfiaAXQhTANhTALIjZAaIhQAJIgIAAQi7ATi9AKIh0AHIgHAAQi8AIi9ADIgrABIgFAAQiaADiaAAIh8gBg");
	this.shape_120.setTransform(936.475,258.425);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#00000B").s().p("AB1GKIgmAAIgCAAQhrgBhsgEIgNAAIgCAAIjogHQhsgFhtgBIgwAAQh6gBh5gHIhCgEIgDAAIgFgBIgCAAQhXgHhWgIIg/gGIgDgBIgwgFIgCAAQiYgRiYgZIg7gKQhngThmgVIgFgBQh8gah9geIgPgEIgGgBQh7geh8gcIgEgBIhEgQIgCAAIgGgCIgBAAIhfgWIgDgBIglgIIg1gMIgEAAIhcgTIgHgBIhrgWIgJgBIhTgOIgKgCIglgFIgKgCIhbgNQi7gbi8gPIgIAAIhZgGQi7gLi7AGIgFAAIhIADQixAJivAUIgjADIgFABQjcAbjXAsIgIABIgGABQjfAwjhArIgCABIgBAAQjlAqjsAPIgBAAQjsAOjtgKIgBAAIgVgBQjegLjagwIgHgCIgFgCQgdgFgcgIIgDgBIgSgFIgDgBIgCgCIgHgFIgCgBIgFgLIAAgBIAGgKIACgBIABgCIAGgDIAHAAIADAAIABAAQDTAmDTAVIAgADIAEAAQDUASDVgKIAbgBIAEAAQDXgNDSgjIAEgBIAogGQDjgpDegzIACgBIABAAQDWgwDdggIACAAIAIgCQDWgeDagIIAfgBIADAAQCcgFCcAEQBWACBVAFIAFAAQCNAGCNAPQBQAHBQALIAHABQCSAUCPAcIECAzIAHABQBkAUBjAXIBuAZIAGACIAFABIAGABIDiAwIAKADIA/AOIDJAqIAKABQBtAVBtASIAEABIAFABQBuASBuANIAGABQBrANBtAHIAHACIAfACIAEABIACAAIAEgBIAHABQDnAPDoAEIABAAIAEAAIHlAJIAHAAIA1AAQDKADDKgDIAJAAQBPgCBPgCIE+gMIALgBIA7gCQA3gDA3gEIANgBQB0gIB0gOIANgCIBVgLQCvgXCtgeIANgDIBAgLQCAgYCBgdICLgfIAQgEQCigjCkgfIBwgWIAOgCQCnghCmgmQBYgUBZgRIAQgEQCWgcCYgUIArgGIASgCQDhgcDhgSIAqgCIASgCQDFgODFgGIBBgCIASgBQBQgBBRAAIARAAQBwgCBxADIDDACIARAAQCTAACSgEIBugFIATgBQCggICggPIB7gOIAWgCIBdgLIBZgPIBTgQIBTgOIBZgRIAbgGIAGgBIA6gMQAlgIAkgKIANgGIAEgBIAFgCIAEgBIAEgBIAFgBIABAAIAFABIAFACIACAAIADACIAHAEIABAAIADAFIAEAFIACAFIABAHIAAACIgBACIgBAHIgBADIgFAIIgCAEIgKAGQgyARgyANIgEABQg0AOg0AMIgFABQhFARhHAMIgBAAIgwAJQgzAJg0AHQg9AKg8AHIgBAAIgYADIgBAAIgCABIgBAAQhxAOhyAKQh+AKh9AFQh+AIh9gBIjfAAIkAgCQhwgChvADQiDADiEAHIhnAGIgBAAIi7AKIglADIgCAAQjZAPjYAaIgRACQipAUimAgIgBAAQgyAIgxAMIlIBCIicAfQiHAaiGAdQhoAWhmAYQiZAliaAbIimAeIjZAgIhQALIgIABQi7AYi9AOIh0AIIgHABQi8AKi9AEIgrABIgFAAQiaADiaABIh7AAg");
	this.shape_121.setTransform(936.375,260.15);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#00000C").s().p("AB0GRIgmAAQhrAAhugEIgNAAQh1gEh1gFQhsgGhsgCIgxgBQh6gCh4gKIhFgFIgJgBQhWgIhWgKIg/gIIgEAAIgygHQiZgWiXgdIg7gMQhpgXhpgZQh8geh8giIgVgFQh9gjh+ghIhGgSIgIgCIhfgZIgogKIg0gNIhhgVIhygYIhcgRIgugJIhlgQQi8gci8gOIhhgGQi7gLi6AIIhNAEQixAMiwAYIgjAFQjeAgjaA3IgIABQjhA6jlA1IgCABQjmA0jsATQjuAUjtgLIgVgBQjegMjag1IgLgEIg8gQIgVgGIgDgCIgHgFIgCgBIgEgLIAAAAIAEgLIAEgCIAGgDIAKAAIABAAQDSAqDUAXIAkADQDTAUDVgNIAfgCQDZgPDUgsIApgIQDjgyDgg9IABAAQDXg7DdgnIAJgCQDWgkDagMIAigBQCcgHCcADQBYACBYAFQCMAGCNAOQBUAIBUAMQCRAVCPAfQCFAcCDAfQBkAXBjAYIB5AgIAGACIDsA6IA/AQQBoAaBqAYQBwAZBvAXIAEAAQByAXBxAQQBuAQBwALIAmADIAFAAIAGABQDoATDoAGIAFAAIHrALIA1ABQDOAEDOgFQBQgBBPgDQCkgHCkgJIA8gEQA9gEA9gFQB7gLB7gSIBVgNQC1geCzgmIBAgNQCAgdCBghICagnQCigoCjgiIB/gaQCmgkClgoQBggXBhgTQCWgdCYgTIA9gIQDigbDigLIA8gDQDFgKDHgBIBTAAICzACQBxADBwAFQBrAFBqADQCTADCSgBQBBAABBgCQChgFCfgPQBJgGBJgJIBcgLIBZgQIBTgQIBUgQIBYgSIAhgHIA7gOQAkgJAkgLIASgIIAEgCIAIgCIAFgCIAGABIAHABIAEACIAIAFIAEAEIAEAGIACAFIACAIIAAADIgCAKIgGAMIgKAIQg0ASg1APQg1AQg3ANQhFAShGAOIgxAJQgzAJg0AIQg9AJg9AIIgZADIgEABQhxANhyAJQh/AJh9ADQh+AEh+gDIjggHIkBgJQhvgFhxAAQiDgBiEAEIhnAEIi9AGIgmACQjbAKjZAYIgRACQipATimAgQgyAJgyAMIlHBFIicAiQiHAdiGAgQhnAZhlAbQiZApiaAiQhTAShUAQIjYAoIhRANQi+AdjBARIh0AKQi/APjBAFIgrABQidAEicABIh7gBg");
	this.shape_122.setTransform(936.3,261.875);

	this.instance_16 = new lib.PuppetShape_5copy("synched",1,false);
	this.instance_16.setTransform(936.2,263.6);

	this.instance_17 = new lib.PuppetShape_4("synched",1,false);
	this.instance_17.setTransform(937.4,269.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15}]}).to({state:[{t:this.shape_96}]},1).to({state:[{t:this.shape_97}]},1).to({state:[{t:this.shape_98}]},1).to({state:[{t:this.shape_99}]},1).to({state:[{t:this.shape_100}]},1).to({state:[{t:this.shape_101}]},1).to({state:[{t:this.shape_102}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_104}]},1).to({state:[{t:this.shape_105}]},1).to({state:[{t:this.shape_106}]},1).to({state:[{t:this.shape_107}]},1).to({state:[{t:this.shape_108}]},1).to({state:[{t:this.shape_109}]},1).to({state:[{t:this.shape_110}]},1).to({state:[{t:this.shape_111}]},1).to({state:[{t:this.shape_112}]},1).to({state:[{t:this.shape_113}]},1).to({state:[{t:this.shape_114}]},1).to({state:[{t:this.shape_115}]},1).to({state:[{t:this.shape_116}]},1).to({state:[{t:this.shape_117}]},1).to({state:[{t:this.shape_118}]},1).to({state:[{t:this.shape_119}]},1).to({state:[{t:this.shape_120}]},1).to({state:[{t:this.shape_121}]},1).to({state:[{t:this.shape_122}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(1035.9,666,789.5,277.5);
// library properties:
lib.properties = {
	id: '9D38D838CA093A45A56B28A09A01E046',
	width: 1920,
	height: 1080,
	fps: 8,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_1.png", id:"seaweed_farm_02_atlas_1"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_2.png", id:"seaweed_farm_02_atlas_2"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_3.png", id:"seaweed_farm_02_atlas_3"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_4.png", id:"seaweed_farm_02_atlas_4"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_5.png", id:"seaweed_farm_02_atlas_5"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_6.png", id:"seaweed_farm_02_atlas_6"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_7.png", id:"seaweed_farm_02_atlas_7"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_8.png", id:"seaweed_farm_02_atlas_8"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_9.png", id:"seaweed_farm_02_atlas_9"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_10.png", id:"seaweed_farm_02_atlas_10"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_11.png", id:"seaweed_farm_02_atlas_11"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_12.png", id:"seaweed_farm_02_atlas_12"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_13.png", id:"seaweed_farm_02_atlas_13"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_14.png", id:"seaweed_farm_02_atlas_14"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_15.png", id:"seaweed_farm_02_atlas_15"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_16.png", id:"seaweed_farm_02_atlas_16"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_17.png", id:"seaweed_farm_02_atlas_17"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_18.png", id:"seaweed_farm_02_atlas_18"},
		{src:"//cdn.shopify.com/s/files/1/0556/1899/4372/t/1/assets/seaweed_farm_02_atlas_19.png", id:"seaweed_farm_02_atlas_19"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['9D38D838CA093A45A56B28A09A01E046'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;